/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Account = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Account';
  contained?: Maybe<Array<Resource>>;
  coverage?: Maybe<Array<AccountCoverage>>;
  description?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  guarantor?: Maybe<Array<AccountGuarantor>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Reference>;
  partOf?: Maybe<Reference>;
  resourceType: Scalars['String']['output'];
  servicePeriod?: Maybe<Period>;
  status: AccountStatus;
  subject?: Maybe<Array<Reference>>;
  text?: Maybe<Narrative>;
  type?: Maybe<CodeableConcept>;
};

export type AccountCoverage = BackboneElementInterface & ElementInterface & {
  __typename?: 'AccountCoverage';
  coverage: Reference;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  priority?: Maybe<Scalars['Int']['output']>;
};

export type AccountGuarantor = BackboneElementInterface & ElementInterface & {
  __typename?: 'AccountGuarantor';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  onHold?: Maybe<Scalars['Boolean']['output']>;
  party: Reference;
  period?: Maybe<Period>;
};

export enum AccountStatus {
  Active = 'active',
  EnteredInError = 'entered_in_error',
  Inactive = 'inactive',
  OnHold = 'on_hold',
  Unknown = 'unknown'
}

export enum ActionCardinalityBehavior {
  Multiple = 'multiple',
  Single = 'single'
}

export enum ActionConditionKind {
  Applicability = 'applicability',
  Start = 'start',
  Stop = 'stop'
}

export enum ActionGroupingBehavior {
  LogicalGroup = 'logical_group',
  SentenceGroup = 'sentence_group',
  VisualGroup = 'visual_group'
}

export enum ActionParticipantType {
  Device = 'device',
  Patient = 'patient',
  Practitioner = 'practitioner',
  RelatedPerson = 'related_person'
}

export enum ActionPrecheckBehavior {
  No = 'no',
  Yes = 'yes'
}

export enum ActionRelationshipType {
  After = 'after',
  AfterEnd = 'after_end',
  AfterStart = 'after_start',
  Before = 'before',
  BeforeEnd = 'before_end',
  BeforeStart = 'before_start',
  Concurrent = 'concurrent',
  ConcurrentWithEnd = 'concurrent_with_end',
  ConcurrentWithStart = 'concurrent_with_start'
}

export enum ActionRequiredBehavior {
  Could = 'could',
  Must = 'must',
  MustUnlessDocumented = 'must_unless_documented'
}

export enum ActionSelectionBehavior {
  All = 'all',
  AllOrNone = 'all_or_none',
  Any = 'any',
  AtMostOne = 'at_most_one',
  ExactlyOne = 'exactly_one',
  OneOrMore = 'one_or_more'
}

export type Address = ElementInterface & {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  line?: Maybe<Array<Scalars['String']['output']>>;
  period?: Maybe<Period>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AddressType>;
  use?: Maybe<AddressUse>;
};

export enum AddressType {
  Both = 'both',
  Physical = 'physical',
  Postal = 'postal'
}

export enum AddressUse {
  Billing = 'billing',
  Home = 'home',
  Old = 'old',
  Temp = 'temp',
  Work = 'work'
}

export enum AdministrativeGender {
  Female = 'female',
  Male = 'male',
  Other = 'other',
  Unknown = 'unknown'
}

export type Age = ElementInterface & QuantityInterface & {
  __typename?: 'Age';
  code?: Maybe<Scalars['String']['output']>;
  comparator?: Maybe<QuantityComparator>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  system?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum AllTypes {
  Account = 'Account',
  ActivityDefinition = 'ActivityDefinition',
  Address = 'Address',
  AdverseEvent = 'AdverseEvent',
  Age = 'Age',
  AllergyIntolerance = 'AllergyIntolerance',
  Annotation = 'Annotation',
  Any = 'Any',
  Appointment = 'Appointment',
  AppointmentResponse = 'AppointmentResponse',
  Attachment = 'Attachment',
  AuditEvent = 'AuditEvent',
  BackboneElement = 'BackboneElement',
  Basic = 'Basic',
  Binary = 'Binary',
  BiologicallyDerivedProduct = 'BiologicallyDerivedProduct',
  BodyStructure = 'BodyStructure',
  Bundle = 'Bundle',
  CapabilityStatement = 'CapabilityStatement',
  CarePlan = 'CarePlan',
  CareTeam = 'CareTeam',
  CatalogEntry = 'CatalogEntry',
  ChargeItem = 'ChargeItem',
  ChargeItemDefinition = 'ChargeItemDefinition',
  Claim = 'Claim',
  ClaimResponse = 'ClaimResponse',
  ClinicalImpression = 'ClinicalImpression',
  CodeSystem = 'CodeSystem',
  CodeableConcept = 'CodeableConcept',
  Coding = 'Coding',
  Communication = 'Communication',
  CommunicationRequest = 'CommunicationRequest',
  CompartmentDefinition = 'CompartmentDefinition',
  Composition = 'Composition',
  ConceptMap = 'ConceptMap',
  Condition = 'Condition',
  Consent = 'Consent',
  ContactDetail = 'ContactDetail',
  ContactPoint = 'ContactPoint',
  Contract = 'Contract',
  Contributor = 'Contributor',
  Count = 'Count',
  Coverage = 'Coverage',
  CoverageEligibilityRequest = 'CoverageEligibilityRequest',
  CoverageEligibilityResponse = 'CoverageEligibilityResponse',
  DataRequirement = 'DataRequirement',
  DetectedIssue = 'DetectedIssue',
  Device = 'Device',
  DeviceDefinition = 'DeviceDefinition',
  DeviceMetric = 'DeviceMetric',
  DeviceRequest = 'DeviceRequest',
  DeviceUseStatement = 'DeviceUseStatement',
  DiagnosticReport = 'DiagnosticReport',
  Distance = 'Distance',
  DocumentManifest = 'DocumentManifest',
  DocumentReference = 'DocumentReference',
  DomainResource = 'DomainResource',
  Dosage = 'Dosage',
  Duration = 'Duration',
  EffectEvidenceSynthesis = 'EffectEvidenceSynthesis',
  Element = 'Element',
  ElementDefinition = 'ElementDefinition',
  Encounter = 'Encounter',
  Endpoint = 'Endpoint',
  EnrollmentRequest = 'EnrollmentRequest',
  EnrollmentResponse = 'EnrollmentResponse',
  EpisodeOfCare = 'EpisodeOfCare',
  EventDefinition = 'EventDefinition',
  Evidence = 'Evidence',
  EvidenceVariable = 'EvidenceVariable',
  ExampleScenario = 'ExampleScenario',
  ExplanationOfBenefit = 'ExplanationOfBenefit',
  Expression = 'Expression',
  Extension = 'Extension',
  FamilyMemberHistory = 'FamilyMemberHistory',
  Flag = 'Flag',
  Goal = 'Goal',
  GraphDefinition = 'GraphDefinition',
  Group = 'Group',
  GuidanceResponse = 'GuidanceResponse',
  HealthcareService = 'HealthcareService',
  HumanName = 'HumanName',
  Identifier = 'Identifier',
  ImagingStudy = 'ImagingStudy',
  Immunization = 'Immunization',
  ImmunizationEvaluation = 'ImmunizationEvaluation',
  ImmunizationRecommendation = 'ImmunizationRecommendation',
  ImplementationGuide = 'ImplementationGuide',
  InsurancePlan = 'InsurancePlan',
  Invoice = 'Invoice',
  Library = 'Library',
  Linkage = 'Linkage',
  List = 'List',
  Location = 'Location',
  MarketingStatus = 'MarketingStatus',
  Measure = 'Measure',
  MeasureReport = 'MeasureReport',
  Media = 'Media',
  Medication = 'Medication',
  MedicationAdministration = 'MedicationAdministration',
  MedicationDispense = 'MedicationDispense',
  MedicationKnowledge = 'MedicationKnowledge',
  MedicationRequest = 'MedicationRequest',
  MedicationStatement = 'MedicationStatement',
  MedicinalProduct = 'MedicinalProduct',
  MedicinalProductAuthorization = 'MedicinalProductAuthorization',
  MedicinalProductContraindication = 'MedicinalProductContraindication',
  MedicinalProductIndication = 'MedicinalProductIndication',
  MedicinalProductIngredient = 'MedicinalProductIngredient',
  MedicinalProductInteraction = 'MedicinalProductInteraction',
  MedicinalProductManufactured = 'MedicinalProductManufactured',
  MedicinalProductPackaged = 'MedicinalProductPackaged',
  MedicinalProductPharmaceutical = 'MedicinalProductPharmaceutical',
  MedicinalProductUndesirableEffect = 'MedicinalProductUndesirableEffect',
  MessageDefinition = 'MessageDefinition',
  MessageHeader = 'MessageHeader',
  Meta = 'Meta',
  MolecularSequence = 'MolecularSequence',
  Money = 'Money',
  MoneyQuantity = 'MoneyQuantity',
  NamingSystem = 'NamingSystem',
  Narrative = 'Narrative',
  NutritionOrder = 'NutritionOrder',
  Observation = 'Observation',
  ObservationDefinition = 'ObservationDefinition',
  OperationDefinition = 'OperationDefinition',
  OperationOutcome = 'OperationOutcome',
  Organization = 'Organization',
  OrganizationAffiliation = 'OrganizationAffiliation',
  ParameterDefinition = 'ParameterDefinition',
  Parameters = 'Parameters',
  Patient = 'Patient',
  PaymentNotice = 'PaymentNotice',
  PaymentReconciliation = 'PaymentReconciliation',
  Period = 'Period',
  Person = 'Person',
  PlanDefinition = 'PlanDefinition',
  Population = 'Population',
  Practitioner = 'Practitioner',
  PractitionerRole = 'PractitionerRole',
  Procedure = 'Procedure',
  ProdCharacteristic = 'ProdCharacteristic',
  ProductShelfLife = 'ProductShelfLife',
  Provenance = 'Provenance',
  Quantity = 'Quantity',
  Questionnaire = 'Questionnaire',
  QuestionnaireResponse = 'QuestionnaireResponse',
  Range = 'Range',
  Ratio = 'Ratio',
  Reference = 'Reference',
  RelatedArtifact = 'RelatedArtifact',
  RelatedPerson = 'RelatedPerson',
  RequestGroup = 'RequestGroup',
  ResearchDefinition = 'ResearchDefinition',
  ResearchElementDefinition = 'ResearchElementDefinition',
  ResearchStudy = 'ResearchStudy',
  ResearchSubject = 'ResearchSubject',
  Resource = 'Resource',
  RiskAssessment = 'RiskAssessment',
  RiskEvidenceSynthesis = 'RiskEvidenceSynthesis',
  SampledData = 'SampledData',
  Schedule = 'Schedule',
  SearchParameter = 'SearchParameter',
  ServiceRequest = 'ServiceRequest',
  Signature = 'Signature',
  SimpleQuantity = 'SimpleQuantity',
  Slot = 'Slot',
  Specimen = 'Specimen',
  SpecimenDefinition = 'SpecimenDefinition',
  StructureDefinition = 'StructureDefinition',
  StructureMap = 'StructureMap',
  Subscription = 'Subscription',
  Substance = 'Substance',
  SubstanceAmount = 'SubstanceAmount',
  SubstanceNucleicAcid = 'SubstanceNucleicAcid',
  SubstancePolymer = 'SubstancePolymer',
  SubstanceProtein = 'SubstanceProtein',
  SubstanceReferenceInformation = 'SubstanceReferenceInformation',
  SubstanceSourceMaterial = 'SubstanceSourceMaterial',
  SubstanceSpecification = 'SubstanceSpecification',
  SupplyDelivery = 'SupplyDelivery',
  SupplyRequest = 'SupplyRequest',
  Task = 'Task',
  TerminologyCapabilities = 'TerminologyCapabilities',
  TestReport = 'TestReport',
  TestScript = 'TestScript',
  Timing = 'Timing',
  TriggerDefinition = 'TriggerDefinition',
  Type = 'Type',
  UsageContext = 'UsageContext',
  ValueSet = 'ValueSet',
  VerificationResult = 'VerificationResult',
  VisionPrescription = 'VisionPrescription',
  Base64Binary = 'base64Binary',
  Boolean = 'boolean',
  Canonical = 'canonical',
  Code = 'code',
  Date = 'date',
  DateTime = 'dateTime',
  Decimal = 'decimal',
  Id = 'id',
  Instant = 'instant',
  Integer = 'integer',
  Markdown = 'markdown',
  Oid = 'oid',
  PositiveInt = 'positiveInt',
  String = 'string',
  Time = 'time',
  UnsignedInt = 'unsignedInt',
  Uri = 'uri',
  Url = 'url',
  Uuid = 'uuid',
  Xhtml = 'xhtml'
}

export type AllergyIntolerance = DomainResourceInterface & ResourceInterface & {
  __typename?: 'AllergyIntolerance';
  BasicList?: Maybe<Array<Basic>>;
  ProvenanceList?: Maybe<Array<Provenance>>;
  asserter?: Maybe<Reference>;
  category?: Maybe<Array<AllergyIntoleranceCategory>>;
  clinicalStatus?: Maybe<CodeableConcept>;
  code?: Maybe<CodeableConcept>;
  contained?: Maybe<Array<Resource>>;
  criticality?: Maybe<AllergyIntoleranceCriticality>;
  encounter?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastOccurrence?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  onsetAge?: Maybe<Age>;
  onsetDateTime?: Maybe<Scalars['String']['output']>;
  onsetPeriod?: Maybe<Period>;
  onsetRange?: Maybe<Range>;
  onsetString?: Maybe<Scalars['String']['output']>;
  patient: Reference;
  reaction?: Maybe<Array<AllergyIntoleranceReaction>>;
  recordedDate?: Maybe<Scalars['String']['output']>;
  recorder?: Maybe<Reference>;
  resourceType: Scalars['String']['output'];
  text?: Maybe<Narrative>;
  type?: Maybe<AllergyIntoleranceType>;
  verificationStatus?: Maybe<CodeableConcept>;
};


export type AllergyIntoleranceBasicListArgs = {
  _reference: Scalars['String']['input'];
};


export type AllergyIntoleranceProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export enum AllergyIntoleranceCategory {
  Biologic = 'biologic',
  Environment = 'environment',
  Food = 'food',
  Medication = 'medication'
}

export type AllergyIntoleranceConnection = {
  __typename?: 'AllergyIntoleranceConnection';
  edges?: Maybe<Array<AllergyIntoleranceEdge>>;
  pageInfo: PageInfo;
};

export enum AllergyIntoleranceCriticality {
  High = 'high',
  Low = 'low',
  UnableToAssess = 'unable_to_assess'
}

export type AllergyIntoleranceEdge = {
  __typename?: 'AllergyIntoleranceEdge';
  cursor: Scalars['String']['output'];
  node: AllergyIntolerance;
};

export type AllergyIntoleranceFilterParams = {
  clinicalStatus?: InputMaybe<FilterComparatorStringSet>;
  code?: InputMaybe<FilterComparatorStringSet>;
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type AllergyIntoleranceReaction = BackboneElementInterface & ElementInterface & {
  __typename?: 'AllergyIntoleranceReaction';
  description?: Maybe<Scalars['String']['output']>;
  exposureRoute?: Maybe<CodeableConcept>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  manifestation: Array<CodeableConcept>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  onset?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<ReactionEventSeverity>;
  substance?: Maybe<CodeableConcept>;
};

export type AllergyIntoleranceSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export enum AllergyIntoleranceType {
  Allergy = 'allergy',
  Intolerance = 'intolerance'
}

export type Annotation = ElementInterface & {
  __typename?: 'Annotation';
  authorReference?: Maybe<Reference>;
  authorString?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  text: Scalars['String']['output'];
  time?: Maybe<Scalars['String']['output']>;
};

export type Appointment = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Appointment';
  ProvenanceList?: Maybe<Array<Provenance>>;
  appointmentType?: Maybe<CodeableConcept>;
  basedOn?: Maybe<Array<Reference>>;
  cancelationReason?: Maybe<CodeableConcept>;
  comment?: Maybe<Scalars['String']['output']>;
  contained?: Maybe<Array<Resource>>;
  created?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  minutesDuration?: Maybe<Scalars['Int']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  participant: Array<AppointmentParticipant>;
  patientInstruction?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  reasonReference?: Maybe<Array<Reference>>;
  requestedPeriod?: Maybe<Array<Period>>;
  resourceType: Scalars['String']['output'];
  serviceCategory?: Maybe<Array<CodeableConcept>>;
  serviceType?: Maybe<Array<CodeableConcept>>;
  slot?: Maybe<Array<Reference>>;
  specialty?: Maybe<Array<CodeableConcept>>;
  start?: Maybe<Scalars['String']['output']>;
  status: Appointmentstatus;
  supportingInformation?: Maybe<Array<Reference>>;
  text?: Maybe<Narrative>;
};


export type AppointmentProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type AppointmentConnection = {
  __typename?: 'AppointmentConnection';
  edges?: Maybe<Array<AppointmentEdge>>;
  pageInfo: PageInfo;
};

export type AppointmentEdge = {
  __typename?: 'AppointmentEdge';
  cursor: Scalars['String']['output'];
  node: Appointment;
};

export type AppointmentFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  status?: InputMaybe<FilterComparatorString>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type AppointmentParticipant = BackboneElementInterface & ElementInterface & {
  __typename?: 'AppointmentParticipant';
  actor?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  period?: Maybe<Period>;
  required?: Maybe<Participantrequired>;
  status: Participationstatus;
  type?: Maybe<Array<CodeableConcept>>;
};

export type AppointmentResponse = DomainResourceInterface & ResourceInterface & {
  __typename?: 'AppointmentResponse';
  actor?: Maybe<Reference>;
  appointment: Reference;
  comment?: Maybe<Scalars['String']['output']>;
  contained?: Maybe<Array<Resource>>;
  end?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  participantStatus: Participationstatus;
  participantType?: Maybe<Array<CodeableConcept>>;
  resourceType: Scalars['String']['output'];
  start?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Narrative>;
};

export type AppointmentSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export enum Appointmentstatus {
  Arrived = 'arrived',
  Booked = 'booked',
  Cancelled = 'cancelled',
  CheckedIn = 'checked_in',
  EnteredInError = 'entered_in_error',
  Fulfilled = 'fulfilled',
  Noshow = 'noshow',
  Pending = 'pending',
  Proposed = 'proposed',
  Waitlist = 'waitlist'
}

export type Attachment = ElementInterface & {
  __typename?: 'Attachment';
  contentType?: Maybe<Scalars['String']['output']>;
  creation?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  hash?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BackboneElementInterface = {
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type Basic = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Basic';
  author?: Maybe<Reference>;
  code: CodeableConcept;
  contained?: Maybe<Array<Resource>>;
  created?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  resourceType: Scalars['String']['output'];
  subject?: Maybe<Reference>;
  text?: Maybe<Narrative>;
};

export type BasicConnection = {
  __typename?: 'BasicConnection';
  edges?: Maybe<Array<BasicEdge>>;
  pageInfo: PageInfo;
};

export type BasicEdge = {
  __typename?: 'BasicEdge';
  cursor: Scalars['String']['output'];
  node: Basic;
};

export type BasicFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type BasicSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export type Binary = ResourceInterface & {
  __typename?: 'Binary';
  ProvenanceList?: Maybe<Array<Provenance>>;
  contentType: Scalars['String']['output'];
  data?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  resourceType: Scalars['String']['output'];
  securityContext?: Maybe<Reference>;
};


export type BinaryProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type BinaryConnection = {
  __typename?: 'BinaryConnection';
  edges?: Maybe<Array<BinaryEdge>>;
  pageInfo: PageInfo;
};

export type BinaryEdge = {
  __typename?: 'BinaryEdge';
  cursor: Scalars['String']['output'];
  node: Binary;
};

export type BinaryFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type BinarySortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export type CarePlan = DomainResourceInterface & ResourceInterface & {
  __typename?: 'CarePlan';
  activity?: Maybe<Array<CarePlanActivity>>;
  addresses?: Maybe<Array<Reference>>;
  author?: Maybe<Reference>;
  basedOn?: Maybe<Array<Reference>>;
  careTeam?: Maybe<Array<Reference>>;
  category?: Maybe<Array<CodeableConcept>>;
  contained?: Maybe<Array<Resource>>;
  contributor?: Maybe<Array<Reference>>;
  created?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  encounter?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  goal?: Maybe<Array<Reference>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  instantiatesCanonical?: Maybe<Array<Scalars['String']['output']>>;
  instantiatesUri?: Maybe<Array<Scalars['String']['output']>>;
  intent: CarePlanIntent;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  partOf?: Maybe<Array<Reference>>;
  period?: Maybe<Period>;
  replaces?: Maybe<Array<Reference>>;
  resourceType: Scalars['String']['output'];
  status: RequestStatus;
  subject: Reference;
  supportingInfo?: Maybe<Array<Reference>>;
  text?: Maybe<Narrative>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CarePlanActivity = BackboneElementInterface & ElementInterface & {
  __typename?: 'CarePlanActivity';
  detail?: Maybe<CarePlanActivityDetail>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  outcomeCodeableConcept?: Maybe<Array<CodeableConcept>>;
  outcomeReference?: Maybe<Array<Reference>>;
  progress?: Maybe<Array<Annotation>>;
  reference?: Maybe<Reference>;
};

export type CarePlanActivityDetail = BackboneElementInterface & ElementInterface & {
  __typename?: 'CarePlanActivityDetail';
  code?: Maybe<CodeableConcept>;
  dailyAmount?: Maybe<Quantity>;
  description?: Maybe<Scalars['String']['output']>;
  doNotPerform?: Maybe<Scalars['Boolean']['output']>;
  extension?: Maybe<Array<Extension>>;
  goal?: Maybe<Array<Reference>>;
  id?: Maybe<Scalars['ID']['output']>;
  instantiatesCanonical?: Maybe<Array<Scalars['String']['output']>>;
  instantiatesUri?: Maybe<Array<Scalars['String']['output']>>;
  kind?: Maybe<CarePlanActivityKind>;
  location?: Maybe<Reference>;
  modifierExtension?: Maybe<Array<Extension>>;
  performer?: Maybe<Array<Reference>>;
  productCodeableConcept?: Maybe<CodeableConcept>;
  productReference?: Maybe<Reference>;
  quantity?: Maybe<Quantity>;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  reasonReference?: Maybe<Array<Reference>>;
  scheduledPeriod?: Maybe<Period>;
  scheduledString?: Maybe<Scalars['String']['output']>;
  scheduledTiming?: Maybe<Timing>;
  status: CarePlanActivityStatus;
  statusReason?: Maybe<CodeableConcept>;
};

export enum CarePlanActivityKind {
  Appointment = 'Appointment',
  CommunicationRequest = 'CommunicationRequest',
  DeviceRequest = 'DeviceRequest',
  MedicationRequest = 'MedicationRequest',
  NutritionOrder = 'NutritionOrder',
  ServiceRequest = 'ServiceRequest',
  Task = 'Task',
  VisionPrescription = 'VisionPrescription'
}

export enum CarePlanActivityStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  EnteredInError = 'entered_in_error',
  InProgress = 'in_progress',
  NotStarted = 'not_started',
  OnHold = 'on_hold',
  Scheduled = 'scheduled',
  Stopped = 'stopped',
  Unknown = 'unknown'
}

export type CarePlanConnection = {
  __typename?: 'CarePlanConnection';
  edges?: Maybe<Array<CarePlanEdge>>;
  pageInfo: PageInfo;
};

export type CarePlanEdge = {
  __typename?: 'CarePlanEdge';
  cursor: Scalars['String']['output'];
  node: CarePlan;
};

export type CarePlanFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export enum CarePlanIntent {
  Option = 'option',
  Order = 'order',
  Plan = 'plan',
  Proposal = 'proposal'
}

export type CarePlanSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export type CareTeam = DomainResourceInterface & ResourceInterface & {
  __typename?: 'CareTeam';
  ProvenanceList?: Maybe<Array<Provenance>>;
  category?: Maybe<Array<CodeableConcept>>;
  contained?: Maybe<Array<Resource>>;
  encounter?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  managingOrganization?: Maybe<Array<Reference>>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Array<Annotation>>;
  participant?: Maybe<Array<CareTeamParticipant>>;
  period?: Maybe<Period>;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  reasonReference?: Maybe<Array<Reference>>;
  resourceType: Scalars['String']['output'];
  status?: Maybe<CareTeamStatus>;
  subject?: Maybe<Reference>;
  telecom?: Maybe<Array<ContactPoint>>;
  text?: Maybe<Narrative>;
};


export type CareTeamProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type CareTeamConnection = {
  __typename?: 'CareTeamConnection';
  edges?: Maybe<Array<CareTeamEdge>>;
  pageInfo: PageInfo;
};

export type CareTeamEdge = {
  __typename?: 'CareTeamEdge';
  cursor: Scalars['String']['output'];
  node: CareTeam;
};

export type CareTeamFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  status?: InputMaybe<FilterComparatorString>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type CareTeamParticipant = BackboneElementInterface & ElementInterface & {
  __typename?: 'CareTeamParticipant';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  member?: Maybe<Reference>;
  modifierExtension?: Maybe<Array<Extension>>;
  onBehalfOf?: Maybe<Reference>;
  period?: Maybe<Period>;
  role?: Maybe<Array<CodeableConcept>>;
};

export type CareTeamSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export enum CareTeamStatus {
  Active = 'active',
  EnteredInError = 'entered_in_error',
  Inactive = 'inactive',
  Proposed = 'proposed',
  Suspended = 'suspended'
}

export type Claim = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Claim';
  accident?: Maybe<ClaimAccident>;
  billablePeriod?: Maybe<Period>;
  careTeam?: Maybe<Array<ClaimCareTeam>>;
  contained?: Maybe<Array<Resource>>;
  created: Scalars['String']['output'];
  diagnosis?: Maybe<Array<ClaimDiagnosis>>;
  enterer?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  facility?: Maybe<Reference>;
  fundsReserve?: Maybe<CodeableConcept>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  insurance: Array<ClaimInsurance>;
  insurer?: Maybe<Reference>;
  item?: Maybe<Array<ClaimItem>>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  originalPrescription?: Maybe<Reference>;
  patient: Reference;
  payee?: Maybe<ClaimPayee>;
  prescription?: Maybe<Reference>;
  priority: CodeableConcept;
  procedure?: Maybe<Array<ClaimProcedure>>;
  provider: Reference;
  referral?: Maybe<Reference>;
  related?: Maybe<Array<ClaimRelated>>;
  resourceType: Scalars['String']['output'];
  status: FmStatus;
  subType?: Maybe<CodeableConcept>;
  supportingInfo?: Maybe<Array<ClaimSupportingInfo>>;
  text?: Maybe<Narrative>;
  total?: Maybe<Money>;
  type: CodeableConcept;
  use: ClaimUse;
};

export type ClaimAccident = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimAccident';
  date: Scalars['String']['output'];
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  locationAddress?: Maybe<Address>;
  locationReference?: Maybe<Reference>;
  modifierExtension?: Maybe<Array<Extension>>;
  type?: Maybe<CodeableConcept>;
};

export type ClaimCareTeam = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimCareTeam';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  provider: Reference;
  qualification?: Maybe<CodeableConcept>;
  responsible?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<CodeableConcept>;
  sequence: Scalars['Int']['output'];
};

export type ClaimConnection = {
  __typename?: 'ClaimConnection';
  edges?: Maybe<Array<ClaimEdge>>;
  pageInfo: PageInfo;
};

export type ClaimDiagnosis = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimDiagnosis';
  diagnosisCodeableConcept?: Maybe<CodeableConcept>;
  diagnosisReference?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  onAdmission?: Maybe<CodeableConcept>;
  packageCode?: Maybe<CodeableConcept>;
  sequence: Scalars['Int']['output'];
  type?: Maybe<Array<CodeableConcept>>;
};

export type ClaimEdge = {
  __typename?: 'ClaimEdge';
  cursor: Scalars['String']['output'];
  node: Claim;
};

export type ClaimFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type ClaimInsurance = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimInsurance';
  businessArrangement?: Maybe<Scalars['String']['output']>;
  claimResponse?: Maybe<Reference>;
  coverage: Reference;
  extension?: Maybe<Array<Extension>>;
  focal: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Identifier>;
  modifierExtension?: Maybe<Array<Extension>>;
  preAuthRef?: Maybe<Array<Scalars['String']['output']>>;
  sequence: Scalars['Int']['output'];
};

export type ClaimItem = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimItem';
  bodySite?: Maybe<CodeableConcept>;
  careTeamSequence?: Maybe<Array<Scalars['Int']['output']>>;
  category?: Maybe<CodeableConcept>;
  detail?: Maybe<Array<ClaimItemDetail>>;
  diagnosisSequence?: Maybe<Array<Scalars['Int']['output']>>;
  encounter?: Maybe<Array<Reference>>;
  extension?: Maybe<Array<Extension>>;
  factor?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  informationSequence?: Maybe<Array<Scalars['Int']['output']>>;
  locationAddress?: Maybe<Address>;
  locationCodeableConcept?: Maybe<CodeableConcept>;
  locationReference?: Maybe<Reference>;
  modifier?: Maybe<Array<CodeableConcept>>;
  modifierExtension?: Maybe<Array<Extension>>;
  net?: Maybe<Money>;
  procedureSequence?: Maybe<Array<Scalars['Int']['output']>>;
  productOrService: CodeableConcept;
  programCode?: Maybe<Array<CodeableConcept>>;
  quantity?: Maybe<Quantity>;
  revenue?: Maybe<CodeableConcept>;
  sequence: Scalars['Int']['output'];
  servicedDate?: Maybe<Scalars['String']['output']>;
  servicedPeriod?: Maybe<Period>;
  subSite?: Maybe<Array<CodeableConcept>>;
  udi?: Maybe<Array<Reference>>;
  unitPrice?: Maybe<Money>;
};

export type ClaimItemDetail = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimItemDetail';
  category?: Maybe<CodeableConcept>;
  extension?: Maybe<Array<Extension>>;
  factor?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  modifier?: Maybe<Array<CodeableConcept>>;
  modifierExtension?: Maybe<Array<Extension>>;
  net?: Maybe<Money>;
  productOrService: CodeableConcept;
  programCode?: Maybe<Array<CodeableConcept>>;
  quantity?: Maybe<Quantity>;
  revenue?: Maybe<CodeableConcept>;
  sequence: Scalars['Int']['output'];
  subDetail?: Maybe<Array<ClaimItemDetailSubDetail>>;
  udi?: Maybe<Array<Reference>>;
  unitPrice?: Maybe<Money>;
};

export type ClaimItemDetailSubDetail = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimItemDetailSubDetail';
  category?: Maybe<CodeableConcept>;
  extension?: Maybe<Array<Extension>>;
  factor?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  modifier?: Maybe<Array<CodeableConcept>>;
  modifierExtension?: Maybe<Array<Extension>>;
  net?: Maybe<Money>;
  productOrService: CodeableConcept;
  programCode?: Maybe<Array<CodeableConcept>>;
  quantity?: Maybe<Quantity>;
  revenue?: Maybe<CodeableConcept>;
  sequence: Scalars['Int']['output'];
  udi?: Maybe<Array<Reference>>;
  unitPrice?: Maybe<Money>;
};

export type ClaimPayee = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimPayee';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  party?: Maybe<Reference>;
  type: CodeableConcept;
};

export type ClaimProcedure = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimProcedure';
  date?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  procedureCodeableConcept?: Maybe<CodeableConcept>;
  procedureReference?: Maybe<Reference>;
  sequence: Scalars['Int']['output'];
  type?: Maybe<Array<CodeableConcept>>;
  udi?: Maybe<Array<Reference>>;
};

export type ClaimRelated = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimRelated';
  claim?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  reference?: Maybe<Identifier>;
  relationship?: Maybe<CodeableConcept>;
};

export type ClaimResponse = DomainResourceInterface & ResourceInterface & {
  __typename?: 'ClaimResponse';
  addItem?: Maybe<Array<ClaimResponseAddItem>>;
  adjudication?: Maybe<Array<ClaimResponseItemAdjudication>>;
  communicationRequest?: Maybe<Array<Reference>>;
  contained?: Maybe<Array<Resource>>;
  created: Scalars['String']['output'];
  disposition?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Array<ClaimResponseError>>;
  extension?: Maybe<Array<Extension>>;
  form?: Maybe<Attachment>;
  formCode?: Maybe<CodeableConcept>;
  fundsReserve?: Maybe<CodeableConcept>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  insurance?: Maybe<Array<ClaimResponseInsurance>>;
  insurer: Reference;
  item?: Maybe<Array<ClaimResponseItem>>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  outcome: RemittanceOutcome;
  patient: Reference;
  payeeType?: Maybe<CodeableConcept>;
  payment?: Maybe<ClaimResponsePayment>;
  preAuthPeriod?: Maybe<Period>;
  preAuthRef?: Maybe<Scalars['String']['output']>;
  processNote?: Maybe<Array<ClaimResponseProcessNote>>;
  request?: Maybe<Reference>;
  requestor?: Maybe<Reference>;
  resourceType: Scalars['String']['output'];
  status: FmStatus;
  subType?: Maybe<CodeableConcept>;
  text?: Maybe<Narrative>;
  total?: Maybe<Array<ClaimResponseTotal>>;
  type: CodeableConcept;
  use: ClaimUse;
};

export type ClaimResponseAddItem = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimResponseAddItem';
  adjudication: Array<ClaimResponseItemAdjudication>;
  bodySite?: Maybe<CodeableConcept>;
  detail?: Maybe<Array<ClaimResponseAddItemDetail>>;
  detailSequence?: Maybe<Array<Scalars['Int']['output']>>;
  extension?: Maybe<Array<Extension>>;
  factor?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  itemSequence?: Maybe<Array<Scalars['Int']['output']>>;
  locationAddress?: Maybe<Address>;
  locationCodeableConcept?: Maybe<CodeableConcept>;
  locationReference?: Maybe<Reference>;
  modifier?: Maybe<Array<CodeableConcept>>;
  modifierExtension?: Maybe<Array<Extension>>;
  net?: Maybe<Money>;
  noteNumber?: Maybe<Array<Scalars['Int']['output']>>;
  productOrService: CodeableConcept;
  programCode?: Maybe<Array<CodeableConcept>>;
  provider?: Maybe<Array<Reference>>;
  quantity?: Maybe<Quantity>;
  servicedDate?: Maybe<Scalars['String']['output']>;
  servicedPeriod?: Maybe<Period>;
  subSite?: Maybe<Array<CodeableConcept>>;
  subdetailSequence?: Maybe<Array<Scalars['Int']['output']>>;
  unitPrice?: Maybe<Money>;
};

export type ClaimResponseAddItemDetail = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimResponseAddItemDetail';
  adjudication: Array<ClaimResponseItemAdjudication>;
  extension?: Maybe<Array<Extension>>;
  factor?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  modifier?: Maybe<Array<CodeableConcept>>;
  modifierExtension?: Maybe<Array<Extension>>;
  net?: Maybe<Money>;
  noteNumber?: Maybe<Array<Scalars['Int']['output']>>;
  productOrService: CodeableConcept;
  quantity?: Maybe<Quantity>;
  subDetail?: Maybe<Array<ClaimResponseAddItemDetailSubDetail>>;
  unitPrice?: Maybe<Money>;
};

export type ClaimResponseAddItemDetailSubDetail = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimResponseAddItemDetailSubDetail';
  adjudication: Array<ClaimResponseItemAdjudication>;
  extension?: Maybe<Array<Extension>>;
  factor?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  modifier?: Maybe<Array<CodeableConcept>>;
  modifierExtension?: Maybe<Array<Extension>>;
  net?: Maybe<Money>;
  noteNumber?: Maybe<Array<Scalars['Int']['output']>>;
  productOrService: CodeableConcept;
  quantity?: Maybe<Quantity>;
  unitPrice?: Maybe<Money>;
};

export type ClaimResponseError = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimResponseError';
  code: CodeableConcept;
  detailSequence?: Maybe<Scalars['Int']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  itemSequence?: Maybe<Scalars['Int']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  subDetailSequence?: Maybe<Scalars['Int']['output']>;
};

export type ClaimResponseInsurance = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimResponseInsurance';
  businessArrangement?: Maybe<Scalars['String']['output']>;
  claimResponse?: Maybe<Reference>;
  coverage: Reference;
  extension?: Maybe<Array<Extension>>;
  focal: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  sequence: Scalars['Int']['output'];
};

export type ClaimResponseItem = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimResponseItem';
  adjudication: Array<ClaimResponseItemAdjudication>;
  detail?: Maybe<Array<ClaimResponseItemDetail>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  itemSequence: Scalars['Int']['output'];
  modifierExtension?: Maybe<Array<Extension>>;
  noteNumber?: Maybe<Array<Scalars['Int']['output']>>;
};

export type ClaimResponseItemAdjudication = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimResponseItemAdjudication';
  amount?: Maybe<Money>;
  category: CodeableConcept;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  reason?: Maybe<CodeableConcept>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ClaimResponseItemDetail = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimResponseItemDetail';
  adjudication: Array<ClaimResponseItemAdjudication>;
  detailSequence: Scalars['Int']['output'];
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  noteNumber?: Maybe<Array<Scalars['Int']['output']>>;
  subDetail?: Maybe<Array<ClaimResponseItemDetailSubDetail>>;
};

export type ClaimResponseItemDetailSubDetail = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimResponseItemDetailSubDetail';
  adjudication?: Maybe<Array<ClaimResponseItemAdjudication>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  noteNumber?: Maybe<Array<Scalars['Int']['output']>>;
  subDetailSequence: Scalars['Int']['output'];
};

export type ClaimResponsePayment = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimResponsePayment';
  adjustment?: Maybe<Money>;
  adjustmentReason?: Maybe<CodeableConcept>;
  amount: Money;
  date?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Identifier>;
  modifierExtension?: Maybe<Array<Extension>>;
  type: CodeableConcept;
};

export type ClaimResponseProcessNote = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimResponseProcessNote';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  language?: Maybe<CodeableConcept>;
  modifierExtension?: Maybe<Array<Extension>>;
  number?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
  type?: Maybe<NoteType>;
};

export type ClaimResponseTotal = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimResponseTotal';
  amount: Money;
  category: CodeableConcept;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type ClaimSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export type ClaimSupportingInfo = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClaimSupportingInfo';
  category: CodeableConcept;
  code?: Maybe<CodeableConcept>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  reason?: Maybe<CodeableConcept>;
  sequence: Scalars['Int']['output'];
  timingDate?: Maybe<Scalars['String']['output']>;
  timingPeriod?: Maybe<Period>;
  valueAttachment?: Maybe<Attachment>;
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  valueQuantity?: Maybe<Quantity>;
  valueReference?: Maybe<Reference>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export enum ClaimUse {
  Claim = 'claim',
  Preauthorization = 'preauthorization',
  Predetermination = 'predetermination'
}

export type ClinicalImpression = DomainResourceInterface & ResourceInterface & {
  __typename?: 'ClinicalImpression';
  assessor?: Maybe<Reference>;
  code?: Maybe<CodeableConcept>;
  contained?: Maybe<Array<Resource>>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveDateTime?: Maybe<Scalars['String']['output']>;
  effectivePeriod?: Maybe<Period>;
  encounter?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  finding?: Maybe<Array<ClinicalImpressionFinding>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  investigation?: Maybe<Array<ClinicalImpressionInvestigation>>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  previous?: Maybe<Reference>;
  problem?: Maybe<Array<Reference>>;
  prognosisCodeableConcept?: Maybe<Array<CodeableConcept>>;
  prognosisReference?: Maybe<Array<Reference>>;
  protocol?: Maybe<Array<Scalars['String']['output']>>;
  resourceType: Scalars['String']['output'];
  status: ClinicalimpressionStatus;
  statusReason?: Maybe<CodeableConcept>;
  subject: Reference;
  summary?: Maybe<Scalars['String']['output']>;
  supportingInfo?: Maybe<Array<Reference>>;
  text?: Maybe<Narrative>;
};

export type ClinicalImpressionFinding = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClinicalImpressionFinding';
  basis?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  itemCodeableConcept?: Maybe<CodeableConcept>;
  itemReference?: Maybe<Reference>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type ClinicalImpressionInvestigation = BackboneElementInterface & ElementInterface & {
  __typename?: 'ClinicalImpressionInvestigation';
  code: CodeableConcept;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  item?: Maybe<Array<Reference>>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export enum ClinicalimpressionStatus {
  Completed = 'completed',
  EnteredInError = 'entered_in_error',
  InProgress = 'in_progress'
}

export type CodeableConcept = ElementInterface & {
  __typename?: 'CodeableConcept';
  coding?: Maybe<Array<Coding>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Coding = ElementInterface & {
  __typename?: 'Coding';
  code?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  system?: Maybe<Scalars['String']['output']>;
  userSelected?: Maybe<Scalars['Boolean']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type CommunicationRequest = DomainResourceInterface & ResourceInterface & {
  __typename?: 'CommunicationRequest';
  about?: Maybe<Array<Reference>>;
  authoredOn?: Maybe<Scalars['String']['output']>;
  basedOn?: Maybe<Array<Reference>>;
  category?: Maybe<Array<CodeableConcept>>;
  contained?: Maybe<Array<Resource>>;
  doNotPerform?: Maybe<Scalars['Boolean']['output']>;
  encounter?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  groupIdentifier?: Maybe<Identifier>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Array<CodeableConcept>>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  occurrenceDateTime?: Maybe<Scalars['String']['output']>;
  occurrencePeriod?: Maybe<Period>;
  payload?: Maybe<Array<CommunicationRequestPayload>>;
  priority?: Maybe<RequestPriority>;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  reasonReference?: Maybe<Array<Reference>>;
  recipient?: Maybe<Array<Reference>>;
  replaces?: Maybe<Array<Reference>>;
  requester?: Maybe<Reference>;
  resourceType: Scalars['String']['output'];
  sender?: Maybe<Reference>;
  status: RequestStatus;
  statusReason?: Maybe<CodeableConcept>;
  subject?: Maybe<Reference>;
  text?: Maybe<Narrative>;
};

export type CommunicationRequestPayload = BackboneElementInterface & ElementInterface & {
  __typename?: 'CommunicationRequestPayload';
  contentAttachment?: Maybe<Attachment>;
  contentReference?: Maybe<Reference>;
  contentString?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type Composition = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Composition';
  attester?: Maybe<Array<CompositionAttester>>;
  author: Array<Reference>;
  category?: Maybe<Array<CodeableConcept>>;
  confidentiality?: Maybe<Scalars['String']['output']>;
  contained?: Maybe<Array<Resource>>;
  custodian?: Maybe<Reference>;
  date: Scalars['String']['output'];
  encounter?: Maybe<Reference>;
  event?: Maybe<Array<CompositionEvent>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Identifier>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  relatesTo?: Maybe<Array<CompositionRelatesTo>>;
  resourceType: Scalars['String']['output'];
  section?: Maybe<Array<CompositionSection>>;
  status: CompositionStatus;
  subject?: Maybe<Reference>;
  text?: Maybe<Narrative>;
  title: Scalars['String']['output'];
  type: CodeableConcept;
};

export enum CompositionAttestationMode {
  Legal = 'legal',
  Official = 'official',
  Personal = 'personal',
  Professional = 'professional'
}

export type CompositionAttester = BackboneElementInterface & ElementInterface & {
  __typename?: 'CompositionAttester';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  mode: CompositionAttestationMode;
  modifierExtension?: Maybe<Array<Extension>>;
  party?: Maybe<Reference>;
  time?: Maybe<Scalars['String']['output']>;
};

export type CompositionEvent = BackboneElementInterface & ElementInterface & {
  __typename?: 'CompositionEvent';
  code?: Maybe<Array<CodeableConcept>>;
  detail?: Maybe<Array<Reference>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  period?: Maybe<Period>;
};

export type CompositionRelatesTo = BackboneElementInterface & ElementInterface & {
  __typename?: 'CompositionRelatesTo';
  code: DocumentRelationshipType;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  targetIdentifier?: Maybe<Identifier>;
  targetReference?: Maybe<Reference>;
};

export type CompositionSection = BackboneElementInterface & ElementInterface & {
  __typename?: 'CompositionSection';
  author?: Maybe<Array<Reference>>;
  code?: Maybe<CodeableConcept>;
  emptyReason?: Maybe<CodeableConcept>;
  entry?: Maybe<Array<Reference>>;
  extension?: Maybe<Array<Extension>>;
  focus?: Maybe<Reference>;
  id?: Maybe<Scalars['ID']['output']>;
  mode?: Maybe<ListMode>;
  modifierExtension?: Maybe<Array<Extension>>;
  orderedBy?: Maybe<CodeableConcept>;
  section?: Maybe<Array<CompositionSection>>;
  text?: Maybe<Narrative>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum CompositionStatus {
  Amended = 'amended',
  EnteredInError = 'entered_in_error',
  Final = 'final',
  Preliminary = 'preliminary'
}

export type Condition = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Condition';
  BasicList?: Maybe<Array<Basic>>;
  ProvenanceList?: Maybe<Array<Provenance>>;
  abatementAge?: Maybe<Age>;
  abatementDateTime?: Maybe<Scalars['String']['output']>;
  abatementPeriod?: Maybe<Period>;
  abatementRange?: Maybe<Range>;
  abatementString?: Maybe<Scalars['String']['output']>;
  asserter?: Maybe<Reference>;
  bodySite?: Maybe<Array<CodeableConcept>>;
  category?: Maybe<Array<CodeableConcept>>;
  clinicalStatus?: Maybe<CodeableConcept>;
  code?: Maybe<CodeableConcept>;
  contained?: Maybe<Array<Resource>>;
  encounter?: Maybe<Reference>;
  evidence?: Maybe<Array<ConditionEvidence>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  onsetAge?: Maybe<Age>;
  onsetDateTime?: Maybe<Scalars['String']['output']>;
  onsetPeriod?: Maybe<Period>;
  onsetRange?: Maybe<Range>;
  onsetString?: Maybe<Scalars['String']['output']>;
  recordedDate?: Maybe<Scalars['String']['output']>;
  recorder?: Maybe<Reference>;
  resourceType: Scalars['String']['output'];
  severity?: Maybe<CodeableConcept>;
  stage?: Maybe<Array<ConditionStage>>;
  subject: Reference;
  text?: Maybe<Narrative>;
  verificationStatus?: Maybe<CodeableConcept>;
};


export type ConditionBasicListArgs = {
  _reference: Scalars['String']['input'];
};


export type ConditionProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type ConditionConnection = {
  __typename?: 'ConditionConnection';
  edges?: Maybe<Array<ConditionEdge>>;
  pageInfo: PageInfo;
};

export type ConditionEdge = {
  __typename?: 'ConditionEdge';
  cursor: Scalars['String']['output'];
  node: Condition;
};

export type ConditionEvidence = BackboneElementInterface & ElementInterface & {
  __typename?: 'ConditionEvidence';
  code?: Maybe<Array<CodeableConcept>>;
  detail?: Maybe<Array<Reference>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type ConditionFilterParams = {
  clinicalStatus?: InputMaybe<FilterComparatorStringSet>;
  code?: InputMaybe<FilterComparatorStringSet>;
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type ConditionSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export type ConditionStage = BackboneElementInterface & ElementInterface & {
  __typename?: 'ConditionStage';
  assessment?: Maybe<Array<Reference>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  summary?: Maybe<CodeableConcept>;
  type?: Maybe<CodeableConcept>;
};

export type Consent = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Consent';
  ProvenanceList?: Maybe<Array<Provenance>>;
  category: Array<CodeableConcept>;
  contained?: Maybe<Array<Resource>>;
  dateTime?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  organization?: Maybe<Array<Reference>>;
  patient?: Maybe<Reference>;
  performer?: Maybe<Array<Reference>>;
  policy?: Maybe<Array<ConsentPolicy>>;
  policyRule?: Maybe<CodeableConcept>;
  provision?: Maybe<ConsentProvision>;
  resourceType: Scalars['String']['output'];
  scope: CodeableConcept;
  sourceAttachment?: Maybe<Attachment>;
  sourceReference?: Maybe<Reference>;
  status: ConsentStateCodes;
  text?: Maybe<Narrative>;
  verification?: Maybe<Array<ConsentVerification>>;
};


export type ConsentProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type ConsentConnection = {
  __typename?: 'ConsentConnection';
  edges?: Maybe<Array<ConsentEdge>>;
  pageInfo: PageInfo;
};

export enum ConsentDataMeaning {
  Authoredby = 'authoredby',
  Dependents = 'dependents',
  Instance = 'instance',
  Related = 'related'
}

export type ConsentEdge = {
  __typename?: 'ConsentEdge';
  cursor: Scalars['String']['output'];
  node: Consent;
};

export type ConsentFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type ConsentPolicy = BackboneElementInterface & ElementInterface & {
  __typename?: 'ConsentPolicy';
  authority?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type ConsentProvision = BackboneElementInterface & ElementInterface & {
  __typename?: 'ConsentProvision';
  action?: Maybe<Array<CodeableConcept>>;
  actor?: Maybe<Array<ConsentProvisionActor>>;
  class?: Maybe<Array<Coding>>;
  code?: Maybe<Array<CodeableConcept>>;
  data?: Maybe<Array<ConsentProvisionData>>;
  dataPeriod?: Maybe<Period>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  period?: Maybe<Period>;
  provision?: Maybe<Array<ConsentProvision>>;
  purpose?: Maybe<Array<Coding>>;
  securityLabel?: Maybe<Array<Coding>>;
  type?: Maybe<ConsentProvisionType>;
};

export type ConsentProvisionActor = BackboneElementInterface & ElementInterface & {
  __typename?: 'ConsentProvisionActor';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  reference: Reference;
  role: CodeableConcept;
};

export type ConsentProvisionData = BackboneElementInterface & ElementInterface & {
  __typename?: 'ConsentProvisionData';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  meaning: ConsentDataMeaning;
  modifierExtension?: Maybe<Array<Extension>>;
  reference: Reference;
};

export enum ConsentProvisionType {
  Deny = 'deny',
  Permit = 'permit'
}

export type ConsentSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export enum ConsentStateCodes {
  Active = 'active',
  Draft = 'draft',
  EnteredInError = 'entered_in_error',
  Inactive = 'inactive',
  Proposed = 'proposed',
  Rejected = 'rejected'
}

export type ConsentVerification = BackboneElementInterface & ElementInterface & {
  __typename?: 'ConsentVerification';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  verificationDate?: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
  verifiedWith?: Maybe<Reference>;
};

export type ContactDetail = ElementInterface & {
  __typename?: 'ContactDetail';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  telecom?: Maybe<Array<ContactPoint>>;
};

export type ContactPoint = ElementInterface & {
  __typename?: 'ContactPoint';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  period?: Maybe<Period>;
  rank?: Maybe<Scalars['Int']['output']>;
  system?: Maybe<ContactPointSystem>;
  use?: Maybe<ContactPointUse>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum ContactPointSystem {
  Email = 'email',
  Fax = 'fax',
  Other = 'other',
  Pager = 'pager',
  Phone = 'phone',
  Sms = 'sms',
  Url = 'url'
}

export enum ContactPointUse {
  Home = 'home',
  Mobile = 'mobile',
  Old = 'old',
  Temp = 'temp',
  Work = 'work'
}

export type Contract = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Contract';
  alias?: Maybe<Array<Scalars['String']['output']>>;
  applies?: Maybe<Period>;
  author?: Maybe<Reference>;
  authority?: Maybe<Array<Reference>>;
  contained?: Maybe<Array<Resource>>;
  contentDefinition?: Maybe<ContractContentDefinition>;
  contentDerivative?: Maybe<CodeableConcept>;
  domain?: Maybe<Array<Reference>>;
  expirationType?: Maybe<CodeableConcept>;
  extension?: Maybe<Array<Extension>>;
  friendly?: Maybe<Array<ContractFriendly>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  instantiatesCanonical?: Maybe<Reference>;
  instantiatesUri?: Maybe<Scalars['String']['output']>;
  issued?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  legal?: Maybe<Array<ContractLegal>>;
  legalState?: Maybe<CodeableConcept>;
  legallyBindingAttachment?: Maybe<Attachment>;
  legallyBindingReference?: Maybe<Reference>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<Scalars['String']['output']>;
  relevantHistory?: Maybe<Array<Reference>>;
  resourceType: Scalars['String']['output'];
  rule?: Maybe<Array<ContractRule>>;
  scope?: Maybe<CodeableConcept>;
  signer?: Maybe<Array<ContractSigner>>;
  site?: Maybe<Array<Reference>>;
  status?: Maybe<ContractStatus>;
  subType?: Maybe<Array<CodeableConcept>>;
  subject?: Maybe<Array<Reference>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  supportingInfo?: Maybe<Array<Reference>>;
  term?: Maybe<Array<ContractTerm>>;
  text?: Maybe<Narrative>;
  title?: Maybe<Scalars['String']['output']>;
  topicCodeableConcept?: Maybe<CodeableConcept>;
  topicReference?: Maybe<Reference>;
  type?: Maybe<CodeableConcept>;
  url?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type ContractContentDefinition = BackboneElementInterface & ElementInterface & {
  __typename?: 'ContractContentDefinition';
  copyright?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  publicationDate?: Maybe<Scalars['String']['output']>;
  publicationStatus: ContractPublicationstatus;
  publisher?: Maybe<Reference>;
  subType?: Maybe<CodeableConcept>;
  type: CodeableConcept;
};

export type ContractFriendly = BackboneElementInterface & ElementInterface & {
  __typename?: 'ContractFriendly';
  contentAttachment?: Maybe<Attachment>;
  contentReference?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type ContractLegal = BackboneElementInterface & ElementInterface & {
  __typename?: 'ContractLegal';
  contentAttachment?: Maybe<Attachment>;
  contentReference?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export enum ContractPublicationstatus {
  Amended = 'amended',
  Appended = 'appended',
  Cancelled = 'cancelled',
  Disputed = 'disputed',
  EnteredInError = 'entered_in_error',
  Executable = 'executable',
  Executed = 'executed',
  Negotiable = 'negotiable',
  Offered = 'offered',
  Policy = 'policy',
  Rejected = 'rejected',
  Renewed = 'renewed',
  Resolved = 'resolved',
  Revoked = 'revoked',
  Terminated = 'terminated'
}

export type ContractRule = BackboneElementInterface & ElementInterface & {
  __typename?: 'ContractRule';
  contentAttachment?: Maybe<Attachment>;
  contentReference?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type ContractSigner = BackboneElementInterface & ElementInterface & {
  __typename?: 'ContractSigner';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  party: Reference;
  signature: Array<Signature>;
  type: Coding;
};

export enum ContractStatus {
  Amended = 'amended',
  Appended = 'appended',
  Cancelled = 'cancelled',
  Disputed = 'disputed',
  EnteredInError = 'entered_in_error',
  Executable = 'executable',
  Executed = 'executed',
  Negotiable = 'negotiable',
  Offered = 'offered',
  Policy = 'policy',
  Rejected = 'rejected',
  Renewed = 'renewed',
  Resolved = 'resolved',
  Revoked = 'revoked',
  Terminated = 'terminated'
}

export type ContractTerm = BackboneElementInterface & ElementInterface & {
  __typename?: 'ContractTerm';
  action?: Maybe<Array<ContractTermAction>>;
  applies?: Maybe<Period>;
  asset?: Maybe<Array<ContractTermAsset>>;
  extension?: Maybe<Array<Extension>>;
  group?: Maybe<Array<ContractTerm>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Identifier>;
  issued?: Maybe<Scalars['String']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  offer: ContractTermOffer;
  securityLabel?: Maybe<Array<ContractTermSecurityLabel>>;
  subType?: Maybe<CodeableConcept>;
  text?: Maybe<Scalars['String']['output']>;
  topicCodeableConcept?: Maybe<CodeableConcept>;
  topicReference?: Maybe<Reference>;
  type?: Maybe<CodeableConcept>;
};

export type ContractTermAction = BackboneElementInterface & ElementInterface & {
  __typename?: 'ContractTermAction';
  context?: Maybe<Reference>;
  contextLinkId?: Maybe<Array<Scalars['String']['output']>>;
  doNotPerform?: Maybe<Scalars['Boolean']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  intent: CodeableConcept;
  linkId?: Maybe<Array<Scalars['String']['output']>>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  occurrenceDateTime?: Maybe<Scalars['String']['output']>;
  occurrencePeriod?: Maybe<Period>;
  occurrenceTiming?: Maybe<Timing>;
  performer?: Maybe<Reference>;
  performerLinkId?: Maybe<Array<Scalars['String']['output']>>;
  performerRole?: Maybe<CodeableConcept>;
  performerType?: Maybe<Array<CodeableConcept>>;
  reason?: Maybe<Array<Scalars['String']['output']>>;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  reasonLinkId?: Maybe<Array<Scalars['String']['output']>>;
  reasonReference?: Maybe<Array<Reference>>;
  requester?: Maybe<Array<Reference>>;
  requesterLinkId?: Maybe<Array<Scalars['String']['output']>>;
  securityLabelNumber?: Maybe<Array<Scalars['Int']['output']>>;
  status: CodeableConcept;
  subject?: Maybe<Array<ContractTermActionSubject>>;
  type: CodeableConcept;
};

export type ContractTermActionSubject = BackboneElementInterface & ElementInterface & {
  __typename?: 'ContractTermActionSubject';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  reference: Array<Reference>;
  role?: Maybe<CodeableConcept>;
};

export type ContractTermAsset = BackboneElementInterface & ElementInterface & {
  __typename?: 'ContractTermAsset';
  answer?: Maybe<Array<ContractTermOfferAnswer>>;
  condition?: Maybe<Scalars['String']['output']>;
  context?: Maybe<Array<ContractTermAssetContext>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  linkId?: Maybe<Array<Scalars['String']['output']>>;
  modifierExtension?: Maybe<Array<Extension>>;
  period?: Maybe<Array<Period>>;
  periodType?: Maybe<Array<CodeableConcept>>;
  relationship?: Maybe<Coding>;
  scope?: Maybe<CodeableConcept>;
  securityLabelNumber?: Maybe<Array<Scalars['Int']['output']>>;
  subtype?: Maybe<Array<CodeableConcept>>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Array<CodeableConcept>>;
  typeReference?: Maybe<Array<Reference>>;
  usePeriod?: Maybe<Array<Period>>;
  valuedItem?: Maybe<Array<ContractTermAssetValuedItem>>;
};

export type ContractTermAssetContext = BackboneElementInterface & ElementInterface & {
  __typename?: 'ContractTermAssetContext';
  code?: Maybe<Array<CodeableConcept>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  reference?: Maybe<Reference>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ContractTermAssetValuedItem = BackboneElementInterface & ElementInterface & {
  __typename?: 'ContractTermAssetValuedItem';
  effectiveTime?: Maybe<Scalars['String']['output']>;
  entityCodeableConcept?: Maybe<CodeableConcept>;
  entityReference?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  factor?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Identifier>;
  linkId?: Maybe<Array<Scalars['String']['output']>>;
  modifierExtension?: Maybe<Array<Extension>>;
  net?: Maybe<Money>;
  payment?: Maybe<Scalars['String']['output']>;
  paymentDate?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Quantity>;
  recipient?: Maybe<Reference>;
  responsible?: Maybe<Reference>;
  securityLabelNumber?: Maybe<Array<Scalars['Int']['output']>>;
  unitPrice?: Maybe<Money>;
};

export type ContractTermOffer = BackboneElementInterface & ElementInterface & {
  __typename?: 'ContractTermOffer';
  answer?: Maybe<Array<ContractTermOfferAnswer>>;
  decision?: Maybe<CodeableConcept>;
  decisionMode?: Maybe<Array<CodeableConcept>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  linkId?: Maybe<Array<Scalars['String']['output']>>;
  modifierExtension?: Maybe<Array<Extension>>;
  party?: Maybe<Array<ContractTermOfferParty>>;
  securityLabelNumber?: Maybe<Array<Scalars['Int']['output']>>;
  text?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Reference>;
  type?: Maybe<CodeableConcept>;
};

export type ContractTermOfferAnswer = BackboneElementInterface & ElementInterface & {
  __typename?: 'ContractTermOfferAnswer';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  valueAttachment?: Maybe<Attachment>;
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  valueCoding?: Maybe<Coding>;
  valueDate?: Maybe<Scalars['String']['output']>;
  valueDateTime?: Maybe<Scalars['String']['output']>;
  valueDecimal?: Maybe<Scalars['Float']['output']>;
  valueInteger?: Maybe<Scalars['Int']['output']>;
  valueQuantity?: Maybe<Quantity>;
  valueReference?: Maybe<Reference>;
  valueString?: Maybe<Scalars['String']['output']>;
  valueTime?: Maybe<Scalars['String']['output']>;
  valueUri?: Maybe<Scalars['String']['output']>;
};

export type ContractTermOfferParty = BackboneElementInterface & ElementInterface & {
  __typename?: 'ContractTermOfferParty';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  reference: Array<Reference>;
  role: CodeableConcept;
};

export type ContractTermSecurityLabel = BackboneElementInterface & ElementInterface & {
  __typename?: 'ContractTermSecurityLabel';
  category?: Maybe<Array<Coding>>;
  classification: Coding;
  control?: Maybe<Array<Coding>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  number?: Maybe<Array<Scalars['Int']['output']>>;
};

export type Contributor = ElementInterface & {
  __typename?: 'Contributor';
  contact?: Maybe<Array<ContactDetail>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  type: ContributorType;
};

export enum ContributorType {
  Author = 'author',
  Editor = 'editor',
  Endorser = 'endorser',
  Reviewer = 'reviewer'
}

export type Count = ElementInterface & QuantityInterface & {
  __typename?: 'Count';
  code?: Maybe<Scalars['String']['output']>;
  comparator?: Maybe<QuantityComparator>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  system?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type Coverage = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Coverage';
  ProvenanceList?: Maybe<Array<Provenance>>;
  beneficiary: Reference;
  class?: Maybe<Array<CoverageClass>>;
  contained?: Maybe<Array<Resource>>;
  contract?: Maybe<Array<Reference>>;
  costToBeneficiary?: Maybe<Array<CoverageCostToBeneficiary>>;
  dependent?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  network?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  payor: Array<Reference>;
  period?: Maybe<Period>;
  policyHolder?: Maybe<Reference>;
  relationship?: Maybe<CodeableConcept>;
  resourceType: Scalars['String']['output'];
  status: FmStatus;
  subrogation?: Maybe<Scalars['Boolean']['output']>;
  subscriber?: Maybe<Reference>;
  subscriberId?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Narrative>;
  type?: Maybe<CodeableConcept>;
};


export type CoverageProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type CoverageClass = BackboneElementInterface & ElementInterface & {
  __typename?: 'CoverageClass';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<Scalars['String']['output']>;
  type: CodeableConcept;
  value: Scalars['String']['output'];
};

export type CoverageConnection = {
  __typename?: 'CoverageConnection';
  edges?: Maybe<Array<CoverageEdge>>;
  pageInfo: PageInfo;
};

export type CoverageCostToBeneficiary = BackboneElementInterface & ElementInterface & {
  __typename?: 'CoverageCostToBeneficiary';
  exception?: Maybe<Array<CoverageCostToBeneficiaryException>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  type?: Maybe<CodeableConcept>;
  valueMoney?: Maybe<Money>;
  valueQuantity?: Maybe<Quantity>;
};

export type CoverageCostToBeneficiaryException = BackboneElementInterface & ElementInterface & {
  __typename?: 'CoverageCostToBeneficiaryException';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  period?: Maybe<Period>;
  type: CodeableConcept;
};

export type CoverageEdge = {
  __typename?: 'CoverageEdge';
  cursor: Scalars['String']['output'];
  node: Coverage;
};

export type CoverageEligibilityRequest = DomainResourceInterface & ResourceInterface & {
  __typename?: 'CoverageEligibilityRequest';
  contained?: Maybe<Array<Resource>>;
  created: Scalars['String']['output'];
  enterer?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  facility?: Maybe<Reference>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  insurance?: Maybe<Array<CoverageEligibilityRequestInsurance>>;
  insurer: Reference;
  item?: Maybe<Array<CoverageEligibilityRequestItem>>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  patient: Reference;
  priority?: Maybe<CodeableConcept>;
  provider?: Maybe<Reference>;
  purpose: Array<EligibilityrequestPurpose>;
  resourceType: Scalars['String']['output'];
  servicedDate?: Maybe<Scalars['String']['output']>;
  servicedPeriod?: Maybe<Period>;
  status: FmStatus;
  supportingInfo?: Maybe<Array<CoverageEligibilityRequestSupportingInfo>>;
  text?: Maybe<Narrative>;
};

export type CoverageEligibilityRequestConnection = {
  __typename?: 'CoverageEligibilityRequestConnection';
  edges?: Maybe<Array<CoverageEligibilityRequestEdge>>;
  pageInfo: PageInfo;
};

export type CoverageEligibilityRequestEdge = {
  __typename?: 'CoverageEligibilityRequestEdge';
  cursor: Scalars['String']['output'];
  node: CoverageEligibilityRequest;
};

export type CoverageEligibilityRequestFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type CoverageEligibilityRequestInsurance = BackboneElementInterface & ElementInterface & {
  __typename?: 'CoverageEligibilityRequestInsurance';
  businessArrangement?: Maybe<Scalars['String']['output']>;
  coverage: Reference;
  extension?: Maybe<Array<Extension>>;
  focal?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type CoverageEligibilityRequestItem = BackboneElementInterface & ElementInterface & {
  __typename?: 'CoverageEligibilityRequestItem';
  category?: Maybe<CodeableConcept>;
  detail?: Maybe<Array<Reference>>;
  diagnosis?: Maybe<Array<CoverageEligibilityRequestItemDiagnosis>>;
  extension?: Maybe<Array<Extension>>;
  facility?: Maybe<Reference>;
  id?: Maybe<Scalars['ID']['output']>;
  modifier?: Maybe<Array<CodeableConcept>>;
  modifierExtension?: Maybe<Array<Extension>>;
  productOrService?: Maybe<CodeableConcept>;
  provider?: Maybe<Reference>;
  quantity?: Maybe<Quantity>;
  supportingInfoSequence?: Maybe<Array<Scalars['Int']['output']>>;
  unitPrice?: Maybe<Money>;
};

export type CoverageEligibilityRequestItemDiagnosis = BackboneElementInterface & ElementInterface & {
  __typename?: 'CoverageEligibilityRequestItemDiagnosis';
  diagnosisCodeableConcept?: Maybe<CodeableConcept>;
  diagnosisReference?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type CoverageEligibilityRequestSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export type CoverageEligibilityRequestSupportingInfo = BackboneElementInterface & ElementInterface & {
  __typename?: 'CoverageEligibilityRequestSupportingInfo';
  appliesToAll?: Maybe<Scalars['Boolean']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  information: Reference;
  modifierExtension?: Maybe<Array<Extension>>;
  sequence: Scalars['Int']['output'];
};

export type CoverageFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type CoverageSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export type DataRequirement = ElementInterface & {
  __typename?: 'DataRequirement';
  codeFilter?: Maybe<Array<DataRequirementCodeFilter>>;
  dateFilter?: Maybe<Array<DataRequirementDateFilter>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  mustSupport?: Maybe<Array<Scalars['String']['output']>>;
  profile?: Maybe<Array<Scalars['String']['output']>>;
  sort?: Maybe<Array<DataRequirementSort>>;
  subjectCodeableConcept?: Maybe<CodeableConcept>;
  subjectReference?: Maybe<Reference>;
  type: AllTypes;
};

export type DataRequirementCodeFilter = ElementInterface & {
  __typename?: 'DataRequirementCodeFilter';
  code?: Maybe<Array<Coding>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  searchParam?: Maybe<Scalars['String']['output']>;
  valueSet?: Maybe<Scalars['String']['output']>;
};

export type DataRequirementDateFilter = ElementInterface & {
  __typename?: 'DataRequirementDateFilter';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  searchParam?: Maybe<Scalars['String']['output']>;
  valueDateTime?: Maybe<Scalars['String']['output']>;
  valueDuration?: Maybe<Duration>;
  valuePeriod?: Maybe<Period>;
};

export type DataRequirementSort = ElementInterface & {
  __typename?: 'DataRequirementSort';
  direction: SortDirection;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  path: Scalars['String']['output'];
};

export enum DaysOfWeek {
  Fri = 'fri',
  Mon = 'mon',
  Sat = 'sat',
  Sun = 'sun',
  Thu = 'thu',
  Tue = 'tue',
  Wed = 'wed'
}

export type DetectedIssue = DomainResourceInterface & ResourceInterface & {
  __typename?: 'DetectedIssue';
  author?: Maybe<Reference>;
  code?: Maybe<CodeableConcept>;
  contained?: Maybe<Array<Resource>>;
  detail?: Maybe<Scalars['String']['output']>;
  evidence?: Maybe<Array<DetectedIssueEvidence>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifiedDateTime?: Maybe<Scalars['String']['output']>;
  identifiedPeriod?: Maybe<Period>;
  identifier?: Maybe<Array<Identifier>>;
  implicated?: Maybe<Array<Reference>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  mitigation?: Maybe<Array<DetectedIssueMitigation>>;
  modifierExtension?: Maybe<Array<Extension>>;
  patient?: Maybe<Reference>;
  reference?: Maybe<Scalars['String']['output']>;
  resourceType: Scalars['String']['output'];
  severity?: Maybe<DetectedissueSeverity>;
  status: ObservationStatus;
  text?: Maybe<Narrative>;
};

export type DetectedIssueConnection = {
  __typename?: 'DetectedIssueConnection';
  edges?: Maybe<Array<DetectedIssueEdge>>;
  pageInfo: PageInfo;
};

export type DetectedIssueEdge = {
  __typename?: 'DetectedIssueEdge';
  cursor: Scalars['String']['output'];
  node: DetectedIssue;
};

export type DetectedIssueEvidence = BackboneElementInterface & ElementInterface & {
  __typename?: 'DetectedIssueEvidence';
  code?: Maybe<Array<CodeableConcept>>;
  detail?: Maybe<Array<Reference>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type DetectedIssueFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type DetectedIssueMitigation = BackboneElementInterface & ElementInterface & {
  __typename?: 'DetectedIssueMitigation';
  action: CodeableConcept;
  author?: Maybe<Reference>;
  date?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type DetectedIssueSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export enum DetectedissueSeverity {
  High = 'high',
  Low = 'low',
  Moderate = 'moderate'
}

export type Device = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Device';
  ProvenanceList?: Maybe<Array<Provenance>>;
  contact?: Maybe<Array<ContactPoint>>;
  contained?: Maybe<Array<Resource>>;
  definition?: Maybe<Reference>;
  deviceName?: Maybe<Array<DeviceDeviceName>>;
  distinctIdentifier?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Reference>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  manufactureDate?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modelNumber?: Maybe<Scalars['String']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  owner?: Maybe<Reference>;
  parent?: Maybe<Reference>;
  partNumber?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Reference>;
  property?: Maybe<Array<DeviceProperty>>;
  resourceType: Scalars['String']['output'];
  safety?: Maybe<Array<CodeableConcept>>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  specialization?: Maybe<Array<DeviceSpecialization>>;
  status?: Maybe<DeviceStatus>;
  statusReason?: Maybe<Array<CodeableConcept>>;
  text?: Maybe<Narrative>;
  type?: Maybe<CodeableConcept>;
  udiCarrier?: Maybe<Array<DeviceUdiCarrier>>;
  url?: Maybe<Scalars['String']['output']>;
};


export type DeviceProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type DeviceConnection = {
  __typename?: 'DeviceConnection';
  edges?: Maybe<Array<DeviceEdge>>;
  pageInfo: PageInfo;
};

export type DeviceDefinition = DomainResourceInterface & ResourceInterface & {
  __typename?: 'DeviceDefinition';
  capability?: Maybe<Array<DeviceDefinitionCapability>>;
  contact?: Maybe<Array<ContactPoint>>;
  contained?: Maybe<Array<Resource>>;
  deviceName?: Maybe<Array<DeviceDefinitionDeviceName>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Array<CodeableConcept>>;
  manufacturerReference?: Maybe<Reference>;
  manufacturerString?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Array<DeviceDefinitionMaterial>>;
  meta?: Maybe<Meta>;
  modelNumber?: Maybe<Scalars['String']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  onlineInformation?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Reference>;
  parentDevice?: Maybe<Reference>;
  physicalCharacteristics?: Maybe<ProdCharacteristic>;
  property?: Maybe<Array<DeviceDefinitionProperty>>;
  quantity?: Maybe<Quantity>;
  resourceType: Scalars['String']['output'];
  safety?: Maybe<Array<CodeableConcept>>;
  shelfLifeStorage?: Maybe<Array<ProductShelfLife>>;
  specialization?: Maybe<Array<DeviceDefinitionSpecialization>>;
  text?: Maybe<Narrative>;
  type?: Maybe<CodeableConcept>;
  udiDeviceIdentifier?: Maybe<Array<DeviceDefinitionUdiDeviceIdentifier>>;
  url?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Array<Scalars['String']['output']>>;
};

export type DeviceDefinitionCapability = BackboneElementInterface & ElementInterface & {
  __typename?: 'DeviceDefinitionCapability';
  description?: Maybe<Array<CodeableConcept>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  type: CodeableConcept;
};

export type DeviceDefinitionDeviceName = BackboneElementInterface & ElementInterface & {
  __typename?: 'DeviceDefinitionDeviceName';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  name: Scalars['String']['output'];
  type: DeviceNametype;
};

export type DeviceDefinitionMaterial = BackboneElementInterface & ElementInterface & {
  __typename?: 'DeviceDefinitionMaterial';
  allergenicIndicator?: Maybe<Scalars['Boolean']['output']>;
  alternate?: Maybe<Scalars['Boolean']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  substance: CodeableConcept;
};

export type DeviceDefinitionProperty = BackboneElementInterface & ElementInterface & {
  __typename?: 'DeviceDefinitionProperty';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  type: CodeableConcept;
  valueCode?: Maybe<Array<CodeableConcept>>;
  valueQuantity?: Maybe<Array<Quantity>>;
};

export type DeviceDefinitionSpecialization = BackboneElementInterface & ElementInterface & {
  __typename?: 'DeviceDefinitionSpecialization';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  systemType: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export type DeviceDefinitionUdiDeviceIdentifier = BackboneElementInterface & ElementInterface & {
  __typename?: 'DeviceDefinitionUdiDeviceIdentifier';
  deviceIdentifier: Scalars['String']['output'];
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  issuer: Scalars['String']['output'];
  jurisdiction: Scalars['String']['output'];
  modifierExtension?: Maybe<Array<Extension>>;
};

export type DeviceDeviceName = BackboneElementInterface & ElementInterface & {
  __typename?: 'DeviceDeviceName';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  name: Scalars['String']['output'];
  type: DeviceNametype;
};

export type DeviceEdge = {
  __typename?: 'DeviceEdge';
  cursor: Scalars['String']['output'];
  node: Device;
};

export type DeviceFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type DeviceMetric = DomainResourceInterface & ResourceInterface & {
  __typename?: 'DeviceMetric';
  calibration?: Maybe<Array<DeviceMetricCalibration>>;
  category: MetricCategory;
  color?: Maybe<MetricColor>;
  contained?: Maybe<Array<Resource>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  measurementPeriod?: Maybe<Timing>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  operationalStatus?: Maybe<MetricOperationalStatus>;
  parent?: Maybe<Reference>;
  resourceType: Scalars['String']['output'];
  source?: Maybe<Reference>;
  text?: Maybe<Narrative>;
  type: CodeableConcept;
  unit?: Maybe<CodeableConcept>;
};

export type DeviceMetricCalibration = BackboneElementInterface & ElementInterface & {
  __typename?: 'DeviceMetricCalibration';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  state?: Maybe<MetricCalibrationState>;
  time?: Maybe<Scalars['String']['output']>;
  type?: Maybe<MetricCalibrationType>;
};

export enum DeviceNametype {
  ManufacturerName = 'manufacturer_name',
  ModelName = 'model_name',
  Other = 'other',
  PatientReportedName = 'patient_reported_name',
  UdiLabelName = 'udi_label_name',
  UserFriendlyName = 'user_friendly_name'
}

export type DeviceProperty = BackboneElementInterface & ElementInterface & {
  __typename?: 'DeviceProperty';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  type: CodeableConcept;
  valueCode?: Maybe<Array<CodeableConcept>>;
  valueQuantity?: Maybe<Array<Quantity>>;
};

export type DeviceRequest = DomainResourceInterface & ResourceInterface & {
  __typename?: 'DeviceRequest';
  authoredOn?: Maybe<Scalars['String']['output']>;
  basedOn?: Maybe<Array<Reference>>;
  codeCodeableConcept?: Maybe<CodeableConcept>;
  codeReference?: Maybe<Reference>;
  contained?: Maybe<Array<Resource>>;
  encounter?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  groupIdentifier?: Maybe<Identifier>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  instantiatesCanonical?: Maybe<Array<Scalars['String']['output']>>;
  instantiatesUri?: Maybe<Array<Scalars['String']['output']>>;
  insurance?: Maybe<Array<Reference>>;
  intent: RequestIntent;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  occurrenceDateTime?: Maybe<Scalars['String']['output']>;
  occurrencePeriod?: Maybe<Period>;
  occurrenceTiming?: Maybe<Timing>;
  parameter?: Maybe<Array<DeviceRequestParameter>>;
  performer?: Maybe<Reference>;
  performerType?: Maybe<CodeableConcept>;
  priorRequest?: Maybe<Array<Reference>>;
  priority?: Maybe<RequestPriority>;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  reasonReference?: Maybe<Array<Reference>>;
  relevantHistory?: Maybe<Array<Reference>>;
  requester?: Maybe<Reference>;
  resourceType: Scalars['String']['output'];
  status?: Maybe<RequestStatus>;
  subject: Reference;
  supportingInfo?: Maybe<Array<Reference>>;
  text?: Maybe<Narrative>;
};

export type DeviceRequestParameter = BackboneElementInterface & ElementInterface & {
  __typename?: 'DeviceRequestParameter';
  code?: Maybe<CodeableConcept>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  valueCodeableConcept?: Maybe<CodeableConcept>;
  valueQuantity?: Maybe<Quantity>;
  valueRange?: Maybe<Range>;
};

export type DeviceSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export type DeviceSpecialization = BackboneElementInterface & ElementInterface & {
  __typename?: 'DeviceSpecialization';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  systemType: CodeableConcept;
  version?: Maybe<Scalars['String']['output']>;
};

export enum DeviceStatementStatus {
  Active = 'active',
  Completed = 'completed',
  EnteredInError = 'entered_in_error',
  Intended = 'intended',
  OnHold = 'on_hold',
  Stopped = 'stopped'
}

export enum DeviceStatus {
  Active = 'active',
  EnteredInError = 'entered_in_error',
  Inactive = 'inactive',
  Unknown = 'unknown'
}

export type DeviceUdiCarrier = BackboneElementInterface & ElementInterface & {
  __typename?: 'DeviceUdiCarrier';
  carrierAIDC?: Maybe<Scalars['String']['output']>;
  carrierHRF?: Maybe<Scalars['String']['output']>;
  deviceIdentifier?: Maybe<Scalars['String']['output']>;
  entryType?: Maybe<UdiEntryType>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  issuer?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type DeviceUseStatement = DomainResourceInterface & ResourceInterface & {
  __typename?: 'DeviceUseStatement';
  basedOn?: Maybe<Array<Reference>>;
  bodySite?: Maybe<CodeableConcept>;
  contained?: Maybe<Array<Resource>>;
  derivedFrom?: Maybe<Array<Reference>>;
  device: Reference;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  reasonReference?: Maybe<Array<Reference>>;
  recordedOn?: Maybe<Scalars['String']['output']>;
  resourceType: Scalars['String']['output'];
  source?: Maybe<Reference>;
  status: DeviceStatementStatus;
  subject: Reference;
  text?: Maybe<Narrative>;
  timingDateTime?: Maybe<Scalars['String']['output']>;
  timingPeriod?: Maybe<Period>;
  timingTiming?: Maybe<Timing>;
};

export type DeviceUseStatementConnection = {
  __typename?: 'DeviceUseStatementConnection';
  edges?: Maybe<Array<DeviceUseStatementEdge>>;
  pageInfo: PageInfo;
};

export type DeviceUseStatementEdge = {
  __typename?: 'DeviceUseStatementEdge';
  cursor: Scalars['String']['output'];
  node: DeviceUseStatement;
};

export type DeviceUseStatementFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type DeviceUseStatementSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export type DiagnosticReport = DomainResourceInterface & ResourceInterface & {
  __typename?: 'DiagnosticReport';
  BasicList?: Maybe<Array<Basic>>;
  ProvenanceList?: Maybe<Array<Provenance>>;
  basedOn?: Maybe<Array<Reference>>;
  category?: Maybe<Array<CodeableConcept>>;
  code: CodeableConcept;
  conclusion?: Maybe<Scalars['String']['output']>;
  conclusionCode?: Maybe<Array<CodeableConcept>>;
  contained?: Maybe<Array<Resource>>;
  effectiveDateTime?: Maybe<Scalars['String']['output']>;
  effectivePeriod?: Maybe<Period>;
  encounter?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  imagingStudy?: Maybe<Array<Reference>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  issued?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<DiagnosticReportMedia>>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  performer?: Maybe<Array<Reference>>;
  presentedForm?: Maybe<Array<Attachment>>;
  resourceType: Scalars['String']['output'];
  result?: Maybe<Array<Reference>>;
  resultsInterpreter?: Maybe<Array<Reference>>;
  specimen?: Maybe<Array<Reference>>;
  status: DiagnosticReportStatus;
  subject?: Maybe<Reference>;
  text?: Maybe<Narrative>;
};


export type DiagnosticReportBasicListArgs = {
  _reference: Scalars['String']['input'];
};


export type DiagnosticReportProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type DiagnosticReportConnection = {
  __typename?: 'DiagnosticReportConnection';
  edges?: Maybe<Array<DiagnosticReportEdge>>;
  pageInfo: PageInfo;
};

export type DiagnosticReportEdge = {
  __typename?: 'DiagnosticReportEdge';
  cursor: Scalars['String']['output'];
  node: DiagnosticReport;
};

export type DiagnosticReportFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type DiagnosticReportMedia = BackboneElementInterface & ElementInterface & {
  __typename?: 'DiagnosticReportMedia';
  comment?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  link: Reference;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type DiagnosticReportSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export enum DiagnosticReportStatus {
  Amended = 'amended',
  Appended = 'appended',
  Cancelled = 'cancelled',
  Corrected = 'corrected',
  EnteredInError = 'entered_in_error',
  Final = 'final',
  Partial = 'partial',
  Preliminary = 'preliminary',
  Registered = 'registered',
  Unknown = 'unknown'
}

export type Distance = ElementInterface & QuantityInterface & {
  __typename?: 'Distance';
  code?: Maybe<Scalars['String']['output']>;
  comparator?: Maybe<QuantityComparator>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  system?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type DocumentReference = DomainResourceInterface & ResourceInterface & {
  __typename?: 'DocumentReference';
  BasicList?: Maybe<Array<Basic>>;
  ProvenanceList?: Maybe<Array<Provenance>>;
  authenticator?: Maybe<Reference>;
  author?: Maybe<Array<Reference>>;
  category?: Maybe<Array<CodeableConcept>>;
  contained?: Maybe<Array<Resource>>;
  content: Array<DocumentReferenceContent>;
  context?: Maybe<DocumentReferenceContext>;
  custodian?: Maybe<Reference>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  docStatus?: Maybe<CompositionStatus>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  masterIdentifier?: Maybe<Identifier>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  relatesTo?: Maybe<Array<DocumentReferenceRelatesTo>>;
  resourceType: Scalars['String']['output'];
  securityLabel?: Maybe<Array<CodeableConcept>>;
  status: DocumentReferenceStatus;
  subject?: Maybe<Reference>;
  text?: Maybe<Narrative>;
  type?: Maybe<CodeableConcept>;
};


export type DocumentReferenceBasicListArgs = {
  _reference: Scalars['String']['input'];
};


export type DocumentReferenceProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type DocumentReferenceConnection = {
  __typename?: 'DocumentReferenceConnection';
  edges?: Maybe<Array<DocumentReferenceEdge>>;
  pageInfo: PageInfo;
};

export type DocumentReferenceContent = BackboneElementInterface & ElementInterface & {
  __typename?: 'DocumentReferenceContent';
  attachment: Attachment;
  extension?: Maybe<Array<Extension>>;
  format?: Maybe<Coding>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type DocumentReferenceContext = BackboneElementInterface & ElementInterface & {
  __typename?: 'DocumentReferenceContext';
  encounter?: Maybe<Array<Reference>>;
  event?: Maybe<Array<CodeableConcept>>;
  extension?: Maybe<Array<Extension>>;
  facilityType?: Maybe<CodeableConcept>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  period?: Maybe<Period>;
  practiceSetting?: Maybe<CodeableConcept>;
  related?: Maybe<Array<Reference>>;
  sourcePatientInfo?: Maybe<Reference>;
};

export type DocumentReferenceEdge = {
  __typename?: 'DocumentReferenceEdge';
  cursor: Scalars['String']['output'];
  node: DocumentReference;
};

export type DocumentReferenceFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  status?: InputMaybe<FilterComparatorString>;
  subject?: InputMaybe<FilterComparatorReference>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type DocumentReferenceRelatesTo = BackboneElementInterface & ElementInterface & {
  __typename?: 'DocumentReferenceRelatesTo';
  code: DocumentRelationshipType;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  target: Reference;
};

export type DocumentReferenceSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export enum DocumentReferenceStatus {
  Current = 'current',
  EnteredInError = 'entered_in_error',
  Superseded = 'superseded'
}

export enum DocumentRelationshipType {
  Appends = 'appends',
  Replaces = 'replaces',
  Signs = 'signs',
  Transforms = 'transforms'
}

export type DomainResourceInterface = {
  contained?: Maybe<Array<Resource>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  text?: Maybe<Narrative>;
};

export type Dosage = BackboneElementInterface & ElementInterface & {
  __typename?: 'Dosage';
  additionalInstruction?: Maybe<Array<CodeableConcept>>;
  asNeededBoolean?: Maybe<Scalars['Boolean']['output']>;
  asNeededCodeableConcept?: Maybe<CodeableConcept>;
  doseAndRate?: Maybe<Array<DosageDoseAndRate>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  maxDosePerAdministration?: Maybe<Quantity>;
  maxDosePerLifetime?: Maybe<Quantity>;
  maxDosePerPeriod?: Maybe<Ratio>;
  method?: Maybe<CodeableConcept>;
  modifierExtension?: Maybe<Array<Extension>>;
  patientInstruction?: Maybe<Scalars['String']['output']>;
  route?: Maybe<CodeableConcept>;
  sequence?: Maybe<Scalars['Int']['output']>;
  site?: Maybe<CodeableConcept>;
  text?: Maybe<Scalars['String']['output']>;
  timing?: Maybe<Timing>;
};

export type DosageDoseAndRate = ElementInterface & {
  __typename?: 'DosageDoseAndRate';
  doseQuantity?: Maybe<Quantity>;
  doseRange?: Maybe<Range>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  rateQuantity?: Maybe<Quantity>;
  rateRange?: Maybe<Range>;
  rateRatio?: Maybe<Ratio>;
  type?: Maybe<CodeableConcept>;
};

export type Duration = ElementInterface & QuantityInterface & {
  __typename?: 'Duration';
  code?: Maybe<Scalars['String']['output']>;
  comparator?: Maybe<QuantityComparator>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  system?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ElementInterface = {
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
};

export enum EligibilityrequestPurpose {
  AuthRequirements = 'auth_requirements',
  Benefits = 'benefits',
  Discovery = 'discovery',
  Validation = 'validation'
}

export type Encounter = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Encounter';
  BasicList?: Maybe<Array<Basic>>;
  ProvenanceList?: Maybe<Array<Provenance>>;
  account?: Maybe<Array<Reference>>;
  appointment?: Maybe<Array<Reference>>;
  basedOn?: Maybe<Array<Reference>>;
  class: Coding;
  classHistory?: Maybe<Array<EncounterClassHistory>>;
  contained?: Maybe<Array<Resource>>;
  diagnosis?: Maybe<Array<EncounterDiagnosis>>;
  episodeOfCare?: Maybe<Array<Reference>>;
  extension?: Maybe<Array<Extension>>;
  hospitalization?: Maybe<EncounterHospitalization>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Duration>;
  location?: Maybe<Array<EncounterLocation>>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  partOf?: Maybe<Reference>;
  participant?: Maybe<Array<EncounterParticipant>>;
  period?: Maybe<Period>;
  priority?: Maybe<CodeableConcept>;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  reasonReference?: Maybe<Array<Reference>>;
  resourceType: Scalars['String']['output'];
  serviceProvider?: Maybe<Reference>;
  serviceType?: Maybe<CodeableConcept>;
  status: EncounterStatus;
  statusHistory?: Maybe<Array<EncounterStatusHistory>>;
  subject?: Maybe<Reference>;
  text?: Maybe<Narrative>;
  type?: Maybe<Array<CodeableConcept>>;
};


export type EncounterBasicListArgs = {
  _reference: Scalars['String']['input'];
};


export type EncounterProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type EncounterClassHistory = BackboneElementInterface & ElementInterface & {
  __typename?: 'EncounterClassHistory';
  class: Coding;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  period: Period;
};

export type EncounterConnection = {
  __typename?: 'EncounterConnection';
  edges?: Maybe<Array<EncounterEdge>>;
  pageInfo: PageInfo;
};

export type EncounterDiagnosis = BackboneElementInterface & ElementInterface & {
  __typename?: 'EncounterDiagnosis';
  condition: Reference;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  rank?: Maybe<Scalars['Int']['output']>;
  use?: Maybe<CodeableConcept>;
};

export type EncounterEdge = {
  __typename?: 'EncounterEdge';
  cursor: Scalars['String']['output'];
  node: Encounter;
};

export type EncounterFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  status?: InputMaybe<FilterComparatorString>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type EncounterHospitalization = BackboneElementInterface & ElementInterface & {
  __typename?: 'EncounterHospitalization';
  admitSource?: Maybe<CodeableConcept>;
  destination?: Maybe<Reference>;
  dietPreference?: Maybe<Array<CodeableConcept>>;
  dischargeDisposition?: Maybe<CodeableConcept>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  origin?: Maybe<Reference>;
  preAdmissionIdentifier?: Maybe<Identifier>;
  reAdmission?: Maybe<CodeableConcept>;
  specialArrangement?: Maybe<Array<CodeableConcept>>;
  specialCourtesy?: Maybe<Array<CodeableConcept>>;
};

export type EncounterLocation = BackboneElementInterface & ElementInterface & {
  __typename?: 'EncounterLocation';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  location: Reference;
  modifierExtension?: Maybe<Array<Extension>>;
  period?: Maybe<Period>;
  physicalType?: Maybe<CodeableConcept>;
  status?: Maybe<EncounterLocationStatus>;
};

export enum EncounterLocationStatus {
  Active = 'active',
  Completed = 'completed',
  Planned = 'planned',
  Reserved = 'reserved'
}

export type EncounterParticipant = BackboneElementInterface & ElementInterface & {
  __typename?: 'EncounterParticipant';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  individual?: Maybe<Reference>;
  modifierExtension?: Maybe<Array<Extension>>;
  period?: Maybe<Period>;
  type?: Maybe<Array<CodeableConcept>>;
};

export type EncounterSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export enum EncounterStatus {
  Arrived = 'arrived',
  Cancelled = 'cancelled',
  EnteredInError = 'entered_in_error',
  Finished = 'finished',
  InProgress = 'in_progress',
  Onleave = 'onleave',
  Planned = 'planned',
  Triaged = 'triaged',
  Unknown = 'unknown'
}

export type EncounterStatusHistory = BackboneElementInterface & ElementInterface & {
  __typename?: 'EncounterStatusHistory';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  period: Period;
  status: EncounterStatus;
};

export type Endpoint = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Endpoint';
  address: Scalars['String']['output'];
  connectionType: Coding;
  contact?: Maybe<Array<ContactPoint>>;
  contained?: Maybe<Array<Resource>>;
  extension?: Maybe<Array<Extension>>;
  header?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  managingOrganization?: Maybe<Reference>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<Scalars['String']['output']>;
  payloadMimeType?: Maybe<Array<Scalars['String']['output']>>;
  payloadType: Array<CodeableConcept>;
  period?: Maybe<Period>;
  resourceType: Scalars['String']['output'];
  status: EndpointStatus;
  text?: Maybe<Narrative>;
};

export enum EndpointStatus {
  Active = 'active',
  EnteredInError = 'entered_in_error',
  Error = 'error',
  Off = 'off',
  Suspended = 'suspended',
  Test = 'test'
}

export type EpisodeOfCare = DomainResourceInterface & ResourceInterface & {
  __typename?: 'EpisodeOfCare';
  account?: Maybe<Array<Reference>>;
  careManager?: Maybe<Reference>;
  contained?: Maybe<Array<Resource>>;
  diagnosis?: Maybe<Array<EpisodeOfCareDiagnosis>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  managingOrganization?: Maybe<Reference>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  patient: Reference;
  period?: Maybe<Period>;
  referralRequest?: Maybe<Array<Reference>>;
  resourceType: Scalars['String']['output'];
  status: EpisodeOfCareStatus;
  statusHistory?: Maybe<Array<EpisodeOfCareStatusHistory>>;
  team?: Maybe<Array<Reference>>;
  text?: Maybe<Narrative>;
  type?: Maybe<Array<CodeableConcept>>;
};

export type EpisodeOfCareConnection = {
  __typename?: 'EpisodeOfCareConnection';
  edges?: Maybe<Array<EpisodeOfCareEdge>>;
  pageInfo: PageInfo;
};

export type EpisodeOfCareDiagnosis = BackboneElementInterface & ElementInterface & {
  __typename?: 'EpisodeOfCareDiagnosis';
  condition: Reference;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  rank?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<CodeableConcept>;
};

export type EpisodeOfCareEdge = {
  __typename?: 'EpisodeOfCareEdge';
  cursor: Scalars['String']['output'];
  node: EpisodeOfCare;
};

export type EpisodeOfCareFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type EpisodeOfCareSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export enum EpisodeOfCareStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  EnteredInError = 'entered_in_error',
  Finished = 'finished',
  Onhold = 'onhold',
  Planned = 'planned',
  Waitlist = 'waitlist'
}

export type EpisodeOfCareStatusHistory = BackboneElementInterface & ElementInterface & {
  __typename?: 'EpisodeOfCareStatusHistory';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  period: Period;
  status: EpisodeOfCareStatus;
};

export enum EventStatus {
  Completed = 'completed',
  EnteredInError = 'entered_in_error',
  InProgress = 'in_progress',
  NotDone = 'not_done',
  OnHold = 'on_hold',
  Preparation = 'preparation',
  Stopped = 'stopped',
  Unknown = 'unknown'
}

export enum EventTiming {
  Ac = 'AC',
  Acd = 'ACD',
  Acm = 'ACM',
  Acv = 'ACV',
  Aft = 'AFT',
  AftEarly = 'AFT_early',
  AftLate = 'AFT_late',
  C = 'C',
  Cd = 'CD',
  Cm = 'CM',
  Cv = 'CV',
  Eve = 'EVE',
  EveEarly = 'EVE_early',
  EveLate = 'EVE_late',
  Hs = 'HS',
  Morn = 'MORN',
  MornEarly = 'MORN_early',
  MornLate = 'MORN_late',
  Night = 'NIGHT',
  Noon = 'NOON',
  Pc = 'PC',
  Pcd = 'PCD',
  Pcm = 'PCM',
  Pcv = 'PCV',
  Phs = 'PHS',
  Wake = 'WAKE'
}

export type Expression = ElementInterface & {
  __typename?: 'Expression';
  description?: Maybe<Scalars['String']['output']>;
  expression?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  language: Scalars['String']['output'];
  name?: Maybe<Scalars['ID']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
};

export type Extension = ElementInterface & {
  __typename?: 'Extension';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  url: Scalars['String']['output'];
  valueAddress?: Maybe<Address>;
  valueAge?: Maybe<Age>;
  valueAnnotation?: Maybe<Annotation>;
  valueAttachment?: Maybe<Attachment>;
  valueBase64Binary?: Maybe<Scalars['String']['output']>;
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  valueCanonical?: Maybe<Scalars['String']['output']>;
  valueCode?: Maybe<Scalars['String']['output']>;
  valueCodeableConcept?: Maybe<CodeableConcept>;
  valueCoding?: Maybe<Coding>;
  valueContactDetail?: Maybe<ContactDetail>;
  valueContactPoint?: Maybe<ContactPoint>;
  valueContributor?: Maybe<Contributor>;
  valueCount?: Maybe<Count>;
  valueDataRequirement?: Maybe<DataRequirement>;
  valueDate?: Maybe<Scalars['String']['output']>;
  valueDateTime?: Maybe<Scalars['String']['output']>;
  valueDecimal?: Maybe<Scalars['Float']['output']>;
  valueDistance?: Maybe<Distance>;
  valueDosage?: Maybe<Dosage>;
  valueDuration?: Maybe<Duration>;
  valueExpression?: Maybe<Expression>;
  valueHumanName?: Maybe<HumanName>;
  valueId?: Maybe<Scalars['ID']['output']>;
  valueIdentifier?: Maybe<Identifier>;
  valueInstant?: Maybe<Scalars['String']['output']>;
  valueInteger?: Maybe<Scalars['Int']['output']>;
  valueMarkdown?: Maybe<Scalars['String']['output']>;
  valueMeta?: Maybe<Meta>;
  valueMoney?: Maybe<Money>;
  valueOid?: Maybe<Scalars['String']['output']>;
  valueParameterDefinition?: Maybe<ParameterDefinition>;
  valuePeriod?: Maybe<Period>;
  valuePositiveInt?: Maybe<Scalars['Int']['output']>;
  valueQuantity?: Maybe<Quantity>;
  valueRange?: Maybe<Range>;
  valueRatio?: Maybe<Ratio>;
  valueReference?: Maybe<Reference>;
  valueRelatedArtifact?: Maybe<RelatedArtifact>;
  valueSampledData?: Maybe<SampledData>;
  valueSignature?: Maybe<Signature>;
  valueString?: Maybe<Scalars['String']['output']>;
  valueTime?: Maybe<Scalars['String']['output']>;
  valueTiming?: Maybe<Timing>;
  valueTriggerDefinition?: Maybe<TriggerDefinition>;
  valueUnsignedInt?: Maybe<Scalars['Int']['output']>;
  valueUri?: Maybe<Scalars['String']['output']>;
  valueUrl?: Maybe<Scalars['String']['output']>;
  valueUsageContext?: Maybe<UsageContext>;
  valueUuid?: Maybe<Scalars['String']['output']>;
};

export type FamilyMemberHistory = DomainResourceInterface & ResourceInterface & {
  __typename?: 'FamilyMemberHistory';
  ageAge?: Maybe<Age>;
  ageRange?: Maybe<Range>;
  ageString?: Maybe<Scalars['String']['output']>;
  bornDate?: Maybe<Scalars['String']['output']>;
  bornPeriod?: Maybe<Period>;
  bornString?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Array<FamilyMemberHistoryCondition>>;
  contained?: Maybe<Array<Resource>>;
  dataAbsentReason?: Maybe<CodeableConcept>;
  date?: Maybe<Scalars['String']['output']>;
  deceasedAge?: Maybe<Age>;
  deceasedBoolean?: Maybe<Scalars['Boolean']['output']>;
  deceasedDate?: Maybe<Scalars['String']['output']>;
  deceasedRange?: Maybe<Range>;
  deceasedString?: Maybe<Scalars['String']['output']>;
  estimatedAge?: Maybe<Scalars['Boolean']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  instantiatesCanonical?: Maybe<Array<Scalars['String']['output']>>;
  instantiatesUri?: Maybe<Array<Scalars['String']['output']>>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Array<Annotation>>;
  patient: Reference;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  reasonReference?: Maybe<Array<Reference>>;
  relationship: CodeableConcept;
  resourceType: Scalars['String']['output'];
  sex?: Maybe<CodeableConcept>;
  status: HistoryStatus;
  text?: Maybe<Narrative>;
};

export type FamilyMemberHistoryCondition = BackboneElementInterface & ElementInterface & {
  __typename?: 'FamilyMemberHistoryCondition';
  code: CodeableConcept;
  contributedToDeath?: Maybe<Scalars['Boolean']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  onsetAge?: Maybe<Age>;
  onsetPeriod?: Maybe<Period>;
  onsetRange?: Maybe<Range>;
  onsetString?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<CodeableConcept>;
};

export type FamilyMemberHistoryConnection = {
  __typename?: 'FamilyMemberHistoryConnection';
  edges?: Maybe<Array<FamilyMemberHistoryEdge>>;
  pageInfo: PageInfo;
};

export type FamilyMemberHistoryEdge = {
  __typename?: 'FamilyMemberHistoryEdge';
  cursor: Scalars['String']['output'];
  node: FamilyMemberHistory;
};

export type FamilyMemberHistoryFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type FamilyMemberHistorySortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export type FilterComparatorDate = {
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  missing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterComparatorIdentifier = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type FilterComparatorReference = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type FilterComparatorString = {
  eq?: InputMaybe<Scalars['String']['input']>;
  missing?: InputMaybe<Scalars['Boolean']['input']>;
  startswith?: InputMaybe<Scalars['String']['input']>;
};

export type FilterComparatorStringSet = {
  allmatch?: InputMaybe<Array<Scalars['String']['input']>>;
  anymatch?: InputMaybe<Array<Scalars['String']['input']>>;
  missing?: InputMaybe<Scalars['Boolean']['input']>;
  nonematch?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum FmStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Draft = 'draft',
  EnteredInError = 'entered_in_error'
}

export type Goal = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Goal';
  achievementStatus?: Maybe<CodeableConcept>;
  addresses?: Maybe<Array<Reference>>;
  category?: Maybe<Array<CodeableConcept>>;
  contained?: Maybe<Array<Resource>>;
  description: CodeableConcept;
  expressedBy?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lifecycleStatus: GoalStatus;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  outcomeCode?: Maybe<Array<CodeableConcept>>;
  outcomeReference?: Maybe<Array<Reference>>;
  priority?: Maybe<CodeableConcept>;
  resourceType: Scalars['String']['output'];
  startCodeableConcept?: Maybe<CodeableConcept>;
  startDate?: Maybe<Scalars['String']['output']>;
  statusDate?: Maybe<Scalars['String']['output']>;
  statusReason?: Maybe<Scalars['String']['output']>;
  subject: Reference;
  target?: Maybe<Array<GoalTarget>>;
  text?: Maybe<Narrative>;
};

export type GoalConnection = {
  __typename?: 'GoalConnection';
  edges?: Maybe<Array<GoalEdge>>;
  pageInfo: PageInfo;
};

export type GoalEdge = {
  __typename?: 'GoalEdge';
  cursor: Scalars['String']['output'];
  node: Goal;
};

export type GoalFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type GoalSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export enum GoalStatus {
  Accepted = 'accepted',
  Active = 'active',
  Cancelled = 'cancelled',
  Completed = 'completed',
  EnteredInError = 'entered_in_error',
  OnHold = 'on_hold',
  Planned = 'planned',
  Proposed = 'proposed',
  Rejected = 'rejected'
}

export type GoalTarget = BackboneElementInterface & ElementInterface & {
  __typename?: 'GoalTarget';
  detailBoolean?: Maybe<Scalars['Boolean']['output']>;
  detailCodeableConcept?: Maybe<CodeableConcept>;
  detailInteger?: Maybe<Scalars['Int']['output']>;
  detailQuantity?: Maybe<Quantity>;
  detailRange?: Maybe<Range>;
  detailRatio?: Maybe<Ratio>;
  detailString?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  dueDuration?: Maybe<Duration>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  measure?: Maybe<CodeableConcept>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type Group = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Group';
  active?: Maybe<Scalars['Boolean']['output']>;
  actual: Scalars['Boolean']['output'];
  characteristic?: Maybe<Array<GroupCharacteristic>>;
  code?: Maybe<CodeableConcept>;
  contained?: Maybe<Array<Resource>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  managingEntity?: Maybe<Reference>;
  member?: Maybe<Array<GroupMember>>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  resourceType: Scalars['String']['output'];
  text?: Maybe<Narrative>;
  type: GroupType;
};

export type GroupCharacteristic = BackboneElementInterface & ElementInterface & {
  __typename?: 'GroupCharacteristic';
  code: CodeableConcept;
  exclude: Scalars['Boolean']['output'];
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  period?: Maybe<Period>;
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  valueCodeableConcept?: Maybe<CodeableConcept>;
  valueQuantity?: Maybe<Quantity>;
  valueRange?: Maybe<Range>;
  valueReference?: Maybe<Reference>;
};

export type GroupMember = BackboneElementInterface & ElementInterface & {
  __typename?: 'GroupMember';
  entity: Reference;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  inactive?: Maybe<Scalars['Boolean']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  period?: Maybe<Period>;
};

export enum GroupType {
  Animal = 'animal',
  Device = 'device',
  Medication = 'medication',
  Person = 'person',
  Practitioner = 'practitioner',
  Substance = 'substance'
}

export type HealthcareService = DomainResourceInterface & ResourceInterface & {
  __typename?: 'HealthcareService';
  active?: Maybe<Scalars['Boolean']['output']>;
  appointmentRequired?: Maybe<Scalars['Boolean']['output']>;
  availabilityExceptions?: Maybe<Scalars['String']['output']>;
  availableTime?: Maybe<Array<HealthcareServiceAvailableTime>>;
  category?: Maybe<Array<CodeableConcept>>;
  characteristic?: Maybe<Array<CodeableConcept>>;
  comment?: Maybe<Scalars['String']['output']>;
  communication?: Maybe<Array<CodeableConcept>>;
  contained?: Maybe<Array<Resource>>;
  coverageArea?: Maybe<Array<Reference>>;
  eligibility?: Maybe<Array<HealthcareServiceEligibility>>;
  endpoint?: Maybe<Array<Reference>>;
  extension?: Maybe<Array<Extension>>;
  extraDetails?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Array<Reference>>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<Scalars['String']['output']>;
  notAvailable?: Maybe<Array<HealthcareServiceNotAvailable>>;
  photo?: Maybe<Attachment>;
  program?: Maybe<Array<CodeableConcept>>;
  providedBy?: Maybe<Reference>;
  referralMethod?: Maybe<Array<CodeableConcept>>;
  resourceType: Scalars['String']['output'];
  serviceProvisionCode?: Maybe<Array<CodeableConcept>>;
  specialty?: Maybe<Array<CodeableConcept>>;
  telecom?: Maybe<Array<ContactPoint>>;
  text?: Maybe<Narrative>;
  type?: Maybe<Array<CodeableConcept>>;
};

export type HealthcareServiceAvailableTime = BackboneElementInterface & ElementInterface & {
  __typename?: 'HealthcareServiceAvailableTime';
  allDay?: Maybe<Scalars['Boolean']['output']>;
  availableEndTime?: Maybe<Scalars['String']['output']>;
  availableStartTime?: Maybe<Scalars['String']['output']>;
  daysOfWeek?: Maybe<Array<DaysOfWeek>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type HealthcareServiceEligibility = BackboneElementInterface & ElementInterface & {
  __typename?: 'HealthcareServiceEligibility';
  code?: Maybe<CodeableConcept>;
  comment?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type HealthcareServiceNotAvailable = BackboneElementInterface & ElementInterface & {
  __typename?: 'HealthcareServiceNotAvailable';
  description: Scalars['String']['output'];
  during?: Maybe<Period>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export enum HistoryStatus {
  Completed = 'completed',
  EnteredInError = 'entered_in_error',
  HealthUnknown = 'health_unknown',
  Partial = 'partial'
}

export type HumanName = ElementInterface & {
  __typename?: 'HumanName';
  extension?: Maybe<Array<Extension>>;
  family?: Maybe<Scalars['String']['output']>;
  given?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Scalars['ID']['output']>;
  period?: Maybe<Period>;
  prefix?: Maybe<Array<Scalars['String']['output']>>;
  suffix?: Maybe<Array<Scalars['String']['output']>>;
  text?: Maybe<Scalars['String']['output']>;
  use?: Maybe<NameUse>;
};

export type Identifier = ElementInterface & {
  __typename?: 'Identifier';
  assigner?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  period?: Maybe<Period>;
  system?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CodeableConcept>;
  use?: Maybe<IdentifierUse>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum IdentifierUse {
  Official = 'official',
  Old = 'old',
  Secondary = 'secondary',
  Temp = 'temp',
  Usual = 'usual'
}

export type ImagingStudy = DomainResourceInterface & ResourceInterface & {
  __typename?: 'ImagingStudy';
  basedOn?: Maybe<Array<Reference>>;
  contained?: Maybe<Array<Resource>>;
  description?: Maybe<Scalars['String']['output']>;
  encounter?: Maybe<Reference>;
  endpoint?: Maybe<Array<Reference>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  interpreter?: Maybe<Array<Reference>>;
  language?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Reference>;
  meta?: Maybe<Meta>;
  modality?: Maybe<Array<Coding>>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  numberOfInstances?: Maybe<Scalars['Int']['output']>;
  numberOfSeries?: Maybe<Scalars['Int']['output']>;
  procedureCode?: Maybe<Array<CodeableConcept>>;
  procedureReference?: Maybe<Reference>;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  reasonReference?: Maybe<Array<Reference>>;
  referrer?: Maybe<Reference>;
  resourceType: Scalars['String']['output'];
  series?: Maybe<Array<ImagingStudySeries>>;
  started?: Maybe<Scalars['String']['output']>;
  status: ImagingstudyStatus;
  subject: Reference;
  text?: Maybe<Narrative>;
};

export type ImagingStudySeries = BackboneElementInterface & ElementInterface & {
  __typename?: 'ImagingStudySeries';
  bodySite?: Maybe<Coding>;
  description?: Maybe<Scalars['String']['output']>;
  endpoint?: Maybe<Array<Reference>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  instance?: Maybe<Array<ImagingStudySeriesInstance>>;
  laterality?: Maybe<Coding>;
  modality: Coding;
  modifierExtension?: Maybe<Array<Extension>>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfInstances?: Maybe<Scalars['Int']['output']>;
  performer?: Maybe<Array<ImagingStudySeriesPerformer>>;
  specimen?: Maybe<Array<Reference>>;
  started?: Maybe<Scalars['String']['output']>;
  uid: Scalars['ID']['output'];
};

export type ImagingStudySeriesInstance = BackboneElementInterface & ElementInterface & {
  __typename?: 'ImagingStudySeriesInstance';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  number?: Maybe<Scalars['Int']['output']>;
  sopClass: Coding;
  title?: Maybe<Scalars['String']['output']>;
  uid: Scalars['ID']['output'];
};

export type ImagingStudySeriesPerformer = BackboneElementInterface & ElementInterface & {
  __typename?: 'ImagingStudySeriesPerformer';
  actor: Reference;
  extension?: Maybe<Array<Extension>>;
  function?: Maybe<CodeableConcept>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export enum ImagingstudyStatus {
  Available = 'available',
  Cancelled = 'cancelled',
  EnteredInError = 'entered_in_error',
  Registered = 'registered',
  Unknown = 'unknown'
}

export type Immunization = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Immunization';
  BasicList?: Maybe<Array<Basic>>;
  ProvenanceList?: Maybe<Array<Provenance>>;
  contained?: Maybe<Array<Resource>>;
  doseQuantity?: Maybe<Quantity>;
  education?: Maybe<Array<ImmunizationEducation>>;
  encounter?: Maybe<Reference>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  fundingSource?: Maybe<CodeableConcept>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  isSubpotent?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Reference>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Reference>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  occurrenceDateTime?: Maybe<Scalars['String']['output']>;
  occurrenceString?: Maybe<Scalars['String']['output']>;
  patient: Reference;
  performer?: Maybe<Array<ImmunizationPerformer>>;
  primarySource?: Maybe<Scalars['Boolean']['output']>;
  programEligibility?: Maybe<Array<CodeableConcept>>;
  protocolApplied?: Maybe<Array<ImmunizationProtocolApplied>>;
  reaction?: Maybe<Array<ImmunizationReaction>>;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  reasonReference?: Maybe<Array<Reference>>;
  recorded?: Maybe<Scalars['String']['output']>;
  reportOrigin?: Maybe<CodeableConcept>;
  resourceType: Scalars['String']['output'];
  route?: Maybe<CodeableConcept>;
  site?: Maybe<CodeableConcept>;
  status: ImmunizationStatus;
  statusReason?: Maybe<CodeableConcept>;
  subpotentReason?: Maybe<Array<CodeableConcept>>;
  text?: Maybe<Narrative>;
  vaccineCode: CodeableConcept;
};


export type ImmunizationBasicListArgs = {
  _reference: Scalars['String']['input'];
};


export type ImmunizationProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type ImmunizationConnection = {
  __typename?: 'ImmunizationConnection';
  edges?: Maybe<Array<ImmunizationEdge>>;
  pageInfo: PageInfo;
};

export type ImmunizationEdge = {
  __typename?: 'ImmunizationEdge';
  cursor: Scalars['String']['output'];
  node: Immunization;
};

export type ImmunizationEducation = BackboneElementInterface & ElementInterface & {
  __typename?: 'ImmunizationEducation';
  documentType?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  presentationDate?: Maybe<Scalars['String']['output']>;
  publicationDate?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
};

export type ImmunizationEvaluation = DomainResourceInterface & ResourceInterface & {
  __typename?: 'ImmunizationEvaluation';
  authority?: Maybe<Reference>;
  contained?: Maybe<Array<Resource>>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  doseNumberPositiveInt?: Maybe<Scalars['Int']['output']>;
  doseNumberString?: Maybe<Scalars['String']['output']>;
  doseStatus: CodeableConcept;
  doseStatusReason?: Maybe<Array<CodeableConcept>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  immunizationEvent: Reference;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  patient: Reference;
  resourceType: Scalars['String']['output'];
  series?: Maybe<Scalars['String']['output']>;
  seriesDosesPositiveInt?: Maybe<Scalars['Int']['output']>;
  seriesDosesString?: Maybe<Scalars['String']['output']>;
  status: ImmunizationEvaluationStatus;
  targetDisease: CodeableConcept;
  text?: Maybe<Narrative>;
};

export enum ImmunizationEvaluationStatus {
  Completed = 'completed',
  EnteredInError = 'entered_in_error'
}

export type ImmunizationFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  status?: InputMaybe<FilterComparatorString>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type ImmunizationPerformer = BackboneElementInterface & ElementInterface & {
  __typename?: 'ImmunizationPerformer';
  actor: Reference;
  extension?: Maybe<Array<Extension>>;
  function?: Maybe<CodeableConcept>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type ImmunizationProtocolApplied = BackboneElementInterface & ElementInterface & {
  __typename?: 'ImmunizationProtocolApplied';
  authority?: Maybe<Reference>;
  doseNumberPositiveInt?: Maybe<Scalars['Int']['output']>;
  doseNumberString?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  series?: Maybe<Scalars['String']['output']>;
  seriesDosesPositiveInt?: Maybe<Scalars['Int']['output']>;
  seriesDosesString?: Maybe<Scalars['String']['output']>;
  targetDisease?: Maybe<Array<CodeableConcept>>;
};

export type ImmunizationReaction = BackboneElementInterface & ElementInterface & {
  __typename?: 'ImmunizationReaction';
  date?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  reported?: Maybe<Scalars['Boolean']['output']>;
};

export type ImmunizationRecommendation = DomainResourceInterface & ResourceInterface & {
  __typename?: 'ImmunizationRecommendation';
  authority?: Maybe<Reference>;
  contained?: Maybe<Array<Resource>>;
  date: Scalars['String']['output'];
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  patient: Reference;
  recommendation: Array<ImmunizationRecommendationRecommendation>;
  resourceType: Scalars['String']['output'];
  text?: Maybe<Narrative>;
};

export type ImmunizationRecommendationRecommendation = BackboneElementInterface & ElementInterface & {
  __typename?: 'ImmunizationRecommendationRecommendation';
  contraindicatedVaccineCode?: Maybe<Array<CodeableConcept>>;
  dateCriterion?: Maybe<Array<ImmunizationRecommendationRecommendationDateCriterion>>;
  description?: Maybe<Scalars['String']['output']>;
  doseNumberPositiveInt?: Maybe<Scalars['Int']['output']>;
  doseNumberString?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  forecastReason?: Maybe<Array<CodeableConcept>>;
  forecastStatus: CodeableConcept;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  series?: Maybe<Scalars['String']['output']>;
  seriesDosesPositiveInt?: Maybe<Scalars['Int']['output']>;
  seriesDosesString?: Maybe<Scalars['String']['output']>;
  supportingImmunization?: Maybe<Array<Reference>>;
  supportingPatientInformation?: Maybe<Array<Reference>>;
  targetDisease?: Maybe<CodeableConcept>;
  vaccineCode?: Maybe<Array<CodeableConcept>>;
};

export type ImmunizationRecommendationRecommendationDateCriterion = BackboneElementInterface & ElementInterface & {
  __typename?: 'ImmunizationRecommendationRecommendationDateCriterion';
  code: CodeableConcept;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  value: Scalars['String']['output'];
};

export type ImmunizationSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export enum ImmunizationStatus {
  Completed = 'completed',
  EnteredInError = 'entered_in_error',
  NotDone = 'not_done'
}

export type InsurancePlan = DomainResourceInterface & ResourceInterface & {
  __typename?: 'InsurancePlan';
  administeredBy?: Maybe<Reference>;
  alias?: Maybe<Array<Scalars['String']['output']>>;
  contact?: Maybe<Array<InsurancePlanContact>>;
  contained?: Maybe<Array<Resource>>;
  coverage?: Maybe<Array<InsurancePlanCoverage>>;
  coverageArea?: Maybe<Array<Reference>>;
  endpoint?: Maybe<Array<Reference>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Array<Reference>>;
  ownedBy?: Maybe<Reference>;
  period?: Maybe<Period>;
  plan?: Maybe<Array<InsurancePlanPlan>>;
  resourceType: Scalars['String']['output'];
  status?: Maybe<PublicationStatus>;
  text?: Maybe<Narrative>;
  type?: Maybe<Array<CodeableConcept>>;
};

export type InsurancePlanContact = BackboneElementInterface & ElementInterface & {
  __typename?: 'InsurancePlanContact';
  address?: Maybe<Address>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<HumanName>;
  purpose?: Maybe<CodeableConcept>;
  telecom?: Maybe<Array<ContactPoint>>;
};

export type InsurancePlanCoverage = BackboneElementInterface & ElementInterface & {
  __typename?: 'InsurancePlanCoverage';
  benefit: Array<InsurancePlanCoverageBenefit>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  network?: Maybe<Array<Reference>>;
  type: CodeableConcept;
};

export type InsurancePlanCoverageBenefit = BackboneElementInterface & ElementInterface & {
  __typename?: 'InsurancePlanCoverageBenefit';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  limit?: Maybe<Array<InsurancePlanCoverageBenefitLimit>>;
  modifierExtension?: Maybe<Array<Extension>>;
  requirement?: Maybe<Scalars['String']['output']>;
  type: CodeableConcept;
};

export type InsurancePlanCoverageBenefitLimit = BackboneElementInterface & ElementInterface & {
  __typename?: 'InsurancePlanCoverageBenefitLimit';
  code?: Maybe<CodeableConcept>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  value?: Maybe<Quantity>;
};

export type InsurancePlanPlan = BackboneElementInterface & ElementInterface & {
  __typename?: 'InsurancePlanPlan';
  coverageArea?: Maybe<Array<Reference>>;
  extension?: Maybe<Array<Extension>>;
  generalCost?: Maybe<Array<InsurancePlanPlanGeneralCost>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  modifierExtension?: Maybe<Array<Extension>>;
  network?: Maybe<Array<Reference>>;
  specificCost?: Maybe<Array<InsurancePlanPlanSpecificCost>>;
  type?: Maybe<CodeableConcept>;
};

export type InsurancePlanPlanGeneralCost = BackboneElementInterface & ElementInterface & {
  __typename?: 'InsurancePlanPlanGeneralCost';
  comment?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Money>;
  extension?: Maybe<Array<Extension>>;
  groupSize?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  type?: Maybe<CodeableConcept>;
};

export type InsurancePlanPlanSpecificCost = BackboneElementInterface & ElementInterface & {
  __typename?: 'InsurancePlanPlanSpecificCost';
  benefit?: Maybe<Array<InsurancePlanPlanSpecificCostBenefit>>;
  category: CodeableConcept;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type InsurancePlanPlanSpecificCostBenefit = BackboneElementInterface & ElementInterface & {
  __typename?: 'InsurancePlanPlanSpecificCostBenefit';
  cost?: Maybe<Array<InsurancePlanPlanSpecificCostBenefitCost>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  type: CodeableConcept;
};

export type InsurancePlanPlanSpecificCostBenefitCost = BackboneElementInterface & ElementInterface & {
  __typename?: 'InsurancePlanPlanSpecificCostBenefitCost';
  applicability?: Maybe<CodeableConcept>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  qualifiers?: Maybe<Array<CodeableConcept>>;
  type: CodeableConcept;
  value?: Maybe<Quantity>;
};

export enum ItemType {
  Attachment = 'attachment',
  Boolean = 'boolean',
  Choice = 'choice',
  Date = 'date',
  DateTime = 'dateTime',
  Decimal = 'decimal',
  Display = 'display',
  Group = 'group',
  Integer = 'integer',
  OpenChoice = 'open_choice',
  Quantity = 'quantity',
  Question = 'question',
  Reference = 'reference',
  String = 'string',
  Text = 'text',
  Time = 'time',
  Url = 'url'
}

export enum LinkType {
  Refer = 'refer',
  ReplacedBy = 'replaced_by',
  Replaces = 'replaces',
  Seealso = 'seealso'
}

export type List = DomainResourceInterface & ResourceInterface & {
  __typename?: 'List';
  code?: Maybe<CodeableConcept>;
  contained?: Maybe<Array<Resource>>;
  date?: Maybe<Scalars['String']['output']>;
  emptyReason?: Maybe<CodeableConcept>;
  encounter?: Maybe<Reference>;
  entry?: Maybe<Array<ListEntry>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  mode: ListMode;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  orderedBy?: Maybe<CodeableConcept>;
  resourceType: Scalars['String']['output'];
  source?: Maybe<Reference>;
  status: ListStatus;
  subject?: Maybe<Reference>;
  text?: Maybe<Narrative>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ListEntry = BackboneElementInterface & ElementInterface & {
  __typename?: 'ListEntry';
  date?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  extension?: Maybe<Array<Extension>>;
  flag?: Maybe<CodeableConcept>;
  id?: Maybe<Scalars['ID']['output']>;
  item: Reference;
  modifierExtension?: Maybe<Array<Extension>>;
};

export enum ListMode {
  Changes = 'changes',
  Snapshot = 'snapshot',
  Working = 'working'
}

export enum ListStatus {
  Current = 'current',
  EnteredInError = 'entered_in_error',
  Retired = 'retired'
}

export type Location = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Location';
  address?: Maybe<Address>;
  alias?: Maybe<Array<Scalars['String']['output']>>;
  availabilityExceptions?: Maybe<Scalars['String']['output']>;
  contained?: Maybe<Array<Resource>>;
  description?: Maybe<Scalars['String']['output']>;
  endpoint?: Maybe<Array<Reference>>;
  extension?: Maybe<Array<Extension>>;
  hoursOfOperation?: Maybe<Array<LocationHoursOfOperation>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  managingOrganization?: Maybe<Reference>;
  meta?: Maybe<Meta>;
  mode?: Maybe<LocationMode>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<Scalars['String']['output']>;
  operationalStatus?: Maybe<Coding>;
  partOf?: Maybe<Reference>;
  physicalType?: Maybe<CodeableConcept>;
  position?: Maybe<LocationPosition>;
  resourceType: Scalars['String']['output'];
  status?: Maybe<LocationStatus>;
  telecom?: Maybe<Array<ContactPoint>>;
  text?: Maybe<Narrative>;
  type?: Maybe<Array<CodeableConcept>>;
};

export type LocationHoursOfOperation = BackboneElementInterface & ElementInterface & {
  __typename?: 'LocationHoursOfOperation';
  allDay?: Maybe<Scalars['Boolean']['output']>;
  closingTime?: Maybe<Scalars['String']['output']>;
  daysOfWeek?: Maybe<Array<DaysOfWeek>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  openingTime?: Maybe<Scalars['String']['output']>;
};

export enum LocationMode {
  Instance = 'instance',
  Kind = 'kind'
}

export type LocationPosition = BackboneElementInterface & ElementInterface & {
  __typename?: 'LocationPosition';
  altitude?: Maybe<Scalars['Float']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  modifierExtension?: Maybe<Array<Extension>>;
};

export enum LocationStatus {
  Active = 'active',
  Inactive = 'inactive',
  Suspended = 'suspended'
}

export type Measure = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Measure';
  approvalDate?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Array<ContactDetail>>;
  clinicalRecommendationStatement?: Maybe<Scalars['String']['output']>;
  compositeScoring?: Maybe<CodeableConcept>;
  contact?: Maybe<Array<ContactDetail>>;
  contained?: Maybe<Array<Resource>>;
  copyright?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  definition?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  editor?: Maybe<Array<ContactDetail>>;
  effectivePeriod?: Maybe<Period>;
  endorser?: Maybe<Array<ContactDetail>>;
  experimental?: Maybe<Scalars['Boolean']['output']>;
  extension?: Maybe<Array<Extension>>;
  group?: Maybe<Array<MeasureGroup>>;
  guidance?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  improvementNotation?: Maybe<CodeableConcept>;
  jurisdiction?: Maybe<Array<CodeableConcept>>;
  language?: Maybe<Scalars['String']['output']>;
  lastReviewDate?: Maybe<Scalars['String']['output']>;
  library?: Maybe<Array<Scalars['String']['output']>>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<Scalars['String']['output']>;
  publisher?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  rateAggregation?: Maybe<Scalars['String']['output']>;
  rationale?: Maybe<Scalars['String']['output']>;
  relatedArtifact?: Maybe<Array<RelatedArtifact>>;
  resourceType: Scalars['String']['output'];
  reviewer?: Maybe<Array<ContactDetail>>;
  riskAdjustment?: Maybe<Scalars['String']['output']>;
  scoring?: Maybe<CodeableConcept>;
  status: PublicationStatus;
  subjectCodeableConcept?: Maybe<CodeableConcept>;
  subjectReference?: Maybe<Reference>;
  subtitle?: Maybe<Scalars['String']['output']>;
  supplementalData?: Maybe<Array<MeasureSupplementalData>>;
  text?: Maybe<Narrative>;
  title?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Array<CodeableConcept>>;
  type?: Maybe<Array<CodeableConcept>>;
  url?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['String']['output']>;
  useContext?: Maybe<Array<UsageContext>>;
  version?: Maybe<Scalars['String']['output']>;
};

export type MeasureGroup = BackboneElementInterface & ElementInterface & {
  __typename?: 'MeasureGroup';
  code?: Maybe<CodeableConcept>;
  description?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  population?: Maybe<Array<MeasureGroupPopulation>>;
  stratifier?: Maybe<Array<MeasureGroupStratifier>>;
};

export type MeasureGroupPopulation = BackboneElementInterface & ElementInterface & {
  __typename?: 'MeasureGroupPopulation';
  code?: Maybe<CodeableConcept>;
  criteria: Expression;
  description?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type MeasureGroupStratifier = BackboneElementInterface & ElementInterface & {
  __typename?: 'MeasureGroupStratifier';
  code?: Maybe<CodeableConcept>;
  component?: Maybe<Array<MeasureGroupStratifierComponent>>;
  criteria?: Maybe<Expression>;
  description?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type MeasureGroupStratifierComponent = BackboneElementInterface & ElementInterface & {
  __typename?: 'MeasureGroupStratifierComponent';
  code?: Maybe<CodeableConcept>;
  criteria: Expression;
  description?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type MeasureReport = DomainResourceInterface & ResourceInterface & {
  __typename?: 'MeasureReport';
  ProvenanceList?: Maybe<Array<Provenance>>;
  contained?: Maybe<Array<Resource>>;
  date?: Maybe<Scalars['String']['output']>;
  evaluatedResource?: Maybe<Array<Reference>>;
  extension?: Maybe<Array<Extension>>;
  group?: Maybe<Array<MeasureReportGroup>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  improvementNotation?: Maybe<CodeableConcept>;
  language?: Maybe<Scalars['String']['output']>;
  measure: Scalars['String']['output'];
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  period: Period;
  reporter?: Maybe<Reference>;
  resourceType: Scalars['String']['output'];
  status: MeasureReportStatus;
  subject?: Maybe<Reference>;
  text?: Maybe<Narrative>;
  type: MeasureReportType;
};


export type MeasureReportProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type MeasureReportConnection = {
  __typename?: 'MeasureReportConnection';
  edges?: Maybe<Array<MeasureReportEdge>>;
  pageInfo: PageInfo;
};

export type MeasureReportEdge = {
  __typename?: 'MeasureReportEdge';
  cursor: Scalars['String']['output'];
  node: MeasureReport;
};

export type MeasureReportFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type MeasureReportGroup = BackboneElementInterface & ElementInterface & {
  __typename?: 'MeasureReportGroup';
  code?: Maybe<CodeableConcept>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  measureScore?: Maybe<Quantity>;
  modifierExtension?: Maybe<Array<Extension>>;
  population?: Maybe<Array<MeasureReportGroupPopulation>>;
  stratifier?: Maybe<Array<MeasureReportGroupStratifier>>;
};

export type MeasureReportGroupPopulation = BackboneElementInterface & ElementInterface & {
  __typename?: 'MeasureReportGroupPopulation';
  code?: Maybe<CodeableConcept>;
  count?: Maybe<Scalars['Int']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  subjectResults?: Maybe<Reference>;
};

export type MeasureReportGroupStratifier = BackboneElementInterface & ElementInterface & {
  __typename?: 'MeasureReportGroupStratifier';
  code?: Maybe<Array<CodeableConcept>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  stratum?: Maybe<Array<MeasureReportGroupStratifierStratum>>;
};

export type MeasureReportGroupStratifierStratum = BackboneElementInterface & ElementInterface & {
  __typename?: 'MeasureReportGroupStratifierStratum';
  component?: Maybe<Array<MeasureReportGroupStratifierStratumComponent>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  measureScore?: Maybe<Quantity>;
  modifierExtension?: Maybe<Array<Extension>>;
  population?: Maybe<Array<MeasureReportGroupStratifierStratumPopulation>>;
  value?: Maybe<CodeableConcept>;
};

export type MeasureReportGroupStratifierStratumComponent = BackboneElementInterface & ElementInterface & {
  __typename?: 'MeasureReportGroupStratifierStratumComponent';
  code: CodeableConcept;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  value: CodeableConcept;
};

export type MeasureReportGroupStratifierStratumPopulation = BackboneElementInterface & ElementInterface & {
  __typename?: 'MeasureReportGroupStratifierStratumPopulation';
  code?: Maybe<CodeableConcept>;
  count?: Maybe<Scalars['Int']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  subjectResults?: Maybe<Reference>;
};

export type MeasureReportSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export enum MeasureReportStatus {
  Complete = 'complete',
  Error = 'error',
  Pending = 'pending'
}

export enum MeasureReportType {
  DataCollection = 'data_collection',
  Individual = 'individual',
  SubjectList = 'subject_list',
  Summary = 'summary'
}

export type MeasureSupplementalData = BackboneElementInterface & ElementInterface & {
  __typename?: 'MeasureSupplementalData';
  code?: Maybe<CodeableConcept>;
  criteria: Expression;
  description?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  usage?: Maybe<Array<CodeableConcept>>;
};

export type Media = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Media';
  basedOn?: Maybe<Array<Reference>>;
  bodySite?: Maybe<CodeableConcept>;
  contained?: Maybe<Array<Resource>>;
  content: Attachment;
  createdDateTime?: Maybe<Scalars['String']['output']>;
  createdPeriod?: Maybe<Period>;
  device?: Maybe<Reference>;
  deviceName?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  encounter?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  frames?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  issued?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modality?: Maybe<CodeableConcept>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  operator?: Maybe<Reference>;
  partOf?: Maybe<Array<Reference>>;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  resourceType: Scalars['String']['output'];
  status: EventStatus;
  subject?: Maybe<Reference>;
  text?: Maybe<Narrative>;
  type?: Maybe<CodeableConcept>;
  view?: Maybe<CodeableConcept>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type Medication = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Medication';
  amount?: Maybe<Ratio>;
  batch?: Maybe<MedicationBatch>;
  code?: Maybe<CodeableConcept>;
  contained?: Maybe<Array<Resource>>;
  extension?: Maybe<Array<Extension>>;
  form?: Maybe<CodeableConcept>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  ingredient?: Maybe<Array<MedicationIngredient>>;
  language?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Reference>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  resourceType: Scalars['String']['output'];
  status?: Maybe<MedicationStatus>;
  text?: Maybe<Narrative>;
};

export enum MedicationAdminStatus {
  Completed = 'completed',
  EnteredInError = 'entered_in_error',
  InProgress = 'in_progress',
  NotDone = 'not_done',
  OnHold = 'on_hold',
  Stopped = 'stopped',
  Unknown = 'unknown'
}

export type MedicationAdministration = DomainResourceInterface & ResourceInterface & {
  __typename?: 'MedicationAdministration';
  ProvenanceList?: Maybe<Array<Provenance>>;
  category?: Maybe<CodeableConcept>;
  contained?: Maybe<Array<Resource>>;
  context?: Maybe<Reference>;
  device?: Maybe<Array<Reference>>;
  dosage?: Maybe<MedicationAdministrationDosage>;
  effectiveDateTime?: Maybe<Scalars['String']['output']>;
  effectivePeriod?: Maybe<Period>;
  eventHistory?: Maybe<Array<Reference>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  instantiates?: Maybe<Array<Scalars['String']['output']>>;
  language?: Maybe<Scalars['String']['output']>;
  medicationCodeableConcept?: Maybe<CodeableConcept>;
  medicationReference?: Maybe<Reference>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  partOf?: Maybe<Array<Reference>>;
  performer?: Maybe<Array<MedicationAdministrationPerformer>>;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  reasonReference?: Maybe<Array<Reference>>;
  request?: Maybe<Reference>;
  resourceType: Scalars['String']['output'];
  status: MedicationAdminStatus;
  statusReason?: Maybe<Array<CodeableConcept>>;
  subject: Reference;
  supportingInformation?: Maybe<Array<Reference>>;
  text?: Maybe<Narrative>;
};


export type MedicationAdministrationProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type MedicationAdministrationConnection = {
  __typename?: 'MedicationAdministrationConnection';
  edges?: Maybe<Array<MedicationAdministrationEdge>>;
  pageInfo: PageInfo;
};

export type MedicationAdministrationDosage = BackboneElementInterface & ElementInterface & {
  __typename?: 'MedicationAdministrationDosage';
  dose?: Maybe<Quantity>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  method?: Maybe<CodeableConcept>;
  modifierExtension?: Maybe<Array<Extension>>;
  rateQuantity?: Maybe<Quantity>;
  rateRatio?: Maybe<Ratio>;
  route?: Maybe<CodeableConcept>;
  site?: Maybe<CodeableConcept>;
  text?: Maybe<Scalars['String']['output']>;
};

export type MedicationAdministrationEdge = {
  __typename?: 'MedicationAdministrationEdge';
  cursor: Scalars['String']['output'];
  node: MedicationAdministration;
};

export type MedicationAdministrationFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  status?: InputMaybe<FilterComparatorString>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type MedicationAdministrationPerformer = BackboneElementInterface & ElementInterface & {
  __typename?: 'MedicationAdministrationPerformer';
  actor: Reference;
  extension?: Maybe<Array<Extension>>;
  function?: Maybe<CodeableConcept>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type MedicationAdministrationSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export type MedicationBatch = BackboneElementInterface & ElementInterface & {
  __typename?: 'MedicationBatch';
  expirationDate?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type MedicationDispense = DomainResourceInterface & ResourceInterface & {
  __typename?: 'MedicationDispense';
  ProvenanceList?: Maybe<Array<Provenance>>;
  authorizingPrescription?: Maybe<Array<Reference>>;
  category?: Maybe<CodeableConcept>;
  contained?: Maybe<Array<Resource>>;
  context?: Maybe<Reference>;
  daysSupply?: Maybe<Quantity>;
  destination?: Maybe<Reference>;
  detectedIssue?: Maybe<Array<Reference>>;
  dosageInstruction?: Maybe<Array<Dosage>>;
  eventHistory?: Maybe<Array<Reference>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Reference>;
  medicationCodeableConcept?: Maybe<CodeableConcept>;
  medicationReference?: Maybe<Reference>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  partOf?: Maybe<Array<Reference>>;
  performer?: Maybe<Array<MedicationDispensePerformer>>;
  quantity?: Maybe<Quantity>;
  receiver?: Maybe<Array<Reference>>;
  resourceType: Scalars['String']['output'];
  status: MedicationdispenseStatus;
  statusReasonCodeableConcept?: Maybe<CodeableConcept>;
  statusReasonReference?: Maybe<Reference>;
  subject?: Maybe<Reference>;
  substitution?: Maybe<MedicationDispenseSubstitution>;
  supportingInformation?: Maybe<Array<Reference>>;
  text?: Maybe<Narrative>;
  type?: Maybe<CodeableConcept>;
  whenHandedOver?: Maybe<Scalars['String']['output']>;
  whenPrepared?: Maybe<Scalars['String']['output']>;
};


export type MedicationDispenseProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type MedicationDispenseConnection = {
  __typename?: 'MedicationDispenseConnection';
  edges?: Maybe<Array<MedicationDispenseEdge>>;
  pageInfo: PageInfo;
};

export type MedicationDispenseEdge = {
  __typename?: 'MedicationDispenseEdge';
  cursor: Scalars['String']['output'];
  node: MedicationDispense;
};

export type MedicationDispenseFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  status?: InputMaybe<FilterComparatorString>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type MedicationDispensePerformer = BackboneElementInterface & ElementInterface & {
  __typename?: 'MedicationDispensePerformer';
  actor: Reference;
  extension?: Maybe<Array<Extension>>;
  function?: Maybe<CodeableConcept>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type MedicationDispenseSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export type MedicationDispenseSubstitution = BackboneElementInterface & ElementInterface & {
  __typename?: 'MedicationDispenseSubstitution';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  reason?: Maybe<Array<CodeableConcept>>;
  responsibleParty?: Maybe<Array<Reference>>;
  type?: Maybe<CodeableConcept>;
  wasSubstituted: Scalars['Boolean']['output'];
};

export type MedicationIngredient = BackboneElementInterface & ElementInterface & {
  __typename?: 'MedicationIngredient';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  itemCodeableConcept?: Maybe<CodeableConcept>;
  itemReference?: Maybe<Reference>;
  modifierExtension?: Maybe<Array<Extension>>;
  strength?: Maybe<Ratio>;
};

export type MedicationRequest = DomainResourceInterface & ResourceInterface & {
  __typename?: 'MedicationRequest';
  ProvenanceList?: Maybe<Array<Provenance>>;
  authoredOn?: Maybe<Scalars['String']['output']>;
  basedOn?: Maybe<Array<Reference>>;
  category?: Maybe<Array<CodeableConcept>>;
  contained?: Maybe<Array<Resource>>;
  courseOfTherapyType?: Maybe<CodeableConcept>;
  detectedIssue?: Maybe<Array<Reference>>;
  dispenseRequest?: Maybe<MedicationRequestDispenseRequest>;
  doNotPerform?: Maybe<Scalars['Boolean']['output']>;
  dosageInstruction?: Maybe<Array<Dosage>>;
  encounter?: Maybe<Reference>;
  eventHistory?: Maybe<Array<Reference>>;
  extension?: Maybe<Array<Extension>>;
  groupIdentifier?: Maybe<Identifier>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  instantiatesCanonical?: Maybe<Array<Scalars['String']['output']>>;
  instantiatesUri?: Maybe<Array<Scalars['String']['output']>>;
  insurance?: Maybe<Array<Reference>>;
  intent: MedicationrequestIntent;
  language?: Maybe<Scalars['String']['output']>;
  medicationCodeableConcept?: Maybe<CodeableConcept>;
  medicationReference?: Maybe<Reference>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  performer?: Maybe<Reference>;
  performerType?: Maybe<CodeableConcept>;
  priorPrescription?: Maybe<Reference>;
  priority?: Maybe<RequestPriority>;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  reasonReference?: Maybe<Array<Reference>>;
  recorder?: Maybe<Reference>;
  reportedBoolean?: Maybe<Scalars['Boolean']['output']>;
  reportedReference?: Maybe<Reference>;
  requester?: Maybe<Reference>;
  resourceType: Scalars['String']['output'];
  status: MedicationrequestStatus;
  statusReason?: Maybe<CodeableConcept>;
  subject: Reference;
  substitution?: Maybe<MedicationRequestSubstitution>;
  supportingInformation?: Maybe<Array<Reference>>;
  text?: Maybe<Narrative>;
};


export type MedicationRequestProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type MedicationRequestConnection = {
  __typename?: 'MedicationRequestConnection';
  edges?: Maybe<Array<MedicationRequestEdge>>;
  pageInfo: PageInfo;
};

export type MedicationRequestDispenseRequest = BackboneElementInterface & ElementInterface & {
  __typename?: 'MedicationRequestDispenseRequest';
  dispenseInterval?: Maybe<Duration>;
  expectedSupplyDuration?: Maybe<Duration>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  initialFill?: Maybe<MedicationRequestDispenseRequestInitialFill>;
  modifierExtension?: Maybe<Array<Extension>>;
  numberOfRepeatsAllowed?: Maybe<Scalars['Int']['output']>;
  performer?: Maybe<Reference>;
  quantity?: Maybe<Quantity>;
  validityPeriod?: Maybe<Period>;
};

export type MedicationRequestDispenseRequestInitialFill = BackboneElementInterface & ElementInterface & {
  __typename?: 'MedicationRequestDispenseRequestInitialFill';
  duration?: Maybe<Duration>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  quantity?: Maybe<Quantity>;
};

export type MedicationRequestEdge = {
  __typename?: 'MedicationRequestEdge';
  cursor: Scalars['String']['output'];
  node: MedicationRequest;
};

export type MedicationRequestFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  status?: InputMaybe<FilterComparatorString>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type MedicationRequestSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export type MedicationRequestSubstitution = BackboneElementInterface & ElementInterface & {
  __typename?: 'MedicationRequestSubstitution';
  allowedBoolean?: Maybe<Scalars['Boolean']['output']>;
  allowedCodeableConcept?: Maybe<CodeableConcept>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  reason?: Maybe<CodeableConcept>;
};

export type MedicationStatement = DomainResourceInterface & ResourceInterface & {
  __typename?: 'MedicationStatement';
  BasicList?: Maybe<Array<Basic>>;
  ProvenanceList?: Maybe<Array<Provenance>>;
  basedOn?: Maybe<Array<Reference>>;
  category?: Maybe<CodeableConcept>;
  contained?: Maybe<Array<Resource>>;
  context?: Maybe<Reference>;
  dateAsserted?: Maybe<Scalars['String']['output']>;
  derivedFrom?: Maybe<Array<Reference>>;
  dosage?: Maybe<Array<Dosage>>;
  effectiveDateTime?: Maybe<Scalars['String']['output']>;
  effectivePeriod?: Maybe<Period>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  informationSource?: Maybe<Reference>;
  language?: Maybe<Scalars['String']['output']>;
  medicationCodeableConcept?: Maybe<CodeableConcept>;
  medicationReference?: Maybe<Reference>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  partOf?: Maybe<Array<Reference>>;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  reasonReference?: Maybe<Array<Reference>>;
  resourceType: Scalars['String']['output'];
  status: MedicationStatementStatus;
  statusReason?: Maybe<Array<CodeableConcept>>;
  subject: Reference;
  text?: Maybe<Narrative>;
};


export type MedicationStatementBasicListArgs = {
  _reference: Scalars['String']['input'];
};


export type MedicationStatementProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type MedicationStatementConnection = {
  __typename?: 'MedicationStatementConnection';
  edges?: Maybe<Array<MedicationStatementEdge>>;
  pageInfo: PageInfo;
};

export type MedicationStatementEdge = {
  __typename?: 'MedicationStatementEdge';
  cursor: Scalars['String']['output'];
  node: MedicationStatement;
};

export type MedicationStatementFilterParams = {
  dateAsserted?: InputMaybe<FilterComparatorDate>;
  effectivePeriodStart?: InputMaybe<FilterComparatorDate>;
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  status?: InputMaybe<FilterComparatorString>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type MedicationStatementSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export enum MedicationStatementStatus {
  Active = 'active',
  Completed = 'completed',
  EnteredInError = 'entered_in_error',
  Intended = 'intended',
  NotTaken = 'not_taken',
  OnHold = 'on_hold',
  Stopped = 'stopped',
  Unknown = 'unknown'
}

export enum MedicationStatus {
  Active = 'active',
  EnteredInError = 'entered_in_error',
  Inactive = 'inactive'
}

export enum MedicationdispenseStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Declined = 'declined',
  EnteredInError = 'entered_in_error',
  InProgress = 'in_progress',
  OnHold = 'on_hold',
  Preparation = 'preparation',
  Stopped = 'stopped',
  Unknown = 'unknown'
}

export enum MedicationrequestIntent {
  FillerOrder = 'filler_order',
  InstanceOrder = 'instance_order',
  Option = 'option',
  Order = 'order',
  OriginalOrder = 'original_order',
  Plan = 'plan',
  Proposal = 'proposal',
  ReflexOrder = 'reflex_order'
}

export enum MedicationrequestStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Draft = 'draft',
  EnteredInError = 'entered_in_error',
  OnHold = 'on_hold',
  Stopped = 'stopped',
  Unknown = 'unknown'
}

export type Meta = ElementInterface & {
  __typename?: 'Meta';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Array<Scalars['String']['output']>>;
  security?: Maybe<Array<Coding>>;
  source?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Array<Coding>>;
  versionId?: Maybe<Scalars['ID']['output']>;
};

export enum MetricCalibrationState {
  Calibrated = 'calibrated',
  CalibrationRequired = 'calibration_required',
  NotCalibrated = 'not_calibrated',
  Unspecified = 'unspecified'
}

export enum MetricCalibrationType {
  Gain = 'gain',
  Offset = 'offset',
  TwoPoint = 'two_point',
  Unspecified = 'unspecified'
}

export enum MetricCategory {
  Calculation = 'calculation',
  Measurement = 'measurement',
  Setting = 'setting',
  Unspecified = 'unspecified'
}

export enum MetricColor {
  Black = 'black',
  Blue = 'blue',
  Cyan = 'cyan',
  Green = 'green',
  Magenta = 'magenta',
  Red = 'red',
  White = 'white',
  Yellow = 'yellow'
}

export enum MetricOperationalStatus {
  EnteredInError = 'entered_in_error',
  Off = 'off',
  On = 'on',
  Standby = 'standby'
}

export type MolecularSequence = DomainResourceInterface & ResourceInterface & {
  __typename?: 'MolecularSequence';
  contained?: Maybe<Array<Resource>>;
  coordinateSystem: Scalars['Int']['output'];
  device?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  observedSeq?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Reference>;
  performer?: Maybe<Reference>;
  pointer?: Maybe<Array<Reference>>;
  quality?: Maybe<Array<MolecularSequenceQuality>>;
  quantity?: Maybe<Quantity>;
  readCoverage?: Maybe<Scalars['Int']['output']>;
  referenceSeq?: Maybe<MolecularSequenceReferenceSeq>;
  repository?: Maybe<Array<MolecularSequenceRepository>>;
  resourceType: Scalars['String']['output'];
  specimen?: Maybe<Reference>;
  structureVariant?: Maybe<Array<MolecularSequenceStructureVariant>>;
  text?: Maybe<Narrative>;
  type?: Maybe<SequenceType>;
  variant?: Maybe<Array<MolecularSequenceVariant>>;
};

export type MolecularSequenceQuality = BackboneElementInterface & ElementInterface & {
  __typename?: 'MolecularSequenceQuality';
  end?: Maybe<Scalars['Int']['output']>;
  extension?: Maybe<Array<Extension>>;
  fScore?: Maybe<Scalars['Float']['output']>;
  gtFP?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  method?: Maybe<CodeableConcept>;
  modifierExtension?: Maybe<Array<Extension>>;
  precision?: Maybe<Scalars['Float']['output']>;
  queryFP?: Maybe<Scalars['Float']['output']>;
  queryTP?: Maybe<Scalars['Float']['output']>;
  recall?: Maybe<Scalars['Float']['output']>;
  roc?: Maybe<MolecularSequenceQualityRoc>;
  score?: Maybe<Quantity>;
  standardSequence?: Maybe<CodeableConcept>;
  start?: Maybe<Scalars['Int']['output']>;
  truthFN?: Maybe<Scalars['Float']['output']>;
  truthTP?: Maybe<Scalars['Float']['output']>;
  type: QualityType;
};

export type MolecularSequenceQualityRoc = BackboneElementInterface & ElementInterface & {
  __typename?: 'MolecularSequenceQualityRoc';
  extension?: Maybe<Array<Extension>>;
  fMeasure?: Maybe<Array<Scalars['Float']['output']>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  numFN?: Maybe<Array<Scalars['Int']['output']>>;
  numFP?: Maybe<Array<Scalars['Int']['output']>>;
  numTP?: Maybe<Array<Scalars['Int']['output']>>;
  precision?: Maybe<Array<Scalars['Float']['output']>>;
  score?: Maybe<Array<Scalars['Int']['output']>>;
  sensitivity?: Maybe<Array<Scalars['Float']['output']>>;
};

export type MolecularSequenceReferenceSeq = BackboneElementInterface & ElementInterface & {
  __typename?: 'MolecularSequenceReferenceSeq';
  chromosome?: Maybe<CodeableConcept>;
  extension?: Maybe<Array<Extension>>;
  genomeBuild?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  orientation?: Maybe<OrientationType>;
  referenceSeqId?: Maybe<CodeableConcept>;
  referenceSeqPointer?: Maybe<Reference>;
  referenceSeqString?: Maybe<Scalars['String']['output']>;
  strand?: Maybe<StrandType>;
  windowEnd?: Maybe<Scalars['Int']['output']>;
  windowStart?: Maybe<Scalars['Int']['output']>;
};

export type MolecularSequenceRepository = BackboneElementInterface & ElementInterface & {
  __typename?: 'MolecularSequenceRepository';
  datasetId?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<Scalars['String']['output']>;
  readsetId?: Maybe<Scalars['String']['output']>;
  type: RepositoryType;
  url?: Maybe<Scalars['String']['output']>;
  variantsetId?: Maybe<Scalars['String']['output']>;
};

export type MolecularSequenceStructureVariant = BackboneElementInterface & ElementInterface & {
  __typename?: 'MolecularSequenceStructureVariant';
  exact?: Maybe<Scalars['Boolean']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  inner?: Maybe<MolecularSequenceStructureVariantInner>;
  length?: Maybe<Scalars['Int']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  outer?: Maybe<MolecularSequenceStructureVariantOuter>;
  variantType?: Maybe<CodeableConcept>;
};

export type MolecularSequenceStructureVariantInner = BackboneElementInterface & ElementInterface & {
  __typename?: 'MolecularSequenceStructureVariantInner';
  end?: Maybe<Scalars['Int']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  start?: Maybe<Scalars['Int']['output']>;
};

export type MolecularSequenceStructureVariantOuter = BackboneElementInterface & ElementInterface & {
  __typename?: 'MolecularSequenceStructureVariantOuter';
  end?: Maybe<Scalars['Int']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  start?: Maybe<Scalars['Int']['output']>;
};

export type MolecularSequenceVariant = BackboneElementInterface & ElementInterface & {
  __typename?: 'MolecularSequenceVariant';
  cigar?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['Int']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  observedAllele?: Maybe<Scalars['String']['output']>;
  referenceAllele?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  variantPointer?: Maybe<Reference>;
};

export type Money = ElementInterface & {
  __typename?: 'Money';
  currency?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum NameUse {
  Anonymous = 'anonymous',
  Maiden = 'maiden',
  Nickname = 'nickname',
  Official = 'official',
  Old = 'old',
  Temp = 'temp',
  Usual = 'usual'
}

export type Narrative = ElementInterface & {
  __typename?: 'Narrative';
  div: Scalars['String']['output'];
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  status: NarrativeStatus;
};

export enum NarrativeStatus {
  Additional = 'additional',
  Empty = 'empty',
  Extensions = 'extensions',
  Generated = 'generated'
}

export enum NoteType {
  Display = 'display',
  Print = 'print',
  Printoper = 'printoper'
}

export type NutritionOrder = DomainResourceInterface & ResourceInterface & {
  __typename?: 'NutritionOrder';
  allergyIntolerance?: Maybe<Array<Reference>>;
  contained?: Maybe<Array<Resource>>;
  dateTime: Scalars['String']['output'];
  encounter?: Maybe<Reference>;
  enteralFormula?: Maybe<NutritionOrderEnteralFormula>;
  excludeFoodModifier?: Maybe<Array<CodeableConcept>>;
  extension?: Maybe<Array<Extension>>;
  foodPreferenceModifier?: Maybe<Array<CodeableConcept>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  instantiates?: Maybe<Array<Scalars['String']['output']>>;
  instantiatesCanonical?: Maybe<Array<Scalars['String']['output']>>;
  instantiatesUri?: Maybe<Array<Scalars['String']['output']>>;
  intent: RequestIntent;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  oralDiet?: Maybe<NutritionOrderOralDiet>;
  orderer?: Maybe<Reference>;
  patient: Reference;
  resourceType: Scalars['String']['output'];
  status: RequestStatus;
  supplement?: Maybe<Array<NutritionOrderSupplement>>;
  text?: Maybe<Narrative>;
};

export type NutritionOrderEnteralFormula = BackboneElementInterface & ElementInterface & {
  __typename?: 'NutritionOrderEnteralFormula';
  additiveProductName?: Maybe<Scalars['String']['output']>;
  additiveType?: Maybe<CodeableConcept>;
  administration?: Maybe<Array<NutritionOrderEnteralFormulaAdministration>>;
  administrationInstruction?: Maybe<Scalars['String']['output']>;
  baseFormulaProductName?: Maybe<Scalars['String']['output']>;
  baseFormulaType?: Maybe<CodeableConcept>;
  caloricDensity?: Maybe<Quantity>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  maxVolumeToDeliver?: Maybe<Quantity>;
  modifierExtension?: Maybe<Array<Extension>>;
  routeofAdministration?: Maybe<CodeableConcept>;
};

export type NutritionOrderEnteralFormulaAdministration = BackboneElementInterface & ElementInterface & {
  __typename?: 'NutritionOrderEnteralFormulaAdministration';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  quantity?: Maybe<Quantity>;
  rateQuantity?: Maybe<Quantity>;
  rateRatio?: Maybe<Ratio>;
  schedule?: Maybe<Timing>;
};

export type NutritionOrderOralDiet = BackboneElementInterface & ElementInterface & {
  __typename?: 'NutritionOrderOralDiet';
  extension?: Maybe<Array<Extension>>;
  fluidConsistencyType?: Maybe<Array<CodeableConcept>>;
  id?: Maybe<Scalars['ID']['output']>;
  instruction?: Maybe<Scalars['String']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  nutrient?: Maybe<Array<NutritionOrderOralDietNutrient>>;
  schedule?: Maybe<Array<Timing>>;
  texture?: Maybe<Array<NutritionOrderOralDietTexture>>;
  type?: Maybe<Array<CodeableConcept>>;
};

export type NutritionOrderOralDietNutrient = BackboneElementInterface & ElementInterface & {
  __typename?: 'NutritionOrderOralDietNutrient';
  amount?: Maybe<Quantity>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifier?: Maybe<CodeableConcept>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type NutritionOrderOralDietTexture = BackboneElementInterface & ElementInterface & {
  __typename?: 'NutritionOrderOralDietTexture';
  extension?: Maybe<Array<Extension>>;
  foodType?: Maybe<CodeableConcept>;
  id?: Maybe<Scalars['ID']['output']>;
  modifier?: Maybe<CodeableConcept>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type NutritionOrderSupplement = BackboneElementInterface & ElementInterface & {
  __typename?: 'NutritionOrderSupplement';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  instruction?: Maybe<Scalars['String']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  productName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Quantity>;
  schedule?: Maybe<Array<Timing>>;
  type?: Maybe<CodeableConcept>;
};

export type Observation = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Observation';
  ProvenanceList?: Maybe<Array<Provenance>>;
  basedOn?: Maybe<Array<Reference>>;
  bodySite?: Maybe<CodeableConcept>;
  category?: Maybe<Array<CodeableConcept>>;
  code: CodeableConcept;
  component?: Maybe<Array<ObservationComponent>>;
  contained?: Maybe<Array<Resource>>;
  dataAbsentReason?: Maybe<CodeableConcept>;
  derivedFrom?: Maybe<Array<Reference>>;
  device?: Maybe<Reference>;
  effectiveDateTime?: Maybe<Scalars['String']['output']>;
  effectiveInstant?: Maybe<Scalars['String']['output']>;
  effectivePeriod?: Maybe<Period>;
  effectiveTiming?: Maybe<Timing>;
  encounter?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  focus?: Maybe<Array<Reference>>;
  hasMember?: Maybe<Array<Reference>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  interpretation?: Maybe<Array<CodeableConcept>>;
  issued?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  method?: Maybe<CodeableConcept>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  partOf?: Maybe<Array<Reference>>;
  performer?: Maybe<Array<Reference>>;
  referenceRange?: Maybe<Array<ObservationReferenceRange>>;
  resourceType: Scalars['String']['output'];
  specimen?: Maybe<Reference>;
  status: ObservationStatus;
  subject?: Maybe<Reference>;
  text?: Maybe<Narrative>;
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  valueCodeableConcept?: Maybe<CodeableConcept>;
  valueDateTime?: Maybe<Scalars['String']['output']>;
  valueInteger?: Maybe<Scalars['Int']['output']>;
  valuePeriod?: Maybe<Period>;
  valueQuantity?: Maybe<Quantity>;
  valueRange?: Maybe<Range>;
  valueRatio?: Maybe<Ratio>;
  valueSampledData?: Maybe<SampledData>;
  valueString?: Maybe<Scalars['String']['output']>;
  valueTime?: Maybe<Scalars['String']['output']>;
};


export type ObservationProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type ObservationComponent = BackboneElementInterface & ElementInterface & {
  __typename?: 'ObservationComponent';
  code: CodeableConcept;
  dataAbsentReason?: Maybe<CodeableConcept>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  interpretation?: Maybe<Array<CodeableConcept>>;
  modifierExtension?: Maybe<Array<Extension>>;
  referenceRange?: Maybe<Array<ObservationReferenceRange>>;
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  valueCodeableConcept?: Maybe<CodeableConcept>;
  valueDateTime?: Maybe<Scalars['String']['output']>;
  valueInteger?: Maybe<Scalars['Int']['output']>;
  valuePeriod?: Maybe<Period>;
  valueQuantity?: Maybe<Quantity>;
  valueRange?: Maybe<Range>;
  valueRatio?: Maybe<Ratio>;
  valueSampledData?: Maybe<SampledData>;
  valueString?: Maybe<Scalars['String']['output']>;
  valueTime?: Maybe<Scalars['String']['output']>;
};

export type ObservationConnection = {
  __typename?: 'ObservationConnection';
  edges?: Maybe<Array<ObservationEdge>>;
  pageInfo: PageInfo;
};

export type ObservationEdge = {
  __typename?: 'ObservationEdge';
  cursor: Scalars['String']['output'];
  node: Observation;
};

export type ObservationFilterParams = {
  code?: InputMaybe<FilterComparatorStringSet>;
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  status?: InputMaybe<FilterComparatorString>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type ObservationReferenceRange = BackboneElementInterface & ElementInterface & {
  __typename?: 'ObservationReferenceRange';
  age?: Maybe<Range>;
  appliesTo?: Maybe<Array<CodeableConcept>>;
  extension?: Maybe<Array<Extension>>;
  high?: Maybe<Quantity>;
  id?: Maybe<Scalars['ID']['output']>;
  low?: Maybe<Quantity>;
  modifierExtension?: Maybe<Array<Extension>>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CodeableConcept>;
};

export type ObservationSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export enum ObservationStatus {
  Amended = 'amended',
  Cancelled = 'cancelled',
  Corrected = 'corrected',
  EnteredInError = 'entered_in_error',
  Final = 'final',
  Preliminary = 'preliminary',
  Registered = 'registered',
  Unknown = 'unknown'
}

export enum OperationParameterUse {
  In = 'in',
  Out = 'out'
}

export type Organization = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Organization';
  ProvenanceList?: Maybe<Array<Provenance>>;
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Array<Address>>;
  alias?: Maybe<Array<Scalars['String']['output']>>;
  contact?: Maybe<Array<OrganizationContact>>;
  contained?: Maybe<Array<Resource>>;
  endpoint?: Maybe<Array<Reference>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<Scalars['String']['output']>;
  partOf?: Maybe<Reference>;
  resourceType: Scalars['String']['output'];
  telecom?: Maybe<Array<ContactPoint>>;
  text?: Maybe<Narrative>;
  type?: Maybe<Array<CodeableConcept>>;
};


export type OrganizationProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  edges?: Maybe<Array<OrganizationEdge>>;
  pageInfo: PageInfo;
};

export type OrganizationContact = BackboneElementInterface & ElementInterface & {
  __typename?: 'OrganizationContact';
  address?: Maybe<Address>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<HumanName>;
  purpose?: Maybe<CodeableConcept>;
  telecom?: Maybe<Array<ContactPoint>>;
};

export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type OrganizationFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type OrganizationSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export enum OrientationType {
  Antisense = 'antisense',
  Sense = 'sense'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
};

export type ParameterDefinition = ElementInterface & {
  __typename?: 'ParameterDefinition';
  documentation?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  max?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Scalars['String']['output']>;
  type: AllTypes;
  use: OperationParameterUse;
};

export enum Participantrequired {
  InformationOnly = 'information_only',
  Optional = 'optional',
  Required = 'required'
}

export enum Participationstatus {
  Accepted = 'accepted',
  Declined = 'declined',
  NeedsAction = 'needs_action',
  Tentative = 'tentative'
}

export type Patient = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Patient';
  ProvenanceList?: Maybe<Array<Provenance>>;
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Array<Address>>;
  birthDate?: Maybe<Scalars['String']['output']>;
  communication?: Maybe<Array<PatientCommunication>>;
  contact?: Maybe<Array<PatientContact>>;
  contained?: Maybe<Array<Resource>>;
  deceasedBoolean?: Maybe<Scalars['Boolean']['output']>;
  deceasedDateTime?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  gender?: Maybe<AdministrativeGender>;
  generalPractitioner?: Maybe<Array<Reference>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Array<PatientLink>>;
  managingOrganization?: Maybe<Reference>;
  maritalStatus?: Maybe<CodeableConcept>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  multipleBirthBoolean?: Maybe<Scalars['Boolean']['output']>;
  multipleBirthInteger?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Array<HumanName>>;
  photo?: Maybe<Array<Attachment>>;
  resourceType: Scalars['String']['output'];
  telecom?: Maybe<Array<ContactPoint>>;
  text?: Maybe<Narrative>;
};


export type PatientProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type PatientCommunication = BackboneElementInterface & ElementInterface & {
  __typename?: 'PatientCommunication';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  language: CodeableConcept;
  modifierExtension?: Maybe<Array<Extension>>;
  preferred?: Maybe<Scalars['Boolean']['output']>;
};

export type PatientConnection = {
  __typename?: 'PatientConnection';
  edges?: Maybe<Array<PatientEdge>>;
  pageInfo: PageInfo;
};

export type PatientContact = BackboneElementInterface & ElementInterface & {
  __typename?: 'PatientContact';
  address?: Maybe<Address>;
  extension?: Maybe<Array<Extension>>;
  gender?: Maybe<AdministrativeGender>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<HumanName>;
  organization?: Maybe<Reference>;
  period?: Maybe<Period>;
  relationship?: Maybe<Array<CodeableConcept>>;
  telecom?: Maybe<Array<ContactPoint>>;
};

export type PatientEdge = {
  __typename?: 'PatientEdge';
  cursor: Scalars['String']['output'];
  node: Patient;
};

export type PatientFilterParams = {
  identifier?: InputMaybe<FilterComparatorIdentifier>;
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type PatientLink = BackboneElementInterface & ElementInterface & {
  __typename?: 'PatientLink';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  other: Reference;
  type: LinkType;
};

export type PatientSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export type Period = ElementInterface & {
  __typename?: 'Period';
  end?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type PlanDefinition = DomainResourceInterface & ResourceInterface & {
  __typename?: 'PlanDefinition';
  action?: Maybe<Array<PlanDefinitionAction>>;
  approvalDate?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Array<ContactDetail>>;
  contact?: Maybe<Array<ContactDetail>>;
  contained?: Maybe<Array<Resource>>;
  copyright?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  editor?: Maybe<Array<ContactDetail>>;
  effectivePeriod?: Maybe<Period>;
  endorser?: Maybe<Array<ContactDetail>>;
  experimental?: Maybe<Scalars['Boolean']['output']>;
  extension?: Maybe<Array<Extension>>;
  goal?: Maybe<Array<PlanDefinitionGoal>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Array<CodeableConcept>>;
  language?: Maybe<Scalars['String']['output']>;
  lastReviewDate?: Maybe<Scalars['String']['output']>;
  library?: Maybe<Array<Scalars['String']['output']>>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<Scalars['String']['output']>;
  publisher?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  relatedArtifact?: Maybe<Array<RelatedArtifact>>;
  resourceType: Scalars['String']['output'];
  reviewer?: Maybe<Array<ContactDetail>>;
  status: PublicationStatus;
  subjectCodeableConcept?: Maybe<CodeableConcept>;
  subjectReference?: Maybe<Reference>;
  subtitle?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Narrative>;
  title?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Array<CodeableConcept>>;
  type?: Maybe<CodeableConcept>;
  url?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['String']['output']>;
  useContext?: Maybe<Array<UsageContext>>;
  version?: Maybe<Scalars['String']['output']>;
};

export type PlanDefinitionAction = BackboneElementInterface & ElementInterface & {
  __typename?: 'PlanDefinitionAction';
  action?: Maybe<Array<PlanDefinitionAction>>;
  cardinalityBehavior?: Maybe<ActionCardinalityBehavior>;
  code?: Maybe<Array<CodeableConcept>>;
  condition?: Maybe<Array<PlanDefinitionActionCondition>>;
  definitionCanonical?: Maybe<Scalars['String']['output']>;
  definitionUri?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentation?: Maybe<Array<RelatedArtifact>>;
  dynamicValue?: Maybe<Array<PlanDefinitionActionDynamicValue>>;
  extension?: Maybe<Array<Extension>>;
  goalId?: Maybe<Array<Scalars['ID']['output']>>;
  groupingBehavior?: Maybe<ActionGroupingBehavior>;
  id?: Maybe<Scalars['ID']['output']>;
  input?: Maybe<Array<DataRequirement>>;
  modifierExtension?: Maybe<Array<Extension>>;
  output?: Maybe<Array<DataRequirement>>;
  participant?: Maybe<Array<PlanDefinitionActionParticipant>>;
  precheckBehavior?: Maybe<ActionPrecheckBehavior>;
  prefix?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<RequestPriority>;
  reason?: Maybe<Array<CodeableConcept>>;
  relatedAction?: Maybe<Array<PlanDefinitionActionRelatedAction>>;
  requiredBehavior?: Maybe<ActionRequiredBehavior>;
  selectionBehavior?: Maybe<ActionSelectionBehavior>;
  subjectCodeableConcept?: Maybe<CodeableConcept>;
  subjectReference?: Maybe<Reference>;
  textEquivalent?: Maybe<Scalars['String']['output']>;
  timingAge?: Maybe<Age>;
  timingDateTime?: Maybe<Scalars['String']['output']>;
  timingDuration?: Maybe<Duration>;
  timingPeriod?: Maybe<Period>;
  timingRange?: Maybe<Range>;
  timingTiming?: Maybe<Timing>;
  title?: Maybe<Scalars['String']['output']>;
  transform?: Maybe<Scalars['String']['output']>;
  trigger?: Maybe<Array<TriggerDefinition>>;
  type?: Maybe<CodeableConcept>;
};

export type PlanDefinitionActionCondition = BackboneElementInterface & ElementInterface & {
  __typename?: 'PlanDefinitionActionCondition';
  expression?: Maybe<Expression>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  kind: ActionConditionKind;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type PlanDefinitionActionDynamicValue = BackboneElementInterface & ElementInterface & {
  __typename?: 'PlanDefinitionActionDynamicValue';
  expression?: Maybe<Expression>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  path?: Maybe<Scalars['String']['output']>;
};

export type PlanDefinitionActionParticipant = BackboneElementInterface & ElementInterface & {
  __typename?: 'PlanDefinitionActionParticipant';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  role?: Maybe<CodeableConcept>;
  type: ActionParticipantType;
};

export type PlanDefinitionActionRelatedAction = BackboneElementInterface & ElementInterface & {
  __typename?: 'PlanDefinitionActionRelatedAction';
  actionId: Scalars['ID']['output'];
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  offsetDuration?: Maybe<Duration>;
  offsetRange?: Maybe<Range>;
  relationship: ActionRelationshipType;
};

export type PlanDefinitionGoal = BackboneElementInterface & ElementInterface & {
  __typename?: 'PlanDefinitionGoal';
  addresses?: Maybe<Array<CodeableConcept>>;
  category?: Maybe<CodeableConcept>;
  description: CodeableConcept;
  documentation?: Maybe<Array<RelatedArtifact>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  priority?: Maybe<CodeableConcept>;
  start?: Maybe<CodeableConcept>;
  target?: Maybe<Array<PlanDefinitionGoalTarget>>;
};

export type PlanDefinitionGoalTarget = BackboneElementInterface & ElementInterface & {
  __typename?: 'PlanDefinitionGoalTarget';
  detailCodeableConcept?: Maybe<CodeableConcept>;
  detailQuantity?: Maybe<Quantity>;
  detailRange?: Maybe<Range>;
  due?: Maybe<Duration>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  measure?: Maybe<CodeableConcept>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type Practitioner = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Practitioner';
  ProvenanceList?: Maybe<Array<Provenance>>;
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Array<Address>>;
  birthDate?: Maybe<Scalars['String']['output']>;
  communication?: Maybe<Array<CodeableConcept>>;
  contained?: Maybe<Array<Resource>>;
  extension?: Maybe<Array<Extension>>;
  gender?: Maybe<AdministrativeGender>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<Array<HumanName>>;
  photo?: Maybe<Array<Attachment>>;
  qualification?: Maybe<Array<PractitionerQualification>>;
  resourceType: Scalars['String']['output'];
  telecom?: Maybe<Array<ContactPoint>>;
  text?: Maybe<Narrative>;
};


export type PractitionerProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type PractitionerConnection = {
  __typename?: 'PractitionerConnection';
  edges?: Maybe<Array<PractitionerEdge>>;
  pageInfo: PageInfo;
};

export type PractitionerEdge = {
  __typename?: 'PractitionerEdge';
  cursor: Scalars['String']['output'];
  node: Practitioner;
};

export type PractitionerFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type PractitionerQualification = BackboneElementInterface & ElementInterface & {
  __typename?: 'PractitionerQualification';
  code: CodeableConcept;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  issuer?: Maybe<Reference>;
  modifierExtension?: Maybe<Array<Extension>>;
  period?: Maybe<Period>;
};

export type PractitionerRole = DomainResourceInterface & ResourceInterface & {
  __typename?: 'PractitionerRole';
  active?: Maybe<Scalars['Boolean']['output']>;
  availabilityExceptions?: Maybe<Scalars['String']['output']>;
  availableTime?: Maybe<Array<PractitionerRoleAvailableTime>>;
  code?: Maybe<Array<CodeableConcept>>;
  contained?: Maybe<Array<Resource>>;
  endpoint?: Maybe<Array<Reference>>;
  extension?: Maybe<Array<Extension>>;
  healthcareService?: Maybe<Array<Reference>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Array<Reference>>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  notAvailable?: Maybe<Array<PractitionerRoleNotAvailable>>;
  organization?: Maybe<Reference>;
  period?: Maybe<Period>;
  practitioner?: Maybe<Reference>;
  resourceType: Scalars['String']['output'];
  specialty?: Maybe<Array<CodeableConcept>>;
  telecom?: Maybe<Array<ContactPoint>>;
  text?: Maybe<Narrative>;
};

export type PractitionerRoleAvailableTime = BackboneElementInterface & ElementInterface & {
  __typename?: 'PractitionerRoleAvailableTime';
  allDay?: Maybe<Scalars['Boolean']['output']>;
  availableEndTime?: Maybe<Scalars['String']['output']>;
  availableStartTime?: Maybe<Scalars['String']['output']>;
  daysOfWeek?: Maybe<Array<DaysOfWeek>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type PractitionerRoleNotAvailable = BackboneElementInterface & ElementInterface & {
  __typename?: 'PractitionerRoleNotAvailable';
  description: Scalars['String']['output'];
  during?: Maybe<Period>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type PractitionerSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export type Procedure = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Procedure';
  ProvenanceList?: Maybe<Array<Provenance>>;
  asserter?: Maybe<Reference>;
  basedOn?: Maybe<Array<Reference>>;
  bodySite?: Maybe<Array<CodeableConcept>>;
  category?: Maybe<CodeableConcept>;
  code?: Maybe<CodeableConcept>;
  complication?: Maybe<Array<CodeableConcept>>;
  complicationDetail?: Maybe<Array<Reference>>;
  contained?: Maybe<Array<Resource>>;
  encounter?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  focalDevice?: Maybe<Array<ProcedureFocalDevice>>;
  followUp?: Maybe<Array<CodeableConcept>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  instantiatesCanonical?: Maybe<Array<Scalars['String']['output']>>;
  instantiatesUri?: Maybe<Array<Scalars['String']['output']>>;
  language?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Reference>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  outcome?: Maybe<CodeableConcept>;
  partOf?: Maybe<Array<Reference>>;
  performedAge?: Maybe<Age>;
  performedDateTime?: Maybe<Scalars['String']['output']>;
  performedPeriod?: Maybe<Period>;
  performedRange?: Maybe<Range>;
  performedString?: Maybe<Scalars['String']['output']>;
  performer?: Maybe<Array<ProcedurePerformer>>;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  reasonReference?: Maybe<Array<Reference>>;
  recorder?: Maybe<Reference>;
  report?: Maybe<Array<Reference>>;
  resourceType: Scalars['String']['output'];
  status: EventStatus;
  statusReason?: Maybe<CodeableConcept>;
  subject: Reference;
  text?: Maybe<Narrative>;
  usedCode?: Maybe<Array<CodeableConcept>>;
  usedReference?: Maybe<Array<Reference>>;
};


export type ProcedureProvenanceListArgs = {
  _reference: Scalars['String']['input'];
};

export type ProcedureConnection = {
  __typename?: 'ProcedureConnection';
  edges?: Maybe<Array<ProcedureEdge>>;
  pageInfo: PageInfo;
};

export type ProcedureEdge = {
  __typename?: 'ProcedureEdge';
  cursor: Scalars['String']['output'];
  node: Procedure;
};

export type ProcedureFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type ProcedureFocalDevice = BackboneElementInterface & ElementInterface & {
  __typename?: 'ProcedureFocalDevice';
  action?: Maybe<CodeableConcept>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  manipulated: Reference;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type ProcedurePerformer = BackboneElementInterface & ElementInterface & {
  __typename?: 'ProcedurePerformer';
  actor: Reference;
  extension?: Maybe<Array<Extension>>;
  function?: Maybe<CodeableConcept>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  onBehalfOf?: Maybe<Reference>;
};

export type ProcedureSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export type ProdCharacteristic = BackboneElementInterface & ElementInterface & {
  __typename?: 'ProdCharacteristic';
  color?: Maybe<Array<Scalars['String']['output']>>;
  depth?: Maybe<Quantity>;
  extension?: Maybe<Array<Extension>>;
  externalDiameter?: Maybe<Quantity>;
  height?: Maybe<Quantity>;
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<Array<Attachment>>;
  imprint?: Maybe<Array<Scalars['String']['output']>>;
  modifierExtension?: Maybe<Array<Extension>>;
  nominalVolume?: Maybe<Quantity>;
  scoring?: Maybe<CodeableConcept>;
  shape?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Quantity>;
  width?: Maybe<Quantity>;
};

export type ProductShelfLife = BackboneElementInterface & ElementInterface & {
  __typename?: 'ProductShelfLife';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Identifier>;
  modifierExtension?: Maybe<Array<Extension>>;
  period: Quantity;
  specialPrecautionsForStorage?: Maybe<Array<CodeableConcept>>;
  type: CodeableConcept;
};

export type Provenance = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Provenance';
  activity?: Maybe<CodeableConcept>;
  agent: Array<ProvenanceAgent>;
  contained?: Maybe<Array<Resource>>;
  entity?: Maybe<Array<ProvenanceEntity>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Reference>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  occurredDateTime?: Maybe<Scalars['String']['output']>;
  occurredPeriod?: Maybe<Period>;
  policy?: Maybe<Array<Scalars['String']['output']>>;
  reason?: Maybe<Array<CodeableConcept>>;
  recorded: Scalars['String']['output'];
  resourceType: Scalars['String']['output'];
  signature?: Maybe<Array<Signature>>;
  target: Array<Reference>;
  text?: Maybe<Narrative>;
};

export type ProvenanceAgent = BackboneElementInterface & ElementInterface & {
  __typename?: 'ProvenanceAgent';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  onBehalfOf?: Maybe<Reference>;
  role?: Maybe<Array<CodeableConcept>>;
  type?: Maybe<CodeableConcept>;
  who: Reference;
};

export type ProvenanceConnection = {
  __typename?: 'ProvenanceConnection';
  edges?: Maybe<Array<ProvenanceEdge>>;
  pageInfo: PageInfo;
};

export type ProvenanceEdge = {
  __typename?: 'ProvenanceEdge';
  cursor: Scalars['String']['output'];
  node: Provenance;
};

export type ProvenanceEntity = BackboneElementInterface & ElementInterface & {
  __typename?: 'ProvenanceEntity';
  agent?: Maybe<Array<ProvenanceAgent>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  role: ProvenanceEntityRole;
  what: Reference;
};

export enum ProvenanceEntityRole {
  Derivation = 'derivation',
  Quotation = 'quotation',
  Removal = 'removal',
  Revision = 'revision',
  Source = 'source'
}

export type ProvenanceFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type ProvenanceSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export enum PublicationStatus {
  Active = 'active',
  Draft = 'draft',
  Retired = 'retired',
  Unknown = 'unknown'
}

export enum QualityType {
  Indel = 'indel',
  Snp = 'snp',
  Unknown = 'unknown'
}

export type Quantity = ElementInterface & {
  __typename?: 'Quantity';
  code?: Maybe<Scalars['String']['output']>;
  comparator?: Maybe<QuantityComparator>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  system?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum QuantityComparator {
  GreaterThan = 'greaterThan',
  GreaterThanEqual = 'greaterThanEqual',
  LessThan = 'lessThan',
  LessThanEqual = 'lessThanEqual'
}

export type QuantityInterface = {
  code?: Maybe<Scalars['String']['output']>;
  comparator?: Maybe<QuantityComparator>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  system?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type Query = {
  __typename?: 'Query';
  AllergyIntolerance?: Maybe<AllergyIntolerance>;
  AllergyIntoleranceConnection?: Maybe<AllergyIntoleranceConnection>;
  AllergyIntoleranceHistory?: Maybe<Array<AllergyIntolerance>>;
  AllergyIntoleranceList?: Maybe<Array<AllergyIntolerance>>;
  Appointment?: Maybe<Appointment>;
  AppointmentConnection?: Maybe<AppointmentConnection>;
  AppointmentHistory?: Maybe<Array<Appointment>>;
  AppointmentList?: Maybe<Array<Appointment>>;
  Basic?: Maybe<Basic>;
  BasicConnection?: Maybe<BasicConnection>;
  BasicHistory?: Maybe<Array<Basic>>;
  BasicList?: Maybe<Array<Basic>>;
  Binary?: Maybe<Binary>;
  BinaryConnection?: Maybe<BinaryConnection>;
  BinaryHistory?: Maybe<Array<Binary>>;
  BinaryList?: Maybe<Array<Binary>>;
  CarePlan?: Maybe<CarePlan>;
  CarePlanConnection?: Maybe<CarePlanConnection>;
  CarePlanHistory?: Maybe<Array<CarePlan>>;
  CarePlanList?: Maybe<Array<CarePlan>>;
  CareTeam?: Maybe<CareTeam>;
  CareTeamConnection?: Maybe<CareTeamConnection>;
  CareTeamHistory?: Maybe<Array<CareTeam>>;
  CareTeamList?: Maybe<Array<CareTeam>>;
  Claim?: Maybe<Claim>;
  ClaimConnection?: Maybe<ClaimConnection>;
  ClaimHistory?: Maybe<Array<Claim>>;
  ClaimList?: Maybe<Array<Claim>>;
  Condition?: Maybe<Condition>;
  ConditionConnection?: Maybe<ConditionConnection>;
  ConditionHistory?: Maybe<Array<Condition>>;
  ConditionList?: Maybe<Array<Condition>>;
  Consent?: Maybe<Consent>;
  ConsentConnection?: Maybe<ConsentConnection>;
  ConsentHistory?: Maybe<Array<Consent>>;
  ConsentList?: Maybe<Array<Consent>>;
  Coverage?: Maybe<Coverage>;
  CoverageConnection?: Maybe<CoverageConnection>;
  CoverageEligibilityRequest?: Maybe<CoverageEligibilityRequest>;
  CoverageEligibilityRequestConnection?: Maybe<CoverageEligibilityRequestConnection>;
  CoverageEligibilityRequestHistory?: Maybe<Array<CoverageEligibilityRequest>>;
  CoverageEligibilityRequestList?: Maybe<Array<CoverageEligibilityRequest>>;
  CoverageHistory?: Maybe<Array<Coverage>>;
  CoverageList?: Maybe<Array<Coverage>>;
  DetectedIssue?: Maybe<DetectedIssue>;
  DetectedIssueConnection?: Maybe<DetectedIssueConnection>;
  DetectedIssueHistory?: Maybe<Array<DetectedIssue>>;
  DetectedIssueList?: Maybe<Array<DetectedIssue>>;
  Device?: Maybe<Device>;
  DeviceConnection?: Maybe<DeviceConnection>;
  DeviceHistory?: Maybe<Array<Device>>;
  DeviceList?: Maybe<Array<Device>>;
  DeviceUseStatement?: Maybe<DeviceUseStatement>;
  DeviceUseStatementConnection?: Maybe<DeviceUseStatementConnection>;
  DeviceUseStatementHistory?: Maybe<Array<DeviceUseStatement>>;
  DeviceUseStatementList?: Maybe<Array<DeviceUseStatement>>;
  DiagnosticReport?: Maybe<DiagnosticReport>;
  DiagnosticReportConnection?: Maybe<DiagnosticReportConnection>;
  DiagnosticReportHistory?: Maybe<Array<DiagnosticReport>>;
  DiagnosticReportList?: Maybe<Array<DiagnosticReport>>;
  DocumentReference?: Maybe<DocumentReference>;
  DocumentReferenceConnection?: Maybe<DocumentReferenceConnection>;
  DocumentReferenceHistory?: Maybe<Array<DocumentReference>>;
  DocumentReferenceList?: Maybe<Array<DocumentReference>>;
  Encounter?: Maybe<Encounter>;
  EncounterConnection?: Maybe<EncounterConnection>;
  EncounterHistory?: Maybe<Array<Encounter>>;
  EncounterList?: Maybe<Array<Encounter>>;
  EpisodeOfCare?: Maybe<EpisodeOfCare>;
  EpisodeOfCareConnection?: Maybe<EpisodeOfCareConnection>;
  EpisodeOfCareHistory?: Maybe<Array<EpisodeOfCare>>;
  EpisodeOfCareList?: Maybe<Array<EpisodeOfCare>>;
  FamilyMemberHistory?: Maybe<FamilyMemberHistory>;
  FamilyMemberHistoryConnection?: Maybe<FamilyMemberHistoryConnection>;
  FamilyMemberHistoryHistory?: Maybe<Array<FamilyMemberHistory>>;
  FamilyMemberHistoryList?: Maybe<Array<FamilyMemberHistory>>;
  Goal?: Maybe<Goal>;
  GoalConnection?: Maybe<GoalConnection>;
  GoalHistory?: Maybe<Array<Goal>>;
  GoalList?: Maybe<Array<Goal>>;
  Immunization?: Maybe<Immunization>;
  ImmunizationConnection?: Maybe<ImmunizationConnection>;
  ImmunizationHistory?: Maybe<Array<Immunization>>;
  ImmunizationList?: Maybe<Array<Immunization>>;
  Location?: Maybe<Location>;
  Measure?: Maybe<Measure>;
  MeasureReport?: Maybe<MeasureReport>;
  MeasureReportConnection?: Maybe<MeasureReportConnection>;
  MeasureReportHistory?: Maybe<Array<MeasureReport>>;
  MeasureReportList?: Maybe<Array<MeasureReport>>;
  MedicationAdministration?: Maybe<MedicationAdministration>;
  MedicationAdministrationConnection?: Maybe<MedicationAdministrationConnection>;
  MedicationAdministrationHistory?: Maybe<Array<MedicationAdministration>>;
  MedicationAdministrationList?: Maybe<Array<MedicationAdministration>>;
  MedicationDispense?: Maybe<MedicationDispense>;
  MedicationDispenseConnection?: Maybe<MedicationDispenseConnection>;
  MedicationDispenseHistory?: Maybe<Array<MedicationDispense>>;
  MedicationDispenseList?: Maybe<Array<MedicationDispense>>;
  MedicationRequest?: Maybe<MedicationRequest>;
  MedicationRequestConnection?: Maybe<MedicationRequestConnection>;
  MedicationRequestHistory?: Maybe<Array<MedicationRequest>>;
  MedicationRequestList?: Maybe<Array<MedicationRequest>>;
  MedicationStatement?: Maybe<MedicationStatement>;
  MedicationStatementConnection?: Maybe<MedicationStatementConnection>;
  MedicationStatementHistory?: Maybe<Array<MedicationStatement>>;
  MedicationStatementList?: Maybe<Array<MedicationStatement>>;
  Observation?: Maybe<Observation>;
  ObservationConnection?: Maybe<ObservationConnection>;
  ObservationHistory?: Maybe<Array<Observation>>;
  ObservationList?: Maybe<Array<Observation>>;
  Organization?: Maybe<Organization>;
  OrganizationConnection?: Maybe<OrganizationConnection>;
  OrganizationHistory?: Maybe<Array<Organization>>;
  OrganizationList?: Maybe<Array<Organization>>;
  Patient?: Maybe<Patient>;
  PatientConnection?: Maybe<PatientConnection>;
  PatientHistory?: Maybe<Array<Patient>>;
  PatientList?: Maybe<Array<Patient>>;
  Practitioner?: Maybe<Practitioner>;
  PractitionerConnection?: Maybe<PractitionerConnection>;
  PractitionerHistory?: Maybe<Array<Practitioner>>;
  PractitionerList?: Maybe<Array<Practitioner>>;
  Procedure?: Maybe<Procedure>;
  ProcedureConnection?: Maybe<ProcedureConnection>;
  ProcedureHistory?: Maybe<Array<Procedure>>;
  ProcedureList?: Maybe<Array<Procedure>>;
  Provenance?: Maybe<Provenance>;
  ProvenanceConnection?: Maybe<ProvenanceConnection>;
  ProvenanceHistory?: Maybe<Array<Provenance>>;
  ProvenanceList?: Maybe<Array<Provenance>>;
  QuestionnaireResponse?: Maybe<QuestionnaireResponse>;
  QuestionnaireResponseConnection?: Maybe<QuestionnaireResponseConnection>;
  QuestionnaireResponseHistory?: Maybe<Array<QuestionnaireResponse>>;
  QuestionnaireResponseList?: Maybe<Array<QuestionnaireResponse>>;
  RelatedPerson?: Maybe<RelatedPerson>;
  RelatedPersonConnection?: Maybe<RelatedPersonConnection>;
  RelatedPersonHistory?: Maybe<Array<RelatedPerson>>;
  RelatedPersonList?: Maybe<Array<RelatedPerson>>;
  Search?: Maybe<SearchConnection>;
  ServiceRequest?: Maybe<ServiceRequest>;
  ServiceRequestConnection?: Maybe<ServiceRequestConnection>;
  ServiceRequestHistory?: Maybe<Array<ServiceRequest>>;
  ServiceRequestList?: Maybe<Array<ServiceRequest>>;
  SupplyRequest?: Maybe<SupplyRequest>;
  SupplyRequestConnection?: Maybe<SupplyRequestConnection>;
  SupplyRequestHistory?: Maybe<Array<SupplyRequest>>;
  SupplyRequestList?: Maybe<Array<SupplyRequest>>;
};


export type QueryAllergyIntoleranceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAllergyIntoleranceConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: AllergyIntoleranceFilterParams;
  first?: Scalars['Int']['input'];
  sort?: AllergyIntoleranceSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryAllergyIntoleranceHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryAllergyIntoleranceListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: AllergyIntoleranceFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryAppointmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAppointmentConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: AppointmentFilterParams;
  first?: Scalars['Int']['input'];
  sort?: AppointmentSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryAppointmentHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryAppointmentListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: AppointmentFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryBasicArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBasicConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: BasicFilterParams;
  first?: Scalars['Int']['input'];
  sort?: BasicSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryBasicHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryBasicListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: BasicFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryBinaryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBinaryConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: BinaryFilterParams;
  first?: Scalars['Int']['input'];
  sort?: BinarySortParams;
  upid: Scalars['ID']['input'];
};


export type QueryBinaryHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryBinaryListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: BinaryFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryCarePlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCarePlanConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: CarePlanFilterParams;
  first?: Scalars['Int']['input'];
  sort?: CarePlanSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryCarePlanHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryCarePlanListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: CarePlanFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryCareTeamArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCareTeamConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: CareTeamFilterParams;
  first?: Scalars['Int']['input'];
  sort?: CareTeamSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryCareTeamHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryCareTeamListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: CareTeamFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryClaimArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClaimConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: ClaimFilterParams;
  first?: Scalars['Int']['input'];
  sort?: ClaimSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryClaimHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryClaimListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: ClaimFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryConditionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConditionConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: ConditionFilterParams;
  first?: Scalars['Int']['input'];
  sort?: ConditionSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryConditionHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryConditionListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: ConditionFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryConsentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConsentConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: ConsentFilterParams;
  first?: Scalars['Int']['input'];
  sort?: ConsentSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryConsentHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryConsentListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: ConsentFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryCoverageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCoverageConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: CoverageFilterParams;
  first?: Scalars['Int']['input'];
  sort?: CoverageSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryCoverageEligibilityRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCoverageEligibilityRequestConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: CoverageEligibilityRequestFilterParams;
  first?: Scalars['Int']['input'];
  sort?: CoverageEligibilityRequestSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryCoverageEligibilityRequestHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryCoverageEligibilityRequestListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: CoverageEligibilityRequestFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryCoverageHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryCoverageListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: CoverageFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryDetectedIssueArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDetectedIssueConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: DetectedIssueFilterParams;
  first?: Scalars['Int']['input'];
  sort?: DetectedIssueSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryDetectedIssueHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryDetectedIssueListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: DetectedIssueFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDeviceConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: DeviceFilterParams;
  first?: Scalars['Int']['input'];
  sort?: DeviceSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryDeviceHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryDeviceListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: DeviceFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryDeviceUseStatementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDeviceUseStatementConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: DeviceUseStatementFilterParams;
  first?: Scalars['Int']['input'];
  sort?: DeviceUseStatementSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryDeviceUseStatementHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryDeviceUseStatementListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: DeviceUseStatementFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryDiagnosticReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDiagnosticReportConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: DiagnosticReportFilterParams;
  first?: Scalars['Int']['input'];
  sort?: DiagnosticReportSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryDiagnosticReportHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryDiagnosticReportListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: DiagnosticReportFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryDocumentReferenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentReferenceConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: DocumentReferenceFilterParams;
  first?: Scalars['Int']['input'];
  sort?: DocumentReferenceSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryDocumentReferenceHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryDocumentReferenceListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: DocumentReferenceFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryEncounterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEncounterConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: EncounterFilterParams;
  first?: Scalars['Int']['input'];
  sort?: EncounterSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryEncounterHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryEncounterListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: EncounterFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryEpisodeOfCareArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEpisodeOfCareConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: EpisodeOfCareFilterParams;
  first?: Scalars['Int']['input'];
  sort?: EpisodeOfCareSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryEpisodeOfCareHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryEpisodeOfCareListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: EpisodeOfCareFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryFamilyMemberHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFamilyMemberHistoryConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: FamilyMemberHistoryFilterParams;
  first?: Scalars['Int']['input'];
  sort?: FamilyMemberHistorySortParams;
  upid: Scalars['ID']['input'];
};


export type QueryFamilyMemberHistoryHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryFamilyMemberHistoryListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: FamilyMemberHistoryFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryGoalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGoalConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: GoalFilterParams;
  first?: Scalars['Int']['input'];
  sort?: GoalSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryGoalHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryGoalListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: GoalFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryImmunizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImmunizationConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: ImmunizationFilterParams;
  first?: Scalars['Int']['input'];
  sort?: ImmunizationSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryImmunizationHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryImmunizationListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: ImmunizationFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMeasureArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMeasureReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMeasureReportConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: MeasureReportFilterParams;
  first?: Scalars['Int']['input'];
  sort?: MeasureReportSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryMeasureReportHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryMeasureReportListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: MeasureReportFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryMedicationAdministrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMedicationAdministrationConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: MedicationAdministrationFilterParams;
  first?: Scalars['Int']['input'];
  sort?: MedicationAdministrationSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryMedicationAdministrationHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryMedicationAdministrationListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: MedicationAdministrationFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryMedicationDispenseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMedicationDispenseConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: MedicationDispenseFilterParams;
  first?: Scalars['Int']['input'];
  sort?: MedicationDispenseSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryMedicationDispenseHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryMedicationDispenseListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: MedicationDispenseFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryMedicationRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMedicationRequestConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: MedicationRequestFilterParams;
  first?: Scalars['Int']['input'];
  sort?: MedicationRequestSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryMedicationRequestHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryMedicationRequestListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: MedicationRequestFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryMedicationStatementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMedicationStatementConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: MedicationStatementFilterParams;
  first?: Scalars['Int']['input'];
  sort?: MedicationStatementSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryMedicationStatementHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryMedicationStatementListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: MedicationStatementFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryObservationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryObservationConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: ObservationFilterParams;
  first?: Scalars['Int']['input'];
  sort?: ObservationSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryObservationHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryObservationListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: ObservationFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationConnectionArgs = {
  after?: Scalars['String']['input'];
  builderID?: InputMaybe<Scalars['ID']['input']>;
  filter?: OrganizationFilterParams;
  first?: Scalars['Int']['input'];
  sort?: OrganizationSortParams;
};


export type QueryOrganizationHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryOrganizationListArgs = {
  _count?: Scalars['Int']['input'];
  builderID?: InputMaybe<Scalars['ID']['input']>;
  filter?: OrganizationFilterParams;
};


export type QueryPatientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPatientConnectionArgs = {
  after?: Scalars['String']['input'];
  builderID?: InputMaybe<Scalars['ID']['input']>;
  filter?: PatientFilterParams;
  first?: Scalars['Int']['input'];
  sort?: PatientSortParams;
  upid?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPatientHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryPatientListArgs = {
  _count?: Scalars['Int']['input'];
  builderID?: InputMaybe<Scalars['ID']['input']>;
  filter?: PatientFilterParams;
  upid?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPractitionerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPractitionerConnectionArgs = {
  after?: Scalars['String']['input'];
  builderID?: InputMaybe<Scalars['ID']['input']>;
  filter?: PractitionerFilterParams;
  first?: Scalars['Int']['input'];
  sort?: PractitionerSortParams;
};


export type QueryPractitionerHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryPractitionerListArgs = {
  _count?: Scalars['Int']['input'];
  builderID?: InputMaybe<Scalars['ID']['input']>;
  filter?: PractitionerFilterParams;
};


export type QueryProcedureArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProcedureConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: ProcedureFilterParams;
  first?: Scalars['Int']['input'];
  sort?: ProcedureSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryProcedureHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryProcedureListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: ProcedureFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryProvenanceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProvenanceConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: ProvenanceFilterParams;
  first?: Scalars['Int']['input'];
  sort?: ProvenanceSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryProvenanceHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryProvenanceListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: ProvenanceFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryQuestionnaireResponseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuestionnaireResponseConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: QuestionnaireResponseFilterParams;
  first?: Scalars['Int']['input'];
  sort?: QuestionnaireResponseSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryQuestionnaireResponseHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryQuestionnaireResponseListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: QuestionnaireResponseFilterParams;
  upid: Scalars['ID']['input'];
};


export type QueryRelatedPersonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRelatedPersonConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: RelatedPersonFilterParams;
  first?: Scalars['Int']['input'];
  sort?: RelatedPersonSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryRelatedPersonHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryRelatedPersonListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: RelatedPersonFilterParams;
  upid: Scalars['ID']['input'];
};


export type QuerySearchArgs = {
  after?: Scalars['String']['input'];
  first?: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  upid: Scalars['ID']['input'];
};


export type QueryServiceRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServiceRequestConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: ServiceRequestFilterParams;
  first?: Scalars['Int']['input'];
  sort?: ServiceRequestSortParams;
  upid: Scalars['ID']['input'];
};


export type QueryServiceRequestHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QueryServiceRequestListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: ServiceRequestFilterParams;
  upid: Scalars['ID']['input'];
};


export type QuerySupplyRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplyRequestConnectionArgs = {
  after?: Scalars['String']['input'];
  filter?: SupplyRequestFilterParams;
  first?: Scalars['Int']['input'];
  sort?: SupplyRequestSortParams;
  upid: Scalars['ID']['input'];
};


export type QuerySupplyRequestHistoryArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type QuerySupplyRequestListArgs = {
  _count?: Scalars['Int']['input'];
  filter?: SupplyRequestFilterParams;
  upid: Scalars['ID']['input'];
};

export type Questionnaire = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Questionnaire';
  approvalDate?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Array<Coding>>;
  contact?: Maybe<Array<ContactDetail>>;
  contained?: Maybe<Array<Resource>>;
  copyright?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  derivedFrom?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  effectivePeriod?: Maybe<Period>;
  experimental?: Maybe<Scalars['Boolean']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Array<QuestionnaireItem>>;
  jurisdiction?: Maybe<Array<CodeableConcept>>;
  language?: Maybe<Scalars['String']['output']>;
  lastReviewDate?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<Scalars['String']['output']>;
  publisher?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  resourceType: Scalars['String']['output'];
  status: PublicationStatus;
  subjectType?: Maybe<Array<ResourceTypes>>;
  text?: Maybe<Narrative>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  useContext?: Maybe<Array<UsageContext>>;
  version?: Maybe<Scalars['String']['output']>;
};

export enum QuestionnaireAnswersStatus {
  Amended = 'amended',
  Completed = 'completed',
  EnteredInError = 'entered_in_error',
  InProgress = 'in_progress',
  Stopped = 'stopped'
}

export enum QuestionnaireEnableBehavior {
  All = 'all',
  Any = 'any'
}

export enum QuestionnaireEnableOperator {
  Equal = 'equal',
  Exists = 'exists',
  GreaterThan = 'greaterThan',
  GreaterThanEqual = 'greaterThanEqual',
  LessThan = 'lessThan',
  LessThanEqual = 'lessThanEqual',
  NotEqual = 'notEqual'
}

export type QuestionnaireItem = BackboneElementInterface & ElementInterface & {
  __typename?: 'QuestionnaireItem';
  answerOption?: Maybe<Array<QuestionnaireItemAnswerOption>>;
  answerValueSet?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Array<Coding>>;
  definition?: Maybe<Scalars['String']['output']>;
  enableBehavior?: Maybe<QuestionnaireEnableBehavior>;
  enableWhen?: Maybe<Array<QuestionnaireItemEnableWhen>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  initial?: Maybe<Array<QuestionnaireItemInitial>>;
  item?: Maybe<Array<QuestionnaireItem>>;
  linkId: Scalars['String']['output'];
  maxLength?: Maybe<Scalars['Int']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  prefix?: Maybe<Scalars['String']['output']>;
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  repeats?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type: ItemType;
};

export type QuestionnaireItemAnswerOption = BackboneElementInterface & ElementInterface & {
  __typename?: 'QuestionnaireItemAnswerOption';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  initialSelected?: Maybe<Scalars['Boolean']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  valueCoding?: Maybe<Coding>;
  valueDate?: Maybe<Scalars['String']['output']>;
  valueInteger?: Maybe<Scalars['Int']['output']>;
  valueReference?: Maybe<Reference>;
  valueString?: Maybe<Scalars['String']['output']>;
  valueTime?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireItemEnableWhen = BackboneElementInterface & ElementInterface & {
  __typename?: 'QuestionnaireItemEnableWhen';
  answerBoolean?: Maybe<Scalars['Boolean']['output']>;
  answerCoding?: Maybe<Coding>;
  answerDate?: Maybe<Scalars['String']['output']>;
  answerDateTime?: Maybe<Scalars['String']['output']>;
  answerDecimal?: Maybe<Scalars['Float']['output']>;
  answerInteger?: Maybe<Scalars['Int']['output']>;
  answerQuantity?: Maybe<Quantity>;
  answerReference?: Maybe<Reference>;
  answerString?: Maybe<Scalars['String']['output']>;
  answerTime?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  operator: QuestionnaireEnableOperator;
  question: Scalars['String']['output'];
};

export type QuestionnaireItemInitial = BackboneElementInterface & ElementInterface & {
  __typename?: 'QuestionnaireItemInitial';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  valueAttachment?: Maybe<Attachment>;
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  valueCoding?: Maybe<Coding>;
  valueDate?: Maybe<Scalars['String']['output']>;
  valueDateTime?: Maybe<Scalars['String']['output']>;
  valueDecimal?: Maybe<Scalars['Float']['output']>;
  valueInteger?: Maybe<Scalars['Int']['output']>;
  valueQuantity?: Maybe<Quantity>;
  valueReference?: Maybe<Reference>;
  valueString?: Maybe<Scalars['String']['output']>;
  valueTime?: Maybe<Scalars['String']['output']>;
  valueUri?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireResponse = DomainResourceInterface & ResourceInterface & {
  __typename?: 'QuestionnaireResponse';
  author?: Maybe<Reference>;
  authored?: Maybe<Scalars['String']['output']>;
  basedOn?: Maybe<Array<Reference>>;
  contained?: Maybe<Array<Resource>>;
  encounter?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Identifier>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Array<QuestionnaireResponseItem>>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  partOf?: Maybe<Array<Reference>>;
  questionnaire?: Maybe<Scalars['String']['output']>;
  resourceType: Scalars['String']['output'];
  source?: Maybe<Reference>;
  status: QuestionnaireAnswersStatus;
  subject?: Maybe<Reference>;
  text?: Maybe<Narrative>;
};

export type QuestionnaireResponseConnection = {
  __typename?: 'QuestionnaireResponseConnection';
  edges?: Maybe<Array<QuestionnaireResponseEdge>>;
  pageInfo: PageInfo;
};

export type QuestionnaireResponseEdge = {
  __typename?: 'QuestionnaireResponseEdge';
  cursor: Scalars['String']['output'];
  node: QuestionnaireResponse;
};

export type QuestionnaireResponseFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type QuestionnaireResponseItem = BackboneElementInterface & ElementInterface & {
  __typename?: 'QuestionnaireResponseItem';
  answer?: Maybe<Array<QuestionnaireResponseItemAnswer>>;
  definition?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  item?: Maybe<Array<QuestionnaireResponseItem>>;
  linkId: Scalars['String']['output'];
  modifierExtension?: Maybe<Array<Extension>>;
  text?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireResponseItemAnswer = BackboneElementInterface & ElementInterface & {
  __typename?: 'QuestionnaireResponseItemAnswer';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  item?: Maybe<Array<QuestionnaireResponseItem>>;
  modifierExtension?: Maybe<Array<Extension>>;
  valueAttachment?: Maybe<Attachment>;
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  valueCoding?: Maybe<Coding>;
  valueDate?: Maybe<Scalars['String']['output']>;
  valueDateTime?: Maybe<Scalars['String']['output']>;
  valueDecimal?: Maybe<Scalars['Float']['output']>;
  valueInteger?: Maybe<Scalars['Int']['output']>;
  valueQuantity?: Maybe<Quantity>;
  valueReference?: Maybe<Reference>;
  valueString?: Maybe<Scalars['String']['output']>;
  valueTime?: Maybe<Scalars['String']['output']>;
  valueUri?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireResponseSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export type Range = ElementInterface & {
  __typename?: 'Range';
  extension?: Maybe<Array<Extension>>;
  high?: Maybe<Quantity>;
  id?: Maybe<Scalars['ID']['output']>;
  low?: Maybe<Quantity>;
};

export type Ratio = ElementInterface & {
  __typename?: 'Ratio';
  denominator?: Maybe<Quantity>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  numerator?: Maybe<Quantity>;
};

export enum ReactionEventSeverity {
  Mild = 'mild',
  Moderate = 'moderate',
  Severe = 'severe'
}

export type Reference = ElementInterface & {
  __typename?: 'Reference';
  display?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Identifier>;
  reference?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<ResourceInterface>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RelatedArtifact = ElementInterface & {
  __typename?: 'RelatedArtifact';
  citation?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Attachment>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
  type: RelatedArtifactType;
  url?: Maybe<Scalars['String']['output']>;
};

export enum RelatedArtifactType {
  Citation = 'citation',
  ComposedOf = 'composed_of',
  DependsOn = 'depends_on',
  DerivedFrom = 'derived_from',
  Documentation = 'documentation',
  Justification = 'justification',
  Predecessor = 'predecessor',
  Successor = 'successor'
}

export type RelatedPerson = DomainResourceInterface & ResourceInterface & {
  __typename?: 'RelatedPerson';
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Array<Address>>;
  birthDate?: Maybe<Scalars['String']['output']>;
  communication?: Maybe<Array<RelatedPersonCommunication>>;
  contained?: Maybe<Array<Resource>>;
  extension?: Maybe<Array<Extension>>;
  gender?: Maybe<AdministrativeGender>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<Array<HumanName>>;
  patient: Reference;
  period?: Maybe<Period>;
  photo?: Maybe<Array<Attachment>>;
  relationship?: Maybe<Array<CodeableConcept>>;
  resourceType: Scalars['String']['output'];
  telecom?: Maybe<Array<ContactPoint>>;
  text?: Maybe<Narrative>;
};

export type RelatedPersonCommunication = BackboneElementInterface & ElementInterface & {
  __typename?: 'RelatedPersonCommunication';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  language: CodeableConcept;
  modifierExtension?: Maybe<Array<Extension>>;
  preferred?: Maybe<Scalars['Boolean']['output']>;
};

export type RelatedPersonConnection = {
  __typename?: 'RelatedPersonConnection';
  edges?: Maybe<Array<RelatedPersonEdge>>;
  pageInfo: PageInfo;
};

export type RelatedPersonEdge = {
  __typename?: 'RelatedPersonEdge';
  cursor: Scalars['String']['output'];
  node: RelatedPerson;
};

export type RelatedPersonFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type RelatedPersonSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export enum RemittanceOutcome {
  Complete = 'complete',
  Error = 'error',
  Partial = 'partial',
  Queued = 'queued'
}

export enum RepositoryType {
  Directlink = 'directlink',
  Login = 'login',
  Oauth = 'oauth',
  Openapi = 'openapi',
  Other = 'other'
}

export type RequestGroup = DomainResourceInterface & ResourceInterface & {
  __typename?: 'RequestGroup';
  action?: Maybe<Array<RequestGroupAction>>;
  author?: Maybe<Reference>;
  authoredOn?: Maybe<Scalars['String']['output']>;
  basedOn?: Maybe<Array<Reference>>;
  code?: Maybe<CodeableConcept>;
  contained?: Maybe<Array<Resource>>;
  encounter?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  groupIdentifier?: Maybe<Identifier>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  instantiatesCanonical?: Maybe<Array<Scalars['String']['output']>>;
  instantiatesUri?: Maybe<Array<Scalars['String']['output']>>;
  intent: RequestIntent;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  priority?: Maybe<RequestPriority>;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  reasonReference?: Maybe<Array<Reference>>;
  replaces?: Maybe<Array<Reference>>;
  resourceType: Scalars['String']['output'];
  status: RequestStatus;
  subject?: Maybe<Reference>;
  text?: Maybe<Narrative>;
};

export type RequestGroupAction = BackboneElementInterface & ElementInterface & {
  __typename?: 'RequestGroupAction';
  action?: Maybe<Array<RequestGroupAction>>;
  cardinalityBehavior?: Maybe<ActionCardinalityBehavior>;
  code?: Maybe<Array<CodeableConcept>>;
  condition?: Maybe<Array<RequestGroupActionCondition>>;
  description?: Maybe<Scalars['String']['output']>;
  documentation?: Maybe<Array<RelatedArtifact>>;
  extension?: Maybe<Array<Extension>>;
  groupingBehavior?: Maybe<ActionGroupingBehavior>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  participant?: Maybe<Array<Reference>>;
  precheckBehavior?: Maybe<ActionPrecheckBehavior>;
  prefix?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<RequestPriority>;
  relatedAction?: Maybe<Array<RequestGroupActionRelatedAction>>;
  requiredBehavior?: Maybe<ActionRequiredBehavior>;
  resource?: Maybe<Reference>;
  selectionBehavior?: Maybe<ActionSelectionBehavior>;
  textEquivalent?: Maybe<Scalars['String']['output']>;
  timingAge?: Maybe<Age>;
  timingDateTime?: Maybe<Scalars['String']['output']>;
  timingDuration?: Maybe<Duration>;
  timingPeriod?: Maybe<Period>;
  timingRange?: Maybe<Range>;
  timingTiming?: Maybe<Timing>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CodeableConcept>;
};

export type RequestGroupActionCondition = BackboneElementInterface & ElementInterface & {
  __typename?: 'RequestGroupActionCondition';
  expression?: Maybe<Expression>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  kind: ActionConditionKind;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type RequestGroupActionRelatedAction = BackboneElementInterface & ElementInterface & {
  __typename?: 'RequestGroupActionRelatedAction';
  actionId: Scalars['ID']['output'];
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  offsetDuration?: Maybe<Duration>;
  offsetRange?: Maybe<Range>;
  relationship: ActionRelationshipType;
};

export enum RequestIntent {
  Directive = 'directive',
  FillerOrder = 'filler_order',
  InstanceOrder = 'instance_order',
  Option = 'option',
  Order = 'order',
  OriginalOrder = 'original_order',
  Plan = 'plan',
  Proposal = 'proposal',
  ReflexOrder = 'reflex_order'
}

export enum RequestPriority {
  Asap = 'asap',
  Routine = 'routine',
  Stat = 'stat',
  Urgent = 'urgent'
}

export enum RequestStatus {
  Active = 'active',
  Completed = 'completed',
  Draft = 'draft',
  EnteredInError = 'entered_in_error',
  OnHold = 'on_hold',
  Revoked = 'revoked',
  Unknown = 'unknown'
}

export type ResearchStudy = DomainResourceInterface & ResourceInterface & {
  __typename?: 'ResearchStudy';
  arm?: Maybe<Array<ResearchStudyArm>>;
  category?: Maybe<Array<CodeableConcept>>;
  condition?: Maybe<Array<CodeableConcept>>;
  contact?: Maybe<Array<ContactDetail>>;
  contained?: Maybe<Array<Resource>>;
  description?: Maybe<Scalars['String']['output']>;
  enrollment?: Maybe<Array<Reference>>;
  extension?: Maybe<Array<Extension>>;
  focus?: Maybe<Array<CodeableConcept>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  keyword?: Maybe<Array<CodeableConcept>>;
  language?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Array<CodeableConcept>>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  objective?: Maybe<Array<ResearchStudyObjective>>;
  partOf?: Maybe<Array<Reference>>;
  period?: Maybe<Period>;
  phase?: Maybe<CodeableConcept>;
  primaryPurposeType?: Maybe<CodeableConcept>;
  principalInvestigator?: Maybe<Reference>;
  protocol?: Maybe<Array<Reference>>;
  reasonStopped?: Maybe<CodeableConcept>;
  relatedArtifact?: Maybe<Array<RelatedArtifact>>;
  resourceType: Scalars['String']['output'];
  site?: Maybe<Array<Reference>>;
  sponsor?: Maybe<Reference>;
  status: ResearchStudyStatus;
  text?: Maybe<Narrative>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ResearchStudyArm = BackboneElementInterface & ElementInterface & {
  __typename?: 'ResearchStudyArm';
  description?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  name: Scalars['String']['output'];
  type?: Maybe<CodeableConcept>;
};

export type ResearchStudyObjective = BackboneElementInterface & ElementInterface & {
  __typename?: 'ResearchStudyObjective';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CodeableConcept>;
};

export enum ResearchStudyStatus {
  Active = 'active',
  AdministrativelyCompleted = 'administratively_completed',
  Approved = 'approved',
  ClosedToAccrual = 'closed_to_accrual',
  ClosedToAccrualAndIntervention = 'closed_to_accrual_and_intervention',
  Completed = 'completed',
  Disapproved = 'disapproved',
  InReview = 'in_review',
  TemporarilyClosedToAccrual = 'temporarily_closed_to_accrual',
  TemporarilyClosedToAccrualAndIntervention = 'temporarily_closed_to_accrual_and_intervention',
  Withdrawn = 'withdrawn'
}

export type Resource = {
  __typename?: 'Resource';
  id?: Maybe<Scalars['ID']['output']>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  resource?: Maybe<ResourceInterface>;
  resourceType: Scalars['String']['output'];
};

export type ResourceInterface = {
  id?: Maybe<Scalars['ID']['output']>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
};

export enum ResourceTypes {
  Account = 'Account',
  ActivityDefinition = 'ActivityDefinition',
  AdverseEvent = 'AdverseEvent',
  AllergyIntolerance = 'AllergyIntolerance',
  Appointment = 'Appointment',
  AppointmentResponse = 'AppointmentResponse',
  AuditEvent = 'AuditEvent',
  Basic = 'Basic',
  Binary = 'Binary',
  BiologicallyDerivedProduct = 'BiologicallyDerivedProduct',
  BodyStructure = 'BodyStructure',
  Bundle = 'Bundle',
  CapabilityStatement = 'CapabilityStatement',
  CarePlan = 'CarePlan',
  CareTeam = 'CareTeam',
  CatalogEntry = 'CatalogEntry',
  ChargeItem = 'ChargeItem',
  ChargeItemDefinition = 'ChargeItemDefinition',
  Claim = 'Claim',
  ClaimResponse = 'ClaimResponse',
  ClinicalImpression = 'ClinicalImpression',
  CodeSystem = 'CodeSystem',
  Communication = 'Communication',
  CommunicationRequest = 'CommunicationRequest',
  CompartmentDefinition = 'CompartmentDefinition',
  Composition = 'Composition',
  ConceptMap = 'ConceptMap',
  Condition = 'Condition',
  Consent = 'Consent',
  Contract = 'Contract',
  Coverage = 'Coverage',
  CoverageEligibilityRequest = 'CoverageEligibilityRequest',
  CoverageEligibilityResponse = 'CoverageEligibilityResponse',
  DetectedIssue = 'DetectedIssue',
  Device = 'Device',
  DeviceDefinition = 'DeviceDefinition',
  DeviceMetric = 'DeviceMetric',
  DeviceRequest = 'DeviceRequest',
  DeviceUseStatement = 'DeviceUseStatement',
  DiagnosticReport = 'DiagnosticReport',
  DocumentManifest = 'DocumentManifest',
  DocumentReference = 'DocumentReference',
  DomainResource = 'DomainResource',
  EffectEvidenceSynthesis = 'EffectEvidenceSynthesis',
  Encounter = 'Encounter',
  Endpoint = 'Endpoint',
  EnrollmentRequest = 'EnrollmentRequest',
  EnrollmentResponse = 'EnrollmentResponse',
  EpisodeOfCare = 'EpisodeOfCare',
  EventDefinition = 'EventDefinition',
  Evidence = 'Evidence',
  EvidenceVariable = 'EvidenceVariable',
  ExampleScenario = 'ExampleScenario',
  ExplanationOfBenefit = 'ExplanationOfBenefit',
  FamilyMemberHistory = 'FamilyMemberHistory',
  Flag = 'Flag',
  Goal = 'Goal',
  GraphDefinition = 'GraphDefinition',
  Group = 'Group',
  GuidanceResponse = 'GuidanceResponse',
  HealthcareService = 'HealthcareService',
  ImagingStudy = 'ImagingStudy',
  Immunization = 'Immunization',
  ImmunizationEvaluation = 'ImmunizationEvaluation',
  ImmunizationRecommendation = 'ImmunizationRecommendation',
  ImplementationGuide = 'ImplementationGuide',
  InsurancePlan = 'InsurancePlan',
  Invoice = 'Invoice',
  Library = 'Library',
  Linkage = 'Linkage',
  List = 'List',
  Location = 'Location',
  Measure = 'Measure',
  MeasureReport = 'MeasureReport',
  Media = 'Media',
  Medication = 'Medication',
  MedicationAdministration = 'MedicationAdministration',
  MedicationDispense = 'MedicationDispense',
  MedicationKnowledge = 'MedicationKnowledge',
  MedicationRequest = 'MedicationRequest',
  MedicationStatement = 'MedicationStatement',
  MedicinalProduct = 'MedicinalProduct',
  MedicinalProductAuthorization = 'MedicinalProductAuthorization',
  MedicinalProductContraindication = 'MedicinalProductContraindication',
  MedicinalProductIndication = 'MedicinalProductIndication',
  MedicinalProductIngredient = 'MedicinalProductIngredient',
  MedicinalProductInteraction = 'MedicinalProductInteraction',
  MedicinalProductManufactured = 'MedicinalProductManufactured',
  MedicinalProductPackaged = 'MedicinalProductPackaged',
  MedicinalProductPharmaceutical = 'MedicinalProductPharmaceutical',
  MedicinalProductUndesirableEffect = 'MedicinalProductUndesirableEffect',
  MessageDefinition = 'MessageDefinition',
  MessageHeader = 'MessageHeader',
  MolecularSequence = 'MolecularSequence',
  NamingSystem = 'NamingSystem',
  NutritionOrder = 'NutritionOrder',
  Observation = 'Observation',
  ObservationDefinition = 'ObservationDefinition',
  OperationDefinition = 'OperationDefinition',
  OperationOutcome = 'OperationOutcome',
  Organization = 'Organization',
  OrganizationAffiliation = 'OrganizationAffiliation',
  Parameters = 'Parameters',
  Patient = 'Patient',
  PaymentNotice = 'PaymentNotice',
  PaymentReconciliation = 'PaymentReconciliation',
  Person = 'Person',
  PlanDefinition = 'PlanDefinition',
  Practitioner = 'Practitioner',
  PractitionerRole = 'PractitionerRole',
  Procedure = 'Procedure',
  Provenance = 'Provenance',
  Questionnaire = 'Questionnaire',
  QuestionnaireResponse = 'QuestionnaireResponse',
  RelatedPerson = 'RelatedPerson',
  RequestGroup = 'RequestGroup',
  ResearchDefinition = 'ResearchDefinition',
  ResearchElementDefinition = 'ResearchElementDefinition',
  ResearchStudy = 'ResearchStudy',
  ResearchSubject = 'ResearchSubject',
  Resource = 'Resource',
  RiskAssessment = 'RiskAssessment',
  RiskEvidenceSynthesis = 'RiskEvidenceSynthesis',
  Schedule = 'Schedule',
  SearchParameter = 'SearchParameter',
  ServiceRequest = 'ServiceRequest',
  Slot = 'Slot',
  Specimen = 'Specimen',
  SpecimenDefinition = 'SpecimenDefinition',
  StructureDefinition = 'StructureDefinition',
  StructureMap = 'StructureMap',
  Subscription = 'Subscription',
  Substance = 'Substance',
  SubstanceNucleicAcid = 'SubstanceNucleicAcid',
  SubstancePolymer = 'SubstancePolymer',
  SubstanceProtein = 'SubstanceProtein',
  SubstanceReferenceInformation = 'SubstanceReferenceInformation',
  SubstanceSourceMaterial = 'SubstanceSourceMaterial',
  SubstanceSpecification = 'SubstanceSpecification',
  SupplyDelivery = 'SupplyDelivery',
  SupplyRequest = 'SupplyRequest',
  Task = 'Task',
  TerminologyCapabilities = 'TerminologyCapabilities',
  TestReport = 'TestReport',
  TestScript = 'TestScript',
  ValueSet = 'ValueSet',
  VerificationResult = 'VerificationResult',
  VisionPrescription = 'VisionPrescription'
}

export type RiskAssessment = DomainResourceInterface & ResourceInterface & {
  __typename?: 'RiskAssessment';
  basedOn?: Maybe<Reference>;
  basis?: Maybe<Array<Reference>>;
  code?: Maybe<CodeableConcept>;
  condition?: Maybe<Reference>;
  contained?: Maybe<Array<Resource>>;
  encounter?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  method?: Maybe<CodeableConcept>;
  mitigation?: Maybe<Scalars['String']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  occurrenceDateTime?: Maybe<Scalars['String']['output']>;
  occurrencePeriod?: Maybe<Period>;
  parent?: Maybe<Reference>;
  performer?: Maybe<Reference>;
  prediction?: Maybe<Array<RiskAssessmentPrediction>>;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  reasonReference?: Maybe<Array<Reference>>;
  resourceType: Scalars['String']['output'];
  status: ObservationStatus;
  subject: Reference;
  text?: Maybe<Narrative>;
};

export type RiskAssessmentPrediction = BackboneElementInterface & ElementInterface & {
  __typename?: 'RiskAssessmentPrediction';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  outcome?: Maybe<CodeableConcept>;
  probabilityDecimal?: Maybe<Scalars['Float']['output']>;
  probabilityRange?: Maybe<Range>;
  qualitativeRisk?: Maybe<CodeableConcept>;
  rationale?: Maybe<Scalars['String']['output']>;
  relativeRisk?: Maybe<Scalars['Float']['output']>;
  whenPeriod?: Maybe<Period>;
  whenRange?: Maybe<Range>;
};

export type SampledData = ElementInterface & {
  __typename?: 'SampledData';
  data?: Maybe<Scalars['String']['output']>;
  dimensions: Scalars['Int']['output'];
  extension?: Maybe<Array<Extension>>;
  factor?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lowerLimit?: Maybe<Scalars['Float']['output']>;
  origin: Quantity;
  period: Scalars['Float']['output'];
  upperLimit?: Maybe<Scalars['Float']['output']>;
};

export type Schedule = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Schedule';
  active?: Maybe<Scalars['Boolean']['output']>;
  actor: Array<Reference>;
  comment?: Maybe<Scalars['String']['output']>;
  contained?: Maybe<Array<Resource>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  planningHorizon?: Maybe<Period>;
  resourceType: Scalars['String']['output'];
  serviceCategory?: Maybe<Array<CodeableConcept>>;
  serviceType?: Maybe<Array<CodeableConcept>>;
  specialty?: Maybe<Array<CodeableConcept>>;
  text?: Maybe<Narrative>;
};

export type SearchConnection = {
  __typename?: 'SearchConnection';
  edges: Array<SearchEdge>;
  pageInfo: PageInfo;
};

export type SearchContext = {
  __typename?: 'SearchContext';
  location: Scalars['String']['output'];
  term: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type SearchEdge = {
  __typename?: 'SearchEdge';
  cursor: Scalars['String']['output'];
  node: SearchResult;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  context: SearchContext;
  id: Scalars['ID']['output'];
  resource: ResourceInterface;
  resourceType: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export enum SequenceType {
  Aa = 'aa',
  Dna = 'dna',
  Rna = 'rna'
}

export type ServiceRequest = DomainResourceInterface & ResourceInterface & {
  __typename?: 'ServiceRequest';
  asNeededBoolean?: Maybe<Scalars['Boolean']['output']>;
  asNeededCodeableConcept?: Maybe<CodeableConcept>;
  authoredOn?: Maybe<Scalars['String']['output']>;
  basedOn?: Maybe<Array<Reference>>;
  bodySite?: Maybe<Array<CodeableConcept>>;
  category?: Maybe<Array<CodeableConcept>>;
  code?: Maybe<CodeableConcept>;
  contained?: Maybe<Array<Resource>>;
  doNotPerform?: Maybe<Scalars['Boolean']['output']>;
  encounter?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  instantiatesCanonical?: Maybe<Array<Scalars['String']['output']>>;
  instantiatesUri?: Maybe<Array<Scalars['String']['output']>>;
  insurance?: Maybe<Array<Reference>>;
  intent: RequestIntent;
  language?: Maybe<Scalars['String']['output']>;
  locationCode?: Maybe<Array<CodeableConcept>>;
  locationReference?: Maybe<Array<Reference>>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  occurrenceDateTime?: Maybe<Scalars['String']['output']>;
  occurrencePeriod?: Maybe<Period>;
  occurrenceTiming?: Maybe<Timing>;
  orderDetail?: Maybe<Array<CodeableConcept>>;
  patientInstruction?: Maybe<Scalars['String']['output']>;
  performer?: Maybe<Array<Reference>>;
  performerType?: Maybe<CodeableConcept>;
  priority?: Maybe<RequestPriority>;
  quantityQuantity?: Maybe<Quantity>;
  quantityRange?: Maybe<Range>;
  quantityRatio?: Maybe<Ratio>;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  reasonReference?: Maybe<Array<Reference>>;
  relevantHistory?: Maybe<Array<Reference>>;
  replaces?: Maybe<Array<Reference>>;
  requester?: Maybe<Reference>;
  requisition?: Maybe<Identifier>;
  resourceType: Scalars['String']['output'];
  specimen?: Maybe<Array<Reference>>;
  status: RequestStatus;
  subject: Reference;
  supportingInfo?: Maybe<Array<Reference>>;
  text?: Maybe<Narrative>;
};

export type ServiceRequestConnection = {
  __typename?: 'ServiceRequestConnection';
  edges?: Maybe<Array<ServiceRequestEdge>>;
  pageInfo: PageInfo;
};

export type ServiceRequestEdge = {
  __typename?: 'ServiceRequestEdge';
  cursor: Scalars['String']['output'];
  node: ServiceRequest;
};

export type ServiceRequestFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type ServiceRequestSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export type Signature = ElementInterface & {
  __typename?: 'Signature';
  data?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  onBehalfOf?: Maybe<Reference>;
  sigFormat?: Maybe<Scalars['String']['output']>;
  targetFormat?: Maybe<Scalars['String']['output']>;
  type: Array<Coding>;
  when: Scalars['String']['output'];
  who: Reference;
};

export type Slot = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Slot';
  appointmentType?: Maybe<CodeableConcept>;
  comment?: Maybe<Scalars['String']['output']>;
  contained?: Maybe<Array<Resource>>;
  end: Scalars['String']['output'];
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  overbooked?: Maybe<Scalars['Boolean']['output']>;
  resourceType: Scalars['String']['output'];
  schedule: Reference;
  serviceCategory?: Maybe<Array<CodeableConcept>>;
  serviceType?: Maybe<Array<CodeableConcept>>;
  specialty?: Maybe<Array<CodeableConcept>>;
  start: Scalars['String']['output'];
  status: Slotstatus;
  text?: Maybe<Narrative>;
};

export enum Slotstatus {
  Busy = 'busy',
  BusyTentative = 'busy_tentative',
  BusyUnavailable = 'busy_unavailable',
  EnteredInError = 'entered_in_error',
  Free = 'free'
}

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortDirection {
  Ascending = 'ascending',
  Descending = 'descending'
}

export type Specimen = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Specimen';
  accessionIdentifier?: Maybe<Identifier>;
  collection?: Maybe<SpecimenCollection>;
  condition?: Maybe<Array<CodeableConcept>>;
  contained?: Maybe<Array<Resource>>;
  container?: Maybe<Array<SpecimenContainer>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  parent?: Maybe<Array<Reference>>;
  processing?: Maybe<Array<SpecimenProcessing>>;
  receivedTime?: Maybe<Scalars['String']['output']>;
  request?: Maybe<Array<Reference>>;
  resourceType: Scalars['String']['output'];
  status?: Maybe<SpecimenStatus>;
  subject?: Maybe<Reference>;
  text?: Maybe<Narrative>;
  type?: Maybe<CodeableConcept>;
};

export type SpecimenCollection = BackboneElementInterface & ElementInterface & {
  __typename?: 'SpecimenCollection';
  bodySite?: Maybe<CodeableConcept>;
  collectedDateTime?: Maybe<Scalars['String']['output']>;
  collectedPeriod?: Maybe<Period>;
  collector?: Maybe<Reference>;
  duration?: Maybe<Duration>;
  extension?: Maybe<Array<Extension>>;
  fastingStatusCodeableConcept?: Maybe<CodeableConcept>;
  fastingStatusDuration?: Maybe<Duration>;
  id?: Maybe<Scalars['ID']['output']>;
  method?: Maybe<CodeableConcept>;
  modifierExtension?: Maybe<Array<Extension>>;
  quantity?: Maybe<Quantity>;
};

export type SpecimenContainer = BackboneElementInterface & ElementInterface & {
  __typename?: 'SpecimenContainer';
  additiveCodeableConcept?: Maybe<CodeableConcept>;
  additiveReference?: Maybe<Reference>;
  capacity?: Maybe<Quantity>;
  description?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  modifierExtension?: Maybe<Array<Extension>>;
  specimenQuantity?: Maybe<Quantity>;
  type?: Maybe<CodeableConcept>;
};

export type SpecimenProcessing = BackboneElementInterface & ElementInterface & {
  __typename?: 'SpecimenProcessing';
  additive?: Maybe<Array<Reference>>;
  description?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  procedure?: Maybe<CodeableConcept>;
  timeDateTime?: Maybe<Scalars['String']['output']>;
  timePeriod?: Maybe<Period>;
};

export enum SpecimenStatus {
  Available = 'available',
  EnteredInError = 'entered_in_error',
  Unavailable = 'unavailable',
  Unsatisfactory = 'unsatisfactory'
}

export enum StrandType {
  Crick = 'crick',
  Watson = 'watson'
}

export type Substance = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Substance';
  category?: Maybe<Array<CodeableConcept>>;
  code: CodeableConcept;
  contained?: Maybe<Array<Resource>>;
  description?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  ingredient?: Maybe<Array<SubstanceIngredient>>;
  instance?: Maybe<Array<SubstanceInstance>>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  resourceType: Scalars['String']['output'];
  status?: Maybe<SubstanceStatus>;
  text?: Maybe<Narrative>;
};

export type SubstanceIngredient = BackboneElementInterface & ElementInterface & {
  __typename?: 'SubstanceIngredient';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  quantity?: Maybe<Ratio>;
  substanceCodeableConcept?: Maybe<CodeableConcept>;
  substanceReference?: Maybe<Reference>;
};

export type SubstanceInstance = BackboneElementInterface & ElementInterface & {
  __typename?: 'SubstanceInstance';
  expiry?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Identifier>;
  modifierExtension?: Maybe<Array<Extension>>;
  quantity?: Maybe<Quantity>;
};

export enum SubstanceStatus {
  Active = 'active',
  EnteredInError = 'entered_in_error',
  Inactive = 'inactive'
}

export type SupplyRequest = DomainResourceInterface & ResourceInterface & {
  __typename?: 'SupplyRequest';
  authoredOn?: Maybe<Scalars['String']['output']>;
  category?: Maybe<CodeableConcept>;
  contained?: Maybe<Array<Resource>>;
  deliverFrom?: Maybe<Reference>;
  deliverTo?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  itemCodeableConcept?: Maybe<CodeableConcept>;
  itemReference?: Maybe<Reference>;
  language?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  occurrenceDateTime?: Maybe<Scalars['String']['output']>;
  occurrencePeriod?: Maybe<Period>;
  occurrenceTiming?: Maybe<Timing>;
  parameter?: Maybe<Array<SupplyRequestParameter>>;
  priority?: Maybe<RequestPriority>;
  quantity: Quantity;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  reasonReference?: Maybe<Array<Reference>>;
  requester?: Maybe<Reference>;
  resourceType: Scalars['String']['output'];
  status?: Maybe<SupplyrequestStatus>;
  supplier?: Maybe<Array<Reference>>;
  text?: Maybe<Narrative>;
};

export type SupplyRequestConnection = {
  __typename?: 'SupplyRequestConnection';
  edges?: Maybe<Array<SupplyRequestEdge>>;
  pageInfo: PageInfo;
};

export type SupplyRequestEdge = {
  __typename?: 'SupplyRequestEdge';
  cursor: Scalars['String']['output'];
  node: SupplyRequest;
};

export type SupplyRequestFilterParams = {
  ids?: InputMaybe<FilterComparatorStringSet>;
  security?: InputMaybe<FilterComparatorStringSet>;
  tag?: InputMaybe<FilterComparatorStringSet>;
};

export type SupplyRequestParameter = BackboneElementInterface & ElementInterface & {
  __typename?: 'SupplyRequestParameter';
  code?: Maybe<CodeableConcept>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  valueCodeableConcept?: Maybe<CodeableConcept>;
  valueQuantity?: Maybe<Quantity>;
  valueRange?: Maybe<Range>;
};

export type SupplyRequestSortParams = {
  lastUpdated?: InputMaybe<Sort>;
};

export enum SupplyrequestStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Draft = 'draft',
  EnteredInError = 'entered_in_error',
  Suspended = 'suspended',
  Unknown = 'unknown'
}

export type Task = DomainResourceInterface & ResourceInterface & {
  __typename?: 'Task';
  authoredOn?: Maybe<Scalars['String']['output']>;
  basedOn?: Maybe<Array<Reference>>;
  businessStatus?: Maybe<CodeableConcept>;
  code?: Maybe<CodeableConcept>;
  contained?: Maybe<Array<Resource>>;
  description?: Maybe<Scalars['String']['output']>;
  encounter?: Maybe<Reference>;
  executionPeriod?: Maybe<Period>;
  extension?: Maybe<Array<Extension>>;
  focus?: Maybe<Reference>;
  for?: Maybe<Reference>;
  groupIdentifier?: Maybe<Identifier>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  input?: Maybe<Array<TaskInput>>;
  instantiatesCanonical?: Maybe<Scalars['String']['output']>;
  instantiatesUri?: Maybe<Scalars['String']['output']>;
  insurance?: Maybe<Array<Reference>>;
  intent: TaskIntent;
  language?: Maybe<Scalars['String']['output']>;
  lastModified?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Reference>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  output?: Maybe<Array<TaskOutput>>;
  owner?: Maybe<Reference>;
  partOf?: Maybe<Array<Reference>>;
  performerType?: Maybe<Array<CodeableConcept>>;
  priority?: Maybe<RequestPriority>;
  reasonCode?: Maybe<CodeableConcept>;
  reasonReference?: Maybe<Reference>;
  relevantHistory?: Maybe<Array<Reference>>;
  requester?: Maybe<Reference>;
  resourceType: Scalars['String']['output'];
  restriction?: Maybe<TaskRestriction>;
  status: TaskStatus;
  statusReason?: Maybe<CodeableConcept>;
  text?: Maybe<Narrative>;
};

export type TaskInput = BackboneElementInterface & ElementInterface & {
  __typename?: 'TaskInput';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  type: CodeableConcept;
  valueAddress?: Maybe<Address>;
  valueAge?: Maybe<Age>;
  valueAnnotation?: Maybe<Annotation>;
  valueAttachment?: Maybe<Attachment>;
  valueBase64Binary?: Maybe<Scalars['String']['output']>;
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  valueCanonical?: Maybe<Scalars['String']['output']>;
  valueCode?: Maybe<Scalars['String']['output']>;
  valueCodeableConcept?: Maybe<CodeableConcept>;
  valueCoding?: Maybe<Coding>;
  valueContactDetail?: Maybe<ContactDetail>;
  valueContactPoint?: Maybe<ContactPoint>;
  valueContributor?: Maybe<Contributor>;
  valueCount?: Maybe<Count>;
  valueDataRequirement?: Maybe<DataRequirement>;
  valueDate?: Maybe<Scalars['String']['output']>;
  valueDateTime?: Maybe<Scalars['String']['output']>;
  valueDecimal?: Maybe<Scalars['Float']['output']>;
  valueDistance?: Maybe<Distance>;
  valueDosage?: Maybe<Dosage>;
  valueDuration?: Maybe<Duration>;
  valueExpression?: Maybe<Expression>;
  valueHumanName?: Maybe<HumanName>;
  valueId?: Maybe<Scalars['ID']['output']>;
  valueIdentifier?: Maybe<Identifier>;
  valueInstant?: Maybe<Scalars['String']['output']>;
  valueInteger?: Maybe<Scalars['Int']['output']>;
  valueMarkdown?: Maybe<Scalars['String']['output']>;
  valueMeta?: Maybe<Meta>;
  valueMoney?: Maybe<Money>;
  valueOid?: Maybe<Scalars['String']['output']>;
  valueParameterDefinition?: Maybe<ParameterDefinition>;
  valuePeriod?: Maybe<Period>;
  valuePositiveInt?: Maybe<Scalars['Int']['output']>;
  valueQuantity?: Maybe<Quantity>;
  valueRange?: Maybe<Range>;
  valueRatio?: Maybe<Ratio>;
  valueReference?: Maybe<Reference>;
  valueRelatedArtifact?: Maybe<RelatedArtifact>;
  valueSampledData?: Maybe<SampledData>;
  valueSignature?: Maybe<Signature>;
  valueString?: Maybe<Scalars['String']['output']>;
  valueTime?: Maybe<Scalars['String']['output']>;
  valueTiming?: Maybe<Timing>;
  valueTriggerDefinition?: Maybe<TriggerDefinition>;
  valueUnsignedInt?: Maybe<Scalars['Int']['output']>;
  valueUri?: Maybe<Scalars['String']['output']>;
  valueUrl?: Maybe<Scalars['String']['output']>;
  valueUsageContext?: Maybe<UsageContext>;
  valueUuid?: Maybe<Scalars['String']['output']>;
};

export enum TaskIntent {
  FillerOrder = 'filler_order',
  InstanceOrder = 'instance_order',
  Option = 'option',
  Order = 'order',
  OriginalOrder = 'original_order',
  Plan = 'plan',
  Proposal = 'proposal',
  ReflexOrder = 'reflex_order',
  Unknown = 'unknown'
}

export type TaskOutput = BackboneElementInterface & ElementInterface & {
  __typename?: 'TaskOutput';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  type: CodeableConcept;
  valueAddress?: Maybe<Address>;
  valueAge?: Maybe<Age>;
  valueAnnotation?: Maybe<Annotation>;
  valueAttachment?: Maybe<Attachment>;
  valueBase64Binary?: Maybe<Scalars['String']['output']>;
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  valueCanonical?: Maybe<Scalars['String']['output']>;
  valueCode?: Maybe<Scalars['String']['output']>;
  valueCodeableConcept?: Maybe<CodeableConcept>;
  valueCoding?: Maybe<Coding>;
  valueContactDetail?: Maybe<ContactDetail>;
  valueContactPoint?: Maybe<ContactPoint>;
  valueContributor?: Maybe<Contributor>;
  valueCount?: Maybe<Count>;
  valueDataRequirement?: Maybe<DataRequirement>;
  valueDate?: Maybe<Scalars['String']['output']>;
  valueDateTime?: Maybe<Scalars['String']['output']>;
  valueDecimal?: Maybe<Scalars['Float']['output']>;
  valueDistance?: Maybe<Distance>;
  valueDosage?: Maybe<Dosage>;
  valueDuration?: Maybe<Duration>;
  valueExpression?: Maybe<Expression>;
  valueHumanName?: Maybe<HumanName>;
  valueId?: Maybe<Scalars['ID']['output']>;
  valueIdentifier?: Maybe<Identifier>;
  valueInstant?: Maybe<Scalars['String']['output']>;
  valueInteger?: Maybe<Scalars['Int']['output']>;
  valueMarkdown?: Maybe<Scalars['String']['output']>;
  valueMeta?: Maybe<Meta>;
  valueMoney?: Maybe<Money>;
  valueOid?: Maybe<Scalars['String']['output']>;
  valueParameterDefinition?: Maybe<ParameterDefinition>;
  valuePeriod?: Maybe<Period>;
  valuePositiveInt?: Maybe<Scalars['Int']['output']>;
  valueQuantity?: Maybe<Quantity>;
  valueRange?: Maybe<Range>;
  valueRatio?: Maybe<Ratio>;
  valueReference?: Maybe<Reference>;
  valueRelatedArtifact?: Maybe<RelatedArtifact>;
  valueSampledData?: Maybe<SampledData>;
  valueSignature?: Maybe<Signature>;
  valueString?: Maybe<Scalars['String']['output']>;
  valueTime?: Maybe<Scalars['String']['output']>;
  valueTiming?: Maybe<Timing>;
  valueTriggerDefinition?: Maybe<TriggerDefinition>;
  valueUnsignedInt?: Maybe<Scalars['Int']['output']>;
  valueUri?: Maybe<Scalars['String']['output']>;
  valueUrl?: Maybe<Scalars['String']['output']>;
  valueUsageContext?: Maybe<UsageContext>;
  valueUuid?: Maybe<Scalars['String']['output']>;
};

export type TaskRestriction = BackboneElementInterface & ElementInterface & {
  __typename?: 'TaskRestriction';
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  period?: Maybe<Period>;
  recipient?: Maybe<Array<Reference>>;
  repetitions?: Maybe<Scalars['Int']['output']>;
};

export enum TaskStatus {
  Accepted = 'accepted',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Draft = 'draft',
  EnteredInError = 'entered_in_error',
  Failed = 'failed',
  InProgress = 'in_progress',
  OnHold = 'on_hold',
  Ready = 'ready',
  Received = 'received',
  Rejected = 'rejected',
  Requested = 'requested'
}

export type Timing = BackboneElementInterface & ElementInterface & {
  __typename?: 'Timing';
  code?: Maybe<CodeableConcept>;
  event?: Maybe<Array<Scalars['String']['output']>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  repeat?: Maybe<TimingRepeat>;
};

export type TimingRepeat = ElementInterface & {
  __typename?: 'TimingRepeat';
  boundsDuration?: Maybe<Duration>;
  boundsPeriod?: Maybe<Period>;
  boundsRange?: Maybe<Range>;
  count?: Maybe<Scalars['Int']['output']>;
  countMax?: Maybe<Scalars['Int']['output']>;
  dayOfWeek?: Maybe<Array<DaysOfWeek>>;
  duration?: Maybe<Scalars['Float']['output']>;
  durationMax?: Maybe<Scalars['Float']['output']>;
  durationUnit?: Maybe<UnitsOfTime>;
  extension?: Maybe<Array<Extension>>;
  frequency?: Maybe<Scalars['Int']['output']>;
  frequencyMax?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  period?: Maybe<Scalars['Float']['output']>;
  periodMax?: Maybe<Scalars['Float']['output']>;
  periodUnit?: Maybe<UnitsOfTime>;
  timeOfDay?: Maybe<Array<Scalars['String']['output']>>;
  when?: Maybe<Array<EventTiming>>;
};

export type TriggerDefinition = ElementInterface & {
  __typename?: 'TriggerDefinition';
  condition?: Maybe<Expression>;
  data?: Maybe<Array<DataRequirement>>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  timingDate?: Maybe<Scalars['String']['output']>;
  timingDateTime?: Maybe<Scalars['String']['output']>;
  timingReference?: Maybe<Reference>;
  timingTiming?: Maybe<Timing>;
  type: TriggerType;
};

export enum TriggerType {
  DataAccessEnded = 'data_access_ended',
  DataAccessed = 'data_accessed',
  DataAdded = 'data_added',
  DataChanged = 'data_changed',
  DataModified = 'data_modified',
  DataRemoved = 'data_removed',
  NamedEvent = 'named_event',
  Periodic = 'periodic'
}

export enum UdiEntryType {
  Barcode = 'barcode',
  Card = 'card',
  Manual = 'manual',
  Rfid = 'rfid',
  SelfReported = 'self_reported',
  Unknown = 'unknown'
}

export enum UnitsOfTime {
  A = 'a',
  D = 'd',
  H = 'h',
  Min = 'min',
  Mo = 'mo',
  S = 's',
  Wk = 'wk'
}

export type UsageContext = ElementInterface & {
  __typename?: 'UsageContext';
  code: Coding;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  valueCodeableConcept?: Maybe<CodeableConcept>;
  valueQuantity?: Maybe<Quantity>;
  valueRange?: Maybe<Range>;
  valueReference?: Maybe<Reference>;
};

export enum VisionBaseCodes {
  Down = 'down',
  In = 'in',
  Out = 'out',
  Up = 'up'
}

export enum VisionEyeCodes {
  Left = 'left',
  Right = 'right'
}

export type VisionPrescription = DomainResourceInterface & ResourceInterface & {
  __typename?: 'VisionPrescription';
  contained?: Maybe<Array<Resource>>;
  created: Scalars['String']['output'];
  dateWritten: Scalars['String']['output'];
  encounter?: Maybe<Reference>;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Array<Identifier>>;
  implicitRules?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lensSpecification: Array<VisionPrescriptionLensSpecification>;
  meta?: Maybe<Meta>;
  modifierExtension?: Maybe<Array<Extension>>;
  patient: Reference;
  prescriber: Reference;
  resourceType: Scalars['String']['output'];
  status: FmStatus;
  text?: Maybe<Narrative>;
};

export type VisionPrescriptionLensSpecification = BackboneElementInterface & ElementInterface & {
  __typename?: 'VisionPrescriptionLensSpecification';
  add?: Maybe<Scalars['Float']['output']>;
  axis?: Maybe<Scalars['Int']['output']>;
  backCurve?: Maybe<Scalars['Float']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  cylinder?: Maybe<Scalars['Float']['output']>;
  diameter?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Quantity>;
  extension?: Maybe<Array<Extension>>;
  eye: VisionEyeCodes;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
  note?: Maybe<Array<Annotation>>;
  power?: Maybe<Scalars['Float']['output']>;
  prism?: Maybe<Array<VisionPrescriptionLensSpecificationPrism>>;
  product: CodeableConcept;
  sphere?: Maybe<Scalars['Float']['output']>;
};

export type VisionPrescriptionLensSpecificationPrism = BackboneElementInterface & ElementInterface & {
  __typename?: 'VisionPrescriptionLensSpecificationPrism';
  amount: Scalars['Float']['output'];
  base: VisionBaseCodes;
  extension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['ID']['output']>;
  modifierExtension?: Maybe<Array<Extension>>;
};

export type TransitionOfCareLensQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TransitionOfCareLensQueryQuery = { __typename?: 'Query', EpisodeOfCare?: (
    { __typename?: 'EpisodeOfCare', patient: { __typename?: 'Reference', resource?:
        | { __typename?: 'Account' }
        | { __typename?: 'AllergyIntolerance' }
        | { __typename?: 'Appointment' }
        | { __typename?: 'AppointmentResponse' }
        | { __typename?: 'Basic' }
        | { __typename?: 'Binary' }
        | { __typename?: 'CarePlan' }
        | { __typename?: 'CareTeam' }
        | { __typename?: 'Claim' }
        | { __typename?: 'ClaimResponse' }
        | { __typename?: 'ClinicalImpression' }
        | { __typename?: 'CommunicationRequest' }
        | { __typename?: 'Composition' }
        | { __typename?: 'Condition' }
        | { __typename?: 'Consent' }
        | { __typename?: 'Contract' }
        | { __typename?: 'Coverage' }
        | { __typename?: 'CoverageEligibilityRequest' }
        | { __typename?: 'DetectedIssue' }
        | { __typename?: 'Device' }
        | { __typename?: 'DeviceDefinition' }
        | { __typename?: 'DeviceMetric' }
        | { __typename?: 'DeviceRequest' }
        | { __typename?: 'DeviceUseStatement' }
        | { __typename?: 'DiagnosticReport' }
        | { __typename?: 'DocumentReference' }
        | { __typename?: 'Encounter' }
        | { __typename?: 'Endpoint' }
        | { __typename?: 'EpisodeOfCare' }
        | { __typename?: 'FamilyMemberHistory' }
        | { __typename?: 'Goal' }
        | { __typename?: 'Group' }
        | { __typename?: 'HealthcareService' }
        | { __typename?: 'ImagingStudy' }
        | { __typename?: 'Immunization' }
        | { __typename?: 'ImmunizationEvaluation' }
        | { __typename?: 'ImmunizationRecommendation' }
        | { __typename?: 'InsurancePlan' }
        | { __typename?: 'List' }
        | { __typename?: 'Location' }
        | { __typename?: 'Measure' }
        | { __typename?: 'MeasureReport' }
        | { __typename?: 'Media' }
        | { __typename?: 'Medication' }
        | { __typename?: 'MedicationAdministration' }
        | { __typename?: 'MedicationDispense' }
        | { __typename?: 'MedicationRequest' }
        | { __typename?: 'MedicationStatement' }
        | { __typename?: 'MolecularSequence' }
        | { __typename?: 'NutritionOrder' }
        | { __typename?: 'Observation' }
        | { __typename?: 'Organization' }
        | { __typename?: 'Patient', id?: string | null, resourceType: string, gender?: AdministrativeGender | null, birthDate?: string | null, name?: Array<{ __typename?: 'HumanName', family?: string | null, given?: Array<string> | null }> | null, identifier?: Array<{ __typename?: 'Identifier', system?: string | null, value?: string | null, assigner?: { __typename?: 'Reference', display?: string | null } | null }> | null }
        | { __typename?: 'PlanDefinition' }
        | { __typename?: 'Practitioner' }
        | { __typename?: 'PractitionerRole' }
        | { __typename?: 'Procedure' }
        | { __typename?: 'Provenance' }
        | { __typename?: 'Questionnaire' }
        | { __typename?: 'QuestionnaireResponse' }
        | { __typename?: 'RelatedPerson' }
        | { __typename?: 'RequestGroup' }
        | { __typename?: 'ResearchStudy' }
        | { __typename?: 'RiskAssessment' }
        | { __typename?: 'Schedule' }
        | { __typename?: 'ServiceRequest' }
        | { __typename?: 'Slot' }
        | { __typename?: 'Specimen' }
        | { __typename?: 'Substance' }
        | { __typename?: 'SupplyRequest' }
        | { __typename?: 'Task' }
        | { __typename?: 'VisionPrescription' }
       | null } }
    & { ' $fragmentRefs'?: { 'EpisodeOfCareFragment': EpisodeOfCareFragment } }
  ) | null };

export type AllergiesQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
  cursor: Scalars['String']['input'];
  sort: AllergyIntoleranceSortParams;
  filter?: AllergyIntoleranceFilterParams;
  first: Scalars['Int']['input'];
}>;


export type AllergiesQuery = { __typename?: 'Query', AllergyIntoleranceConnection?: { __typename?: 'AllergyIntoleranceConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges?: Array<{ __typename?: 'AllergyIntoleranceEdge', node: { __typename?: 'AllergyIntolerance', id?: string | null, resourceType: string, type?: AllergyIntoleranceType | null, category?: Array<AllergyIntoleranceCategory> | null, criticality?: AllergyIntoleranceCriticality | null, onsetDateTime?: string | null, recordedDate?: string | null, lastOccurrence?: string | null, BasicList?: Array<(
          { __typename?: 'Basic' }
          & { ' $fragmentRefs'?: { 'BasicFragment': BasicFragment } }
        )> | null, meta?: { __typename?: 'Meta', tag?: Array<{ __typename?: 'Coding', system?: string | null, code?: string | null, display?: string | null }> | null } | null, clinicalStatus?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null, verificationStatus?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, code?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, patient: { __typename?: 'Reference', reference?: string | null, resource?:
            | { __typename?: 'Account' }
            | { __typename?: 'AllergyIntolerance' }
            | { __typename?: 'Appointment' }
            | { __typename?: 'AppointmentResponse' }
            | { __typename?: 'Basic' }
            | { __typename?: 'Binary' }
            | { __typename?: 'CarePlan' }
            | { __typename?: 'CareTeam' }
            | { __typename?: 'Claim' }
            | { __typename?: 'ClaimResponse' }
            | { __typename?: 'ClinicalImpression' }
            | { __typename?: 'CommunicationRequest' }
            | { __typename?: 'Composition' }
            | { __typename?: 'Condition' }
            | { __typename?: 'Consent' }
            | { __typename?: 'Contract' }
            | { __typename?: 'Coverage' }
            | { __typename?: 'CoverageEligibilityRequest' }
            | { __typename?: 'DetectedIssue' }
            | { __typename?: 'Device' }
            | { __typename?: 'DeviceDefinition' }
            | { __typename?: 'DeviceMetric' }
            | { __typename?: 'DeviceRequest' }
            | { __typename?: 'DeviceUseStatement' }
            | { __typename?: 'DiagnosticReport' }
            | { __typename?: 'DocumentReference' }
            | { __typename?: 'Encounter' }
            | { __typename?: 'Endpoint' }
            | { __typename?: 'EpisodeOfCare' }
            | { __typename?: 'FamilyMemberHistory' }
            | { __typename?: 'Goal' }
            | { __typename?: 'Group' }
            | { __typename?: 'HealthcareService' }
            | { __typename?: 'ImagingStudy' }
            | { __typename?: 'Immunization' }
            | { __typename?: 'ImmunizationEvaluation' }
            | { __typename?: 'ImmunizationRecommendation' }
            | { __typename?: 'InsurancePlan' }
            | { __typename?: 'List' }
            | { __typename?: 'Location' }
            | { __typename?: 'Measure' }
            | { __typename?: 'MeasureReport' }
            | { __typename?: 'Media' }
            | { __typename?: 'Medication' }
            | { __typename?: 'MedicationAdministration' }
            | { __typename?: 'MedicationDispense' }
            | { __typename?: 'MedicationRequest' }
            | { __typename?: 'MedicationStatement' }
            | { __typename?: 'MolecularSequence' }
            | { __typename?: 'NutritionOrder' }
            | { __typename?: 'Observation' }
            | { __typename?: 'Organization' }
            | (
              { __typename?: 'Patient', managingOrganization?: { __typename?: 'Reference', resource?:
                  | { __typename?: 'Account' }
                  | { __typename?: 'AllergyIntolerance' }
                  | { __typename?: 'Appointment' }
                  | { __typename?: 'AppointmentResponse' }
                  | { __typename?: 'Basic' }
                  | { __typename?: 'Binary' }
                  | { __typename?: 'CarePlan' }
                  | { __typename?: 'CareTeam' }
                  | { __typename?: 'Claim' }
                  | { __typename?: 'ClaimResponse' }
                  | { __typename?: 'ClinicalImpression' }
                  | { __typename?: 'CommunicationRequest' }
                  | { __typename?: 'Composition' }
                  | { __typename?: 'Condition' }
                  | { __typename?: 'Consent' }
                  | { __typename?: 'Contract' }
                  | { __typename?: 'Coverage' }
                  | { __typename?: 'CoverageEligibilityRequest' }
                  | { __typename?: 'DetectedIssue' }
                  | { __typename?: 'Device' }
                  | { __typename?: 'DeviceDefinition' }
                  | { __typename?: 'DeviceMetric' }
                  | { __typename?: 'DeviceRequest' }
                  | { __typename?: 'DeviceUseStatement' }
                  | { __typename?: 'DiagnosticReport' }
                  | { __typename?: 'DocumentReference' }
                  | { __typename?: 'Encounter' }
                  | { __typename?: 'Endpoint' }
                  | { __typename?: 'EpisodeOfCare' }
                  | { __typename?: 'FamilyMemberHistory' }
                  | { __typename?: 'Goal' }
                  | { __typename?: 'Group' }
                  | { __typename?: 'HealthcareService' }
                  | { __typename?: 'ImagingStudy' }
                  | { __typename?: 'Immunization' }
                  | { __typename?: 'ImmunizationEvaluation' }
                  | { __typename?: 'ImmunizationRecommendation' }
                  | { __typename?: 'InsurancePlan' }
                  | { __typename?: 'List' }
                  | { __typename?: 'Location' }
                  | { __typename?: 'Measure' }
                  | { __typename?: 'MeasureReport' }
                  | { __typename?: 'Media' }
                  | { __typename?: 'Medication' }
                  | { __typename?: 'MedicationAdministration' }
                  | { __typename?: 'MedicationDispense' }
                  | { __typename?: 'MedicationRequest' }
                  | { __typename?: 'MedicationStatement' }
                  | { __typename?: 'MolecularSequence' }
                  | { __typename?: 'NutritionOrder' }
                  | { __typename?: 'Observation' }
                  | { __typename?: 'Organization', name?: string | null }
                  | { __typename?: 'Patient' }
                  | { __typename?: 'PlanDefinition' }
                  | { __typename?: 'Practitioner' }
                  | { __typename?: 'PractitionerRole' }
                  | { __typename?: 'Procedure' }
                  | { __typename?: 'Provenance' }
                  | { __typename?: 'Questionnaire' }
                  | { __typename?: 'QuestionnaireResponse' }
                  | { __typename?: 'RelatedPerson' }
                  | { __typename?: 'RequestGroup' }
                  | { __typename?: 'ResearchStudy' }
                  | { __typename?: 'RiskAssessment' }
                  | { __typename?: 'Schedule' }
                  | { __typename?: 'ServiceRequest' }
                  | { __typename?: 'Slot' }
                  | { __typename?: 'Specimen' }
                  | { __typename?: 'Substance' }
                  | { __typename?: 'SupplyRequest' }
                  | { __typename?: 'Task' }
                  | { __typename?: 'VisionPrescription' }
                 | null } | null }
              & { ' $fragmentRefs'?: { 'PatientFragment': PatientFragment } }
            )
            | { __typename?: 'PlanDefinition' }
            | { __typename?: 'Practitioner' }
            | { __typename?: 'PractitionerRole' }
            | { __typename?: 'Procedure' }
            | { __typename?: 'Provenance' }
            | { __typename?: 'Questionnaire' }
            | { __typename?: 'QuestionnaireResponse' }
            | { __typename?: 'RelatedPerson' }
            | { __typename?: 'RequestGroup' }
            | { __typename?: 'ResearchStudy' }
            | { __typename?: 'RiskAssessment' }
            | { __typename?: 'Schedule' }
            | { __typename?: 'ServiceRequest' }
            | { __typename?: 'Slot' }
            | { __typename?: 'Specimen' }
            | { __typename?: 'Substance' }
            | { __typename?: 'SupplyRequest' }
            | { __typename?: 'Task' }
            | { __typename?: 'VisionPrescription' }
           | null }, encounter?: { __typename?: 'Reference', reference?: string | null, resource?:
            | { __typename?: 'Account' }
            | { __typename?: 'AllergyIntolerance' }
            | { __typename?: 'Appointment' }
            | { __typename?: 'AppointmentResponse' }
            | { __typename?: 'Basic' }
            | { __typename?: 'Binary' }
            | { __typename?: 'CarePlan' }
            | { __typename?: 'CareTeam' }
            | { __typename?: 'Claim' }
            | { __typename?: 'ClaimResponse' }
            | { __typename?: 'ClinicalImpression' }
            | { __typename?: 'CommunicationRequest' }
            | { __typename?: 'Composition' }
            | { __typename?: 'Condition' }
            | { __typename?: 'Consent' }
            | { __typename?: 'Contract' }
            | { __typename?: 'Coverage' }
            | { __typename?: 'CoverageEligibilityRequest' }
            | { __typename?: 'DetectedIssue' }
            | { __typename?: 'Device' }
            | { __typename?: 'DeviceDefinition' }
            | { __typename?: 'DeviceMetric' }
            | { __typename?: 'DeviceRequest' }
            | { __typename?: 'DeviceUseStatement' }
            | { __typename?: 'DiagnosticReport' }
            | { __typename?: 'DocumentReference' }
            | (
              { __typename?: 'Encounter' }
              & { ' $fragmentRefs'?: { 'EncounterReferenceFragment': EncounterReferenceFragment } }
            )
            | { __typename?: 'Endpoint' }
            | { __typename?: 'EpisodeOfCare' }
            | { __typename?: 'FamilyMemberHistory' }
            | { __typename?: 'Goal' }
            | { __typename?: 'Group' }
            | { __typename?: 'HealthcareService' }
            | { __typename?: 'ImagingStudy' }
            | { __typename?: 'Immunization' }
            | { __typename?: 'ImmunizationEvaluation' }
            | { __typename?: 'ImmunizationRecommendation' }
            | { __typename?: 'InsurancePlan' }
            | { __typename?: 'List' }
            | { __typename?: 'Location' }
            | { __typename?: 'Measure' }
            | { __typename?: 'MeasureReport' }
            | { __typename?: 'Media' }
            | { __typename?: 'Medication' }
            | { __typename?: 'MedicationAdministration' }
            | { __typename?: 'MedicationDispense' }
            | { __typename?: 'MedicationRequest' }
            | { __typename?: 'MedicationStatement' }
            | { __typename?: 'MolecularSequence' }
            | { __typename?: 'NutritionOrder' }
            | { __typename?: 'Observation' }
            | { __typename?: 'Organization' }
            | { __typename?: 'Patient' }
            | { __typename?: 'PlanDefinition' }
            | { __typename?: 'Practitioner' }
            | { __typename?: 'PractitionerRole' }
            | { __typename?: 'Procedure' }
            | { __typename?: 'Provenance' }
            | { __typename?: 'Questionnaire' }
            | { __typename?: 'QuestionnaireResponse' }
            | { __typename?: 'RelatedPerson' }
            | { __typename?: 'RequestGroup' }
            | { __typename?: 'ResearchStudy' }
            | { __typename?: 'RiskAssessment' }
            | { __typename?: 'Schedule' }
            | { __typename?: 'ServiceRequest' }
            | { __typename?: 'Slot' }
            | { __typename?: 'Specimen' }
            | { __typename?: 'Substance' }
            | { __typename?: 'SupplyRequest' }
            | { __typename?: 'Task' }
            | { __typename?: 'VisionPrescription' }
           | null } | null, onsetAge?: { __typename?: 'Age', value?: number | null, unit?: string | null, system?: string | null, code?: string | null } | null, onsetPeriod?: { __typename?: 'Period', start?: string | null, end?: string | null } | null, recorder?: { __typename?: 'Reference', reference?: string | null, resource?:
            | { __typename?: 'Account' }
            | { __typename?: 'AllergyIntolerance' }
            | { __typename?: 'Appointment' }
            | { __typename?: 'AppointmentResponse' }
            | { __typename?: 'Basic' }
            | { __typename?: 'Binary' }
            | { __typename?: 'CarePlan' }
            | { __typename?: 'CareTeam' }
            | { __typename?: 'Claim' }
            | { __typename?: 'ClaimResponse' }
            | { __typename?: 'ClinicalImpression' }
            | { __typename?: 'CommunicationRequest' }
            | { __typename?: 'Composition' }
            | { __typename?: 'Condition' }
            | { __typename?: 'Consent' }
            | { __typename?: 'Contract' }
            | { __typename?: 'Coverage' }
            | { __typename?: 'CoverageEligibilityRequest' }
            | { __typename?: 'DetectedIssue' }
            | { __typename?: 'Device' }
            | { __typename?: 'DeviceDefinition' }
            | { __typename?: 'DeviceMetric' }
            | { __typename?: 'DeviceRequest' }
            | { __typename?: 'DeviceUseStatement' }
            | { __typename?: 'DiagnosticReport' }
            | { __typename?: 'DocumentReference' }
            | { __typename?: 'Encounter' }
            | { __typename?: 'Endpoint' }
            | { __typename?: 'EpisodeOfCare' }
            | { __typename?: 'FamilyMemberHistory' }
            | { __typename?: 'Goal' }
            | { __typename?: 'Group' }
            | { __typename?: 'HealthcareService' }
            | { __typename?: 'ImagingStudy' }
            | { __typename?: 'Immunization' }
            | { __typename?: 'ImmunizationEvaluation' }
            | { __typename?: 'ImmunizationRecommendation' }
            | { __typename?: 'InsurancePlan' }
            | { __typename?: 'List' }
            | { __typename?: 'Location' }
            | { __typename?: 'Measure' }
            | { __typename?: 'MeasureReport' }
            | { __typename?: 'Media' }
            | { __typename?: 'Medication' }
            | { __typename?: 'MedicationAdministration' }
            | { __typename?: 'MedicationDispense' }
            | { __typename?: 'MedicationRequest' }
            | { __typename?: 'MedicationStatement' }
            | { __typename?: 'MolecularSequence' }
            | { __typename?: 'NutritionOrder' }
            | { __typename?: 'Observation' }
            | { __typename?: 'Organization' }
            | { __typename?: 'Patient' }
            | { __typename?: 'PlanDefinition' }
            | (
              { __typename?: 'Practitioner' }
              & { ' $fragmentRefs'?: { 'PractitionerFragment': PractitionerFragment } }
            )
            | { __typename?: 'PractitionerRole' }
            | { __typename?: 'Procedure' }
            | { __typename?: 'Provenance' }
            | { __typename?: 'Questionnaire' }
            | { __typename?: 'QuestionnaireResponse' }
            | { __typename?: 'RelatedPerson' }
            | { __typename?: 'RequestGroup' }
            | { __typename?: 'ResearchStudy' }
            | { __typename?: 'RiskAssessment' }
            | { __typename?: 'Schedule' }
            | { __typename?: 'ServiceRequest' }
            | { __typename?: 'Slot' }
            | { __typename?: 'Specimen' }
            | { __typename?: 'Substance' }
            | { __typename?: 'SupplyRequest' }
            | { __typename?: 'Task' }
            | { __typename?: 'VisionPrescription' }
           | null } | null, note?: Array<{ __typename?: 'Annotation', text: string, time?: string | null }> | null, reaction?: Array<{ __typename?: 'AllergyIntoleranceReaction', onset?: string | null, severity?: ReactionEventSeverity | null, substance?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
              { __typename?: 'Coding' }
              & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
            )> | null } | null, manifestation: Array<{ __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
              { __typename?: 'Coding' }
              & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
            )> | null }>, note?: Array<{ __typename?: 'Annotation', text: string, time?: string | null }> | null }> | null } }> | null } | null };

export type AppointmentsQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
}>;


export type AppointmentsQuery = { __typename?: 'Query', AppointmentConnection?: { __typename?: 'AppointmentConnection', edges?: Array<{ __typename?: 'AppointmentEdge', node: (
        { __typename?: 'Appointment' }
        & { ' $fragmentRefs'?: { 'AppointmentFragment': AppointmentFragment } }
      ) }> | null } | null };

export type CareTeamsQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
  cursor: Scalars['String']['input'];
  sort: CareTeamSortParams;
  first: Scalars['Int']['input'];
}>;


export type CareTeamsQuery = { __typename?: 'Query', CareTeamConnection?: { __typename?: 'CareTeamConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges?: Array<{ __typename?: 'CareTeamEdge', node: { __typename?: 'CareTeam', id?: string | null, resourceType: string, status?: CareTeamStatus | null, name?: string | null, meta?: { __typename?: 'Meta', versionId?: string | null, extension?: Array<{ __typename?: 'Extension', url: string, valueInstant?: string | null }> | null, tag?: Array<{ __typename?: 'Coding', system?: string | null, code?: string | null }> | null } | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null, category?: Array<{ __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null }> | null, period?: { __typename?: 'Period', start?: string | null, end?: string | null } | null, participant?: Array<{ __typename?: 'CareTeamParticipant', role?: Array<{ __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
              { __typename?: 'Coding' }
              & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
            )> | null }> | null, member?: { __typename?: 'Reference', reference?: string | null, resource?:
              | { __typename?: 'Account' }
              | { __typename?: 'AllergyIntolerance' }
              | { __typename?: 'Appointment' }
              | { __typename?: 'AppointmentResponse' }
              | { __typename?: 'Basic' }
              | { __typename?: 'Binary' }
              | { __typename?: 'CarePlan' }
              | { __typename?: 'CareTeam' }
              | { __typename?: 'Claim' }
              | { __typename?: 'ClaimResponse' }
              | { __typename?: 'ClinicalImpression' }
              | { __typename?: 'CommunicationRequest' }
              | { __typename?: 'Composition' }
              | { __typename?: 'Condition' }
              | { __typename?: 'Consent' }
              | { __typename?: 'Contract' }
              | { __typename?: 'Coverage' }
              | { __typename?: 'CoverageEligibilityRequest' }
              | { __typename?: 'DetectedIssue' }
              | { __typename?: 'Device' }
              | { __typename?: 'DeviceDefinition' }
              | { __typename?: 'DeviceMetric' }
              | { __typename?: 'DeviceRequest' }
              | { __typename?: 'DeviceUseStatement' }
              | { __typename?: 'DiagnosticReport' }
              | { __typename?: 'DocumentReference' }
              | { __typename?: 'Encounter' }
              | { __typename?: 'Endpoint' }
              | { __typename?: 'EpisodeOfCare' }
              | { __typename?: 'FamilyMemberHistory' }
              | { __typename?: 'Goal' }
              | { __typename?: 'Group' }
              | { __typename?: 'HealthcareService' }
              | { __typename?: 'ImagingStudy' }
              | { __typename?: 'Immunization' }
              | { __typename?: 'ImmunizationEvaluation' }
              | { __typename?: 'ImmunizationRecommendation' }
              | { __typename?: 'InsurancePlan' }
              | { __typename?: 'List' }
              | { __typename?: 'Location' }
              | { __typename?: 'Measure' }
              | { __typename?: 'MeasureReport' }
              | { __typename?: 'Media' }
              | { __typename?: 'Medication' }
              | { __typename?: 'MedicationAdministration' }
              | { __typename?: 'MedicationDispense' }
              | { __typename?: 'MedicationRequest' }
              | { __typename?: 'MedicationStatement' }
              | { __typename?: 'MolecularSequence' }
              | { __typename?: 'NutritionOrder' }
              | { __typename?: 'Observation' }
              | { __typename?: 'Organization' }
              | { __typename?: 'Patient' }
              | { __typename?: 'PlanDefinition' }
              | (
                { __typename?: 'Practitioner' }
                & { ' $fragmentRefs'?: { 'PractitionerFragment': PractitionerFragment } }
              )
              | { __typename?: 'PractitionerRole' }
              | { __typename?: 'Procedure' }
              | { __typename?: 'Provenance' }
              | { __typename?: 'Questionnaire' }
              | { __typename?: 'QuestionnaireResponse' }
              | { __typename?: 'RelatedPerson' }
              | { __typename?: 'RequestGroup' }
              | { __typename?: 'ResearchStudy' }
              | { __typename?: 'RiskAssessment' }
              | { __typename?: 'Schedule' }
              | { __typename?: 'ServiceRequest' }
              | { __typename?: 'Slot' }
              | { __typename?: 'Specimen' }
              | { __typename?: 'Substance' }
              | { __typename?: 'SupplyRequest' }
              | { __typename?: 'Task' }
              | { __typename?: 'VisionPrescription' }
             | null } | null, onBehalfOf?: { __typename?: 'Reference', reference?: string | null } | null }> | null, reasonCode?: Array<{ __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null }> | null, telecom?: Array<{ __typename?: 'ContactPoint', system?: ContactPointSystem | null, value?: string | null, use?: ContactPointUse | null, period?: { __typename?: 'Period', start?: string | null, end?: string | null } | null }> | null, note?: Array<{ __typename?: 'Annotation', text: string }> | null } }> | null } | null };

export type SummaryConditionsQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
  cursor: Scalars['String']['input'];
  filter?: ConditionFilterParams;
  sort: ConditionSortParams;
  first: Scalars['Int']['input'];
}>;


export type SummaryConditionsQuery = { __typename?: 'Query', ConditionConnection?: { __typename?: 'ConditionConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges?: Array<{ __typename?: 'ConditionEdge', node: (
        { __typename?: 'Condition' }
        & { ' $fragmentRefs'?: { 'ConditionFragment': ConditionFragment } }
      ) }> | null } | null };

export type ConditionFragment = { __typename?: 'Condition', id?: string | null, resourceType: string, meta?: { __typename?: 'Meta', tag?: Array<{ __typename?: 'Coding', system?: string | null, code?: string | null }> | null } | null, code?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', system?: string | null, code?: string | null, display?: string | null }> | null } | null } & { ' $fragmentName'?: 'ConditionFragment' };

export type FirstPartyConditionsQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
  cursor: Scalars['String']['input'];
  filter?: ConditionFilterParams;
  sort: ConditionSortParams;
  first: Scalars['Int']['input'];
}>;


export type FirstPartyConditionsQuery = { __typename?: 'Query', ConditionConnection?: { __typename?: 'ConditionConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges?: Array<{ __typename?: 'ConditionEdge', node: (
        { __typename?: 'Condition' }
        & { ' $fragmentRefs'?: { 'ConditionFragment': ConditionFragment } }
      ) }> | null } | null };

export type CoverageQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
  cursor: Scalars['String']['input'];
  filter?: CoverageFilterParams;
  sort: CoverageSortParams;
  first: Scalars['Int']['input'];
}>;


export type CoverageQuery = { __typename?: 'Query', CoverageConnection?: { __typename?: 'CoverageConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges?: Array<{ __typename?: 'CoverageEdge', node: { __typename?: 'Coverage', id?: string | null, subscriberId?: string | null, beneficiary: { __typename?: 'Reference', reference?: string | null }, class?: Array<{ __typename?: 'CoverageClass', value: string, name?: string | null, type: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
              { __typename?: 'Coding' }
              & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
            )> | null } }> | null, type?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, payor: Array<{ __typename?: 'Reference', display?: string | null }>, relationship?: { __typename?: 'CodeableConcept', coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, subscriber?: { __typename?: 'Reference', reference?: string | null, resource?:
            | { __typename?: 'Account' }
            | { __typename?: 'AllergyIntolerance' }
            | { __typename?: 'Appointment' }
            | { __typename?: 'AppointmentResponse' }
            | { __typename?: 'Basic' }
            | { __typename?: 'Binary' }
            | { __typename?: 'CarePlan' }
            | { __typename?: 'CareTeam' }
            | { __typename?: 'Claim' }
            | { __typename?: 'ClaimResponse' }
            | { __typename?: 'ClinicalImpression' }
            | { __typename?: 'CommunicationRequest' }
            | { __typename?: 'Composition' }
            | { __typename?: 'Condition' }
            | { __typename?: 'Consent' }
            | { __typename?: 'Contract' }
            | { __typename?: 'Coverage' }
            | { __typename?: 'CoverageEligibilityRequest' }
            | { __typename?: 'DetectedIssue' }
            | { __typename?: 'Device' }
            | { __typename?: 'DeviceDefinition' }
            | { __typename?: 'DeviceMetric' }
            | { __typename?: 'DeviceRequest' }
            | { __typename?: 'DeviceUseStatement' }
            | { __typename?: 'DiagnosticReport' }
            | { __typename?: 'DocumentReference' }
            | { __typename?: 'Encounter' }
            | { __typename?: 'Endpoint' }
            | { __typename?: 'EpisodeOfCare' }
            | { __typename?: 'FamilyMemberHistory' }
            | { __typename?: 'Goal' }
            | { __typename?: 'Group' }
            | { __typename?: 'HealthcareService' }
            | { __typename?: 'ImagingStudy' }
            | { __typename?: 'Immunization' }
            | { __typename?: 'ImmunizationEvaluation' }
            | { __typename?: 'ImmunizationRecommendation' }
            | { __typename?: 'InsurancePlan' }
            | { __typename?: 'List' }
            | { __typename?: 'Location' }
            | { __typename?: 'Measure' }
            | { __typename?: 'MeasureReport' }
            | { __typename?: 'Media' }
            | { __typename?: 'Medication' }
            | { __typename?: 'MedicationAdministration' }
            | { __typename?: 'MedicationDispense' }
            | { __typename?: 'MedicationRequest' }
            | { __typename?: 'MedicationStatement' }
            | { __typename?: 'MolecularSequence' }
            | { __typename?: 'NutritionOrder' }
            | { __typename?: 'Observation' }
            | { __typename?: 'Organization' }
            | (
              { __typename?: 'Patient' }
              & { ' $fragmentRefs'?: { 'PatientFragment': PatientFragment } }
            )
            | { __typename?: 'PlanDefinition' }
            | { __typename?: 'Practitioner' }
            | { __typename?: 'PractitionerRole' }
            | { __typename?: 'Procedure' }
            | { __typename?: 'Provenance' }
            | { __typename?: 'Questionnaire' }
            | { __typename?: 'QuestionnaireResponse' }
            | { __typename?: 'RelatedPerson' }
            | { __typename?: 'RequestGroup' }
            | { __typename?: 'ResearchStudy' }
            | { __typename?: 'RiskAssessment' }
            | { __typename?: 'Schedule' }
            | { __typename?: 'ServiceRequest' }
            | { __typename?: 'Slot' }
            | { __typename?: 'Specimen' }
            | { __typename?: 'Substance' }
            | { __typename?: 'SupplyRequest' }
            | { __typename?: 'Task' }
            | { __typename?: 'VisionPrescription' }
           | null } | null } }> | null } | null };

export type DiagnosticReportsQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
  cursor: Scalars['String']['input'];
  sort: DiagnosticReportSortParams;
  filter: DiagnosticReportFilterParams;
  first: Scalars['Int']['input'];
}>;


export type DiagnosticReportsQuery = { __typename?: 'Query', DiagnosticReportConnection?: { __typename?: 'DiagnosticReportConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges?: Array<{ __typename?: 'DiagnosticReportEdge', node: { __typename?: 'DiagnosticReport', id?: string | null, resourceType: string, status: DiagnosticReportStatus, effectiveDateTime?: string | null, issued?: string | null, conclusion?: string | null, BasicList?: Array<(
          { __typename?: 'Basic' }
          & { ' $fragmentRefs'?: { 'BasicFragment': BasicFragment } }
        )> | null, meta?: { __typename?: 'Meta', tag?: Array<{ __typename?: 'Coding', system?: string | null, code?: string | null }> | null, extension?: Array<{ __typename?: 'Extension', url: string, valueInstant?: string | null }> | null } | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null, category?: Array<{ __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null }> | null, code: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null }, effectivePeriod?: { __typename?: 'Period', start?: string | null, end?: string | null } | null, performer?: Array<{ __typename?: 'Reference', reference?: string | null, resource?:
            | { __typename?: 'Account' }
            | { __typename?: 'AllergyIntolerance' }
            | { __typename?: 'Appointment' }
            | { __typename?: 'AppointmentResponse' }
            | { __typename?: 'Basic' }
            | { __typename?: 'Binary' }
            | { __typename?: 'CarePlan' }
            | { __typename?: 'CareTeam' }
            | { __typename?: 'Claim' }
            | { __typename?: 'ClaimResponse' }
            | { __typename?: 'ClinicalImpression' }
            | { __typename?: 'CommunicationRequest' }
            | { __typename?: 'Composition' }
            | { __typename?: 'Condition' }
            | { __typename?: 'Consent' }
            | { __typename?: 'Contract' }
            | { __typename?: 'Coverage' }
            | { __typename?: 'CoverageEligibilityRequest' }
            | { __typename?: 'DetectedIssue' }
            | { __typename?: 'Device' }
            | { __typename?: 'DeviceDefinition' }
            | { __typename?: 'DeviceMetric' }
            | { __typename?: 'DeviceRequest' }
            | { __typename?: 'DeviceUseStatement' }
            | { __typename?: 'DiagnosticReport' }
            | { __typename?: 'DocumentReference' }
            | { __typename?: 'Encounter' }
            | { __typename?: 'Endpoint' }
            | { __typename?: 'EpisodeOfCare' }
            | { __typename?: 'FamilyMemberHistory' }
            | { __typename?: 'Goal' }
            | { __typename?: 'Group' }
            | { __typename?: 'HealthcareService' }
            | { __typename?: 'ImagingStudy' }
            | { __typename?: 'Immunization' }
            | { __typename?: 'ImmunizationEvaluation' }
            | { __typename?: 'ImmunizationRecommendation' }
            | { __typename?: 'InsurancePlan' }
            | { __typename?: 'List' }
            | { __typename?: 'Location' }
            | { __typename?: 'Measure' }
            | { __typename?: 'MeasureReport' }
            | { __typename?: 'Media' }
            | { __typename?: 'Medication' }
            | { __typename?: 'MedicationAdministration' }
            | { __typename?: 'MedicationDispense' }
            | { __typename?: 'MedicationRequest' }
            | { __typename?: 'MedicationStatement' }
            | { __typename?: 'MolecularSequence' }
            | { __typename?: 'NutritionOrder' }
            | { __typename?: 'Observation' }
            | { __typename?: 'Organization' }
            | { __typename?: 'Patient' }
            | { __typename?: 'PlanDefinition' }
            | (
              { __typename?: 'Practitioner' }
              & { ' $fragmentRefs'?: { 'PractitionerFragment': PractitionerFragment } }
            )
            | { __typename?: 'PractitionerRole' }
            | { __typename?: 'Procedure' }
            | { __typename?: 'Provenance' }
            | { __typename?: 'Questionnaire' }
            | { __typename?: 'QuestionnaireResponse' }
            | { __typename?: 'RelatedPerson' }
            | { __typename?: 'RequestGroup' }
            | { __typename?: 'ResearchStudy' }
            | { __typename?: 'RiskAssessment' }
            | { __typename?: 'Schedule' }
            | { __typename?: 'ServiceRequest' }
            | { __typename?: 'Slot' }
            | { __typename?: 'Specimen' }
            | { __typename?: 'Substance' }
            | { __typename?: 'SupplyRequest' }
            | { __typename?: 'Task' }
            | { __typename?: 'VisionPrescription' }
           | null }> | null, subject?: { __typename?: 'Reference', reference?: string | null, resource?:
            | { __typename?: 'Account' }
            | { __typename?: 'AllergyIntolerance' }
            | { __typename?: 'Appointment' }
            | { __typename?: 'AppointmentResponse' }
            | { __typename?: 'Basic' }
            | { __typename?: 'Binary' }
            | { __typename?: 'CarePlan' }
            | { __typename?: 'CareTeam' }
            | { __typename?: 'Claim' }
            | { __typename?: 'ClaimResponse' }
            | { __typename?: 'ClinicalImpression' }
            | { __typename?: 'CommunicationRequest' }
            | { __typename?: 'Composition' }
            | { __typename?: 'Condition' }
            | { __typename?: 'Consent' }
            | { __typename?: 'Contract' }
            | { __typename?: 'Coverage' }
            | { __typename?: 'CoverageEligibilityRequest' }
            | { __typename?: 'DetectedIssue' }
            | { __typename?: 'Device' }
            | { __typename?: 'DeviceDefinition' }
            | { __typename?: 'DeviceMetric' }
            | { __typename?: 'DeviceRequest' }
            | { __typename?: 'DeviceUseStatement' }
            | { __typename?: 'DiagnosticReport' }
            | { __typename?: 'DocumentReference' }
            | { __typename?: 'Encounter' }
            | { __typename?: 'Endpoint' }
            | { __typename?: 'EpisodeOfCare' }
            | { __typename?: 'FamilyMemberHistory' }
            | { __typename?: 'Goal' }
            | { __typename?: 'Group' }
            | { __typename?: 'HealthcareService' }
            | { __typename?: 'ImagingStudy' }
            | { __typename?: 'Immunization' }
            | { __typename?: 'ImmunizationEvaluation' }
            | { __typename?: 'ImmunizationRecommendation' }
            | { __typename?: 'InsurancePlan' }
            | { __typename?: 'List' }
            | { __typename?: 'Location' }
            | { __typename?: 'Measure' }
            | { __typename?: 'MeasureReport' }
            | { __typename?: 'Media' }
            | { __typename?: 'Medication' }
            | { __typename?: 'MedicationAdministration' }
            | { __typename?: 'MedicationDispense' }
            | { __typename?: 'MedicationRequest' }
            | { __typename?: 'MedicationStatement' }
            | { __typename?: 'MolecularSequence' }
            | { __typename?: 'NutritionOrder' }
            | { __typename?: 'Observation' }
            | { __typename?: 'Organization' }
            | (
              { __typename?: 'Patient' }
              & { ' $fragmentRefs'?: { 'PatientFragment': PatientFragment } }
            )
            | { __typename?: 'PlanDefinition' }
            | { __typename?: 'Practitioner' }
            | { __typename?: 'PractitionerRole' }
            | { __typename?: 'Procedure' }
            | { __typename?: 'Provenance' }
            | { __typename?: 'Questionnaire' }
            | { __typename?: 'QuestionnaireResponse' }
            | { __typename?: 'RelatedPerson' }
            | { __typename?: 'RequestGroup' }
            | { __typename?: 'ResearchStudy' }
            | { __typename?: 'RiskAssessment' }
            | { __typename?: 'Schedule' }
            | { __typename?: 'ServiceRequest' }
            | { __typename?: 'Slot' }
            | { __typename?: 'Specimen' }
            | { __typename?: 'Substance' }
            | { __typename?: 'SupplyRequest' }
            | { __typename?: 'Task' }
            | { __typename?: 'VisionPrescription' }
           | null } | null, result?: Array<{ __typename?: 'Reference', reference?: string | null, display?: string | null }> | null } }> | null } | null };

export type DocumentReferencesWithBasicsQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
  cursor: Scalars['String']['input'];
  sort: DocumentReferenceSortParams;
  filter?: DocumentReferenceFilterParams;
  first: Scalars['Int']['input'];
}>;


export type DocumentReferencesWithBasicsQuery = { __typename?: 'Query', DocumentReferenceConnection?: { __typename?: 'DocumentReferenceConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges?: Array<{ __typename?: 'DocumentReferenceEdge', node: { __typename?: 'DocumentReference', id?: string | null, resourceType: string, status: DocumentReferenceStatus, docStatus?: CompositionStatus | null, date?: string | null, description?: string | null, BasicList?: Array<(
          { __typename?: 'Basic' }
          & { ' $fragmentRefs'?: { 'BasicFragment': BasicFragment } }
        )> | null, masterIdentifier?: { __typename?: 'Identifier', system?: string | null, use?: IdentifierUse | null, value?: string | null } | null, meta?: { __typename?: 'Meta', versionId?: string | null, extension?: Array<{ __typename?: 'Extension', url: string, valueInstant?: string | null }> | null, tag?: Array<{ __typename?: 'Coding', system?: string | null, code?: string | null }> | null } | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null, type?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, text?: { __typename?: 'Narrative', id?: string | null, div: string } | null, category?: Array<{ __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null }> | null, custodian?: { __typename?: 'Reference', reference?: string | null, display?: string | null } | null, content: Array<{ __typename?: 'DocumentReferenceContent', attachment: { __typename?: 'Attachment', contentType?: string | null, language?: string | null, data?: string | null, url?: string | null, size?: number | null, hash?: string | null, title?: string | null, creation?: string | null }, format?: { __typename?: 'Coding', system?: string | null, version?: string | null, code?: string | null, display?: string | null } | null }>, context?: { __typename?: 'DocumentReferenceContext', period?: { __typename?: 'Period', start?: string | null, end?: string | null } | null, encounter?: Array<{ __typename?: 'Reference', reference?: string | null }> | null } | null } }> | null } | null };

export type DocumentReferencesQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
  cursor: Scalars['String']['input'];
  sort: DocumentReferenceSortParams;
  filter?: DocumentReferenceFilterParams;
  first: Scalars['Int']['input'];
}>;


export type DocumentReferencesQuery = { __typename?: 'Query', DocumentReferenceConnection?: { __typename?: 'DocumentReferenceConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges?: Array<{ __typename?: 'DocumentReferenceEdge', node: { __typename?: 'DocumentReference', id?: string | null, resourceType: string, status: DocumentReferenceStatus, docStatus?: CompositionStatus | null, date?: string | null, description?: string | null, masterIdentifier?: { __typename?: 'Identifier', system?: string | null, use?: IdentifierUse | null, value?: string | null } | null, meta?: { __typename?: 'Meta', versionId?: string | null, extension?: Array<{ __typename?: 'Extension', url: string, valueInstant?: string | null }> | null, tag?: Array<{ __typename?: 'Coding', system?: string | null, code?: string | null }> | null } | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null, type?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, text?: { __typename?: 'Narrative', id?: string | null, div: string } | null, category?: Array<{ __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null }> | null, custodian?: { __typename?: 'Reference', reference?: string | null, display?: string | null } | null, content: Array<{ __typename?: 'DocumentReferenceContent', attachment: { __typename?: 'Attachment', contentType?: string | null, language?: string | null, data?: string | null, url?: string | null, size?: number | null, hash?: string | null, title?: string | null, creation?: string | null }, format?: { __typename?: 'Coding', system?: string | null, version?: string | null, code?: string | null, display?: string | null } | null }>, context?: { __typename?: 'DocumentReferenceContext', period?: { __typename?: 'Period', start?: string | null, end?: string | null } | null, encounter?: Array<{ __typename?: 'Reference', reference?: string | null }> | null } | null } }> | null } | null };

export type DocumentReferencesListQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
  cursor: Scalars['String']['input'];
  sort: DocumentReferenceSortParams;
  filter?: DocumentReferenceFilterParams;
  first: Scalars['Int']['input'];
}>;


export type DocumentReferencesListQuery = { __typename?: 'Query', DocumentReferenceConnection?: { __typename?: 'DocumentReferenceConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges?: Array<{ __typename?: 'DocumentReferenceEdge', node: { __typename?: 'DocumentReference', id?: string | null, resourceType: string, status: DocumentReferenceStatus, docStatus?: CompositionStatus | null, date?: string | null, description?: string | null, BasicList?: Array<(
          { __typename?: 'Basic' }
          & { ' $fragmentRefs'?: { 'BasicFragment': BasicFragment } }
        )> | null, masterIdentifier?: { __typename?: 'Identifier', system?: string | null, use?: IdentifierUse | null, value?: string | null } | null, meta?: { __typename?: 'Meta', tag?: Array<{ __typename?: 'Coding', system?: string | null, code?: string | null }> | null } | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null, type?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, category?: Array<{ __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null }> | null, custodian?: { __typename?: 'Reference', reference?: string | null, display?: string | null } | null, content: Array<{ __typename?: 'DocumentReferenceContent', attachment: { __typename?: 'Attachment', contentType?: string | null, url?: string | null, creation?: string | null } }>, context?: { __typename?: 'DocumentReferenceContext', period?: { __typename?: 'Period', start?: string | null, end?: string | null } | null } | null } }> | null } | null };

export type EncountersQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
  cursor: Scalars['String']['input'];
  sort: EncounterSortParams;
  first: Scalars['Int']['input'];
  filter?: EncounterFilterParams;
}>;


export type EncountersQuery = { __typename?: 'Query', EncounterConnection?: { __typename?: 'EncounterConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges?: Array<{ __typename?: 'EncounterEdge', node: (
        { __typename?: 'Encounter' }
        & { ' $fragmentRefs'?: { 'EncounterFragment': EncounterFragment } }
      ) }> | null } | null };

export type EpisodeOfCareQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
  cursor: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  filter: EpisodeOfCareFilterParams;
}>;


export type EpisodeOfCareQuery = { __typename?: 'Query', EpisodeOfCareConnection?: { __typename?: 'EpisodeOfCareConnection', pageInfo: { __typename?: 'PageInfo', endCursor: string, hasNextPage: boolean }, edges?: Array<{ __typename?: 'EpisodeOfCareEdge', node: (
        { __typename?: 'EpisodeOfCare' }
        & { ' $fragmentRefs'?: { 'EpisodeOfCareFragment': EpisodeOfCareFragment } }
      ) }> | null } | null };

export type BasicFragment = { __typename?: 'Basic', id?: string | null, resourceType: string, meta?: { __typename?: 'Meta', lastUpdated?: string | null } | null, code: { __typename?: 'CodeableConcept', coding?: Array<{ __typename?: 'Coding', code?: string | null, display?: string | null, system?: string | null }> | null }, author?: { __typename?: 'Reference', display?: string | null } | null } & { ' $fragmentName'?: 'BasicFragment' };

export type CodingFragment = { __typename?: 'Coding', code?: string | null, display?: string | null, system?: string | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null } & { ' $fragmentName'?: 'CodingFragment' };

export type EncounterReferenceFragment = { __typename?: 'Encounter', id?: string | null, resourceType: string, status: EncounterStatus, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null, priority?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', code?: string | null, display?: string | null, system?: string | null }> | null } | null } & { ' $fragmentName'?: 'EncounterReferenceFragment' };

export type PractitionerFragment = { __typename?: 'Practitioner', id?: string | null, resourceType: string, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null, name?: Array<{ __typename?: 'HumanName', family?: string | null, given?: Array<string> | null, prefix?: Array<string> | null, suffix?: Array<string> | null, text?: string | null, use?: NameUse | null }> | null, qualification?: Array<{ __typename?: 'PractitionerQualification', code: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', code?: string | null, display?: string | null, system?: string | null }> | null }, period?: { __typename?: 'Period', start?: string | null, end?: string | null } | null }> | null } & { ' $fragmentName'?: 'PractitionerFragment' };

export type ServiceRequestFragment = { __typename?: 'ServiceRequest', id?: string | null, resourceType: string, status: RequestStatus, intent: RequestIntent, authoredOn?: string | null, subject: { __typename?: 'Reference', reference?: string | null }, identifier?: Array<{ __typename?: 'Identifier', system?: string | null, value?: string | null }> | null, requester?: { __typename?: 'Reference', reference?: string | null, display?: string | null, resource?:
      | { __typename?: 'Account' }
      | { __typename?: 'AllergyIntolerance' }
      | { __typename?: 'Appointment' }
      | { __typename?: 'AppointmentResponse' }
      | { __typename?: 'Basic' }
      | { __typename?: 'Binary' }
      | { __typename?: 'CarePlan' }
      | { __typename?: 'CareTeam' }
      | { __typename?: 'Claim' }
      | { __typename?: 'ClaimResponse' }
      | { __typename?: 'ClinicalImpression' }
      | { __typename?: 'CommunicationRequest' }
      | { __typename?: 'Composition' }
      | { __typename?: 'Condition' }
      | { __typename?: 'Consent' }
      | { __typename?: 'Contract' }
      | { __typename?: 'Coverage' }
      | { __typename?: 'CoverageEligibilityRequest' }
      | { __typename?: 'DetectedIssue' }
      | { __typename?: 'Device' }
      | { __typename?: 'DeviceDefinition' }
      | { __typename?: 'DeviceMetric' }
      | { __typename?: 'DeviceRequest' }
      | { __typename?: 'DeviceUseStatement' }
      | { __typename?: 'DiagnosticReport' }
      | { __typename?: 'DocumentReference' }
      | { __typename?: 'Encounter' }
      | { __typename?: 'Endpoint' }
      | { __typename?: 'EpisodeOfCare' }
      | { __typename?: 'FamilyMemberHistory' }
      | { __typename?: 'Goal' }
      | { __typename?: 'Group' }
      | { __typename?: 'HealthcareService' }
      | { __typename?: 'ImagingStudy' }
      | { __typename?: 'Immunization' }
      | { __typename?: 'ImmunizationEvaluation' }
      | { __typename?: 'ImmunizationRecommendation' }
      | { __typename?: 'InsurancePlan' }
      | { __typename?: 'List' }
      | { __typename?: 'Location' }
      | { __typename?: 'Measure' }
      | { __typename?: 'MeasureReport' }
      | { __typename?: 'Media' }
      | { __typename?: 'Medication' }
      | { __typename?: 'MedicationAdministration' }
      | { __typename?: 'MedicationDispense' }
      | { __typename?: 'MedicationRequest' }
      | { __typename?: 'MedicationStatement' }
      | { __typename?: 'MolecularSequence' }
      | { __typename?: 'NutritionOrder' }
      | { __typename?: 'Observation' }
      | { __typename?: 'Organization' }
      | { __typename?: 'Patient' }
      | { __typename?: 'PlanDefinition' }
      | { __typename?: 'Practitioner', id?: string | null, resourceType: string, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null, name?: Array<{ __typename?: 'HumanName', family?: string | null, given?: Array<string> | null, prefix?: Array<string> | null, suffix?: Array<string> | null, text?: string | null, use?: NameUse | null }> | null, qualification?: Array<{ __typename?: 'PractitionerQualification', code: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', code?: string | null, display?: string | null, system?: string | null }> | null }, period?: { __typename?: 'Period', start?: string | null, end?: string | null } | null }> | null }
      | { __typename?: 'PractitionerRole' }
      | { __typename?: 'Procedure' }
      | { __typename?: 'Provenance' }
      | { __typename?: 'Questionnaire' }
      | { __typename?: 'QuestionnaireResponse' }
      | { __typename?: 'RelatedPerson' }
      | { __typename?: 'RequestGroup' }
      | { __typename?: 'ResearchStudy' }
      | { __typename?: 'RiskAssessment' }
      | { __typename?: 'Schedule' }
      | { __typename?: 'ServiceRequest' }
      | { __typename?: 'Slot' }
      | { __typename?: 'Specimen' }
      | { __typename?: 'Substance' }
      | { __typename?: 'SupplyRequest' }
      | { __typename?: 'Task' }
      | { __typename?: 'VisionPrescription' }
     | null, identifier?: { __typename?: 'Identifier', system?: string | null, value?: string | null } | null } | null, reasonCode?: Array<{ __typename?: 'CodeableConcept', text?: string | null }> | null, category?: Array<{ __typename?: 'CodeableConcept', text?: string | null }> | null, performer?: Array<{ __typename?: 'Reference', reference?: string | null, display?: string | null, identifier?: { __typename?: 'Identifier', system?: string | null, value?: string | null } | null }> | null, locationReference?: Array<{ __typename?: 'Reference', reference?: string | null, display?: string | null }> | null } & { ' $fragmentName'?: 'ServiceRequestFragment' };

export type AppointmentFragment = { __typename?: 'Appointment', id?: string | null, resourceType: string, status: Appointmentstatus, start?: string | null, end?: string | null, participant: Array<{ __typename?: 'AppointmentParticipant', status: Participationstatus, actor?: { __typename?: 'Reference', reference?: string | null, display?: string | null, identifier?: { __typename?: 'Identifier', system?: string | null, value?: string | null } | null } | null }>, basedOn?: Array<{ __typename?: 'Reference', reference?: string | null }> | null, serviceType?: Array<{ __typename?: 'CodeableConcept', text?: string | null }> | null, appointmentType?: { __typename?: 'CodeableConcept', text?: string | null } | null, serviceCategory?: Array<{ __typename?: 'CodeableConcept', text?: string | null }> | null, specialty?: Array<{ __typename?: 'CodeableConcept', text?: string | null }> | null } & { ' $fragmentName'?: 'AppointmentFragment' };

export type PatientFragment = { __typename?: 'Patient', id?: string | null, resourceType: string, active?: boolean | null, birthDate?: string | null, gender?: AdministrativeGender | null, meta?: { __typename?: 'Meta', extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null, valueInstant?: string | null }> | null, tag?: Array<{ __typename?: 'Coding', system?: string | null, code?: string | null }> | null } | null, identifier?: Array<{ __typename?: 'Identifier', use?: IdentifierUse | null, system?: string | null, value?: string | null }> | null, contact?: Array<{ __typename?: 'PatientContact', gender?: AdministrativeGender | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, district?: string | null, line?: Array<string> | null, postalCode?: string | null, state?: string | null, text?: string | null, type?: AddressType | null, use?: AddressUse | null, period?: { __typename?: 'Period', start?: string | null, end?: string | null } | null } | null, name?: { __typename?: 'HumanName', family?: string | null, given?: Array<string> | null, prefix?: Array<string> | null, suffix?: Array<string> | null, text?: string | null, use?: NameUse | null } | null, organization?: { __typename?: 'Reference', display?: string | null, type?: string | null, identifier?: { __typename?: 'Identifier', value?: string | null } | null } | null }> | null, maritalStatus?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', code?: string | null, display?: string | null, system?: string | null }> | null } | null, telecom?: Array<{ __typename?: 'ContactPoint', use?: ContactPointUse | null, value?: string | null, system?: ContactPointSystem | null }> | null, address?: Array<{ __typename?: 'Address', city?: string | null, country?: string | null, district?: string | null, line?: Array<string> | null, postalCode?: string | null, state?: string | null, text?: string | null, type?: AddressType | null, use?: AddressUse | null, period?: { __typename?: 'Period', start?: string | null, end?: string | null } | null }> | null, name?: Array<{ __typename?: 'HumanName', family?: string | null, given?: Array<string> | null, prefix?: Array<string> | null, suffix?: Array<string> | null, text?: string | null, use?: NameUse | null }> | null, managingOrganization?: { __typename?: 'Reference', resource?:
      | { __typename?: 'Account' }
      | { __typename?: 'AllergyIntolerance' }
      | { __typename?: 'Appointment' }
      | { __typename?: 'AppointmentResponse' }
      | { __typename?: 'Basic' }
      | { __typename?: 'Binary' }
      | { __typename?: 'CarePlan' }
      | { __typename?: 'CareTeam' }
      | { __typename?: 'Claim' }
      | { __typename?: 'ClaimResponse' }
      | { __typename?: 'ClinicalImpression' }
      | { __typename?: 'CommunicationRequest' }
      | { __typename?: 'Composition' }
      | { __typename?: 'Condition' }
      | { __typename?: 'Consent' }
      | { __typename?: 'Contract' }
      | { __typename?: 'Coverage' }
      | { __typename?: 'CoverageEligibilityRequest' }
      | { __typename?: 'DetectedIssue' }
      | { __typename?: 'Device' }
      | { __typename?: 'DeviceDefinition' }
      | { __typename?: 'DeviceMetric' }
      | { __typename?: 'DeviceRequest' }
      | { __typename?: 'DeviceUseStatement' }
      | { __typename?: 'DiagnosticReport' }
      | { __typename?: 'DocumentReference' }
      | { __typename?: 'Encounter' }
      | { __typename?: 'Endpoint' }
      | { __typename?: 'EpisodeOfCare' }
      | { __typename?: 'FamilyMemberHistory' }
      | { __typename?: 'Goal' }
      | { __typename?: 'Group' }
      | { __typename?: 'HealthcareService' }
      | { __typename?: 'ImagingStudy' }
      | { __typename?: 'Immunization' }
      | { __typename?: 'ImmunizationEvaluation' }
      | { __typename?: 'ImmunizationRecommendation' }
      | { __typename?: 'InsurancePlan' }
      | { __typename?: 'List' }
      | { __typename?: 'Location' }
      | { __typename?: 'Measure' }
      | { __typename?: 'MeasureReport' }
      | { __typename?: 'Media' }
      | { __typename?: 'Medication' }
      | { __typename?: 'MedicationAdministration' }
      | { __typename?: 'MedicationDispense' }
      | { __typename?: 'MedicationRequest' }
      | { __typename?: 'MedicationStatement' }
      | { __typename?: 'MolecularSequence' }
      | { __typename?: 'NutritionOrder' }
      | { __typename?: 'Observation' }
      | (
        { __typename?: 'Organization' }
        & { ' $fragmentRefs'?: { 'OrganizationFragment': OrganizationFragment } }
      )
      | { __typename?: 'Patient' }
      | { __typename?: 'PlanDefinition' }
      | { __typename?: 'Practitioner' }
      | { __typename?: 'PractitionerRole' }
      | { __typename?: 'Procedure' }
      | { __typename?: 'Provenance' }
      | { __typename?: 'Questionnaire' }
      | { __typename?: 'QuestionnaireResponse' }
      | { __typename?: 'RelatedPerson' }
      | { __typename?: 'RequestGroup' }
      | { __typename?: 'ResearchStudy' }
      | { __typename?: 'RiskAssessment' }
      | { __typename?: 'Schedule' }
      | { __typename?: 'ServiceRequest' }
      | { __typename?: 'Slot' }
      | { __typename?: 'Specimen' }
      | { __typename?: 'Substance' }
      | { __typename?: 'SupplyRequest' }
      | { __typename?: 'Task' }
      | { __typename?: 'VisionPrescription' }
     | null } | null } & { ' $fragmentName'?: 'PatientFragment' };

export type ReferenceFragment = { __typename?: 'Reference', id?: string | null, reference?: string | null, type?: string | null, display?: string | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null, identifier?: { __typename?: 'Identifier', id?: string | null, system?: string | null, value?: string | null } | null } & { ' $fragmentName'?: 'ReferenceFragment' };

export type ObservationFragment = { __typename?: 'Observation', id?: string | null, resourceType: string, status: ObservationStatus, effectiveDateTime?: string | null, valueString?: string | null, valueBoolean?: boolean | null, valueInteger?: number | null, valueTime?: string | null, valueDateTime?: string | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null, meta?: { __typename?: 'Meta', tag?: Array<{ __typename?: 'Coding', system?: string | null, code?: string | null }> | null } | null, encounter?: { __typename?: 'Reference', reference?: string | null } | null, category?: Array<{ __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', code?: string | null, display?: string | null, system?: string | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null }> | null }> | null, effectivePeriod?: { __typename?: 'Period', start?: string | null, end?: string | null } | null, referenceRange?: Array<{ __typename?: 'ObservationReferenceRange', text?: string | null }> | null, code: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', code?: string | null, display?: string | null, system?: string | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null }> | null }, component?: Array<{ __typename?: 'ObservationComponent', valueString?: string | null, code: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', code?: string | null, display?: string | null, system?: string | null }> | null }, valueQuantity?: { __typename?: 'Quantity', unit?: string | null, value?: number | null } | null }> | null, ProvenanceList?: Array<{ __typename?: 'Provenance', id?: string | null, entity?: Array<{ __typename?: 'ProvenanceEntity', what: (
        { __typename?: 'Reference' }
        & { ' $fragmentRefs'?: { 'ReferenceFragment': ReferenceFragment } }
      ) }> | null }> | null, valueQuantity?: { __typename?: 'Quantity', comparator?: QuantityComparator | null, unit?: string | null, value?: number | null, system?: string | null, code?: string | null } | null, valueCodeableConcept?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', system?: string | null, code?: string | null, display?: string | null }> | null } | null, valueRange?: { __typename?: 'Range', low?: { __typename?: 'Quantity', unit?: string | null, value?: number | null, system?: string | null, code?: string | null } | null, high?: { __typename?: 'Quantity', unit?: string | null, value?: number | null, system?: string | null, code?: string | null } | null } | null, valueRatio?: { __typename?: 'Ratio', numerator?: { __typename?: 'Quantity', comparator?: QuantityComparator | null, unit?: string | null, value?: number | null, system?: string | null, code?: string | null } | null, denominator?: { __typename?: 'Quantity', unit?: string | null, value?: number | null, system?: string | null, code?: string | null } | null } | null, valuePeriod?: { __typename?: 'Period', start?: string | null, end?: string | null } | null, interpretation?: Array<{ __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', code?: string | null, display?: string | null, system?: string | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null }> | null }> | null, note?: Array<{ __typename?: 'Annotation', text: string }> | null } & { ' $fragmentName'?: 'ObservationFragment' };

export type OrganizationFragment = { __typename?: 'Organization', id?: string | null, resourceType: string, name?: string | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null, telecom?: Array<{ __typename?: 'ContactPoint', system?: ContactPointSystem | null, value?: string | null, period?: { __typename?: 'Period', start?: string | null, end?: string | null } | null }> | null, contact?: Array<{ __typename?: 'OrganizationContact', purpose?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', code?: string | null, display?: string | null, system?: string | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null }> | null } | null, name?: { __typename?: 'HumanName', family?: string | null, given?: Array<string> | null, prefix?: Array<string> | null, suffix?: Array<string> | null, text?: string | null, use?: NameUse | null } | null, telecom?: Array<{ __typename?: 'ContactPoint', system?: ContactPointSystem | null, value?: string | null, period?: { __typename?: 'Period', start?: string | null, end?: string | null } | null }> | null, address?: { __typename?: 'Address', type?: AddressType | null, use?: AddressUse | null, text?: string | null, line?: Array<string> | null, city?: string | null, district?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, period?: { __typename?: 'Period', start?: string | null, end?: string | null } | null } | null }> | null } & { ' $fragmentName'?: 'OrganizationFragment' };

export type ProcedureFragment = { __typename?: 'Procedure', id?: string | null, resourceType: string, ProvenanceList?: Array<{ __typename?: 'Provenance', id?: string | null, entity?: Array<{ __typename?: 'ProvenanceEntity', what: (
        { __typename?: 'Reference' }
        & { ' $fragmentRefs'?: { 'ReferenceFragment': ReferenceFragment } }
      ) }> | null }> | null } & { ' $fragmentName'?: 'ProcedureFragment' };

export type CodeableConceptFragment = { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
    { __typename?: 'Coding' }
    & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
  )> | null } & { ' $fragmentName'?: 'CodeableConceptFragment' };

export type EncounterFragment = { __typename?: 'Encounter', id?: string | null, resourceType: string, status: EncounterStatus, BasicList?: Array<(
    { __typename?: 'Basic' }
    & { ' $fragmentRefs'?: { 'BasicFragment': BasicFragment } }
  )> | null, meta?: { __typename?: 'Meta', versionId?: string | null, tag?: Array<{ __typename?: 'Coding', system?: string | null, code?: string | null }> | null } | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null, extension?: Array<{ __typename?: 'Extension', url: string, valueReference?: { __typename?: 'Reference', id?: string | null, type?: string | null, reference?: string | null } | null }> | null }> | null, class: { __typename?: 'Coding', system?: string | null, version?: string | null, code?: string | null, display?: string | null }, type?: Array<(
    { __typename?: 'CodeableConcept' }
    & { ' $fragmentRefs'?: { 'CodeableConceptFragment': CodeableConceptFragment } }
  )> | null, serviceType?: (
    { __typename?: 'CodeableConcept' }
    & { ' $fragmentRefs'?: { 'CodeableConceptFragment': CodeableConceptFragment } }
  ) | null, priority?: (
    { __typename?: 'CodeableConcept' }
    & { ' $fragmentRefs'?: { 'CodeableConceptFragment': CodeableConceptFragment } }
  ) | null, diagnosis?: Array<{ __typename?: 'EncounterDiagnosis', condition: { __typename?: 'Reference', reference?: string | null, display?: string | null, resource?:
        | { __typename?: 'Account' }
        | { __typename?: 'AllergyIntolerance' }
        | { __typename?: 'Appointment' }
        | { __typename?: 'AppointmentResponse' }
        | { __typename?: 'Basic' }
        | { __typename?: 'Binary' }
        | { __typename?: 'CarePlan' }
        | { __typename?: 'CareTeam' }
        | { __typename?: 'Claim' }
        | { __typename?: 'ClaimResponse' }
        | { __typename?: 'ClinicalImpression' }
        | { __typename?: 'CommunicationRequest' }
        | { __typename?: 'Composition' }
        | { __typename?: 'Condition', code?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
              { __typename?: 'Coding' }
              & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
            )> | null } | null }
        | { __typename?: 'Consent' }
        | { __typename?: 'Contract' }
        | { __typename?: 'Coverage' }
        | { __typename?: 'CoverageEligibilityRequest' }
        | { __typename?: 'DetectedIssue' }
        | { __typename?: 'Device' }
        | { __typename?: 'DeviceDefinition' }
        | { __typename?: 'DeviceMetric' }
        | { __typename?: 'DeviceRequest' }
        | { __typename?: 'DeviceUseStatement' }
        | { __typename?: 'DiagnosticReport' }
        | { __typename?: 'DocumentReference' }
        | { __typename?: 'Encounter' }
        | { __typename?: 'Endpoint' }
        | { __typename?: 'EpisodeOfCare' }
        | { __typename?: 'FamilyMemberHistory' }
        | { __typename?: 'Goal' }
        | { __typename?: 'Group' }
        | { __typename?: 'HealthcareService' }
        | { __typename?: 'ImagingStudy' }
        | { __typename?: 'Immunization' }
        | { __typename?: 'ImmunizationEvaluation' }
        | { __typename?: 'ImmunizationRecommendation' }
        | { __typename?: 'InsurancePlan' }
        | { __typename?: 'List' }
        | { __typename?: 'Location' }
        | { __typename?: 'Measure' }
        | { __typename?: 'MeasureReport' }
        | { __typename?: 'Media' }
        | { __typename?: 'Medication' }
        | { __typename?: 'MedicationAdministration' }
        | { __typename?: 'MedicationDispense' }
        | { __typename?: 'MedicationRequest' }
        | { __typename?: 'MedicationStatement' }
        | { __typename?: 'MolecularSequence' }
        | { __typename?: 'NutritionOrder' }
        | { __typename?: 'Observation' }
        | { __typename?: 'Organization' }
        | { __typename?: 'Patient' }
        | { __typename?: 'PlanDefinition' }
        | { __typename?: 'Practitioner' }
        | { __typename?: 'PractitionerRole' }
        | { __typename?: 'Procedure' }
        | { __typename?: 'Provenance' }
        | { __typename?: 'Questionnaire' }
        | { __typename?: 'QuestionnaireResponse' }
        | { __typename?: 'RelatedPerson' }
        | { __typename?: 'RequestGroup' }
        | { __typename?: 'ResearchStudy' }
        | { __typename?: 'RiskAssessment' }
        | { __typename?: 'Schedule' }
        | { __typename?: 'ServiceRequest' }
        | { __typename?: 'Slot' }
        | { __typename?: 'Specimen' }
        | { __typename?: 'Substance' }
        | { __typename?: 'SupplyRequest' }
        | { __typename?: 'Task' }
        | { __typename?: 'VisionPrescription' }
       | null } }> | null, participant?: Array<{ __typename?: 'EncounterParticipant', individual?: { __typename?: 'Reference', reference?: string | null, display?: string | null, resource?:
        | { __typename?: 'Account' }
        | { __typename?: 'AllergyIntolerance' }
        | { __typename?: 'Appointment' }
        | { __typename?: 'AppointmentResponse' }
        | { __typename?: 'Basic' }
        | { __typename?: 'Binary' }
        | { __typename?: 'CarePlan' }
        | { __typename?: 'CareTeam' }
        | { __typename?: 'Claim' }
        | { __typename?: 'ClaimResponse' }
        | { __typename?: 'ClinicalImpression' }
        | { __typename?: 'CommunicationRequest' }
        | { __typename?: 'Composition' }
        | { __typename?: 'Condition' }
        | { __typename?: 'Consent' }
        | { __typename?: 'Contract' }
        | { __typename?: 'Coverage' }
        | { __typename?: 'CoverageEligibilityRequest' }
        | { __typename?: 'DetectedIssue' }
        | { __typename?: 'Device' }
        | { __typename?: 'DeviceDefinition' }
        | { __typename?: 'DeviceMetric' }
        | { __typename?: 'DeviceRequest' }
        | { __typename?: 'DeviceUseStatement' }
        | { __typename?: 'DiagnosticReport' }
        | { __typename?: 'DocumentReference' }
        | { __typename?: 'Encounter' }
        | { __typename?: 'Endpoint' }
        | { __typename?: 'EpisodeOfCare' }
        | { __typename?: 'FamilyMemberHistory' }
        | { __typename?: 'Goal' }
        | { __typename?: 'Group' }
        | { __typename?: 'HealthcareService' }
        | { __typename?: 'ImagingStudy' }
        | { __typename?: 'Immunization' }
        | { __typename?: 'ImmunizationEvaluation' }
        | { __typename?: 'ImmunizationRecommendation' }
        | { __typename?: 'InsurancePlan' }
        | { __typename?: 'List' }
        | { __typename?: 'Location' }
        | { __typename?: 'Measure' }
        | { __typename?: 'MeasureReport' }
        | { __typename?: 'Media' }
        | { __typename?: 'Medication' }
        | { __typename?: 'MedicationAdministration' }
        | { __typename?: 'MedicationDispense' }
        | { __typename?: 'MedicationRequest' }
        | { __typename?: 'MedicationStatement' }
        | { __typename?: 'MolecularSequence' }
        | { __typename?: 'NutritionOrder' }
        | { __typename?: 'Observation' }
        | { __typename?: 'Organization' }
        | { __typename?: 'Patient' }
        | { __typename?: 'PlanDefinition' }
        | { __typename?: 'Practitioner', name?: Array<{ __typename?: 'HumanName', family?: string | null, given?: Array<string> | null }> | null }
        | { __typename?: 'PractitionerRole' }
        | { __typename?: 'Procedure' }
        | { __typename?: 'Provenance' }
        | { __typename?: 'Questionnaire' }
        | { __typename?: 'QuestionnaireResponse' }
        | { __typename?: 'RelatedPerson' }
        | { __typename?: 'RequestGroup' }
        | { __typename?: 'ResearchStudy' }
        | { __typename?: 'RiskAssessment' }
        | { __typename?: 'Schedule' }
        | { __typename?: 'ServiceRequest' }
        | { __typename?: 'Slot' }
        | { __typename?: 'Specimen' }
        | { __typename?: 'Substance' }
        | { __typename?: 'SupplyRequest' }
        | { __typename?: 'Task' }
        | { __typename?: 'VisionPrescription' }
       | null } | null, type?: Array<(
      { __typename?: 'CodeableConcept' }
      & { ' $fragmentRefs'?: { 'CodeableConceptFragment': CodeableConceptFragment } }
    )> | null, period?: { __typename?: 'Period', start?: string | null, end?: string | null } | null }> | null, period?: { __typename?: 'Period', start?: string | null, end?: string | null } | null, ProvenanceList?: Array<{ __typename?: 'Provenance', id?: string | null, entity?: Array<{ __typename?: 'ProvenanceEntity', what: (
        { __typename?: 'Reference' }
        & { ' $fragmentRefs'?: { 'ReferenceFragment': ReferenceFragment } }
      ) }> | null }> | null, length?: { __typename?: 'Duration', value?: number | null, unit?: string | null } | null, reasonCode?: Array<(
    { __typename?: 'CodeableConcept' }
    & { ' $fragmentRefs'?: { 'CodeableConceptFragment': CodeableConceptFragment } }
  )> | null, hospitalization?: { __typename?: 'EncounterHospitalization', dischargeDisposition?: (
      { __typename?: 'CodeableConcept' }
      & { ' $fragmentRefs'?: { 'CodeableConceptFragment': CodeableConceptFragment } }
    ) | null } | null, location?: Array<{ __typename?: 'EncounterLocation', status?: EncounterLocationStatus | null, location: { __typename?: 'Reference', reference?: string | null, display?: string | null, resource?:
        | { __typename?: 'Account' }
        | { __typename?: 'AllergyIntolerance' }
        | { __typename?: 'Appointment' }
        | { __typename?: 'AppointmentResponse' }
        | { __typename?: 'Basic' }
        | { __typename?: 'Binary' }
        | { __typename?: 'CarePlan' }
        | { __typename?: 'CareTeam' }
        | { __typename?: 'Claim' }
        | { __typename?: 'ClaimResponse' }
        | { __typename?: 'ClinicalImpression' }
        | { __typename?: 'CommunicationRequest' }
        | { __typename?: 'Composition' }
        | { __typename?: 'Condition' }
        | { __typename?: 'Consent' }
        | { __typename?: 'Contract' }
        | { __typename?: 'Coverage' }
        | { __typename?: 'CoverageEligibilityRequest' }
        | { __typename?: 'DetectedIssue' }
        | { __typename?: 'Device' }
        | { __typename?: 'DeviceDefinition' }
        | { __typename?: 'DeviceMetric' }
        | { __typename?: 'DeviceRequest' }
        | { __typename?: 'DeviceUseStatement' }
        | { __typename?: 'DiagnosticReport' }
        | { __typename?: 'DocumentReference' }
        | { __typename?: 'Encounter' }
        | { __typename?: 'Endpoint' }
        | { __typename?: 'EpisodeOfCare' }
        | { __typename?: 'FamilyMemberHistory' }
        | { __typename?: 'Goal' }
        | { __typename?: 'Group' }
        | { __typename?: 'HealthcareService' }
        | { __typename?: 'ImagingStudy' }
        | { __typename?: 'Immunization' }
        | { __typename?: 'ImmunizationEvaluation' }
        | { __typename?: 'ImmunizationRecommendation' }
        | { __typename?: 'InsurancePlan' }
        | { __typename?: 'List' }
        | { __typename?: 'Location', name?: string | null, type?: Array<(
            { __typename?: 'CodeableConcept' }
            & { ' $fragmentRefs'?: { 'CodeableConceptFragment': CodeableConceptFragment } }
          )> | null }
        | { __typename?: 'Measure' }
        | { __typename?: 'MeasureReport' }
        | { __typename?: 'Media' }
        | { __typename?: 'Medication' }
        | { __typename?: 'MedicationAdministration' }
        | { __typename?: 'MedicationDispense' }
        | { __typename?: 'MedicationRequest' }
        | { __typename?: 'MedicationStatement' }
        | { __typename?: 'MolecularSequence' }
        | { __typename?: 'NutritionOrder' }
        | { __typename?: 'Observation' }
        | { __typename?: 'Organization' }
        | { __typename?: 'Patient' }
        | { __typename?: 'PlanDefinition' }
        | { __typename?: 'Practitioner' }
        | { __typename?: 'PractitionerRole' }
        | { __typename?: 'Procedure' }
        | { __typename?: 'Provenance' }
        | { __typename?: 'Questionnaire' }
        | { __typename?: 'QuestionnaireResponse' }
        | { __typename?: 'RelatedPerson' }
        | { __typename?: 'RequestGroup' }
        | { __typename?: 'ResearchStudy' }
        | { __typename?: 'RiskAssessment' }
        | { __typename?: 'Schedule' }
        | { __typename?: 'ServiceRequest' }
        | { __typename?: 'Slot' }
        | { __typename?: 'Specimen' }
        | { __typename?: 'Substance' }
        | { __typename?: 'SupplyRequest' }
        | { __typename?: 'Task' }
        | { __typename?: 'VisionPrescription' }
       | null }, period?: { __typename?: 'Period', start?: string | null, end?: string | null } | null }> | null } & { ' $fragmentName'?: 'EncounterFragment' };

export type EpisodeOfCareFragment = { __typename?: 'EpisodeOfCare', id?: string | null, resourceType: string, status: EpisodeOfCareStatus, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null, valueReference?: { __typename?: 'Reference', id?: string | null, type?: string | null, reference?: string | null, display?: string | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null, valueBoolean?: boolean | null }> | null } | null }> | null, valueReference?: { __typename?: 'Reference', id?: string | null, type?: string | null, reference?: string | null, display?: string | null } | null, valueCodeableConcept?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', system?: string | null, code?: string | null, display?: string | null }> | null } | null, valueCoding?: { __typename?: 'Coding', code?: string | null, display?: string | null, system?: string | null, userSelected?: boolean | null, version?: string | null } | null }> | null, meta?: { __typename?: 'Meta', lastUpdated?: string | null, extension?: Array<{ __typename?: 'Extension', url: string }> | null, security?: Array<{ __typename?: 'Coding', system?: string | null, code?: string | null }> | null, tag?: Array<{ __typename?: 'Coding', system?: string | null, code?: string | null }> | null } | null, period?: { __typename?: 'Period', start?: string | null, end?: string | null } | null, identifier?: Array<{ __typename?: 'Identifier', system?: string | null, value?: string | null, type?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', system?: string | null, code?: string | null, display?: string | null }> | null } | null }> | null, diagnosis?: Array<{ __typename?: 'EpisodeOfCareDiagnosis', role?: { __typename?: 'CodeableConcept', coding?: Array<{ __typename?: 'Coding', system?: string | null, code?: string | null, display?: string | null }> | null } | null, condition: { __typename?: 'Reference', id?: string | null, type?: string | null, reference?: string | null, resource?:
        | { __typename?: 'Account' }
        | { __typename?: 'AllergyIntolerance' }
        | { __typename?: 'Appointment' }
        | { __typename?: 'AppointmentResponse' }
        | { __typename?: 'Basic' }
        | { __typename?: 'Binary' }
        | { __typename?: 'CarePlan' }
        | { __typename?: 'CareTeam' }
        | { __typename?: 'Claim' }
        | { __typename?: 'ClaimResponse' }
        | { __typename?: 'ClinicalImpression' }
        | { __typename?: 'CommunicationRequest' }
        | { __typename?: 'Composition' }
        | { __typename?: 'Condition', id?: string | null, resourceType: string, code?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', display?: string | null, code?: string | null, system?: string | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null }> | null } | null }
        | { __typename?: 'Consent' }
        | { __typename?: 'Contract' }
        | { __typename?: 'Coverage' }
        | { __typename?: 'CoverageEligibilityRequest' }
        | { __typename?: 'DetectedIssue' }
        | { __typename?: 'Device' }
        | { __typename?: 'DeviceDefinition' }
        | { __typename?: 'DeviceMetric' }
        | { __typename?: 'DeviceRequest' }
        | { __typename?: 'DeviceUseStatement' }
        | { __typename?: 'DiagnosticReport' }
        | { __typename?: 'DocumentReference' }
        | { __typename?: 'Encounter' }
        | { __typename?: 'Endpoint' }
        | { __typename?: 'EpisodeOfCare' }
        | { __typename?: 'FamilyMemberHistory' }
        | { __typename?: 'Goal' }
        | { __typename?: 'Group' }
        | { __typename?: 'HealthcareService' }
        | { __typename?: 'ImagingStudy' }
        | { __typename?: 'Immunization' }
        | { __typename?: 'ImmunizationEvaluation' }
        | { __typename?: 'ImmunizationRecommendation' }
        | { __typename?: 'InsurancePlan' }
        | { __typename?: 'List' }
        | { __typename?: 'Location' }
        | { __typename?: 'Measure' }
        | { __typename?: 'MeasureReport' }
        | { __typename?: 'Media' }
        | { __typename?: 'Medication' }
        | { __typename?: 'MedicationAdministration' }
        | { __typename?: 'MedicationDispense' }
        | { __typename?: 'MedicationRequest' }
        | { __typename?: 'MedicationStatement' }
        | { __typename?: 'MolecularSequence' }
        | { __typename?: 'NutritionOrder' }
        | { __typename?: 'Observation' }
        | { __typename?: 'Organization' }
        | { __typename?: 'Patient' }
        | { __typename?: 'PlanDefinition' }
        | { __typename?: 'Practitioner' }
        | { __typename?: 'PractitionerRole' }
        | { __typename?: 'Procedure' }
        | { __typename?: 'Provenance' }
        | { __typename?: 'Questionnaire' }
        | { __typename?: 'QuestionnaireResponse' }
        | { __typename?: 'RelatedPerson' }
        | { __typename?: 'RequestGroup' }
        | { __typename?: 'ResearchStudy' }
        | { __typename?: 'RiskAssessment' }
        | { __typename?: 'Schedule' }
        | { __typename?: 'ServiceRequest' }
        | { __typename?: 'Slot' }
        | { __typename?: 'Specimen' }
        | { __typename?: 'Substance' }
        | { __typename?: 'SupplyRequest' }
        | { __typename?: 'Task' }
        | { __typename?: 'VisionPrescription' }
       | null } }> | null } & { ' $fragmentName'?: 'EpisodeOfCareFragment' };

export type ImmunizationsQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
  cursor: Scalars['String']['input'];
  sort: ImmunizationSortParams;
  first: Scalars['Int']['input'];
}>;


export type ImmunizationsQuery = { __typename?: 'Query', ImmunizationConnection?: { __typename?: 'ImmunizationConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges?: Array<{ __typename?: 'ImmunizationEdge', node: { __typename?: 'Immunization', id?: string | null, resourceType: string, status: ImmunizationStatus, occurrenceDateTime?: string | null, occurrenceString?: string | null, recorded?: string | null, lotNumber?: string | null, expirationDate?: string | null, BasicList?: Array<(
          { __typename?: 'Basic' }
          & { ' $fragmentRefs'?: { 'BasicFragment': BasicFragment } }
        )> | null, meta?: { __typename?: 'Meta', versionId?: string | null, tag?: Array<{ __typename?: 'Coding', system?: string | null, code?: string | null }> | null } | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null, statusReason?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, vaccineCode: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null }, patient: { __typename?: 'Reference', reference?: string | null, resource?:
            | { __typename?: 'Account' }
            | { __typename?: 'AllergyIntolerance' }
            | { __typename?: 'Appointment' }
            | { __typename?: 'AppointmentResponse' }
            | { __typename?: 'Basic' }
            | { __typename?: 'Binary' }
            | { __typename?: 'CarePlan' }
            | { __typename?: 'CareTeam' }
            | { __typename?: 'Claim' }
            | { __typename?: 'ClaimResponse' }
            | { __typename?: 'ClinicalImpression' }
            | { __typename?: 'CommunicationRequest' }
            | { __typename?: 'Composition' }
            | { __typename?: 'Condition' }
            | { __typename?: 'Consent' }
            | { __typename?: 'Contract' }
            | { __typename?: 'Coverage' }
            | { __typename?: 'CoverageEligibilityRequest' }
            | { __typename?: 'DetectedIssue' }
            | { __typename?: 'Device' }
            | { __typename?: 'DeviceDefinition' }
            | { __typename?: 'DeviceMetric' }
            | { __typename?: 'DeviceRequest' }
            | { __typename?: 'DeviceUseStatement' }
            | { __typename?: 'DiagnosticReport' }
            | { __typename?: 'DocumentReference' }
            | { __typename?: 'Encounter' }
            | { __typename?: 'Endpoint' }
            | { __typename?: 'EpisodeOfCare' }
            | { __typename?: 'FamilyMemberHistory' }
            | { __typename?: 'Goal' }
            | { __typename?: 'Group' }
            | { __typename?: 'HealthcareService' }
            | { __typename?: 'ImagingStudy' }
            | { __typename?: 'Immunization' }
            | { __typename?: 'ImmunizationEvaluation' }
            | { __typename?: 'ImmunizationRecommendation' }
            | { __typename?: 'InsurancePlan' }
            | { __typename?: 'List' }
            | { __typename?: 'Location' }
            | { __typename?: 'Measure' }
            | { __typename?: 'MeasureReport' }
            | { __typename?: 'Media' }
            | { __typename?: 'Medication' }
            | { __typename?: 'MedicationAdministration' }
            | { __typename?: 'MedicationDispense' }
            | { __typename?: 'MedicationRequest' }
            | { __typename?: 'MedicationStatement' }
            | { __typename?: 'MolecularSequence' }
            | { __typename?: 'NutritionOrder' }
            | { __typename?: 'Observation' }
            | { __typename?: 'Organization' }
            | (
              { __typename?: 'Patient', managingOrganization?: { __typename?: 'Reference', resource?:
                  | { __typename?: 'Account' }
                  | { __typename?: 'AllergyIntolerance' }
                  | { __typename?: 'Appointment' }
                  | { __typename?: 'AppointmentResponse' }
                  | { __typename?: 'Basic' }
                  | { __typename?: 'Binary' }
                  | { __typename?: 'CarePlan' }
                  | { __typename?: 'CareTeam' }
                  | { __typename?: 'Claim' }
                  | { __typename?: 'ClaimResponse' }
                  | { __typename?: 'ClinicalImpression' }
                  | { __typename?: 'CommunicationRequest' }
                  | { __typename?: 'Composition' }
                  | { __typename?: 'Condition' }
                  | { __typename?: 'Consent' }
                  | { __typename?: 'Contract' }
                  | { __typename?: 'Coverage' }
                  | { __typename?: 'CoverageEligibilityRequest' }
                  | { __typename?: 'DetectedIssue' }
                  | { __typename?: 'Device' }
                  | { __typename?: 'DeviceDefinition' }
                  | { __typename?: 'DeviceMetric' }
                  | { __typename?: 'DeviceRequest' }
                  | { __typename?: 'DeviceUseStatement' }
                  | { __typename?: 'DiagnosticReport' }
                  | { __typename?: 'DocumentReference' }
                  | { __typename?: 'Encounter' }
                  | { __typename?: 'Endpoint' }
                  | { __typename?: 'EpisodeOfCare' }
                  | { __typename?: 'FamilyMemberHistory' }
                  | { __typename?: 'Goal' }
                  | { __typename?: 'Group' }
                  | { __typename?: 'HealthcareService' }
                  | { __typename?: 'ImagingStudy' }
                  | { __typename?: 'Immunization' }
                  | { __typename?: 'ImmunizationEvaluation' }
                  | { __typename?: 'ImmunizationRecommendation' }
                  | { __typename?: 'InsurancePlan' }
                  | { __typename?: 'List' }
                  | { __typename?: 'Location' }
                  | { __typename?: 'Measure' }
                  | { __typename?: 'MeasureReport' }
                  | { __typename?: 'Media' }
                  | { __typename?: 'Medication' }
                  | { __typename?: 'MedicationAdministration' }
                  | { __typename?: 'MedicationDispense' }
                  | { __typename?: 'MedicationRequest' }
                  | { __typename?: 'MedicationStatement' }
                  | { __typename?: 'MolecularSequence' }
                  | { __typename?: 'NutritionOrder' }
                  | { __typename?: 'Observation' }
                  | { __typename?: 'Organization', name?: string | null }
                  | { __typename?: 'Patient' }
                  | { __typename?: 'PlanDefinition' }
                  | { __typename?: 'Practitioner' }
                  | { __typename?: 'PractitionerRole' }
                  | { __typename?: 'Procedure' }
                  | { __typename?: 'Provenance' }
                  | { __typename?: 'Questionnaire' }
                  | { __typename?: 'QuestionnaireResponse' }
                  | { __typename?: 'RelatedPerson' }
                  | { __typename?: 'RequestGroup' }
                  | { __typename?: 'ResearchStudy' }
                  | { __typename?: 'RiskAssessment' }
                  | { __typename?: 'Schedule' }
                  | { __typename?: 'ServiceRequest' }
                  | { __typename?: 'Slot' }
                  | { __typename?: 'Specimen' }
                  | { __typename?: 'Substance' }
                  | { __typename?: 'SupplyRequest' }
                  | { __typename?: 'Task' }
                  | { __typename?: 'VisionPrescription' }
                 | null } | null }
              & { ' $fragmentRefs'?: { 'PatientFragment': PatientFragment } }
            )
            | { __typename?: 'PlanDefinition' }
            | { __typename?: 'Practitioner' }
            | { __typename?: 'PractitionerRole' }
            | { __typename?: 'Procedure' }
            | { __typename?: 'Provenance' }
            | { __typename?: 'Questionnaire' }
            | { __typename?: 'QuestionnaireResponse' }
            | { __typename?: 'RelatedPerson' }
            | { __typename?: 'RequestGroup' }
            | { __typename?: 'ResearchStudy' }
            | { __typename?: 'RiskAssessment' }
            | { __typename?: 'Schedule' }
            | { __typename?: 'ServiceRequest' }
            | { __typename?: 'Slot' }
            | { __typename?: 'Specimen' }
            | { __typename?: 'Substance' }
            | { __typename?: 'SupplyRequest' }
            | { __typename?: 'Task' }
            | { __typename?: 'VisionPrescription' }
           | null } } }> | null } | null };

export type MedicationAdministrationsQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
  cursor: Scalars['String']['input'];
  filter: MedicationAdministrationFilterParams;
  sort: MedicationAdministrationSortParams;
  first: Scalars['Int']['input'];
}>;


export type MedicationAdministrationsQuery = { __typename?: 'Query', MedicationAdministrationConnection?: { __typename?: 'MedicationAdministrationConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges?: Array<{ __typename?: 'MedicationAdministrationEdge', node: { __typename?: 'MedicationAdministration', id?: string | null, resourceType: string, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null, dosage?: { __typename?: 'MedicationAdministrationDosage', text?: string | null, dose?: { __typename?: 'Quantity', value?: number | null, unit?: string | null } | null, route?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
              { __typename?: 'Coding' }
              & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
            )> | null } | null } | null, effectivePeriod?: { __typename?: 'Period', start?: string | null, end?: string | null } | null } }> | null } | null };

export type MedicationDispensesQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
  cursor: Scalars['String']['input'];
  filter: MedicationDispenseFilterParams;
  sort: MedicationDispenseSortParams;
  first: Scalars['Int']['input'];
}>;


export type MedicationDispensesQuery = { __typename?: 'Query', MedicationDispenseConnection?: { __typename?: 'MedicationDispenseConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges?: Array<{ __typename?: 'MedicationDispenseEdge', node: { __typename?: 'MedicationDispense', id?: string | null, resourceType: string, status: MedicationdispenseStatus, whenHandedOver?: string | null, whenPrepared?: string | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null, valueInstant?: string | null }> | null, contained?: Array<{ __typename?: 'Resource', resource?:
            | { __typename?: 'Account' }
            | { __typename?: 'AllergyIntolerance' }
            | { __typename?: 'Appointment' }
            | { __typename?: 'AppointmentResponse' }
            | { __typename?: 'Basic' }
            | { __typename?: 'Binary' }
            | { __typename?: 'CarePlan' }
            | { __typename?: 'CareTeam' }
            | { __typename?: 'Claim' }
            | { __typename?: 'ClaimResponse' }
            | { __typename?: 'ClinicalImpression' }
            | { __typename?: 'CommunicationRequest' }
            | { __typename?: 'Composition' }
            | { __typename?: 'Condition' }
            | { __typename?: 'Consent' }
            | { __typename?: 'Contract' }
            | { __typename?: 'Coverage' }
            | { __typename?: 'CoverageEligibilityRequest' }
            | { __typename?: 'DetectedIssue' }
            | { __typename?: 'Device' }
            | { __typename?: 'DeviceDefinition' }
            | { __typename?: 'DeviceMetric' }
            | { __typename?: 'DeviceRequest' }
            | { __typename?: 'DeviceUseStatement' }
            | { __typename?: 'DiagnosticReport' }
            | { __typename?: 'DocumentReference' }
            | { __typename?: 'Encounter' }
            | { __typename?: 'Endpoint' }
            | { __typename?: 'EpisodeOfCare' }
            | { __typename?: 'FamilyMemberHistory' }
            | { __typename?: 'Goal' }
            | { __typename?: 'Group' }
            | { __typename?: 'HealthcareService' }
            | { __typename?: 'ImagingStudy' }
            | { __typename?: 'Immunization' }
            | { __typename?: 'ImmunizationEvaluation' }
            | { __typename?: 'ImmunizationRecommendation' }
            | { __typename?: 'InsurancePlan' }
            | { __typename?: 'List' }
            | { __typename?: 'Location' }
            | { __typename?: 'Measure' }
            | { __typename?: 'MeasureReport' }
            | { __typename?: 'Media' }
            | { __typename?: 'Medication' }
            | { __typename?: 'MedicationAdministration' }
            | { __typename?: 'MedicationDispense' }
            | { __typename?: 'MedicationRequest' }
            | { __typename?: 'MedicationStatement' }
            | { __typename?: 'MolecularSequence' }
            | { __typename?: 'NutritionOrder' }
            | { __typename?: 'Observation' }
            | { __typename?: 'Organization', id?: string | null, resourceType: string, _organization__name?: string | null, telecom?: Array<{ __typename?: 'ContactPoint', value?: string | null }> | null, address?: Array<{ __typename?: 'Address', city?: string | null, state?: string | null, postalCode?: string | null, text?: string | null, line?: Array<string> | null }> | null }
            | { __typename?: 'Patient' }
            | { __typename?: 'PlanDefinition' }
            | { __typename?: 'Practitioner', id?: string | null, resourceType: string, name?: Array<{ __typename?: 'HumanName', family?: string | null, given?: Array<string> | null }> | null, address?: Array<{ __typename?: 'Address', text?: string | null }> | null, telecom?: Array<{ __typename?: 'ContactPoint', value?: string | null }> | null }
            | { __typename?: 'PractitionerRole' }
            | { __typename?: 'Procedure' }
            | { __typename?: 'Provenance' }
            | { __typename?: 'Questionnaire' }
            | { __typename?: 'QuestionnaireResponse' }
            | { __typename?: 'RelatedPerson' }
            | { __typename?: 'RequestGroup' }
            | { __typename?: 'ResearchStudy' }
            | { __typename?: 'RiskAssessment' }
            | { __typename?: 'Schedule' }
            | { __typename?: 'ServiceRequest' }
            | { __typename?: 'Slot' }
            | { __typename?: 'Specimen' }
            | { __typename?: 'Substance' }
            | { __typename?: 'SupplyRequest' }
            | { __typename?: 'Task' }
            | { __typename?: 'VisionPrescription' }
           | null }> | null, performer?: Array<{ __typename?: 'MedicationDispensePerformer', actor: { __typename?: 'Reference', id?: string | null, reference?: string | null, type?: string | null, display?: string | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null, identifier?: { __typename?: 'Identifier', id?: string | null, system?: string | null, value?: string | null } | null, resource?:
              | { __typename?: 'Account' }
              | { __typename?: 'AllergyIntolerance' }
              | { __typename?: 'Appointment' }
              | { __typename?: 'AppointmentResponse' }
              | { __typename?: 'Basic' }
              | { __typename?: 'Binary' }
              | { __typename?: 'CarePlan' }
              | { __typename?: 'CareTeam' }
              | { __typename?: 'Claim' }
              | { __typename?: 'ClaimResponse' }
              | { __typename?: 'ClinicalImpression' }
              | { __typename?: 'CommunicationRequest' }
              | { __typename?: 'Composition' }
              | { __typename?: 'Condition' }
              | { __typename?: 'Consent' }
              | { __typename?: 'Contract' }
              | { __typename?: 'Coverage' }
              | { __typename?: 'CoverageEligibilityRequest' }
              | { __typename?: 'DetectedIssue' }
              | { __typename?: 'Device' }
              | { __typename?: 'DeviceDefinition' }
              | { __typename?: 'DeviceMetric' }
              | { __typename?: 'DeviceRequest' }
              | { __typename?: 'DeviceUseStatement' }
              | { __typename?: 'DiagnosticReport' }
              | { __typename?: 'DocumentReference' }
              | { __typename?: 'Encounter' }
              | { __typename?: 'Endpoint' }
              | { __typename?: 'EpisodeOfCare' }
              | { __typename?: 'FamilyMemberHistory' }
              | { __typename?: 'Goal' }
              | { __typename?: 'Group' }
              | { __typename?: 'HealthcareService' }
              | { __typename?: 'ImagingStudy' }
              | { __typename?: 'Immunization' }
              | { __typename?: 'ImmunizationEvaluation' }
              | { __typename?: 'ImmunizationRecommendation' }
              | { __typename?: 'InsurancePlan' }
              | { __typename?: 'List' }
              | { __typename?: 'Location' }
              | { __typename?: 'Measure' }
              | { __typename?: 'MeasureReport' }
              | { __typename?: 'Media' }
              | { __typename?: 'Medication' }
              | { __typename?: 'MedicationAdministration' }
              | { __typename?: 'MedicationDispense' }
              | { __typename?: 'MedicationRequest' }
              | { __typename?: 'MedicationStatement' }
              | { __typename?: 'MolecularSequence' }
              | { __typename?: 'NutritionOrder' }
              | { __typename?: 'Observation' }
              | { __typename?: 'Organization', id?: string | null, resourceType: string, name?: string | null, telecom?: Array<{ __typename?: 'ContactPoint', value?: string | null }> | null, address?: Array<{ __typename?: 'Address', city?: string | null, state?: string | null, postalCode?: string | null, text?: string | null, line?: Array<string> | null }> | null }
              | { __typename?: 'Patient' }
              | { __typename?: 'PlanDefinition' }
              | { __typename?: 'Practitioner' }
              | { __typename?: 'PractitionerRole' }
              | { __typename?: 'Procedure' }
              | { __typename?: 'Provenance' }
              | { __typename?: 'Questionnaire' }
              | { __typename?: 'QuestionnaireResponse' }
              | { __typename?: 'RelatedPerson' }
              | { __typename?: 'RequestGroup' }
              | { __typename?: 'ResearchStudy' }
              | { __typename?: 'RiskAssessment' }
              | { __typename?: 'Schedule' }
              | { __typename?: 'ServiceRequest' }
              | { __typename?: 'Slot' }
              | { __typename?: 'Specimen' }
              | { __typename?: 'Substance' }
              | { __typename?: 'SupplyRequest' }
              | { __typename?: 'Task' }
              | { __typename?: 'VisionPrescription' }
             | null } }> | null, quantity?: { __typename?: 'Quantity', value?: number | null, unit?: string | null } | null, medicationCodeableConcept?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, daysSupply?: { __typename?: 'Quantity', value?: number | null, unit?: string | null } | null } }> | null } | null };

export type MedicationRequestsQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
  cursor: Scalars['String']['input'];
  filter: MedicationRequestFilterParams;
  sort: MedicationRequestSortParams;
  first: Scalars['Int']['input'];
}>;


export type MedicationRequestsQuery = { __typename?: 'Query', MedicationRequestConnection?: { __typename?: 'MedicationRequestConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges?: Array<{ __typename?: 'MedicationRequestEdge', node: { __typename?: 'MedicationRequest', id?: string | null, resourceType: string, authoredOn?: string | null, reportedBoolean?: boolean | null, status: MedicationrequestStatus, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null, contained?: Array<{ __typename?: 'Resource', resource?:
            | { __typename?: 'Account' }
            | { __typename?: 'AllergyIntolerance' }
            | { __typename?: 'Appointment' }
            | { __typename?: 'AppointmentResponse' }
            | { __typename?: 'Basic' }
            | { __typename?: 'Binary' }
            | { __typename?: 'CarePlan' }
            | { __typename?: 'CareTeam' }
            | { __typename?: 'Claim' }
            | { __typename?: 'ClaimResponse' }
            | { __typename?: 'ClinicalImpression' }
            | { __typename?: 'CommunicationRequest' }
            | { __typename?: 'Composition' }
            | { __typename?: 'Condition' }
            | { __typename?: 'Consent' }
            | { __typename?: 'Contract' }
            | { __typename?: 'Coverage' }
            | { __typename?: 'CoverageEligibilityRequest' }
            | { __typename?: 'DetectedIssue' }
            | { __typename?: 'Device' }
            | { __typename?: 'DeviceDefinition' }
            | { __typename?: 'DeviceMetric' }
            | { __typename?: 'DeviceRequest' }
            | { __typename?: 'DeviceUseStatement' }
            | { __typename?: 'DiagnosticReport' }
            | { __typename?: 'DocumentReference' }
            | { __typename?: 'Encounter' }
            | { __typename?: 'Endpoint' }
            | { __typename?: 'EpisodeOfCare' }
            | { __typename?: 'FamilyMemberHistory' }
            | { __typename?: 'Goal' }
            | { __typename?: 'Group' }
            | { __typename?: 'HealthcareService' }
            | { __typename?: 'ImagingStudy' }
            | { __typename?: 'Immunization' }
            | { __typename?: 'ImmunizationEvaluation' }
            | { __typename?: 'ImmunizationRecommendation' }
            | { __typename?: 'InsurancePlan' }
            | { __typename?: 'List' }
            | { __typename?: 'Location' }
            | { __typename?: 'Measure' }
            | { __typename?: 'MeasureReport' }
            | { __typename?: 'Media' }
            | { __typename?: 'Medication' }
            | { __typename?: 'MedicationAdministration' }
            | { __typename?: 'MedicationDispense' }
            | { __typename?: 'MedicationRequest' }
            | { __typename?: 'MedicationStatement' }
            | { __typename?: 'MolecularSequence' }
            | { __typename?: 'NutritionOrder' }
            | { __typename?: 'Observation' }
            | { __typename?: 'Organization', id?: string | null, resourceType: string, _organization__name?: string | null, telecom?: Array<{ __typename?: 'ContactPoint', value?: string | null }> | null, address?: Array<{ __typename?: 'Address', city?: string | null, state?: string | null, postalCode?: string | null, text?: string | null, line?: Array<string> | null }> | null }
            | { __typename?: 'Patient' }
            | { __typename?: 'PlanDefinition' }
            | { __typename?: 'Practitioner', id?: string | null, resourceType: string, name?: Array<{ __typename?: 'HumanName', family?: string | null, given?: Array<string> | null }> | null, address?: Array<{ __typename?: 'Address', text?: string | null }> | null, telecom?: Array<{ __typename?: 'ContactPoint', value?: string | null }> | null }
            | { __typename?: 'PractitionerRole' }
            | { __typename?: 'Procedure' }
            | { __typename?: 'Provenance' }
            | { __typename?: 'Questionnaire' }
            | { __typename?: 'QuestionnaireResponse' }
            | { __typename?: 'RelatedPerson' }
            | { __typename?: 'RequestGroup' }
            | { __typename?: 'ResearchStudy' }
            | { __typename?: 'RiskAssessment' }
            | { __typename?: 'Schedule' }
            | { __typename?: 'ServiceRequest' }
            | { __typename?: 'Slot' }
            | { __typename?: 'Specimen' }
            | { __typename?: 'Substance' }
            | { __typename?: 'SupplyRequest' }
            | { __typename?: 'Task' }
            | { __typename?: 'VisionPrescription' }
           | null }> | null, dispenseRequest?: { __typename?: 'MedicationRequestDispenseRequest', numberOfRepeatsAllowed?: number | null, performer?: { __typename?: 'Reference', id?: string | null, reference?: string | null, type?: string | null, display?: string | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null, identifier?: { __typename?: 'Identifier', id?: string | null, system?: string | null, value?: string | null } | null, resource?:
              | { __typename?: 'Account' }
              | { __typename?: 'AllergyIntolerance' }
              | { __typename?: 'Appointment' }
              | { __typename?: 'AppointmentResponse' }
              | { __typename?: 'Basic' }
              | { __typename?: 'Binary' }
              | { __typename?: 'CarePlan' }
              | { __typename?: 'CareTeam' }
              | { __typename?: 'Claim' }
              | { __typename?: 'ClaimResponse' }
              | { __typename?: 'ClinicalImpression' }
              | { __typename?: 'CommunicationRequest' }
              | { __typename?: 'Composition' }
              | { __typename?: 'Condition' }
              | { __typename?: 'Consent' }
              | { __typename?: 'Contract' }
              | { __typename?: 'Coverage' }
              | { __typename?: 'CoverageEligibilityRequest' }
              | { __typename?: 'DetectedIssue' }
              | { __typename?: 'Device' }
              | { __typename?: 'DeviceDefinition' }
              | { __typename?: 'DeviceMetric' }
              | { __typename?: 'DeviceRequest' }
              | { __typename?: 'DeviceUseStatement' }
              | { __typename?: 'DiagnosticReport' }
              | { __typename?: 'DocumentReference' }
              | { __typename?: 'Encounter' }
              | { __typename?: 'Endpoint' }
              | { __typename?: 'EpisodeOfCare' }
              | { __typename?: 'FamilyMemberHistory' }
              | { __typename?: 'Goal' }
              | { __typename?: 'Group' }
              | { __typename?: 'HealthcareService' }
              | { __typename?: 'ImagingStudy' }
              | { __typename?: 'Immunization' }
              | { __typename?: 'ImmunizationEvaluation' }
              | { __typename?: 'ImmunizationRecommendation' }
              | { __typename?: 'InsurancePlan' }
              | { __typename?: 'List' }
              | { __typename?: 'Location' }
              | { __typename?: 'Measure' }
              | { __typename?: 'MeasureReport' }
              | { __typename?: 'Media' }
              | { __typename?: 'Medication' }
              | { __typename?: 'MedicationAdministration' }
              | { __typename?: 'MedicationDispense' }
              | { __typename?: 'MedicationRequest' }
              | { __typename?: 'MedicationStatement' }
              | { __typename?: 'MolecularSequence' }
              | { __typename?: 'NutritionOrder' }
              | { __typename?: 'Observation' }
              | { __typename?: 'Organization', id?: string | null, resourceType: string, name?: string | null, telecom?: Array<{ __typename?: 'ContactPoint', value?: string | null }> | null, address?: Array<{ __typename?: 'Address', city?: string | null, state?: string | null, postalCode?: string | null, text?: string | null, line?: Array<string> | null }> | null }
              | { __typename?: 'Patient' }
              | { __typename?: 'PlanDefinition' }
              | { __typename?: 'Practitioner' }
              | { __typename?: 'PractitionerRole' }
              | { __typename?: 'Procedure' }
              | { __typename?: 'Provenance' }
              | { __typename?: 'Questionnaire' }
              | { __typename?: 'QuestionnaireResponse' }
              | { __typename?: 'RelatedPerson' }
              | { __typename?: 'RequestGroup' }
              | { __typename?: 'ResearchStudy' }
              | { __typename?: 'RiskAssessment' }
              | { __typename?: 'Schedule' }
              | { __typename?: 'ServiceRequest' }
              | { __typename?: 'Slot' }
              | { __typename?: 'Specimen' }
              | { __typename?: 'Substance' }
              | { __typename?: 'SupplyRequest' }
              | { __typename?: 'Task' }
              | { __typename?: 'VisionPrescription' }
             | null } | null, initialFill?: { __typename?: 'MedicationRequestDispenseRequestInitialFill', quantity?: { __typename?: 'Quantity', value?: number | null, unit?: string | null } | null } | null } | null, dosageInstruction?: Array<{ __typename?: 'Dosage', text?: string | null, timing?: { __typename?: 'Timing', repeat?: { __typename?: 'TimingRepeat', boundsPeriod?: { __typename?: 'Period', start?: string | null } | null } | null } | null }> | null, medicationCodeableConcept?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, performer?: (
          { __typename?: 'Reference' }
          & { ' $fragmentRefs'?: { 'ReferenceFragment': ReferenceFragment } }
        ) | null, requester?: { __typename?: 'Reference', id?: string | null, reference?: string | null, type?: string | null, display?: string | null, extension?: Array<{ __typename?: 'Extension', url: string, valueString?: string | null }> | null, identifier?: { __typename?: 'Identifier', id?: string | null, system?: string | null, value?: string | null } | null, resource?:
            | { __typename?: 'Account' }
            | { __typename?: 'AllergyIntolerance' }
            | { __typename?: 'Appointment' }
            | { __typename?: 'AppointmentResponse' }
            | { __typename?: 'Basic' }
            | { __typename?: 'Binary' }
            | { __typename?: 'CarePlan' }
            | { __typename?: 'CareTeam' }
            | { __typename?: 'Claim' }
            | { __typename?: 'ClaimResponse' }
            | { __typename?: 'ClinicalImpression' }
            | { __typename?: 'CommunicationRequest' }
            | { __typename?: 'Composition' }
            | { __typename?: 'Condition' }
            | { __typename?: 'Consent' }
            | { __typename?: 'Contract' }
            | { __typename?: 'Coverage' }
            | { __typename?: 'CoverageEligibilityRequest' }
            | { __typename?: 'DetectedIssue' }
            | { __typename?: 'Device' }
            | { __typename?: 'DeviceDefinition' }
            | { __typename?: 'DeviceMetric' }
            | { __typename?: 'DeviceRequest' }
            | { __typename?: 'DeviceUseStatement' }
            | { __typename?: 'DiagnosticReport' }
            | { __typename?: 'DocumentReference' }
            | { __typename?: 'Encounter' }
            | { __typename?: 'Endpoint' }
            | { __typename?: 'EpisodeOfCare' }
            | { __typename?: 'FamilyMemberHistory' }
            | { __typename?: 'Goal' }
            | { __typename?: 'Group' }
            | { __typename?: 'HealthcareService' }
            | { __typename?: 'ImagingStudy' }
            | { __typename?: 'Immunization' }
            | { __typename?: 'ImmunizationEvaluation' }
            | { __typename?: 'ImmunizationRecommendation' }
            | { __typename?: 'InsurancePlan' }
            | { __typename?: 'List' }
            | { __typename?: 'Location' }
            | { __typename?: 'Measure' }
            | { __typename?: 'MeasureReport' }
            | { __typename?: 'Media' }
            | { __typename?: 'Medication' }
            | { __typename?: 'MedicationAdministration' }
            | { __typename?: 'MedicationDispense' }
            | { __typename?: 'MedicationRequest' }
            | { __typename?: 'MedicationStatement' }
            | { __typename?: 'MolecularSequence' }
            | { __typename?: 'NutritionOrder' }
            | { __typename?: 'Observation' }
            | { __typename?: 'Organization' }
            | { __typename?: 'Patient' }
            | { __typename?: 'PlanDefinition' }
            | { __typename?: 'Practitioner', id?: string | null, resourceType: string, name?: Array<{ __typename?: 'HumanName', family?: string | null, given?: Array<string> | null }> | null, address?: Array<{ __typename?: 'Address', text?: string | null }> | null, telecom?: Array<{ __typename?: 'ContactPoint', value?: string | null }> | null }
            | { __typename?: 'PractitionerRole' }
            | { __typename?: 'Procedure' }
            | { __typename?: 'Provenance' }
            | { __typename?: 'Questionnaire' }
            | { __typename?: 'QuestionnaireResponse' }
            | { __typename?: 'RelatedPerson' }
            | { __typename?: 'RequestGroup' }
            | { __typename?: 'ResearchStudy' }
            | { __typename?: 'RiskAssessment' }
            | { __typename?: 'Schedule' }
            | { __typename?: 'ServiceRequest' }
            | { __typename?: 'Slot' }
            | { __typename?: 'Specimen' }
            | { __typename?: 'Substance' }
            | { __typename?: 'SupplyRequest' }
            | { __typename?: 'Task' }
            | { __typename?: 'VisionPrescription' }
           | null } | null } }> | null } | null };

export type MedicationStatementsQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
  cursor: Scalars['String']['input'];
  filter: MedicationStatementFilterParams;
  sort: MedicationStatementSortParams;
  first: Scalars['Int']['input'];
}>;


export type MedicationStatementsQuery = { __typename?: 'Query', MedicationStatementConnection?: { __typename?: 'MedicationStatementConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges?: Array<{ __typename?: 'MedicationStatementEdge', node: { __typename?: 'MedicationStatement', id?: string | null, resourceType: string, dateAsserted?: string | null, status: MedicationStatementStatus, BasicList?: Array<(
          { __typename?: 'Basic' }
          & { ' $fragmentRefs'?: { 'BasicFragment': BasicFragment } }
        )> | null, meta?: { __typename?: 'Meta', versionId?: string | null, tag?: Array<{ __typename?: 'Coding', system?: string | null, code?: string | null }> | null } | null, extension?: Array<{ __typename?: 'Extension', url: string, valueDateTime?: string | null, valueString?: string | null, valueUnsignedInt?: number | null, extension?: Array<{ __typename?: 'Extension', url: string, valueReference?: { __typename?: 'Reference', id?: string | null, type?: string | null, reference?: string | null } | null }> | null, valueReference?: { __typename?: 'Reference', id?: string | null, type?: string | null, reference?: string | null, display?: string | null } | null, valueQuantity?: { __typename?: 'Quantity', unit?: string | null, value?: number | null } | null }> | null, basedOn?: Array<{ __typename?: 'Reference', type?: string | null }> | null, category?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, contained?: Array<{ __typename?: 'Resource', resource?:
            | { __typename?: 'Account' }
            | { __typename?: 'AllergyIntolerance' }
            | { __typename?: 'Appointment' }
            | { __typename?: 'AppointmentResponse' }
            | { __typename?: 'Basic' }
            | { __typename?: 'Binary' }
            | { __typename?: 'CarePlan' }
            | { __typename?: 'CareTeam' }
            | { __typename?: 'Claim' }
            | { __typename?: 'ClaimResponse' }
            | { __typename?: 'ClinicalImpression' }
            | { __typename?: 'CommunicationRequest' }
            | { __typename?: 'Composition' }
            | { __typename?: 'Condition' }
            | { __typename?: 'Consent' }
            | { __typename?: 'Contract' }
            | { __typename?: 'Coverage' }
            | { __typename?: 'CoverageEligibilityRequest' }
            | { __typename?: 'DetectedIssue' }
            | { __typename?: 'Device' }
            | { __typename?: 'DeviceDefinition' }
            | { __typename?: 'DeviceMetric' }
            | { __typename?: 'DeviceRequest' }
            | { __typename?: 'DeviceUseStatement' }
            | { __typename?: 'DiagnosticReport' }
            | { __typename?: 'DocumentReference' }
            | { __typename?: 'Encounter' }
            | { __typename?: 'Endpoint' }
            | { __typename?: 'EpisodeOfCare' }
            | { __typename?: 'FamilyMemberHistory' }
            | { __typename?: 'Goal' }
            | { __typename?: 'Group' }
            | { __typename?: 'HealthcareService' }
            | { __typename?: 'ImagingStudy' }
            | { __typename?: 'Immunization' }
            | { __typename?: 'ImmunizationEvaluation' }
            | { __typename?: 'ImmunizationRecommendation' }
            | { __typename?: 'InsurancePlan' }
            | { __typename?: 'List' }
            | { __typename?: 'Location' }
            | { __typename?: 'Measure' }
            | { __typename?: 'MeasureReport' }
            | { __typename?: 'Media' }
            | { __typename?: 'Medication', id?: string | null, resourceType: string, code?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
                  { __typename?: 'Coding' }
                  & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
                )> | null } | null }
            | { __typename?: 'MedicationAdministration' }
            | { __typename?: 'MedicationDispense' }
            | { __typename?: 'MedicationRequest' }
            | { __typename?: 'MedicationStatement' }
            | { __typename?: 'MolecularSequence' }
            | { __typename?: 'NutritionOrder' }
            | { __typename?: 'Observation' }
            | { __typename?: 'Organization', id?: string | null, resourceType: string, _organization__name?: string | null }
            | { __typename?: 'Patient' }
            | { __typename?: 'PlanDefinition' }
            | { __typename?: 'Practitioner', id?: string | null, resourceType: string, name?: Array<{ __typename?: 'HumanName', family?: string | null, given?: Array<string> | null }> | null }
            | { __typename?: 'PractitionerRole' }
            | { __typename?: 'Procedure' }
            | { __typename?: 'Provenance' }
            | { __typename?: 'Questionnaire' }
            | { __typename?: 'QuestionnaireResponse' }
            | { __typename?: 'RelatedPerson' }
            | { __typename?: 'RequestGroup' }
            | { __typename?: 'ResearchStudy' }
            | { __typename?: 'RiskAssessment' }
            | { __typename?: 'Schedule' }
            | { __typename?: 'ServiceRequest' }
            | { __typename?: 'Slot' }
            | { __typename?: 'Specimen' }
            | { __typename?: 'Substance' }
            | { __typename?: 'SupplyRequest' }
            | { __typename?: 'Task' }
            | { __typename?: 'VisionPrescription' }
           | null }> | null, context?: { __typename?: 'Reference', display?: string | null } | null, derivedFrom?: Array<{ __typename?: 'Reference', display?: string | null }> | null, dosage?: Array<{ __typename?: 'Dosage', text?: string | null }> | null, effectivePeriod?: { __typename?: 'Period', start?: string | null } | null, identifier?: Array<{ __typename?: 'Identifier', value?: string | null }> | null, informationSource?: { __typename?: 'Reference', type?: string | null } | null, medicationCodeableConcept?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, medicationReference?: { __typename?: 'Reference', display?: string | null } | null, note?: Array<{ __typename?: 'Annotation', text: string }> | null, partOf?: Array<{ __typename?: 'Reference', display?: string | null }> | null, reasonCode?: Array<{ __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null }> | null, reasonReference?: Array<(
          { __typename?: 'Reference' }
          & { ' $fragmentRefs'?: { 'ReferenceFragment': ReferenceFragment } }
        )> | null, statusReason?: Array<{ __typename?: 'CodeableConcept', text?: string | null, coding?: Array<(
            { __typename?: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null }> | null, subject: { __typename?: 'Reference', resource?:
            | { __typename?: 'Account' }
            | { __typename?: 'AllergyIntolerance' }
            | { __typename?: 'Appointment' }
            | { __typename?: 'AppointmentResponse' }
            | { __typename?: 'Basic' }
            | { __typename?: 'Binary' }
            | { __typename?: 'CarePlan' }
            | { __typename?: 'CareTeam' }
            | { __typename?: 'Claim' }
            | { __typename?: 'ClaimResponse' }
            | { __typename?: 'ClinicalImpression' }
            | { __typename?: 'CommunicationRequest' }
            | { __typename?: 'Composition' }
            | { __typename?: 'Condition' }
            | { __typename?: 'Consent' }
            | { __typename?: 'Contract' }
            | { __typename?: 'Coverage' }
            | { __typename?: 'CoverageEligibilityRequest' }
            | { __typename?: 'DetectedIssue' }
            | { __typename?: 'Device' }
            | { __typename?: 'DeviceDefinition' }
            | { __typename?: 'DeviceMetric' }
            | { __typename?: 'DeviceRequest' }
            | { __typename?: 'DeviceUseStatement' }
            | { __typename?: 'DiagnosticReport' }
            | { __typename?: 'DocumentReference' }
            | { __typename?: 'Encounter' }
            | { __typename?: 'Endpoint' }
            | { __typename?: 'EpisodeOfCare' }
            | { __typename?: 'FamilyMemberHistory' }
            | { __typename?: 'Goal' }
            | { __typename?: 'Group' }
            | { __typename?: 'HealthcareService' }
            | { __typename?: 'ImagingStudy' }
            | { __typename?: 'Immunization' }
            | { __typename?: 'ImmunizationEvaluation' }
            | { __typename?: 'ImmunizationRecommendation' }
            | { __typename?: 'InsurancePlan' }
            | { __typename?: 'List' }
            | { __typename?: 'Location' }
            | { __typename?: 'Measure' }
            | { __typename?: 'MeasureReport' }
            | { __typename?: 'Media' }
            | { __typename?: 'Medication' }
            | { __typename?: 'MedicationAdministration' }
            | { __typename?: 'MedicationDispense' }
            | { __typename?: 'MedicationRequest' }
            | { __typename?: 'MedicationStatement' }
            | { __typename?: 'MolecularSequence' }
            | { __typename?: 'NutritionOrder' }
            | { __typename?: 'Observation' }
            | { __typename?: 'Organization' }
            | { __typename?: 'Patient', managingOrganization?: { __typename?: 'Reference', resource?:
                  | { __typename?: 'Account' }
                  | { __typename?: 'AllergyIntolerance' }
                  | { __typename?: 'Appointment' }
                  | { __typename?: 'AppointmentResponse' }
                  | { __typename?: 'Basic' }
                  | { __typename?: 'Binary' }
                  | { __typename?: 'CarePlan' }
                  | { __typename?: 'CareTeam' }
                  | { __typename?: 'Claim' }
                  | { __typename?: 'ClaimResponse' }
                  | { __typename?: 'ClinicalImpression' }
                  | { __typename?: 'CommunicationRequest' }
                  | { __typename?: 'Composition' }
                  | { __typename?: 'Condition' }
                  | { __typename?: 'Consent' }
                  | { __typename?: 'Contract' }
                  | { __typename?: 'Coverage' }
                  | { __typename?: 'CoverageEligibilityRequest' }
                  | { __typename?: 'DetectedIssue' }
                  | { __typename?: 'Device' }
                  | { __typename?: 'DeviceDefinition' }
                  | { __typename?: 'DeviceMetric' }
                  | { __typename?: 'DeviceRequest' }
                  | { __typename?: 'DeviceUseStatement' }
                  | { __typename?: 'DiagnosticReport' }
                  | { __typename?: 'DocumentReference' }
                  | { __typename?: 'Encounter' }
                  | { __typename?: 'Endpoint' }
                  | { __typename?: 'EpisodeOfCare' }
                  | { __typename?: 'FamilyMemberHistory' }
                  | { __typename?: 'Goal' }
                  | { __typename?: 'Group' }
                  | { __typename?: 'HealthcareService' }
                  | { __typename?: 'ImagingStudy' }
                  | { __typename?: 'Immunization' }
                  | { __typename?: 'ImmunizationEvaluation' }
                  | { __typename?: 'ImmunizationRecommendation' }
                  | { __typename?: 'InsurancePlan' }
                  | { __typename?: 'List' }
                  | { __typename?: 'Location' }
                  | { __typename?: 'Measure' }
                  | { __typename?: 'MeasureReport' }
                  | { __typename?: 'Media' }
                  | { __typename?: 'Medication' }
                  | { __typename?: 'MedicationAdministration' }
                  | { __typename?: 'MedicationDispense' }
                  | { __typename?: 'MedicationRequest' }
                  | { __typename?: 'MedicationStatement' }
                  | { __typename?: 'MolecularSequence' }
                  | { __typename?: 'NutritionOrder' }
                  | { __typename?: 'Observation' }
                  | { __typename?: 'Organization', name?: string | null }
                  | { __typename?: 'Patient' }
                  | { __typename?: 'PlanDefinition' }
                  | { __typename?: 'Practitioner' }
                  | { __typename?: 'PractitionerRole' }
                  | { __typename?: 'Procedure' }
                  | { __typename?: 'Provenance' }
                  | { __typename?: 'Questionnaire' }
                  | { __typename?: 'QuestionnaireResponse' }
                  | { __typename?: 'RelatedPerson' }
                  | { __typename?: 'RequestGroup' }
                  | { __typename?: 'ResearchStudy' }
                  | { __typename?: 'RiskAssessment' }
                  | { __typename?: 'Schedule' }
                  | { __typename?: 'ServiceRequest' }
                  | { __typename?: 'Slot' }
                  | { __typename?: 'Specimen' }
                  | { __typename?: 'Substance' }
                  | { __typename?: 'SupplyRequest' }
                  | { __typename?: 'Task' }
                  | { __typename?: 'VisionPrescription' }
                 | null } | null }
            | { __typename?: 'PlanDefinition' }
            | { __typename?: 'Practitioner' }
            | { __typename?: 'PractitionerRole' }
            | { __typename?: 'Procedure' }
            | { __typename?: 'Provenance' }
            | { __typename?: 'Questionnaire' }
            | { __typename?: 'QuestionnaireResponse' }
            | { __typename?: 'RelatedPerson' }
            | { __typename?: 'RequestGroup' }
            | { __typename?: 'ResearchStudy' }
            | { __typename?: 'RiskAssessment' }
            | { __typename?: 'Schedule' }
            | { __typename?: 'ServiceRequest' }
            | { __typename?: 'Slot' }
            | { __typename?: 'Specimen' }
            | { __typename?: 'Substance' }
            | { __typename?: 'SupplyRequest' }
            | { __typename?: 'Task' }
            | { __typename?: 'VisionPrescription' }
           | null } } }> | null } | null };

export type ObservationsQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
  cursor: Scalars['String']['input'];
  sort: ObservationSortParams;
  filter: ObservationFilterParams;
  first: Scalars['Int']['input'];
}>;


export type ObservationsQuery = { __typename?: 'Query', ObservationConnection?: { __typename?: 'ObservationConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges?: Array<{ __typename?: 'ObservationEdge', node: (
        { __typename?: 'Observation' }
        & { ' $fragmentRefs'?: { 'ObservationFragment': ObservationFragment } }
      ) }> | null } | null };

export type PatientsForUpidQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
  cursor: Scalars['String']['input'];
  sort: PatientSortParams;
  first: Scalars['Int']['input'];
  filter?: PatientFilterParams;
}>;


export type PatientsForUpidQuery = { __typename?: 'Query', PatientConnection?: { __typename?: 'PatientConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges?: Array<{ __typename?: 'PatientEdge', node: (
        { __typename?: 'Patient' }
        & { ' $fragmentRefs'?: { 'PatientFragment': PatientFragment } }
      ) }> | null } | null };

export type PatientsForBuilderQueryVariables = Exact<{
  builderID: Scalars['ID']['input'];
  cursor: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  filter?: PatientFilterParams;
}>;


export type PatientsForBuilderQuery = { __typename?: 'Query', PatientConnection?: { __typename?: 'PatientConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges?: Array<{ __typename?: 'PatientEdge', node: (
        { __typename?: 'Patient' }
        & { ' $fragmentRefs'?: { 'PatientFragment': PatientFragment } }
      ) }> | null } | null };

export type ProceduresQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
  cursor: Scalars['String']['input'];
  sort: ProcedureSortParams;
  filter: ProcedureFilterParams;
  first: Scalars['Int']['input'];
}>;


export type ProceduresQuery = { __typename?: 'Query', ProcedureConnection?: { __typename?: 'ProcedureConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges?: Array<{ __typename?: 'ProcedureEdge', node: (
        { __typename?: 'Procedure' }
        & { ' $fragmentRefs'?: { 'ProcedureFragment': ProcedureFragment } }
      ) }> | null } | null };

export type ServiceRequestsQueryVariables = Exact<{
  upid: Scalars['ID']['input'];
}>;


export type ServiceRequestsQuery = { __typename?: 'Query', ServiceRequestConnection?: { __typename?: 'ServiceRequestConnection', edges?: Array<{ __typename?: 'ServiceRequestEdge', node: (
        { __typename?: 'ServiceRequest' }
        & { ' $fragmentRefs'?: { 'ServiceRequestFragment': ServiceRequestFragment } }
      ) }> | null } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const ConditionFragmentDoc = new TypedDocumentString(`
    fragment Condition on Condition {
  id
  resourceType
  meta {
    tag {
      system
      code
    }
  }
  code {
    text
    coding {
      system
      code
      display
    }
  }
}
    `, {"fragmentName":"Condition"}) as unknown as TypedDocumentString<ConditionFragment, unknown>;
export const EncounterReferenceFragmentDoc = new TypedDocumentString(`
    fragment EncounterReference on Encounter {
  id
  resourceType
  extension {
    url
    valueString
  }
  status
  priority {
    text
    coding {
      code
      display
      system
    }
  }
}
    `, {"fragmentName":"EncounterReference"}) as unknown as TypedDocumentString<EncounterReferenceFragment, unknown>;
export const PractitionerFragmentDoc = new TypedDocumentString(`
    fragment Practitioner on Practitioner {
  id
  resourceType
  extension {
    url
    valueString
  }
  name {
    family
    given
    prefix
    suffix
    text
    use
  }
  qualification {
    code {
      text
      coding {
        code
        display
        system
      }
    }
    period {
      start
      end
    }
  }
}
    `, {"fragmentName":"Practitioner"}) as unknown as TypedDocumentString<PractitionerFragment, unknown>;
export const ServiceRequestFragmentDoc = new TypedDocumentString(`
    fragment ServiceRequest on ServiceRequest {
  id
  resourceType
  status
  intent
  subject {
    reference
  }
  identifier {
    system
    value
  }
  requester {
    resource {
      ... on Practitioner {
        id
        resourceType
        extension {
          url
          valueString
        }
        name {
          family
          given
          prefix
          suffix
          text
          use
        }
        qualification {
          code {
            text
            coding {
              code
              display
              system
            }
          }
          period {
            start
            end
          }
        }
      }
    }
    reference
    identifier {
      system
      value
    }
    display
  }
  reasonCode {
    text
  }
  authoredOn
  category {
    text
  }
  performer {
    reference
    identifier {
      system
      value
    }
    display
  }
  locationReference {
    reference
    display
  }
}
    `, {"fragmentName":"ServiceRequest"}) as unknown as TypedDocumentString<ServiceRequestFragment, unknown>;
export const AppointmentFragmentDoc = new TypedDocumentString(`
    fragment Appointment on Appointment {
  id
  resourceType
  status
  participant {
    actor {
      reference
      identifier {
        system
        value
      }
      display
    }
    status
  }
  basedOn {
    reference
  }
  start
  end
  serviceType {
    text
  }
  appointmentType {
    text
  }
  serviceCategory {
    text
  }
  specialty {
    text
  }
}
    `, {"fragmentName":"Appointment"}) as unknown as TypedDocumentString<AppointmentFragment, unknown>;
export const OrganizationFragmentDoc = new TypedDocumentString(`
    fragment Organization on Organization {
  id
  resourceType
  extension {
    url
    valueString
  }
  name
  telecom {
    system
    value
    period {
      start
      end
    }
  }
  contact {
    purpose {
      text
      coding {
        code
        display
        system
        extension {
          url
          valueString
        }
      }
    }
    name {
      family
      given
      prefix
      suffix
      text
      use
    }
    telecom {
      system
      value
      period {
        start
        end
      }
    }
    address {
      type
      use
      text
      line
      city
      district
      state
      postalCode
      country
      period {
        start
        end
      }
    }
  }
}
    `, {"fragmentName":"Organization"}) as unknown as TypedDocumentString<OrganizationFragment, unknown>;
export const PatientFragmentDoc = new TypedDocumentString(`
    fragment Patient on Patient {
  id
  resourceType
  meta {
    extension {
      url
      valueString
      valueInstant
    }
    tag {
      system
      code
    }
  }
  active
  identifier {
    use
    system
    value
  }
  contact {
    address {
      city
      country
      district
      line
      period {
        start
        end
      }
      postalCode
      state
      text
      type
      use
    }
    gender
    name {
      family
      given
      prefix
      suffix
      text
      use
    }
    organization {
      display
      identifier {
        value
      }
      type
    }
  }
  birthDate
  gender
  maritalStatus {
    text
    coding {
      code
      display
      system
    }
  }
  telecom {
    use
    value
    system
  }
  address {
    city
    country
    district
    line
    period {
      start
      end
    }
    postalCode
    state
    text
    type
    use
  }
  name {
    family
    given
    prefix
    suffix
    text
    use
  }
  managingOrganization {
    resource {
      ...Organization
    }
  }
}
    fragment Organization on Organization {
  id
  resourceType
  extension {
    url
    valueString
  }
  name
  telecom {
    system
    value
    period {
      start
      end
    }
  }
  contact {
    purpose {
      text
      coding {
        code
        display
        system
        extension {
          url
          valueString
        }
      }
    }
    name {
      family
      given
      prefix
      suffix
      text
      use
    }
    telecom {
      system
      value
      period {
        start
        end
      }
    }
    address {
      type
      use
      text
      line
      city
      district
      state
      postalCode
      country
      period {
        start
        end
      }
    }
  }
}`, {"fragmentName":"Patient"}) as unknown as TypedDocumentString<PatientFragment, unknown>;
export const ReferenceFragmentDoc = new TypedDocumentString(`
    fragment Reference on Reference {
  id
  extension {
    url
    valueString
  }
  reference
  type
  identifier {
    id
    system
    value
  }
  display
}
    `, {"fragmentName":"Reference"}) as unknown as TypedDocumentString<ReferenceFragment, unknown>;
export const ObservationFragmentDoc = new TypedDocumentString(`
    fragment Observation on Observation {
  id
  resourceType
  extension {
    url
    valueString
  }
  meta {
    tag {
      system
      code
    }
  }
  encounter {
    reference
  }
  status
  category {
    text
    coding {
      code
      display
      system
      extension {
        url
        valueString
      }
    }
  }
  effectivePeriod {
    start
    end
  }
  effectiveDateTime
  referenceRange {
    text
  }
  code {
    text
    coding {
      code
      display
      system
      extension {
        url
        valueString
      }
    }
  }
  component {
    code {
      text
      coding {
        code
        display
        system
      }
    }
    valueQuantity {
      unit
      value
    }
    valueString
  }
  ProvenanceList(_reference: "target") {
    id
    entity {
      what {
        ...Reference
      }
    }
  }
  valueQuantity {
    comparator
    unit
    value
    system
    code
  }
  valueCodeableConcept {
    text
    coding {
      system
      code
      display
    }
  }
  valueString
  valueBoolean
  valueInteger
  valueRange {
    low {
      unit
      value
      system
      code
    }
    high {
      unit
      value
      system
      code
    }
  }
  valueRatio {
    numerator {
      comparator
      unit
      value
      system
      code
    }
    denominator {
      unit
      value
      system
      code
    }
  }
  valueTime
  valueDateTime
  valuePeriod {
    start
    end
  }
  interpretation {
    text
    coding {
      code
      display
      system
      extension {
        url
        valueString
      }
    }
  }
  note {
    text
  }
}
    fragment Reference on Reference {
  id
  extension {
    url
    valueString
  }
  reference
  type
  identifier {
    id
    system
    value
  }
  display
}`, {"fragmentName":"Observation"}) as unknown as TypedDocumentString<ObservationFragment, unknown>;
export const ProcedureFragmentDoc = new TypedDocumentString(`
    fragment Procedure on Procedure {
  id
  resourceType
  ProvenanceList(_reference: "target") {
    id
    entity {
      what {
        ...Reference
      }
    }
  }
}
    fragment Reference on Reference {
  id
  extension {
    url
    valueString
  }
  reference
  type
  identifier {
    id
    system
    value
  }
  display
}`, {"fragmentName":"Procedure"}) as unknown as TypedDocumentString<ProcedureFragment, unknown>;
export const BasicFragmentDoc = new TypedDocumentString(`
    fragment Basic on Basic {
  id
  resourceType
  meta {
    lastUpdated
  }
  code {
    coding {
      code
      display
      system
    }
  }
  author {
    display
  }
}
    `, {"fragmentName":"Basic"}) as unknown as TypedDocumentString<BasicFragment, unknown>;
export const CodingFragmentDoc = new TypedDocumentString(`
    fragment Coding on Coding {
  code
  display
  system
  extension {
    url
    valueString
  }
}
    `, {"fragmentName":"Coding"}) as unknown as TypedDocumentString<CodingFragment, unknown>;
export const CodeableConceptFragmentDoc = new TypedDocumentString(`
    fragment CodeableConcept on CodeableConcept {
  text
  coding {
    ...Coding
  }
}
    fragment Coding on Coding {
  code
  display
  system
  extension {
    url
    valueString
  }
}`, {"fragmentName":"CodeableConcept"}) as unknown as TypedDocumentString<CodeableConceptFragment, unknown>;
export const EncounterFragmentDoc = new TypedDocumentString(`
    fragment Encounter on Encounter {
  id
  resourceType
  BasicList(_reference: "subject") {
    ...Basic
  }
  meta {
    tag {
      system
      code
    }
    versionId
  }
  extension {
    url
    valueString
    extension {
      url
      valueReference {
        id
        type
        reference
      }
    }
  }
  status
  class {
    system
    version
    code
    display
  }
  type {
    ...CodeableConcept
  }
  serviceType {
    ...CodeableConcept
  }
  priority {
    ...CodeableConcept
  }
  diagnosis {
    condition {
      reference
      display
      resource {
        ... on Condition {
          code {
            coding {
              ...Coding
            }
            text
          }
        }
      }
    }
  }
  participant {
    individual {
      reference
      resource {
        ... on Practitioner {
          name {
            family
            given
          }
        }
      }
      display
    }
    type {
      ...CodeableConcept
    }
    period {
      start
      end
    }
  }
  period {
    start
    end
  }
  ProvenanceList(_reference: "target") {
    id
    entity {
      what {
        ...Reference
      }
    }
  }
  length {
    value
    unit
  }
  reasonCode {
    ...CodeableConcept
  }
  hospitalization {
    dischargeDisposition {
      ...CodeableConcept
    }
  }
  location {
    location {
      reference
      display
      resource {
        ... on Location {
          name
          type {
            ...CodeableConcept
          }
        }
      }
    }
    status
    period {
      start
      end
    }
  }
}
    fragment Basic on Basic {
  id
  resourceType
  meta {
    lastUpdated
  }
  code {
    coding {
      code
      display
      system
    }
  }
  author {
    display
  }
}
fragment Coding on Coding {
  code
  display
  system
  extension {
    url
    valueString
  }
}
fragment Reference on Reference {
  id
  extension {
    url
    valueString
  }
  reference
  type
  identifier {
    id
    system
    value
  }
  display
}
fragment CodeableConcept on CodeableConcept {
  text
  coding {
    ...Coding
  }
}`, {"fragmentName":"Encounter"}) as unknown as TypedDocumentString<EncounterFragment, unknown>;
export const EpisodeOfCareFragmentDoc = new TypedDocumentString(`
    fragment EpisodeOfCare on EpisodeOfCare {
  id
  resourceType
  extension {
    url
    extension {
      url
      valueReference {
        id
        type
        reference
        display
        extension {
          url
          valueString
          valueBoolean
        }
      }
      valueString
    }
    valueString
    valueReference {
      id
      type
      reference
      display
    }
    valueCodeableConcept {
      coding {
        system
        code
        display
      }
      text
    }
    valueCoding {
      code
      display
      system
      userSelected
      version
    }
  }
  meta {
    extension {
      url
    }
    security {
      system
      code
    }
    tag {
      system
      code
    }
    lastUpdated
  }
  period {
    start
    end
  }
  identifier {
    system
    value
    type {
      text
      coding {
        system
        code
        display
      }
    }
  }
  status
  diagnosis {
    role {
      coding {
        system
        code
        display
      }
    }
    condition {
      id
      type
      reference
      resource {
        ... on Condition {
          id
          resourceType
          code {
            text
            coding {
              display
              code
              system
              extension {
                url
                valueString
              }
            }
          }
        }
      }
    }
  }
}
    `, {"fragmentName":"EpisodeOfCare"}) as unknown as TypedDocumentString<EpisodeOfCareFragment, unknown>;
export const TransitionOfCareLensQueryDocument = new TypedDocumentString(`
    query TransitionOfCareLensQuery($id: ID!) {
  EpisodeOfCare(id: $id) {
    ...EpisodeOfCare
    patient {
      resource {
        ... on Patient {
          id
          resourceType
          name {
            family
            given
          }
          identifier {
            system
            value
            assigner {
              display
            }
          }
          gender
          birthDate
        }
      }
    }
  }
}
    fragment EpisodeOfCare on EpisodeOfCare {
  id
  resourceType
  extension {
    url
    extension {
      url
      valueReference {
        id
        type
        reference
        display
        extension {
          url
          valueString
          valueBoolean
        }
      }
      valueString
    }
    valueString
    valueReference {
      id
      type
      reference
      display
    }
    valueCodeableConcept {
      coding {
        system
        code
        display
      }
      text
    }
    valueCoding {
      code
      display
      system
      userSelected
      version
    }
  }
  meta {
    extension {
      url
    }
    security {
      system
      code
    }
    tag {
      system
      code
    }
    lastUpdated
  }
  period {
    start
    end
  }
  identifier {
    system
    value
    type {
      text
      coding {
        system
        code
        display
      }
    }
  }
  status
  diagnosis {
    role {
      coding {
        system
        code
        display
      }
    }
    condition {
      id
      type
      reference
      resource {
        ... on Condition {
          id
          resourceType
          code {
            text
            coding {
              display
              code
              system
              extension {
                url
                valueString
              }
            }
          }
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<TransitionOfCareLensQueryQuery, TransitionOfCareLensQueryQueryVariables>;
export const AllergiesDocument = new TypedDocumentString(`
    query Allergies($upid: ID!, $cursor: String!, $sort: AllergyIntoleranceSortParams!, $filter: AllergyIntoleranceFilterParams! = {}, $first: Int!) {
  AllergyIntoleranceConnection(
    upid: $upid
    after: $cursor
    sort: $sort
    filter: $filter
    first: $first
  ) {
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        id
        resourceType
        BasicList(_reference: "subject") {
          ...Basic
        }
        meta {
          tag {
            system
            code
            display
          }
        }
        clinicalStatus {
          text
          coding {
            ...Coding
          }
        }
        extension {
          url
          valueString
        }
        verificationStatus {
          text
          coding {
            ...Coding
          }
        }
        type
        category
        criticality
        code {
          text
          coding {
            ...Coding
          }
        }
        patient {
          reference
          resource {
            ... on Patient {
              ...Patient
              managingOrganization {
                resource {
                  ... on Organization {
                    name
                  }
                }
              }
            }
          }
        }
        encounter {
          reference
          resource {
            ...EncounterReference
          }
        }
        onsetDateTime
        onsetAge {
          value
          unit
          system
          code
        }
        onsetPeriod {
          start
          end
        }
        recordedDate
        recorder {
          reference
          resource {
            ...Practitioner
          }
        }
        lastOccurrence
        note {
          text
          time
        }
        reaction {
          substance {
            text
            coding {
              ...Coding
            }
          }
          manifestation {
            text
            coding {
              ...Coding
            }
          }
          onset
          severity
          note {
            text
            time
          }
        }
      }
    }
  }
}
    fragment Basic on Basic {
  id
  resourceType
  meta {
    lastUpdated
  }
  code {
    coding {
      code
      display
      system
    }
  }
  author {
    display
  }
}
fragment Coding on Coding {
  code
  display
  system
  extension {
    url
    valueString
  }
}
fragment EncounterReference on Encounter {
  id
  resourceType
  extension {
    url
    valueString
  }
  status
  priority {
    text
    coding {
      code
      display
      system
    }
  }
}
fragment Practitioner on Practitioner {
  id
  resourceType
  extension {
    url
    valueString
  }
  name {
    family
    given
    prefix
    suffix
    text
    use
  }
  qualification {
    code {
      text
      coding {
        code
        display
        system
      }
    }
    period {
      start
      end
    }
  }
}
fragment Patient on Patient {
  id
  resourceType
  meta {
    extension {
      url
      valueString
      valueInstant
    }
    tag {
      system
      code
    }
  }
  active
  identifier {
    use
    system
    value
  }
  contact {
    address {
      city
      country
      district
      line
      period {
        start
        end
      }
      postalCode
      state
      text
      type
      use
    }
    gender
    name {
      family
      given
      prefix
      suffix
      text
      use
    }
    organization {
      display
      identifier {
        value
      }
      type
    }
  }
  birthDate
  gender
  maritalStatus {
    text
    coding {
      code
      display
      system
    }
  }
  telecom {
    use
    value
    system
  }
  address {
    city
    country
    district
    line
    period {
      start
      end
    }
    postalCode
    state
    text
    type
    use
  }
  name {
    family
    given
    prefix
    suffix
    text
    use
  }
  managingOrganization {
    resource {
      ...Organization
    }
  }
}
fragment Organization on Organization {
  id
  resourceType
  extension {
    url
    valueString
  }
  name
  telecom {
    system
    value
    period {
      start
      end
    }
  }
  contact {
    purpose {
      text
      coding {
        code
        display
        system
        extension {
          url
          valueString
        }
      }
    }
    name {
      family
      given
      prefix
      suffix
      text
      use
    }
    telecom {
      system
      value
      period {
        start
        end
      }
    }
    address {
      type
      use
      text
      line
      city
      district
      state
      postalCode
      country
      period {
        start
        end
      }
    }
  }
}`) as unknown as TypedDocumentString<AllergiesQuery, AllergiesQueryVariables>;
export const AppointmentsDocument = new TypedDocumentString(`
    query Appointments($upid: ID!) {
  AppointmentConnection(upid: $upid) {
    edges {
      node {
        ...Appointment
      }
    }
  }
}
    fragment Appointment on Appointment {
  id
  resourceType
  status
  participant {
    actor {
      reference
      identifier {
        system
        value
      }
      display
    }
    status
  }
  basedOn {
    reference
  }
  start
  end
  serviceType {
    text
  }
  appointmentType {
    text
  }
  serviceCategory {
    text
  }
  specialty {
    text
  }
}`) as unknown as TypedDocumentString<AppointmentsQuery, AppointmentsQueryVariables>;
export const CareTeamsDocument = new TypedDocumentString(`
    query CareTeams($upid: ID!, $cursor: String!, $sort: CareTeamSortParams!, $first: Int!) {
  CareTeamConnection(upid: $upid, after: $cursor, sort: $sort, first: $first) {
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        id
        resourceType
        meta {
          extension {
            url
            valueInstant
          }
          tag {
            system
            code
          }
          versionId
        }
        extension {
          url
          valueString
        }
        status
        category {
          text
          coding {
            ...Coding
          }
        }
        name
        period {
          start
          end
        }
        participant {
          role {
            text
            coding {
              ...Coding
            }
          }
          member {
            reference
            resource {
              ...Practitioner
            }
          }
          onBehalfOf {
            reference
          }
        }
        reasonCode {
          text
          coding {
            ...Coding
          }
        }
        telecom {
          system
          value
          use
          period {
            start
            end
          }
        }
        note {
          text
        }
      }
    }
  }
}
    fragment Coding on Coding {
  code
  display
  system
  extension {
    url
    valueString
  }
}
fragment Practitioner on Practitioner {
  id
  resourceType
  extension {
    url
    valueString
  }
  name {
    family
    given
    prefix
    suffix
    text
    use
  }
  qualification {
    code {
      text
      coding {
        code
        display
        system
      }
    }
    period {
      start
      end
    }
  }
}`) as unknown as TypedDocumentString<CareTeamsQuery, CareTeamsQueryVariables>;
export const SummaryConditionsDocument = new TypedDocumentString(`
    query SummaryConditions($upid: ID!, $cursor: String!, $filter: ConditionFilterParams! = {}, $sort: ConditionSortParams!, $first: Int!) {
  ConditionConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        ...Condition
      }
    }
  }
}
    fragment Condition on Condition {
  id
  resourceType
  meta {
    tag {
      system
      code
    }
  }
  code {
    text
    coding {
      system
      code
      display
    }
  }
}`) as unknown as TypedDocumentString<SummaryConditionsQuery, SummaryConditionsQueryVariables>;
export const FirstPartyConditionsDocument = new TypedDocumentString(`
    query FirstPartyConditions($upid: ID!, $cursor: String!, $filter: ConditionFilterParams! = {}, $sort: ConditionSortParams!, $first: Int!) {
  ConditionConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        ...Condition
      }
    }
  }
}
    fragment Condition on Condition {
  id
  resourceType
  meta {
    tag {
      system
      code
    }
  }
  code {
    text
    coding {
      system
      code
      display
    }
  }
}`) as unknown as TypedDocumentString<FirstPartyConditionsQuery, FirstPartyConditionsQueryVariables>;
export const CoverageDocument = new TypedDocumentString(`
    query Coverage($upid: ID!, $cursor: String!, $filter: CoverageFilterParams! = {}, $sort: CoverageSortParams!, $first: Int!) {
  CoverageConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        id
        beneficiary {
          reference
        }
        class {
          type {
            text
            coding {
              ...Coding
            }
          }
          value
          name
        }
        type {
          text
          coding {
            ...Coding
          }
        }
        payor {
          display
        }
        relationship {
          coding {
            ...Coding
          }
        }
        subscriberId
        subscriber {
          reference
          resource {
            ...Patient
          }
        }
      }
    }
  }
}
    fragment Coding on Coding {
  code
  display
  system
  extension {
    url
    valueString
  }
}
fragment Patient on Patient {
  id
  resourceType
  meta {
    extension {
      url
      valueString
      valueInstant
    }
    tag {
      system
      code
    }
  }
  active
  identifier {
    use
    system
    value
  }
  contact {
    address {
      city
      country
      district
      line
      period {
        start
        end
      }
      postalCode
      state
      text
      type
      use
    }
    gender
    name {
      family
      given
      prefix
      suffix
      text
      use
    }
    organization {
      display
      identifier {
        value
      }
      type
    }
  }
  birthDate
  gender
  maritalStatus {
    text
    coding {
      code
      display
      system
    }
  }
  telecom {
    use
    value
    system
  }
  address {
    city
    country
    district
    line
    period {
      start
      end
    }
    postalCode
    state
    text
    type
    use
  }
  name {
    family
    given
    prefix
    suffix
    text
    use
  }
  managingOrganization {
    resource {
      ...Organization
    }
  }
}
fragment Organization on Organization {
  id
  resourceType
  extension {
    url
    valueString
  }
  name
  telecom {
    system
    value
    period {
      start
      end
    }
  }
  contact {
    purpose {
      text
      coding {
        code
        display
        system
        extension {
          url
          valueString
        }
      }
    }
    name {
      family
      given
      prefix
      suffix
      text
      use
    }
    telecom {
      system
      value
      period {
        start
        end
      }
    }
    address {
      type
      use
      text
      line
      city
      district
      state
      postalCode
      country
      period {
        start
        end
      }
    }
  }
}`) as unknown as TypedDocumentString<CoverageQuery, CoverageQueryVariables>;
export const DiagnosticReportsDocument = new TypedDocumentString(`
    query DiagnosticReports($upid: ID!, $cursor: String!, $sort: DiagnosticReportSortParams!, $filter: DiagnosticReportFilterParams!, $first: Int!) {
  DiagnosticReportConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        resourceType
        BasicList(_reference: "subject") {
          ...Basic
        }
        meta {
          tag {
            system
            code
          }
          extension {
            url
            valueInstant
          }
        }
        extension {
          url
          valueString
        }
        status
        category {
          text
          coding {
            ...Coding
          }
        }
        code {
          text
          coding {
            ...Coding
          }
        }
        effectiveDateTime
        effectivePeriod {
          start
          end
        }
        issued
        conclusion
        performer {
          reference
          resource {
            ...Practitioner
          }
        }
        subject {
          reference
          resource {
            ...Patient
          }
        }
        result {
          reference
          display
        }
      }
    }
  }
}
    fragment Basic on Basic {
  id
  resourceType
  meta {
    lastUpdated
  }
  code {
    coding {
      code
      display
      system
    }
  }
  author {
    display
  }
}
fragment Coding on Coding {
  code
  display
  system
  extension {
    url
    valueString
  }
}
fragment Practitioner on Practitioner {
  id
  resourceType
  extension {
    url
    valueString
  }
  name {
    family
    given
    prefix
    suffix
    text
    use
  }
  qualification {
    code {
      text
      coding {
        code
        display
        system
      }
    }
    period {
      start
      end
    }
  }
}
fragment Patient on Patient {
  id
  resourceType
  meta {
    extension {
      url
      valueString
      valueInstant
    }
    tag {
      system
      code
    }
  }
  active
  identifier {
    use
    system
    value
  }
  contact {
    address {
      city
      country
      district
      line
      period {
        start
        end
      }
      postalCode
      state
      text
      type
      use
    }
    gender
    name {
      family
      given
      prefix
      suffix
      text
      use
    }
    organization {
      display
      identifier {
        value
      }
      type
    }
  }
  birthDate
  gender
  maritalStatus {
    text
    coding {
      code
      display
      system
    }
  }
  telecom {
    use
    value
    system
  }
  address {
    city
    country
    district
    line
    period {
      start
      end
    }
    postalCode
    state
    text
    type
    use
  }
  name {
    family
    given
    prefix
    suffix
    text
    use
  }
  managingOrganization {
    resource {
      ...Organization
    }
  }
}
fragment Organization on Organization {
  id
  resourceType
  extension {
    url
    valueString
  }
  name
  telecom {
    system
    value
    period {
      start
      end
    }
  }
  contact {
    purpose {
      text
      coding {
        code
        display
        system
        extension {
          url
          valueString
        }
      }
    }
    name {
      family
      given
      prefix
      suffix
      text
      use
    }
    telecom {
      system
      value
      period {
        start
        end
      }
    }
    address {
      type
      use
      text
      line
      city
      district
      state
      postalCode
      country
      period {
        start
        end
      }
    }
  }
}`) as unknown as TypedDocumentString<DiagnosticReportsQuery, DiagnosticReportsQueryVariables>;
export const DocumentReferencesWithBasicsDocument = new TypedDocumentString(`
    query DocumentReferencesWithBasics($upid: ID!, $cursor: String!, $sort: DocumentReferenceSortParams!, $filter: DocumentReferenceFilterParams! = {}, $first: Int!) {
  DocumentReferenceConnection(
    upid: $upid
    after: $cursor
    sort: $sort
    filter: $filter
    first: $first
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        resourceType
        BasicList(_reference: "subject") {
          ...Basic
        }
        masterIdentifier {
          system
          use
          value
        }
        meta {
          extension {
            url
            valueInstant
          }
          tag {
            system
            code
          }
          versionId
        }
        extension {
          url
          valueString
        }
        status
        docStatus
        type {
          text
          coding {
            ...Coding
          }
        }
        text {
          id
          div
        }
        category {
          text
          coding {
            ...Coding
          }
        }
        date
        custodian {
          reference
          display
        }
        description
        content {
          attachment {
            contentType
            language
            data
            url
            size
            hash
            title
            creation
          }
          format {
            system
            version
            code
            display
          }
        }
        context {
          period {
            start
            end
          }
          encounter {
            reference
          }
        }
      }
    }
  }
}
    fragment Basic on Basic {
  id
  resourceType
  meta {
    lastUpdated
  }
  code {
    coding {
      code
      display
      system
    }
  }
  author {
    display
  }
}
fragment Coding on Coding {
  code
  display
  system
  extension {
    url
    valueString
  }
}`) as unknown as TypedDocumentString<DocumentReferencesWithBasicsQuery, DocumentReferencesWithBasicsQueryVariables>;
export const DocumentReferencesDocument = new TypedDocumentString(`
    query DocumentReferences($upid: ID!, $cursor: String!, $sort: DocumentReferenceSortParams!, $filter: DocumentReferenceFilterParams! = {}, $first: Int!) {
  DocumentReferenceConnection(
    upid: $upid
    after: $cursor
    sort: $sort
    filter: $filter
    first: $first
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        resourceType
        masterIdentifier {
          system
          use
          value
        }
        meta {
          extension {
            url
            valueInstant
          }
          tag {
            system
            code
          }
          versionId
        }
        extension {
          url
          valueString
        }
        status
        docStatus
        type {
          text
          coding {
            ...Coding
          }
        }
        text {
          id
          div
        }
        category {
          text
          coding {
            ...Coding
          }
        }
        date
        custodian {
          reference
          display
        }
        description
        content {
          attachment {
            contentType
            language
            data
            url
            size
            hash
            title
            creation
          }
          format {
            system
            version
            code
            display
          }
        }
        context {
          period {
            start
            end
          }
          encounter {
            reference
          }
        }
      }
    }
  }
}
    fragment Coding on Coding {
  code
  display
  system
  extension {
    url
    valueString
  }
}`) as unknown as TypedDocumentString<DocumentReferencesQuery, DocumentReferencesQueryVariables>;
export const DocumentReferencesListDocument = new TypedDocumentString(`
    query DocumentReferencesList($upid: ID!, $cursor: String!, $sort: DocumentReferenceSortParams!, $filter: DocumentReferenceFilterParams! = {}, $first: Int!) {
  DocumentReferenceConnection(
    upid: $upid
    after: $cursor
    sort: $sort
    filter: $filter
    first: $first
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        resourceType
        BasicList(_reference: "subject") {
          ...Basic
        }
        masterIdentifier {
          system
          use
          value
        }
        meta {
          tag {
            system
            code
          }
        }
        extension {
          url
          valueString
        }
        status
        docStatus
        type {
          text
          coding {
            ...Coding
          }
        }
        category {
          text
          coding {
            ...Coding
          }
        }
        date
        custodian {
          reference
          display
        }
        description
        content {
          attachment {
            contentType
            url
            creation
          }
        }
        context {
          period {
            start
            end
          }
        }
      }
    }
  }
}
    fragment Basic on Basic {
  id
  resourceType
  meta {
    lastUpdated
  }
  code {
    coding {
      code
      display
      system
    }
  }
  author {
    display
  }
}
fragment Coding on Coding {
  code
  display
  system
  extension {
    url
    valueString
  }
}`) as unknown as TypedDocumentString<DocumentReferencesListQuery, DocumentReferencesListQueryVariables>;
export const EncountersDocument = new TypedDocumentString(`
    query Encounters($upid: ID!, $cursor: String!, $sort: EncounterSortParams!, $first: Int!, $filter: EncounterFilterParams! = {}) {
  EncounterConnection(
    upid: $upid
    after: $cursor
    sort: $sort
    first: $first
    filter: $filter
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...Encounter
      }
    }
  }
}
    fragment Basic on Basic {
  id
  resourceType
  meta {
    lastUpdated
  }
  code {
    coding {
      code
      display
      system
    }
  }
  author {
    display
  }
}
fragment Coding on Coding {
  code
  display
  system
  extension {
    url
    valueString
  }
}
fragment Reference on Reference {
  id
  extension {
    url
    valueString
  }
  reference
  type
  identifier {
    id
    system
    value
  }
  display
}
fragment CodeableConcept on CodeableConcept {
  text
  coding {
    ...Coding
  }
}
fragment Encounter on Encounter {
  id
  resourceType
  BasicList(_reference: "subject") {
    ...Basic
  }
  meta {
    tag {
      system
      code
    }
    versionId
  }
  extension {
    url
    valueString
    extension {
      url
      valueReference {
        id
        type
        reference
      }
    }
  }
  status
  class {
    system
    version
    code
    display
  }
  type {
    ...CodeableConcept
  }
  serviceType {
    ...CodeableConcept
  }
  priority {
    ...CodeableConcept
  }
  diagnosis {
    condition {
      reference
      display
      resource {
        ... on Condition {
          code {
            coding {
              ...Coding
            }
            text
          }
        }
      }
    }
  }
  participant {
    individual {
      reference
      resource {
        ... on Practitioner {
          name {
            family
            given
          }
        }
      }
      display
    }
    type {
      ...CodeableConcept
    }
    period {
      start
      end
    }
  }
  period {
    start
    end
  }
  ProvenanceList(_reference: "target") {
    id
    entity {
      what {
        ...Reference
      }
    }
  }
  length {
    value
    unit
  }
  reasonCode {
    ...CodeableConcept
  }
  hospitalization {
    dischargeDisposition {
      ...CodeableConcept
    }
  }
  location {
    location {
      reference
      display
      resource {
        ... on Location {
          name
          type {
            ...CodeableConcept
          }
        }
      }
    }
    status
    period {
      start
      end
    }
  }
}`) as unknown as TypedDocumentString<EncountersQuery, EncountersQueryVariables>;
export const EpisodeOfCareDocument = new TypedDocumentString(`
    query EpisodeOfCare($upid: ID!, $cursor: String!, $first: Int!, $filter: EpisodeOfCareFilterParams!) {
  EpisodeOfCareConnection(
    upid: $upid
    after: $cursor
    first: $first
    filter: $filter
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...EpisodeOfCare
      }
    }
  }
}
    fragment EpisodeOfCare on EpisodeOfCare {
  id
  resourceType
  extension {
    url
    extension {
      url
      valueReference {
        id
        type
        reference
        display
        extension {
          url
          valueString
          valueBoolean
        }
      }
      valueString
    }
    valueString
    valueReference {
      id
      type
      reference
      display
    }
    valueCodeableConcept {
      coding {
        system
        code
        display
      }
      text
    }
    valueCoding {
      code
      display
      system
      userSelected
      version
    }
  }
  meta {
    extension {
      url
    }
    security {
      system
      code
    }
    tag {
      system
      code
    }
    lastUpdated
  }
  period {
    start
    end
  }
  identifier {
    system
    value
    type {
      text
      coding {
        system
        code
        display
      }
    }
  }
  status
  diagnosis {
    role {
      coding {
        system
        code
        display
      }
    }
    condition {
      id
      type
      reference
      resource {
        ... on Condition {
          id
          resourceType
          code {
            text
            coding {
              display
              code
              system
              extension {
                url
                valueString
              }
            }
          }
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<EpisodeOfCareQuery, EpisodeOfCareQueryVariables>;
export const ImmunizationsDocument = new TypedDocumentString(`
    query Immunizations($upid: ID!, $cursor: String!, $sort: ImmunizationSortParams!, $first: Int!) {
  ImmunizationConnection(upid: $upid, after: $cursor, sort: $sort, first: $first) {
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        id
        resourceType
        BasicList(_reference: "subject") {
          ...Basic
        }
        meta {
          tag {
            system
            code
          }
          versionId
        }
        extension {
          url
          valueString
        }
        status
        statusReason {
          text
          coding {
            ...Coding
          }
        }
        vaccineCode {
          text
          coding {
            ...Coding
          }
        }
        patient {
          reference
          resource {
            ... on Patient {
              ...Patient
              managingOrganization {
                resource {
                  ... on Organization {
                    name
                  }
                }
              }
            }
          }
        }
        occurrenceDateTime
        occurrenceString
        recorded
        lotNumber
        expirationDate
      }
    }
  }
}
    fragment Basic on Basic {
  id
  resourceType
  meta {
    lastUpdated
  }
  code {
    coding {
      code
      display
      system
    }
  }
  author {
    display
  }
}
fragment Coding on Coding {
  code
  display
  system
  extension {
    url
    valueString
  }
}
fragment Patient on Patient {
  id
  resourceType
  meta {
    extension {
      url
      valueString
      valueInstant
    }
    tag {
      system
      code
    }
  }
  active
  identifier {
    use
    system
    value
  }
  contact {
    address {
      city
      country
      district
      line
      period {
        start
        end
      }
      postalCode
      state
      text
      type
      use
    }
    gender
    name {
      family
      given
      prefix
      suffix
      text
      use
    }
    organization {
      display
      identifier {
        value
      }
      type
    }
  }
  birthDate
  gender
  maritalStatus {
    text
    coding {
      code
      display
      system
    }
  }
  telecom {
    use
    value
    system
  }
  address {
    city
    country
    district
    line
    period {
      start
      end
    }
    postalCode
    state
    text
    type
    use
  }
  name {
    family
    given
    prefix
    suffix
    text
    use
  }
  managingOrganization {
    resource {
      ...Organization
    }
  }
}
fragment Organization on Organization {
  id
  resourceType
  extension {
    url
    valueString
  }
  name
  telecom {
    system
    value
    period {
      start
      end
    }
  }
  contact {
    purpose {
      text
      coding {
        code
        display
        system
        extension {
          url
          valueString
        }
      }
    }
    name {
      family
      given
      prefix
      suffix
      text
      use
    }
    telecom {
      system
      value
      period {
        start
        end
      }
    }
    address {
      type
      use
      text
      line
      city
      district
      state
      postalCode
      country
      period {
        start
        end
      }
    }
  }
}`) as unknown as TypedDocumentString<ImmunizationsQuery, ImmunizationsQueryVariables>;
export const MedicationAdministrationsDocument = new TypedDocumentString(`
    query MedicationAdministrations($upid: ID!, $cursor: String!, $filter: MedicationAdministrationFilterParams!, $sort: MedicationAdministrationSortParams!, $first: Int!) {
  MedicationAdministrationConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        id
        resourceType
        extension {
          url
          valueString
        }
        dosage {
          text
          dose {
            value
            unit
          }
          route {
            text
            coding {
              ...Coding
            }
          }
        }
        effectivePeriod {
          start
          end
        }
      }
    }
  }
}
    fragment Coding on Coding {
  code
  display
  system
  extension {
    url
    valueString
  }
}`) as unknown as TypedDocumentString<MedicationAdministrationsQuery, MedicationAdministrationsQueryVariables>;
export const MedicationDispensesDocument = new TypedDocumentString(`
    query MedicationDispenses($upid: ID!, $cursor: String!, $filter: MedicationDispenseFilterParams!, $sort: MedicationDispenseSortParams!, $first: Int!) {
  MedicationDispenseConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        id
        resourceType
        extension {
          url
          valueString
          valueInstant
        }
        contained {
          resource {
            ... on Practitioner {
              id
              resourceType
              name {
                family
                given
              }
              address {
                text
              }
              telecom {
                value
              }
            }
            ... on Organization {
              id
              resourceType
              _organization__name: name
              telecom {
                value
              }
              address {
                city
                state
                postalCode
                text
                line
              }
            }
          }
        }
        performer {
          actor {
            id
            extension {
              url
              valueString
            }
            reference
            type
            identifier {
              id
              system
              value
            }
            display
            resource {
              ... on Organization {
                id
                resourceType
                name
                telecom {
                  value
                }
                address {
                  city
                  state
                  postalCode
                  text
                  line
                }
              }
            }
          }
        }
        status
        quantity {
          value
          unit
        }
        medicationCodeableConcept {
          text
          coding {
            ...Coding
          }
        }
        daysSupply {
          value
          unit
        }
        whenHandedOver
        whenPrepared
      }
    }
  }
}
    fragment Coding on Coding {
  code
  display
  system
  extension {
    url
    valueString
  }
}`) as unknown as TypedDocumentString<MedicationDispensesQuery, MedicationDispensesQueryVariables>;
export const MedicationRequestsDocument = new TypedDocumentString(`
    query MedicationRequests($upid: ID!, $cursor: String!, $filter: MedicationRequestFilterParams!, $sort: MedicationRequestSortParams!, $first: Int!) {
  MedicationRequestConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        id
        resourceType
        extension {
          url
          valueString
        }
        authoredOn
        reportedBoolean
        contained {
          resource {
            ... on Practitioner {
              id
              resourceType
              name {
                family
                given
              }
              address {
                text
              }
              telecom {
                value
              }
            }
            ... on Organization {
              id
              resourceType
              _organization__name: name
              telecom {
                value
              }
              address {
                city
                state
                postalCode
                text
                line
              }
            }
          }
        }
        dispenseRequest {
          performer {
            id
            extension {
              url
              valueString
            }
            reference
            type
            identifier {
              id
              system
              value
            }
            display
            resource {
              ... on Organization {
                id
                resourceType
                name
                telecom {
                  value
                }
                address {
                  city
                  state
                  postalCode
                  text
                  line
                }
              }
            }
          }
          numberOfRepeatsAllowed
          initialFill {
            quantity {
              value
              unit
            }
          }
        }
        dosageInstruction {
          text
          timing {
            repeat {
              boundsPeriod {
                start
              }
            }
          }
        }
        medicationCodeableConcept {
          text
          coding {
            ...Coding
          }
        }
        performer {
          ...Reference
        }
        requester {
          id
          extension {
            url
            valueString
          }
          reference
          type
          identifier {
            id
            system
            value
          }
          display
          resource {
            ... on Practitioner {
              id
              resourceType
              name {
                family
                given
              }
              address {
                text
              }
              telecom {
                value
              }
            }
          }
        }
        status
      }
    }
  }
}
    fragment Coding on Coding {
  code
  display
  system
  extension {
    url
    valueString
  }
}
fragment Reference on Reference {
  id
  extension {
    url
    valueString
  }
  reference
  type
  identifier {
    id
    system
    value
  }
  display
}`) as unknown as TypedDocumentString<MedicationRequestsQuery, MedicationRequestsQueryVariables>;
export const MedicationStatementsDocument = new TypedDocumentString(`
    query MedicationStatements($upid: ID!, $cursor: String!, $filter: MedicationStatementFilterParams!, $sort: MedicationStatementSortParams!, $first: Int!) {
  MedicationStatementConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        id
        resourceType
        BasicList(_reference: "subject") {
          ...Basic
        }
        meta {
          tag {
            system
            code
          }
          versionId
        }
        extension {
          url
          extension {
            url
            valueReference {
              id
              type
              reference
            }
          }
          valueDateTime
          valueString
          valueReference {
            id
            type
            reference
            display
          }
          valueQuantity {
            unit
            value
          }
          valueUnsignedInt
        }
        basedOn {
          type
        }
        category {
          text
          coding {
            ...Coding
          }
        }
        contained {
          resource {
            ... on Practitioner {
              id
              resourceType
              name {
                family
                given
              }
            }
            ... on Organization {
              id
              resourceType
              _organization__name: name
            }
            ... on Medication {
              id
              resourceType
              code {
                text
                coding {
                  ...Coding
                }
              }
            }
          }
        }
        context {
          display
        }
        dateAsserted
        derivedFrom {
          display
        }
        dosage {
          text
        }
        effectivePeriod {
          start
        }
        identifier {
          value
        }
        informationSource {
          type
        }
        medicationCodeableConcept {
          text
          coding {
            ...Coding
          }
        }
        medicationReference {
          display
        }
        note {
          text
        }
        partOf {
          display
        }
        reasonCode {
          text
          coding {
            ...Coding
          }
        }
        reasonReference {
          ...Reference
        }
        status
        statusReason {
          text
          coding {
            ...Coding
          }
        }
        subject {
          resource {
            ... on Patient {
              managingOrganization {
                resource {
                  ... on Organization {
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    fragment Basic on Basic {
  id
  resourceType
  meta {
    lastUpdated
  }
  code {
    coding {
      code
      display
      system
    }
  }
  author {
    display
  }
}
fragment Coding on Coding {
  code
  display
  system
  extension {
    url
    valueString
  }
}
fragment Reference on Reference {
  id
  extension {
    url
    valueString
  }
  reference
  type
  identifier {
    id
    system
    value
  }
  display
}`) as unknown as TypedDocumentString<MedicationStatementsQuery, MedicationStatementsQueryVariables>;
export const ObservationsDocument = new TypedDocumentString(`
    query Observations($upid: ID!, $cursor: String!, $sort: ObservationSortParams!, $filter: ObservationFilterParams!, $first: Int!) {
  ObservationConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...Observation
      }
    }
  }
}
    fragment Reference on Reference {
  id
  extension {
    url
    valueString
  }
  reference
  type
  identifier {
    id
    system
    value
  }
  display
}
fragment Observation on Observation {
  id
  resourceType
  extension {
    url
    valueString
  }
  meta {
    tag {
      system
      code
    }
  }
  encounter {
    reference
  }
  status
  category {
    text
    coding {
      code
      display
      system
      extension {
        url
        valueString
      }
    }
  }
  effectivePeriod {
    start
    end
  }
  effectiveDateTime
  referenceRange {
    text
  }
  code {
    text
    coding {
      code
      display
      system
      extension {
        url
        valueString
      }
    }
  }
  component {
    code {
      text
      coding {
        code
        display
        system
      }
    }
    valueQuantity {
      unit
      value
    }
    valueString
  }
  ProvenanceList(_reference: "target") {
    id
    entity {
      what {
        ...Reference
      }
    }
  }
  valueQuantity {
    comparator
    unit
    value
    system
    code
  }
  valueCodeableConcept {
    text
    coding {
      system
      code
      display
    }
  }
  valueString
  valueBoolean
  valueInteger
  valueRange {
    low {
      unit
      value
      system
      code
    }
    high {
      unit
      value
      system
      code
    }
  }
  valueRatio {
    numerator {
      comparator
      unit
      value
      system
      code
    }
    denominator {
      unit
      value
      system
      code
    }
  }
  valueTime
  valueDateTime
  valuePeriod {
    start
    end
  }
  interpretation {
    text
    coding {
      code
      display
      system
      extension {
        url
        valueString
      }
    }
  }
  note {
    text
  }
}`) as unknown as TypedDocumentString<ObservationsQuery, ObservationsQueryVariables>;
export const PatientsForUpidDocument = new TypedDocumentString(`
    query PatientsForUpid($upid: ID!, $cursor: String!, $sort: PatientSortParams!, $first: Int!, $filter: PatientFilterParams! = {}) {
  PatientConnection(
    upid: $upid
    after: $cursor
    sort: $sort
    first: $first
    filter: $filter
  ) {
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        ...Patient
      }
    }
  }
}
    fragment Patient on Patient {
  id
  resourceType
  meta {
    extension {
      url
      valueString
      valueInstant
    }
    tag {
      system
      code
    }
  }
  active
  identifier {
    use
    system
    value
  }
  contact {
    address {
      city
      country
      district
      line
      period {
        start
        end
      }
      postalCode
      state
      text
      type
      use
    }
    gender
    name {
      family
      given
      prefix
      suffix
      text
      use
    }
    organization {
      display
      identifier {
        value
      }
      type
    }
  }
  birthDate
  gender
  maritalStatus {
    text
    coding {
      code
      display
      system
    }
  }
  telecom {
    use
    value
    system
  }
  address {
    city
    country
    district
    line
    period {
      start
      end
    }
    postalCode
    state
    text
    type
    use
  }
  name {
    family
    given
    prefix
    suffix
    text
    use
  }
  managingOrganization {
    resource {
      ...Organization
    }
  }
}
fragment Organization on Organization {
  id
  resourceType
  extension {
    url
    valueString
  }
  name
  telecom {
    system
    value
    period {
      start
      end
    }
  }
  contact {
    purpose {
      text
      coding {
        code
        display
        system
        extension {
          url
          valueString
        }
      }
    }
    name {
      family
      given
      prefix
      suffix
      text
      use
    }
    telecom {
      system
      value
      period {
        start
        end
      }
    }
    address {
      type
      use
      text
      line
      city
      district
      state
      postalCode
      country
      period {
        start
        end
      }
    }
  }
}`) as unknown as TypedDocumentString<PatientsForUpidQuery, PatientsForUpidQueryVariables>;
export const PatientsForBuilderDocument = new TypedDocumentString(`
    query PatientsForBuilder($builderID: ID!, $cursor: String!, $first: Int!, $filter: PatientFilterParams! = {}) {
  PatientConnection(
    builderID: $builderID
    after: $cursor
    first: $first
    filter: $filter
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...Patient
      }
    }
  }
}
    fragment Patient on Patient {
  id
  resourceType
  meta {
    extension {
      url
      valueString
      valueInstant
    }
    tag {
      system
      code
    }
  }
  active
  identifier {
    use
    system
    value
  }
  contact {
    address {
      city
      country
      district
      line
      period {
        start
        end
      }
      postalCode
      state
      text
      type
      use
    }
    gender
    name {
      family
      given
      prefix
      suffix
      text
      use
    }
    organization {
      display
      identifier {
        value
      }
      type
    }
  }
  birthDate
  gender
  maritalStatus {
    text
    coding {
      code
      display
      system
    }
  }
  telecom {
    use
    value
    system
  }
  address {
    city
    country
    district
    line
    period {
      start
      end
    }
    postalCode
    state
    text
    type
    use
  }
  name {
    family
    given
    prefix
    suffix
    text
    use
  }
  managingOrganization {
    resource {
      ...Organization
    }
  }
}
fragment Organization on Organization {
  id
  resourceType
  extension {
    url
    valueString
  }
  name
  telecom {
    system
    value
    period {
      start
      end
    }
  }
  contact {
    purpose {
      text
      coding {
        code
        display
        system
        extension {
          url
          valueString
        }
      }
    }
    name {
      family
      given
      prefix
      suffix
      text
      use
    }
    telecom {
      system
      value
      period {
        start
        end
      }
    }
    address {
      type
      use
      text
      line
      city
      district
      state
      postalCode
      country
      period {
        start
        end
      }
    }
  }
}`) as unknown as TypedDocumentString<PatientsForBuilderQuery, PatientsForBuilderQueryVariables>;
export const ProceduresDocument = new TypedDocumentString(`
    query Procedures($upid: ID!, $cursor: String!, $sort: ProcedureSortParams!, $filter: ProcedureFilterParams!, $first: Int!) {
  ProcedureConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...Procedure
      }
    }
  }
}
    fragment Reference on Reference {
  id
  extension {
    url
    valueString
  }
  reference
  type
  identifier {
    id
    system
    value
  }
  display
}
fragment Procedure on Procedure {
  id
  resourceType
  ProvenanceList(_reference: "target") {
    id
    entity {
      what {
        ...Reference
      }
    }
  }
}`) as unknown as TypedDocumentString<ProceduresQuery, ProceduresQueryVariables>;
export const ServiceRequestsDocument = new TypedDocumentString(`
    query ServiceRequests($upid: ID!) {
  ServiceRequestConnection(upid: $upid) {
    edges {
      node {
        ...ServiceRequest
      }
    }
  }
}
    fragment ServiceRequest on ServiceRequest {
  id
  resourceType
  status
  intent
  subject {
    reference
  }
  identifier {
    system
    value
  }
  requester {
    resource {
      ... on Practitioner {
        id
        resourceType
        extension {
          url
          valueString
        }
        name {
          family
          given
          prefix
          suffix
          text
          use
        }
        qualification {
          code {
            text
            coding {
              code
              display
              system
            }
          }
          period {
            start
            end
          }
        }
      }
    }
    reference
    identifier {
      system
      value
    }
    display
  }
  reasonCode {
    text
  }
  authoredOn
  category {
    text
  }
  performer {
    reference
    identifier {
      system
      value
    }
    display
  }
  locationReference {
    reference
    display
  }
}`) as unknown as TypedDocumentString<ServiceRequestsQuery, ServiceRequestsQueryVariables>;